import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
const defaultOptions = {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** An event time */
  EventTime: any
  /** An ISO 8601-encoded date */
  ISO8601Date: any
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any
}

/** Autogenerated input type of AcceptExternalScrapCollectionRequest */
export type AcceptExternalScrapCollectionRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  externalScrapCollectionRequestId: Scalars['ID']
  loadingEventId: Scalars['ID']
}

/** Autogenerated return type of AcceptExternalScrapCollectionRequest */
export type AcceptExternalScrapCollectionRequestPayload = {
  __typename?: 'AcceptExternalScrapCollectionRequestPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  externalScrapCollectionRequest: ExternalScrapCollectionRequest
}

export type AsyncStatus = 'ok'

/** Autogenerated input type of AttachContractAttachedFile */
export type AttachContractAttachedFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 添付先の契約 */
  contractId: Scalars['ID']
  /** 一時ファイル */
  temporaryAttachedFileId: Scalars['ID']
}

/** Autogenerated return type of AttachContractAttachedFile */
export type AttachContractAttachedFilePayload = {
  __typename?: 'AttachContractAttachedFilePayload'
  attachedFile: AttachedFile
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contract: Contract
}

/** Autogenerated input type of AttachLoadingEventAttachedFile */
export type AttachLoadingEventAttachedFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 添付先の配車イベント */
  loadingEventId: Scalars['ID']
  /** 一時ファイル */
  temporaryAttachedFileId: Scalars['ID']
}

/** Autogenerated return type of AttachLoadingEventAttachedFile */
export type AttachLoadingEventAttachedFilePayload = {
  __typename?: 'AttachLoadingEventAttachedFilePayload'
  attachedFile: AttachedFile
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  loadingEvent: LoadingEvent
}

export type AttachedFile = Node & {
  __typename?: 'AttachedFile'
  attachment: Attachment
  contentType: Scalars['String']
  createdAt: Scalars['ISO8601DateTime']
  downloadSignedUrl: Scalars['String']
  employee: Company
  filename: Scalars['String']
  gid: Scalars['ID']
  id: Scalars['ID']
  originalFilename: Scalars['String']
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for AttachedFile. */
export type AttachedFileConnection = {
  __typename?: 'AttachedFileConnection'
  /** A list of edges. */
  edges: Array<AttachedFileEdge>
  /** A list of nodes. */
  nodes: Array<AttachedFile>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type AttachedFileEdge = {
  __typename?: 'AttachedFileEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<AttachedFile>
}

export type Attachment = Contract | LoadingEvent

export type BaseOrderField =
  /** 作成日 */
  | 'CREATED_AT'
  /** ID */
  | 'ID'
  /** 並び順(カラムが存在する場合) */
  | 'ORDER'
  /** 更新日 */
  | 'UPDATED_AT'

export type CarType = Node & {
  __typename?: 'CarType'
  company: Company
  createdAt: Scalars['ISO8601DateTime']
  gid: Scalars['ID']
  id: Scalars['ID']
  name: Scalars['String']
  order?: Maybe<Scalars['Int']>
  trucks: TruckConnection
  updatedAt: Scalars['ISO8601DateTime']
}

export type CarTypeTrucksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  carNumber?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

/** The connection type for CarType. */
export type CarTypeConnection = {
  __typename?: 'CarTypeConnection'
  /** A list of edges. */
  edges: Array<CarTypeEdge>
  /** A list of nodes. */
  nodes: Array<CarType>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CarTypeEdge = {
  __typename?: 'CarTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<CarType>
}

export type Category = 'buy' | 'other' | 'sell'

/** Autogenerated input type of ChangeCompanySiteEventLoadingTime */
export type ChangeCompanySiteEventLoadingTimeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  /** 所要時間 */
  loadingTime: Scalars['EventTime']
}

/** Autogenerated return type of ChangeCompanySiteEventLoadingTime */
export type ChangeCompanySiteEventLoadingTimePayload = {
  __typename?: 'ChangeCompanySiteEventLoadingTimePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  companySiteEvent: CompanySiteEvent
}

/** Autogenerated input type of ChangeEmployeeOrder */
export type ChangeEmployeeOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 従業員 */
  id: Scalars['ID']
  order: Scalars['Int']
}

/** Autogenerated return type of ChangeEmployeeOrder */
export type ChangeEmployeeOrderPayload = {
  __typename?: 'ChangeEmployeeOrderPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employees: Array<Employee>
}

/** Autogenerated input type of ChangeEmployeePassword */
export type ChangeEmployeePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 従業員 */
  id: Scalars['ID']
}

/** Autogenerated return type of ChangeEmployeePassword */
export type ChangeEmployeePasswordPayload = {
  __typename?: 'ChangeEmployeePasswordPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee: Employee
}

/** Autogenerated input type of ChangeLoadingEventFixed */
export type ChangeLoadingEventFixedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 確定しているか否か */
  fixed: Scalars['Boolean']
  /** 配車イベントID */
  id: Scalars['ID']
}

/** Autogenerated return type of ChangeLoadingEventFixed */
export type ChangeLoadingEventFixedPayload = {
  __typename?: 'ChangeLoadingEventFixedPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  loadingEvent?: Maybe<LoadingEvent>
}

/** Autogenerated input type of ChangeLoadingEventStartOn */
export type ChangeLoadingEventStartOnInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  startOn: Scalars['ISO8601DateTime']
}

/** Autogenerated return type of ChangeLoadingEventStartOn */
export type ChangeLoadingEventStartOnPayload = {
  __typename?: 'ChangeLoadingEventStartOnPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  loadingEvent: LoadingEvent
}

/** Autogenerated input type of ChangeLoadingEventState */
export type ChangeLoadingEventStateInput = {
  changeState: State
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of ChangeLoadingEventState */
export type ChangeLoadingEventStatePayload = {
  __typename?: 'ChangeLoadingEventStatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  currentState: State
  loadingEvent: LoadingEvent
}

/** Autogenerated input type of ChangeRequestVehicleAllocationEventToUnit */
export type ChangeRequestVehicleAllocationEventToUnitInput = {
  /** 現着日付 */
  arrivalDate: Scalars['ISO8601Date']
  /** 現着時刻 */
  arrivalTime: Scalars['EventTime']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** ドライバー */
  driverEmployeeId: Scalars['ID']
  /** 高速道路/有料道を使用するか否か */
  fast: Scalars['Boolean']
  /** 配車可能にする配車イベントID */
  loadingEventId: Scalars['ID']
  /** 終了拠点での所要時間 */
  nextCompanySiteEventTime?: InputMaybe<Scalars['Int']>
  /** 開始拠点での所要時間 */
  prevCompanySiteEventTime?: InputMaybe<Scalars['Int']>
  /** トラック */
  truckId: Scalars['ID']
}

/** Autogenerated return type of ChangeRequestVehicleAllocationEventToUnit */
export type ChangeRequestVehicleAllocationEventToUnitPayload = {
  __typename?: 'ChangeRequestVehicleAllocationEventToUnitPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  loadingEvent: LoadingEvent
  unit: Unit
}

/** Autogenerated input type of ChangeTimeUnit */
export type ChangeTimeUnitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 終了日時 */
  endOn: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  /** 開始日時 */
  startOn: Scalars['ISO8601DateTime']
}

/** Autogenerated return type of ChangeTimeUnit */
export type ChangeTimeUnitPayload = {
  __typename?: 'ChangeTimeUnitPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  unit: Unit
}

/** Autogenerated input type of ChangeTruckOrder */
export type ChangeTruckOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** トラック */
  id: Scalars['ID']
  order: Scalars['Int']
}

/** Autogenerated return type of ChangeTruckOrder */
export type ChangeTruckOrderPayload = {
  __typename?: 'ChangeTruckOrderPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  trucks: Array<Truck>
}

/** Autogenerated input type of ChangeUnitFixed */
export type ChangeUnitFixedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 確定しているか否か */
  fixed: Scalars['Boolean']
  /** ユニットID */
  id: Scalars['ID']
}

/** Autogenerated return type of ChangeUnitFixed */
export type ChangeUnitFixedPayload = {
  __typename?: 'ChangeUnitFixedPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  unit?: Maybe<Unit>
}

export type Company = Node & {
  __typename?: 'Company'
  /** 会社の設定一覧を取得する */
  companySettings?: Maybe<CompanySettingConnection>
  companySites?: Maybe<CompanySiteConnection>
  createdAt: Scalars['ISO8601DateTime']
  employees?: Maybe<EmployeeConnection>
  gid: Scalars['ID']
  id: Scalars['ID']
  name: Scalars['String']
  noteTemplate?: Maybe<Scalars['String']>
  tel?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type CompanyCompanySettingsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  kind?: InputMaybe<CompanySettingKind>
  last?: InputMaybe<Scalars['Int']>
  scope?: InputMaybe<CompanySettingScope>
}

export type CompanyCompanySitesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

export type CompanyEmployeesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  freightageRoles?: InputMaybe<Array<Freightage>>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  orderBy?: InputMaybe<OrderByInput>
  systemSettingRoles?: InputMaybe<Array<SystemSetting>>
}

/** The connection type for Company. */
export type CompanyConnection = {
  __typename?: 'CompanyConnection'
  /** A list of edges. */
  edges: Array<CompanyEdge>
  /** A list of nodes. */
  nodes: Array<Company>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<Company>
}

export type CompanyRelation = Node & {
  __typename?: 'CompanyRelation'
  company: Company
  contracts: ContractConnection
  createdAt: Scalars['ISO8601DateTime']
  disabledAt?: Maybe<Scalars['ISO8601DateTime']>
  gid: Scalars['ID']
  id: Scalars['ID']
  involvement: Involvement
  relatedCompany: Company
  updatedAt: Scalars['ISO8601DateTime']
}

export type CompanyRelationContractsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  currentOnly?: InputMaybe<Scalars['Boolean']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  frequent?: InputMaybe<Scalars['Boolean']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  loadingEventOrderBy?: InputMaybe<OrderByInput>
  orderBy?: InputMaybe<OrderByInput>
  text?: InputMaybe<Scalars['String']>
}

/** The connection type for CompanyRelation. */
export type CompanyRelationConnection = {
  __typename?: 'CompanyRelationConnection'
  /** A list of edges. */
  edges: Array<CompanyRelationEdge>
  /** A list of nodes. */
  nodes: Array<CompanyRelation>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CompanyRelationEdge = {
  __typename?: 'CompanyRelationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<CompanyRelation>
}

export type CompanySetting = Node & {
  __typename?: 'CompanySetting'
  company: Company
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  kind: CompanySettingKind
  scope: CompanySettingScope
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for CompanySetting. */
export type CompanySettingConnection = {
  __typename?: 'CompanySettingConnection'
  /** A list of edges. */
  edges: Array<CompanySettingEdge>
  /** A list of nodes. */
  nodes: Array<CompanySetting>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CompanySettingEdge = {
  __typename?: 'CompanySettingEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<CompanySetting>
}

export type CompanySettingKind =
  /** 配車イベント承認 */
  'LOADING_EVENT_APPROVAL'

export type CompanySettingScope =
  /** 編集権限 */
  | 'EDIT'
  /** 参照権限 */
  | 'READ'

export type CompanySite = Node & {
  __typename?: 'CompanySite'
  address: Scalars['String']
  company: Company
  createdAt: Scalars['ISO8601DateTime']
  endTime: Scalars['EventTime']
  gid: Scalars['ID']
  id: Scalars['ID']
  name: Scalars['String']
  startTime: Scalars['EventTime']
  tel?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for CompanySite. */
export type CompanySiteConnection = {
  __typename?: 'CompanySiteConnection'
  /** A list of edges. */
  edges: Array<CompanySiteEdge>
  /** A list of nodes. */
  nodes: Array<CompanySite>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CompanySiteEdge = {
  __typename?: 'CompanySiteEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<CompanySite>
}

export type CompanySiteEvent = Node & {
  __typename?: 'CompanySiteEvent'
  /** 拠点 */
  companySite: CompanySite
  createdAt: Scalars['ISO8601DateTime']
  gid: Scalars['ID']
  id: Scalars['ID']
  /** 荷役時間 */
  loadingTime: Scalars['EventTime']
  route: Route
  updatedAt: Scalars['ISO8601DateTime']
}

export type Contract = Node & {
  __typename?: 'Contract'
  address: Scalars['String']
  attachedFiles: AttachedFileConnection
  carTypes: CarTypeConnection
  cargo?: Maybe<Scalars['String']>
  category: Category
  company: Company
  companyRelation: CompanyRelation
  createdAt: Scalars['ISO8601DateTime']
  gid: Scalars['ID']
  id: Scalars['ID']
  loadingEvents: LoadingEventConnection
  loadingTime: Scalars['EventTime']
  name: Scalars['String']
  note?: Maybe<Scalars['String']>
  relatedCompany: Company
  salesEmployee: Employee
  staffName?: Maybe<Scalars['String']>
  tel?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type ContractAttachedFilesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type ContractCarTypesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type ContractLoadingEventsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

/** The connection type for Contract. */
export type ContractConnection = {
  __typename?: 'ContractConnection'
  /** A list of edges. */
  edges: Array<ContractEdge>
  /** A list of nodes. */
  nodes: Array<Contract>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ContractEdge = {
  __typename?: 'ContractEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<Contract>
}

export type ContractPaperStatus =
  | 'creating_contract_paper'
  | 'exist_contract_paper'
  | 'none_contract_paper'

/** Autogenerated input type of CreateCar */
export type CreateCarInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
}

/** Autogenerated return type of CreateCar */
export type CreateCarPayload = {
  __typename?: 'CreateCarPayload'
  carType: CarType
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated input type of CreateCompanySite */
export type CreateCompanySiteInput = {
  address: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  endTime: Scalars['EventTime']
  name: Scalars['String']
  startTime: Scalars['EventTime']
  tel?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of CreateCompanySite */
export type CreateCompanySitePayload = {
  __typename?: 'CreateCompanySitePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  companySite: CompanySite
}

/** Autogenerated input type of CreateContractAndRelatedCompany */
export type CreateContractAndRelatedCompanyInput = {
  address: Scalars['String']
  carTypeIds?: InputMaybe<Array<Scalars['ID']>>
  cargo?: InputMaybe<Scalars['String']>
  category: Category
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  loadingTime: Scalars['EventTime']
  name: Scalars['String']
  note?: InputMaybe<Scalars['String']>
  relatedCompanyName: Scalars['String']
  salesEmployeeId: Scalars['ID']
  staffName?: InputMaybe<Scalars['String']>
  tel?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of CreateContractAndRelatedCompany */
export type CreateContractAndRelatedCompanyPayload = {
  __typename?: 'CreateContractAndRelatedCompanyPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  companyRelation: CompanyRelation
  contract: Contract
  relatedCompany: Company
}

/** Autogenerated input type of CreateContract */
export type CreateContractInput = {
  address: Scalars['String']
  carTypeIds?: InputMaybe<Array<Scalars['ID']>>
  cargo?: InputMaybe<Scalars['String']>
  category: Category
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  companyRelationId: Scalars['ID']
  loadingTime: Scalars['EventTime']
  name: Scalars['String']
  note?: InputMaybe<Scalars['String']>
  salesEmployeeId: Scalars['ID']
  staffName?: InputMaybe<Scalars['String']>
  tel?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of CreateContract */
export type CreateContractPayload = {
  __typename?: 'CreateContractPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contract: Contract
}

/** Autogenerated input type of CreateEmployee */
export type CreateEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  companySiteId: Scalars['ID']
  email: Scalars['String']
  employeeRoleId: Scalars['ID']
  enableEmailNotification: Scalars['Boolean']
  name: Scalars['String']
  tel?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of CreateEmployee */
export type CreateEmployeePayload = {
  __typename?: 'CreateEmployeePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee: Employee
}

/** Autogenerated input type of CreateEventEmployee */
export type CreateEventEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 従業員 */
  employeeId: Scalars['ID']
  /** 終了日 */
  endOn: Scalars['ISO8601Date']
  /** 終了時刻 */
  endTime: Scalars['EventTime']
  /** メモ */
  note?: InputMaybe<Scalars['String']>
  /** 理由 */
  reasonType: EventEmployeeReasonType
  /** 開始日 */
  startOn: Scalars['ISO8601Date']
  /** 開始時刻 */
  startTime: Scalars['EventTime']
}

/** Autogenerated return type of CreateEventEmployee */
export type CreateEventEmployeePayload = {
  __typename?: 'CreateEventEmployeePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  event: Event
}

/** Autogenerated input type of CreateEventRecurring */
export type CreateEventRecurringInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** イベントID */
  id: Scalars['ID']
  /** 繰返し設定日 */
  recurringDates: Array<Scalars['ISO8601Date']>
}

/** Autogenerated return type of CreateEventRecurring */
export type CreateEventRecurringPayload = {
  __typename?: 'CreateEventRecurringPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  events?: Maybe<Array<Event>>
}

/** Autogenerated input type of CreateEventTruck */
export type CreateEventTruckInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 終了日 */
  endOn: Scalars['ISO8601Date']
  /** 終了時刻 */
  endTime: Scalars['EventTime']
  /** メモ */
  note?: InputMaybe<Scalars['String']>
  /** 理由 */
  reasonType: EventTruckReasonType
  /** 開始日 */
  startOn: Scalars['ISO8601Date']
  /** 開始時刻 */
  startTime: Scalars['EventTime']
  /** トラック */
  truckId: Scalars['ID']
}

/** Autogenerated return type of CreateEventTruck */
export type CreateEventTruckPayload = {
  __typename?: 'CreateEventTruckPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  event: Event
}

/** Autogenerated input type of CreateRelatedCompany */
export type CreateRelatedCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  involvement: Involvement
  name: Scalars['String']
  tel?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of CreateRelatedCompany */
export type CreateRelatedCompanyPayload = {
  __typename?: 'CreateRelatedCompanyPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  companyRelation: CompanyRelation
  relatedCompany: Company
}

/** Autogenerated input type of CreateRequestVehicleAllocationEvent */
export type CreateRequestVehicleAllocationEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  eventDetail: RequestVehicleAllocationEventDetailInput
  requestCount: Scalars['Int']
}

/** Autogenerated return type of CreateRequestVehicleAllocationEvent */
export type CreateRequestVehicleAllocationEventPayload = {
  __typename?: 'CreateRequestVehicleAllocationEventPayload'
  basedContract: Scalars['Boolean']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  loadingEvents: Array<LoadingEvent>
}

/** Autogenerated input type of CreateTemporaryVehicleAllocationEventOrUnit */
export type CreateTemporaryVehicleAllocationEventOrUnitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  event: TemporaryVehicleAllocationEventOrUnitInput
  eventDetail: TemporaryVehicleAllocationEventDetailInput
  eventOption?: InputMaybe<TemporaryVehicleAllocationEventOptionInput>
}

/** Autogenerated return type of CreateTemporaryVehicleAllocationEventOrUnit */
export type CreateTemporaryVehicleAllocationEventOrUnitPayload = {
  __typename?: 'CreateTemporaryVehicleAllocationEventOrUnitPayload'
  basedContract?: Maybe<Scalars['Boolean']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  event?: Maybe<Event>
  unit?: Maybe<Unit>
}

/** Autogenerated input type of CreateTruck */
export type CreateTruckInput = {
  carNumber: Scalars['String']
  carTypeId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  companySiteId: Scalars['ID']
  note?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of CreateTruck */
export type CreateTruckPayload = {
  __typename?: 'CreateTruckPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  truck: Truck
}

/** Autogenerated input type of CreateUnitRecurring */
export type CreateUnitRecurringInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** ユニットID */
  id: Scalars['ID']
  /** 繰返し設定日 */
  recurringDates: Array<Scalars['ISO8601Date']>
}

/** Autogenerated return type of CreateUnitRecurring */
export type CreateUnitRecurringPayload = {
  __typename?: 'CreateUnitRecurringPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  units?: Maybe<Array<Unit>>
}

export type Current = {
  __typename?: 'Current'
  company: Company
  employee: Employee
  externalRequestCount?: Maybe<Scalars['Int']>
  notificationCount: Scalars['Int']
  requestCount?: Maybe<Scalars['Int']>
}

/** Autogenerated return type of CurrentUpdate */
export type CurrentUpdatePayload = {
  __typename?: 'CurrentUpdatePayload'
  current: Current
}

export type DesiredPickupPeriod =
  /** 終日 */
  | 'alltime'
  /** 午前 */
  | 'am'
  /** その他 */
  | 'other'
  /** 午後 */
  | 'pm'

/** Autogenerated input type of DestroyCompanySite */
export type DestroyCompanySiteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DestroyCompanySite */
export type DestroyCompanySitePayload = {
  __typename?: 'DestroyCompanySitePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  companySite: CompanySite
}

/** Autogenerated input type of DestroyEvent */
export type DestroyEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DestroyEvent */
export type DestroyEventPayload = {
  __typename?: 'DestroyEventPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  event: Event
}

/** Autogenerated input type of DestroyLoadingEvent */
export type DestroyLoadingEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DestroyLoadingEvent */
export type DestroyLoadingEventPayload = {
  __typename?: 'DestroyLoadingEventPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  loadingEvent: LoadingEvent
}

/** Autogenerated input type of DestroyUnit */
export type DestroyUnitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DestroyUnit */
export type DestroyUnitPayload = {
  __typename?: 'DestroyUnitPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  unit: Unit
}

/** Autogenerated input type of DisableContract */
export type DisableContractInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DisableContract */
export type DisableContractPayload = {
  __typename?: 'DisableContractPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contract: Contract
}

/** Autogenerated input type of DisableEmployee */
export type DisableEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DisableEmployee */
export type DisableEmployeePayload = {
  __typename?: 'DisableEmployeePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee: Employee
}

/** Autogenerated input type of DisableRelatedCompany */
export type DisableRelatedCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  companyRelationId: Scalars['ID']
}

/** Autogenerated return type of DisableRelatedCompany */
export type DisableRelatedCompanyPayload = {
  __typename?: 'DisableRelatedCompanyPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  companyRelation: CompanyRelation
}

/** Autogenerated input type of DisableTruck */
export type DisableTruckInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DisableTruck */
export type DisableTruckPayload = {
  __typename?: 'DisableTruckPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  truck: Truck
}

/** Autogenerated input type of DuplicateEvent */
export type DuplicateEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DuplicateEvent */
export type DuplicateEventPayload = {
  __typename?: 'DuplicateEventPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  duplicatedEvent: Event
  event: Event
}

/** Autogenerated input type of DuplicateUnit */
export type DuplicateUnitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DuplicateUnit */
export type DuplicateUnitPayload = {
  __typename?: 'DuplicateUnitPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  duplicatedUnit: Unit
  unit: Unit
}

export type Employee = Node & {
  __typename?: 'Employee'
  company: Company
  companySite: CompanySite
  createdAt: Scalars['ISO8601DateTime']
  disabledAt?: Maybe<Scalars['ISO8601DateTime']>
  drivableTrucks: TruckConnection
  email: Scalars['String']
  emailVerifiedAt?: Maybe<Scalars['ISO8601DateTime']>
  employeeDrivableTrucks?: Maybe<EmployeeDrivableTruckConnection>
  employeeRole?: Maybe<EmployeeRole>
  enableEmailNotification: Scalars['Boolean']
  gid: Scalars['ID']
  id: Scalars['ID']
  lineRelationship?: Maybe<LineRelationship>
  name: Scalars['String']
  order?: Maybe<Scalars['Int']>
  tel?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type EmployeeDrivableTrucksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type EmployeeEmployeeDrivableTrucksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

/** The connection type for Employee. */
export type EmployeeConnection = {
  __typename?: 'EmployeeConnection'
  /** A list of edges. */
  edges: Array<EmployeeEdge>
  /** A list of nodes. */
  nodes: Array<Employee>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type EmployeeDrivableTruck = Node & {
  __typename?: 'EmployeeDrivableTruck'
  createdAt: Scalars['ISO8601DateTime']
  employee: Employee
  gid: Scalars['ID']
  id: Scalars['ID']
  priority: Priority
  truck: Truck
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for EmployeeDrivableTruck. */
export type EmployeeDrivableTruckConnection = {
  __typename?: 'EmployeeDrivableTruckConnection'
  /** A list of edges. */
  edges: Array<EmployeeDrivableTruckEdge>
  /** A list of nodes. */
  nodes: Array<EmployeeDrivableTruck>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type EmployeeDrivableTruckEdge = {
  __typename?: 'EmployeeDrivableTruckEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<EmployeeDrivableTruck>
}

export type EmployeeDrivableTruckInput = {
  employeeId: Scalars['ID']
  priority: Priority
}

/** An edge in a connection. */
export type EmployeeEdge = {
  __typename?: 'EmployeeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<Employee>
}

export type EmployeeNotification = Node & {
  __typename?: 'EmployeeNotification'
  createdAt: Scalars['ISO8601DateTime']
  detail?: Maybe<Scalars['String']>
  executeEmployee: Employee
  gid: Scalars['ID']
  id: Scalars['ID']
  isRead: Scalars['Boolean']
  receiveEmployee: Employee
  title?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
  urlPath: Scalars['String']
}

/** The connection type for EmployeeNotification. */
export type EmployeeNotificationConnection = {
  __typename?: 'EmployeeNotificationConnection'
  /** A list of edges. */
  edges: Array<EmployeeNotificationEdge>
  /** A list of nodes. */
  nodes: Array<EmployeeNotification>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type EmployeeNotificationEdge = {
  __typename?: 'EmployeeNotificationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<EmployeeNotification>
}

export type EmployeeRole = Node & {
  __typename?: 'EmployeeRole'
  createdAt: Scalars['ISO8601DateTime']
  freightage: Array<Freightage>
  gid: Scalars['ID']
  id: Scalars['ID']
  name: Scalars['String']
  system: Scalars['Boolean']
  systemSetting: Array<SystemSetting>
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for EmployeeRole. */
export type EmployeeRoleConnection = {
  __typename?: 'EmployeeRoleConnection'
  /** A list of edges. */
  edges: Array<EmployeeRoleEdge>
  /** A list of nodes. */
  nodes: Array<EmployeeRole>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type EmployeeRoleEdge = {
  __typename?: 'EmployeeRoleEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<EmployeeRole>
}

export type EmployeeUnavailablePeriod = Node & {
  __typename?: 'EmployeeUnavailablePeriod'
  createdAt: Scalars['ISO8601DateTime']
  employee?: Maybe<Employee>
  endOn: Scalars['ISO8601DateTime']
  gid: Scalars['ID']
  id: Scalars['ID']
  startOn: Scalars['ISO8601DateTime']
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for EmployeeUnavailablePeriod. */
export type EmployeeUnavailablePeriodConnection = {
  __typename?: 'EmployeeUnavailablePeriodConnection'
  /** A list of edges. */
  edges: Array<EmployeeUnavailablePeriodEdge>
  /** A list of nodes. */
  nodes: Array<EmployeeUnavailablePeriod>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type EmployeeUnavailablePeriodEdge = {
  __typename?: 'EmployeeUnavailablePeriodEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<EmployeeUnavailablePeriod>
}

export type Event = EventEmployee | EventTemporaryVehicleAllocation | EventTruck

/** The connection type for Event. */
export type EventConnection = {
  __typename?: 'EventConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Event>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of EventCreate */
export type EventCreatePayload = {
  __typename?: 'EventCreatePayload'
  event?: Maybe<Event>
}

/** Autogenerated return type of EventDestroy */
export type EventDestroyPayload = {
  __typename?: 'EventDestroyPayload'
  destroiedEventId?: Maybe<Scalars['ID']>
}

/** An edge in a connection. */
export type EventEdge = {
  __typename?: 'EventEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<Event>
}

export type EventEmployee = EventInterface &
  Node & {
    __typename?: 'EventEmployee'
    company: Company
    companyRelation?: Maybe<CompanyRelation>
    createEmployee: Employee
    createdAt: Scalars['ISO8601DateTime']
    detail: EventEmployeeDetail
    employee?: Maybe<Employee>
    endOn: Scalars['ISO8601DateTime']
    endTime: Scalars['EventTime']
    gid: Scalars['ID']
    /** ID of the object. */
    id: Scalars['ID']
    startOn: Scalars['ISO8601DateTime']
    startTime: Scalars['EventTime']
    truck?: Maybe<Truck>
    updatedAt: Scalars['ISO8601DateTime']
  }

export type EventEmployeeDetail = Node & {
  __typename?: 'EventEmployeeDetail'
  event: EventEmployee
  /** ID of the object. */
  id: Scalars['ID']
  note?: Maybe<Scalars['String']>
  reasonType: EventEmployeeReasonType
}

export type EventEmployeeReasonType =
  | 'holiday'
  | 'inspection'
  | 'meeting'
  | 'oneOnOne'
  | 'other'
  | 'paidLeave'
  | 'restTime'
  | 'rollCall'
  | 'siteWork'

export type EventFeasibilityCheckInput = {
  address: Scalars['String']
  employeeId: Scalars['ID']
  loadingTime: Scalars['EventTime']
  startDate: Scalars['ISO8601Date']
  startTime: Scalars['EventTime']
  truckId: Scalars['ID']
}

export type EventFeasible = {
  __typename?: 'EventFeasible'
  /** 履行先住所 */
  address: Scalars['String']
  employee: Employee
  employeeUnavailablePeriods: Array<EmployeeUnavailablePeriod>
  /** 終了日時 */
  endOn: Scalars['ISO8601DateTime']
  /** 履行可能であるか否か */
  feasible: Scalars['Boolean']
  /** 所要時間 */
  loadingTime: Scalars['EventTime']
  /** 開始日時 */
  startOn: Scalars['ISO8601DateTime']
  truck: Truck
  truckUnavailablePeriods: Array<TruckUnavailablePeriod>
}

export type EventInterface = {
  company: Company
  companyRelation?: Maybe<CompanyRelation>
  createEmployee: Employee
  createdAt: Scalars['ISO8601DateTime']
  employee?: Maybe<Employee>
  endOn: Scalars['ISO8601DateTime']
  endTime: Scalars['EventTime']
  gid: Scalars['ID']
  id: Scalars['ID']
  startOn: Scalars['ISO8601DateTime']
  startTime: Scalars['EventTime']
  truck?: Maybe<Truck>
  updatedAt: Scalars['ISO8601DateTime']
}

export type EventTemporaryVehicleAllocation = EventInterface &
  Node & {
    __typename?: 'EventTemporaryVehicleAllocation'
    company: Company
    companyRelation?: Maybe<CompanyRelation>
    createEmployee: Employee
    createdAt: Scalars['ISO8601DateTime']
    detail: EventTemporaryVehicleAllocationDetail
    employee?: Maybe<Employee>
    endOn: Scalars['ISO8601DateTime']
    endTime: Scalars['EventTime']
    gid: Scalars['ID']
    /** ID of the object. */
    id: Scalars['ID']
    plannedArrivalOn: Scalars['ISO8601DateTime']
    plannedLoadingTime: Scalars['EventTime']
    startOn: Scalars['ISO8601DateTime']
    startTime: Scalars['EventTime']
    truck?: Maybe<Truck>
    updatedAt: Scalars['ISO8601DateTime']
  }

export type EventTemporaryVehicleAllocationDetail = Node & {
  __typename?: 'EventTemporaryVehicleAllocationDetail'
  address?: Maybe<Scalars['String']>
  cargo?: Maybe<Scalars['String']>
  category?: Maybe<Category>
  companyRelation?: Maybe<CompanyRelation>
  contract?: Maybe<Contract>
  /** 契約書状況 */
  contractPaperStatus?: Maybe<ContractPaperStatus>
  createdAt: Scalars['ISO8601DateTime']
  event: EventTemporaryVehicleAllocation
  gid: Scalars['ID']
  id: Scalars['ID']
  loadingTime?: Maybe<Scalars['EventTime']>
  /** マニフェスト */
  manifest: Manifest
  name: Scalars['String']
  /** 終了拠点での所要時間 */
  nextCompanySiteEventTime?: Maybe<Scalars['EventTime']>
  note?: Maybe<Scalars['String']>
  /** 作業員数 */
  operatorCount?: Maybe<Scalars['String']>
  /** 開始拠点での所要時間 */
  prevCompanySiteEventTime?: Maybe<Scalars['EventTime']>
  relatedCompanyName?: Maybe<Scalars['String']>
  requestArrivalTime?: Maybe<Scalars['String']>
  requestArrivals: EventTemporaryVehicleAllocationDetailRequestArrivalConnection
  requestCarTypes: EventTemporaryVehicleAllocationDetailRequestCarTypeConnection
  salesEmployee?: Maybe<Employee>
  staffName?: Maybe<Scalars['String']>
  subContract?: Maybe<Contract>
  tel?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type EventTemporaryVehicleAllocationDetailRequestArrivalsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type EventTemporaryVehicleAllocationDetailRequestCarTypesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type EventTemporaryVehicleAllocationDetailRequestArrival = Node & {
  __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrival'
  createdAt: Scalars['ISO8601DateTime']
  date: Scalars['ISO8601Date']
  detail: EventTemporaryVehicleAllocationDetail
  gid: Scalars['ID']
  id: Scalars['ID']
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for EventTemporaryVehicleAllocationDetailRequestArrival. */
export type EventTemporaryVehicleAllocationDetailRequestArrivalConnection = {
  __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrivalConnection'
  /** A list of edges. */
  edges: Array<EventTemporaryVehicleAllocationDetailRequestArrivalEdge>
  /** A list of nodes. */
  nodes: Array<EventTemporaryVehicleAllocationDetailRequestArrival>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type EventTemporaryVehicleAllocationDetailRequestArrivalEdge = {
  __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrivalEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<EventTemporaryVehicleAllocationDetailRequestArrival>
}

export type EventTemporaryVehicleAllocationDetailRequestCarType = Node & {
  __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarType'
  carType: CarType
  createdAt: Scalars['ISO8601DateTime']
  detail: EventTemporaryVehicleAllocationDetail
  gid: Scalars['ID']
  id: Scalars['ID']
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for EventTemporaryVehicleAllocationDetailRequestCarType. */
export type EventTemporaryVehicleAllocationDetailRequestCarTypeConnection = {
  __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarTypeConnection'
  /** A list of edges. */
  edges: Array<EventTemporaryVehicleAllocationDetailRequestCarTypeEdge>
  /** A list of nodes. */
  nodes: Array<EventTemporaryVehicleAllocationDetailRequestCarType>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type EventTemporaryVehicleAllocationDetailRequestCarTypeEdge = {
  __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<EventTemporaryVehicleAllocationDetailRequestCarType>
}

export type EventTruck = EventInterface &
  Node & {
    __typename?: 'EventTruck'
    company: Company
    companyRelation?: Maybe<CompanyRelation>
    createEmployee: Employee
    createdAt: Scalars['ISO8601DateTime']
    detail: EventTruckDetail
    employee?: Maybe<Employee>
    endOn: Scalars['ISO8601DateTime']
    endTime: Scalars['EventTime']
    gid: Scalars['ID']
    /** ID of the object. */
    id: Scalars['ID']
    startOn: Scalars['ISO8601DateTime']
    startTime: Scalars['EventTime']
    truck?: Maybe<Truck>
    updatedAt: Scalars['ISO8601DateTime']
  }

export type EventTruckDetail = Node & {
  __typename?: 'EventTruckDetail'
  event: EventTruck
  /** ID of the object. */
  id: Scalars['ID']
  note?: Maybe<Scalars['String']>
  reasonType: EventTruckReasonType
}

export type EventTruckReasonType = 'other' | 'pitIn' | 'siteWork'

/** Autogenerated return type of EventUpdate */
export type EventUpdatePayload = {
  __typename?: 'EventUpdatePayload'
  event?: Maybe<Event>
}

export type ExternalScrapCollectionRequest = Node & {
  __typename?: 'ExternalScrapCollectionRequest'
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']>
  cargoDetails: Scalars['String']
  comment?: Maybe<Scalars['String']>
  company: Company
  createdAt: Scalars['ISO8601DateTime']
  desiredPickupDate: Scalars['String']
  desiredPickupPeriod: DesiredPickupPeriod
  estimatedContracts: ContractConnection
  gid: Scalars['ID']
  id: Scalars['ID']
  kindOfTruck: Scalars['String']
  loadingEvent?: Maybe<LoadingEvent>
  numberOfTrucks: Scalars['Int']
  rejectedAt?: Maybe<Scalars['ISO8601DateTime']>
  requesterCompanyName: Scalars['String']
  requesterEmail: Scalars['String']
  requesterName: Scalars['String']
  requesterPhone: Scalars['String']
  siteAddress: Scalars['String']
  siteContactName?: Maybe<Scalars['String']>
  siteContactPhone?: Maybe<Scalars['String']>
  siteName: Scalars['String']
  updatedAt: Scalars['ISO8601DateTime']
}

export type ExternalScrapCollectionRequestEstimatedContractsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

/** The connection type for ExternalScrapCollectionRequest. */
export type ExternalScrapCollectionRequestConnection = {
  __typename?: 'ExternalScrapCollectionRequestConnection'
  /** A list of edges. */
  edges: Array<ExternalScrapCollectionRequestEdge>
  /** A list of nodes. */
  nodes: Array<ExternalScrapCollectionRequest>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ExternalScrapCollectionRequestEdge = {
  __typename?: 'ExternalScrapCollectionRequestEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<ExternalScrapCollectionRequest>
}

export type Freightage =
  | 'add'
  | 'execute'
  | 'manage'
  | 'request'
  | 'show'
  | 'show_past'
  | 'show_recent'

export type InfeasibleReason =
  /** 許可されていない運転手 */
  | 'invalid_driver_employee'
  /** 運転手被り */
  | 'overlap_driver_employee'
  /** トラック被り */
  | 'overlap_truck'

export type Involvement = 'customer' | 'subcontractor'

export type Iso8601DatePeriodInput = {
  end: Scalars['ISO8601Date']
  start: Scalars['ISO8601Date']
}

/** Autogenerated input type of JointUnit */
export type JointUnitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  nextUnitId: Scalars['ID']
}

/** Autogenerated return type of JointUnit */
export type JointUnitPayload = {
  __typename?: 'JointUnitPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  unit: Unit
}

export type LineRelationship = Node & {
  __typename?: 'LineRelationship'
  employee: Employee
  gid: Scalars['ID']
  id: Scalars['ID']
  lineUserId: Scalars['String']
}

export type LoadingEvent = Node & {
  __typename?: 'LoadingEvent'
  address: Scalars['String']
  attachedFiles: AttachedFileConnection
  carTypes: CarTypeConnection
  cargo?: Maybe<Scalars['String']>
  category: Category
  company: Company
  companyRelation: CompanyRelation
  contract: Contract
  /** 契約書状況 */
  contractPaperStatus?: Maybe<ContractPaperStatus>
  createdAt: Scalars['ISO8601DateTime']
  createdEmployee: Employee
  currentState: State
  externalScrapCollectionRequest?: Maybe<ExternalScrapCollectionRequest>
  fixed: Scalars['Boolean']
  gid: Scalars['ID']
  id: Scalars['ID']
  loadingTime: Scalars['EventTime']
  /** マニフェスト */
  manifest: Manifest
  name: Scalars['String']
  note?: Maybe<Scalars['String']>
  /** 作業員数 */
  operatorCount?: Maybe<Scalars['String']>
  relatedCompany: Company
  requestArrivalNote: Scalars['String']
  route?: Maybe<Route>
  salesEmployee: Employee
  staffName?: Maybe<Scalars['String']>
  subContract?: Maybe<Contract>
  tel?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type LoadingEventAttachedFilesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type LoadingEventCarTypesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

/** The connection type for LoadingEvent. */
export type LoadingEventConnection = {
  __typename?: 'LoadingEventConnection'
  /** A list of edges. */
  edges: Array<LoadingEventEdge>
  /** A list of nodes. */
  nodes: Array<LoadingEvent>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type LoadingEventEdge = {
  __typename?: 'LoadingEventEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<LoadingEvent>
}

export type Manifest =
  | 'digital_manifest'
  | 'none_manifest'
  | 'paper_manifest_from_contract'
  | 'paper_manifest_from_us'

export type Mutation = {
  __typename?: 'Mutation'
  /** 排出業者のリクエストを許可する */
  acceptExternalScrapCollectionRequest?: Maybe<AcceptExternalScrapCollectionRequestPayload>
  /** 契約にファイルを添付する */
  attachContractAttachedFile?: Maybe<AttachContractAttachedFilePayload>
  /** 配車イベントにファイルを添付する */
  attachLoadingEventAttachedFile?: Maybe<AttachLoadingEventAttachedFilePayload>
  /** 拠点イベントの所要時間変更 */
  changeCompanySiteEventLoadingTime?: Maybe<ChangeCompanySiteEventLoadingTimePayload>
  /** 従業員の順番を変更する */
  changeEmployeeOrder?: Maybe<ChangeEmployeeOrderPayload>
  /** 従業員のパスワード再設定メールを送信する */
  changeEmployeePassword?: Maybe<ChangeEmployeePasswordPayload>
  /** 配車イベントの確定・未確定を変更する */
  changeLoadingEventFixed?: Maybe<ChangeLoadingEventFixedPayload>
  /** 配車イベントの開始日時(着日時)を変更する */
  changeLoadingEventStartOn?: Maybe<ChangeLoadingEventStartOnPayload>
  /** 配車イベントのステータスを変更する */
  changeLoadingEventState?: Maybe<ChangeLoadingEventStatePayload>
  /** 仮の貨物案件を貨物案件に変更する */
  changeRequestVehicleAllocationEventToUnit?: Maybe<ChangeRequestVehicleAllocationEventToUnitPayload>
  /** ユニットの時刻変更 */
  changeTimeUnit?: Maybe<ChangeTimeUnitPayload>
  /** トラックの順番を変更する */
  changeTruckOrder?: Maybe<ChangeTruckOrderPayload>
  /** ユニットの確定・未確定を変更する */
  changeUnitFixed?: Maybe<ChangeUnitFixedPayload>
  /** 車種を追加する */
  createCarType?: Maybe<CreateCarPayload>
  /** 拠点の追加する */
  createCompanySite?: Maybe<CreateCompanySitePayload>
  /** 契約を追加する */
  createContract?: Maybe<CreateContractPayload>
  /** 契約と顧客を同時に追加する */
  createContractAndRelatedCompany?: Maybe<CreateContractAndRelatedCompanyPayload>
  /** 従業員を追加する */
  createEmployee?: Maybe<CreateEmployeePayload>
  /** 運転手休止イベントを追加する */
  createEventEmployee?: Maybe<CreateEventEmployeePayload>
  /** イベントの繰り返しを設定する */
  createEventRecurring?: Maybe<CreateEventRecurringPayload>
  /** トラック休止イベントを追加する */
  createEventTruck?: Maybe<CreateEventTruckPayload>
  /** 取引先を追加する */
  createRelatedCompany?: Maybe<CreateRelatedCompanyPayload>
  /** 配車を依頼する */
  createRequestVehicleAllocationEvent?: Maybe<CreateRequestVehicleAllocationEventPayload>
  /** 配車予定または仮の配車予定を配車表へ追加する */
  createTemporaryVehicleAllocationEventOrUnit?: Maybe<CreateTemporaryVehicleAllocationEventOrUnitPayload>
  /** トラックを追加する */
  createTruck?: Maybe<CreateTruckPayload>
  /** ユニットの繰り返しを設定する */
  createUnitRecurring?: Maybe<CreateUnitRecurringPayload>
  /** 拠点を削除する */
  destroyCompanySite?: Maybe<DestroyCompanySitePayload>
  /** イベントを削除する */
  destroyEvent?: Maybe<DestroyEventPayload>
  /** 配車イベントを削除する */
  destroyLoadingEvent?: Maybe<DestroyLoadingEventPayload>
  /** ユニットを削除する */
  destroyUnit?: Maybe<DestroyUnitPayload>
  /** 契約を論理削除する */
  disableContract?: Maybe<DisableContractPayload>
  /** 従業員を無効化する */
  disableEmployee?: Maybe<DisableEmployeePayload>
  /** 取引先(の取引関係)を論理削除する */
  disableRelatedCompany?: Maybe<DisableRelatedCompanyPayload>
  /** トラックを無効化する */
  disableTruck?: Maybe<DisableTruckPayload>
  /** イベントを複製する */
  duplicateEvent?: Maybe<DuplicateEventPayload>
  /** ユニットを複製する */
  duplicateUnit?: Maybe<DuplicateUnitPayload>
  /** ユニットを結合する */
  jointUnit?: Maybe<JointUnitPayload>
  /** ユニットの通知を行う */
  noticeUnit?: Maybe<NoticeUnitPayload>
  /** 一時添付ファイルを追加する */
  prepareUploadAttachedFile?: Maybe<PrepareUploadAttachedFilePayload>
  /** ユニットの終端に契約に基づいた配車イベントを作成して装着する */
  pushContractToUnit?: Maybe<PushContractToUnitPayload>
  /** 従業員通知を既読にする */
  readEmployeeNotification?: Maybe<ReadEmployeeNotificationPayload>
  /** リソースの稼働状態を更新する */
  refreshResourceFeasibility?: Maybe<RefreshResourceFeasibilityPayload>
  /** 排出業者のリクエストを許可しない */
  rejectExternalScrapCollectionRequest?: Maybe<RejectExternalScrapCollectionRequestPayload>
  /** 添付ファイルを削除する */
  removeAttachedFile?: Maybe<RemoveAttachedFilePayload>
  /** ユニットを分離する */
  separateUnit?: Maybe<SeparateUnitPayload>
  /** ユニットの始端に契約に基づいた配車イベントを作成して装着する */
  shiftContractToUnit?: Maybe<ShiftContractToUnitPayload>
  /** 拠点を更新する */
  updateCompanySite?: Maybe<UpdateCompanySitePayload>
  /** 契約を更新する */
  updateContract?: Maybe<UpdateContractPayload>
  /** 従業員を更新する */
  updateEmployee?: Maybe<UpdateEmployeePayload>
  /** トラックの運転可能運転手を更新する */
  updateEmployeeDrivableTruck?: Maybe<UpdateEmployeeDrivableTruckPayload>
  /** イベントの変更 */
  updateEvent?: Maybe<UpdateEventPayload>
  /** 運転手休止イベントを編集する */
  updateEventEmployee?: Maybe<UpdateEventEmployeePayload>
  /** トラック休止イベントを更新する */
  updateEventTruck?: Maybe<UpdateEventTruckPayload>
  /** 配車イベントを編集する */
  updateLoadingEvent?: Maybe<UpdateLoadingEventPayload>
  /** 自社のユニットを更新する */
  updateOwnUnit?: Maybe<UpdateOwnUnitPayload>
  /** 取引先を更新する */
  updateRelatedCompany?: Maybe<UpdateRelatedCompanyPayload>
  /** 傭車のユニットを更新する */
  updateSubcontractUnit?: Maybe<UpdateSubcontractUnitPayload>
  /** 仮の配車予定を編集する */
  updateTemporaryVehicleAllocationEvent?: Maybe<UpdateTemporaryVehicleAllocationEventPayload>
  /** トラックを編集する */
  updateTruck?: Maybe<UpdateTruckPayload>
}

export type MutationAcceptExternalScrapCollectionRequestArgs = {
  input: AcceptExternalScrapCollectionRequestInput
}

export type MutationAttachContractAttachedFileArgs = {
  input: AttachContractAttachedFileInput
}

export type MutationAttachLoadingEventAttachedFileArgs = {
  input: AttachLoadingEventAttachedFileInput
}

export type MutationChangeCompanySiteEventLoadingTimeArgs = {
  input: ChangeCompanySiteEventLoadingTimeInput
}

export type MutationChangeEmployeeOrderArgs = {
  input: ChangeEmployeeOrderInput
}

export type MutationChangeEmployeePasswordArgs = {
  input: ChangeEmployeePasswordInput
}

export type MutationChangeLoadingEventFixedArgs = {
  input: ChangeLoadingEventFixedInput
}

export type MutationChangeLoadingEventStartOnArgs = {
  input: ChangeLoadingEventStartOnInput
}

export type MutationChangeLoadingEventStateArgs = {
  input: ChangeLoadingEventStateInput
}

export type MutationChangeRequestVehicleAllocationEventToUnitArgs = {
  input: ChangeRequestVehicleAllocationEventToUnitInput
}

export type MutationChangeTimeUnitArgs = {
  input: ChangeTimeUnitInput
}

export type MutationChangeTruckOrderArgs = {
  input: ChangeTruckOrderInput
}

export type MutationChangeUnitFixedArgs = {
  input: ChangeUnitFixedInput
}

export type MutationCreateCarTypeArgs = {
  input: CreateCarInput
}

export type MutationCreateCompanySiteArgs = {
  input: CreateCompanySiteInput
}

export type MutationCreateContractArgs = {
  input: CreateContractInput
}

export type MutationCreateContractAndRelatedCompanyArgs = {
  input: CreateContractAndRelatedCompanyInput
}

export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput
}

export type MutationCreateEventEmployeeArgs = {
  input: CreateEventEmployeeInput
}

export type MutationCreateEventRecurringArgs = {
  input: CreateEventRecurringInput
}

export type MutationCreateEventTruckArgs = {
  input: CreateEventTruckInput
}

export type MutationCreateRelatedCompanyArgs = {
  input: CreateRelatedCompanyInput
}

export type MutationCreateRequestVehicleAllocationEventArgs = {
  input: CreateRequestVehicleAllocationEventInput
}

export type MutationCreateTemporaryVehicleAllocationEventOrUnitArgs = {
  input: CreateTemporaryVehicleAllocationEventOrUnitInput
}

export type MutationCreateTruckArgs = {
  input: CreateTruckInput
}

export type MutationCreateUnitRecurringArgs = {
  input: CreateUnitRecurringInput
}

export type MutationDestroyCompanySiteArgs = {
  input: DestroyCompanySiteInput
}

export type MutationDestroyEventArgs = {
  input: DestroyEventInput
}

export type MutationDestroyLoadingEventArgs = {
  input: DestroyLoadingEventInput
}

export type MutationDestroyUnitArgs = {
  input: DestroyUnitInput
}

export type MutationDisableContractArgs = {
  input: DisableContractInput
}

export type MutationDisableEmployeeArgs = {
  input: DisableEmployeeInput
}

export type MutationDisableRelatedCompanyArgs = {
  input: DisableRelatedCompanyInput
}

export type MutationDisableTruckArgs = {
  input: DisableTruckInput
}

export type MutationDuplicateEventArgs = {
  input: DuplicateEventInput
}

export type MutationDuplicateUnitArgs = {
  input: DuplicateUnitInput
}

export type MutationJointUnitArgs = {
  input: JointUnitInput
}

export type MutationNoticeUnitArgs = {
  input: NoticeUnitInput
}

export type MutationPrepareUploadAttachedFileArgs = {
  input: PrepareUploadAttachedFileInput
}

export type MutationPushContractToUnitArgs = {
  input: PushContractToUnitInput
}

export type MutationReadEmployeeNotificationArgs = {
  input: ReadEmployeeNotificationInput
}

export type MutationRefreshResourceFeasibilityArgs = {
  input: RefreshResourceFeasibilityInput
}

export type MutationRejectExternalScrapCollectionRequestArgs = {
  input: RejectExternalScrapCollectionRequestInput
}

export type MutationRemoveAttachedFileArgs = {
  input: RemoveAttachedFileInput
}

export type MutationSeparateUnitArgs = {
  input: SeparateUnitInput
}

export type MutationShiftContractToUnitArgs = {
  input: ShiftContractToUnitInput
}

export type MutationUpdateCompanySiteArgs = {
  input: UpdateCompanySiteInput
}

export type MutationUpdateContractArgs = {
  input: UpdateContractInput
}

export type MutationUpdateEmployeeArgs = {
  input: UpdateEmployeeInput
}

export type MutationUpdateEmployeeDrivableTruckArgs = {
  input: UpdateEmployeeDrivableTruckInput
}

export type MutationUpdateEventArgs = {
  input: UpdateEventInput
}

export type MutationUpdateEventEmployeeArgs = {
  input: UpdateEventEmployeeInput
}

export type MutationUpdateEventTruckArgs = {
  input: UpdateEventTruckInput
}

export type MutationUpdateLoadingEventArgs = {
  input: UpdateLoadingEventInput
}

export type MutationUpdateOwnUnitArgs = {
  input: UpdateOwnUnitInput
}

export type MutationUpdateRelatedCompanyArgs = {
  input: UpdateRelatedCompanyInput
}

export type MutationUpdateSubcontractUnitArgs = {
  input: UpdateSubcontractUnitInput
}

export type MutationUpdateTemporaryVehicleAllocationEventArgs = {
  input: UpdateTemporaryVehicleAllocationEventInput
}

export type MutationUpdateTruckArgs = {
  input: UpdateTruckInput
}

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']
}

/** Autogenerated input type of NoticeUnit */
export type NoticeUnitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  employeeId: Scalars['ID']
  unitId: Scalars['ID']
}

/** Autogenerated return type of NoticeUnit */
export type NoticeUnitPayload = {
  __typename?: 'NoticeUnitPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  unit: Unit
}

export type OrderByInput = {
  /** 並び順 */
  direction: OrderDirection
  /** カラム名 */
  field: BaseOrderField
}

export type OrderDirection =
  /** 並び替えを昇順にする */
  | 'ASC'
  /** 並び替えを降順にする */
  | 'DESC'

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>
}

export type PositionType = 'first' | 'last' | 'medium' | 'only'

/** Autogenerated input type of PrepareUploadAttachedFile */
export type PrepareUploadAttachedFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** コンテンツタイプ */
  contentType: Scalars['String']
  /** ファイル名 */
  filename: Scalars['String']
}

/** Autogenerated return type of PrepareUploadAttachedFile */
export type PrepareUploadAttachedFilePayload = {
  __typename?: 'PrepareUploadAttachedFilePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  temporaryAttachedFile: TemporaryAttachedFile
}

export type Priority = 'high' | 'low' | 'medium'

/** Autogenerated input type of PushContractToUnit */
export type PushContractToUnitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  contractId: Scalars['ID']
  id: Scalars['ID']
}

/** Autogenerated return type of PushContractToUnit */
export type PushContractToUnitPayload = {
  __typename?: 'PushContractToUnitPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contract: Contract
  loadingEvent: LoadingEvent
  unit: Unit
}

export type Query = {
  __typename?: 'Query'
  carTypes: CarTypeConnection
  companies: CompanyConnection
  companyRelations: CompanyRelationConnection
  companySites: CompanySiteConnection
  contracts: ContractConnection
  current: Current
  employeeDrivableTrucks: EmployeeDrivableTruckConnection
  employeeNotifications: EmployeeNotificationConnection
  employeeRoles: EmployeeRoleConnection
  employeeUnavailablePeriods: EmployeeUnavailablePeriodConnection
  employees: EmployeeConnection
  eventFeasibilityCheck: EventFeasible
  events: EventConnection
  externalScrapCollectionRequests: ExternalScrapCollectionRequestConnection
  loadingEvents: LoadingEventConnection
  /** Fetches an object given its ID. */
  node?: Maybe<Node>
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>
  routes: RouteConnection
  timelineDriverEmployees: EmployeeConnection
  timelineEmployeeBackgrounds: Array<EmployeeUnavailablePeriod>
  timelineTruckBackgrounds: Array<TruckUnavailablePeriod>
  timelineTrucks: TruckConnection
  truckUnavailablePeriods: TruckUnavailablePeriodConnection
  trucks: TruckConnection
  units: UnitConnection
}

export type QueryCarTypesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

export type QueryCompanyRelationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  involvements?: InputMaybe<Array<Involvement>>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
  text?: InputMaybe<Scalars['String']>
}

export type QueryCompanySitesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

export type QueryContractsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  currentOnly?: InputMaybe<Scalars['Boolean']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  frequent?: InputMaybe<Scalars['Boolean']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  loadingEventOrderBy?: InputMaybe<OrderByInput>
  orderBy?: InputMaybe<OrderByInput>
  text?: InputMaybe<Scalars['String']>
}

export type QueryCurrentArgs = {
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  orderBy?: InputMaybe<OrderByInput>
}

export type QueryEmployeeDrivableTrucksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

export type QueryEmployeeNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

export type QueryEmployeeRolesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  freightageRoles?: InputMaybe<Array<Freightage>>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
  systemSettingRoles?: InputMaybe<Array<SystemSetting>>
}

export type QueryEmployeeUnavailablePeriodsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  date?: InputMaybe<Scalars['ISO8601DateTime']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

export type QueryEmployeesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  freightageRoles?: InputMaybe<Array<Freightage>>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  orderBy?: InputMaybe<OrderByInput>
  systemSettingRoles?: InputMaybe<Array<SystemSetting>>
}

export type QueryEventFeasibilityCheckArgs = {
  input: EventFeasibilityCheckInput
}

export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  date?: InputMaybe<Scalars['ISO8601DateTime']>
  dates?: InputMaybe<Iso8601DatePeriodInput>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

export type QueryExternalScrapCollectionRequestsArgs = {
  accepted?: InputMaybe<Scalars['Boolean']>
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  loadingEventId?: InputMaybe<Scalars['ID']>
  orderBy?: InputMaybe<OrderByInput>
  progresses?: InputMaybe<Scalars['Boolean']>
  rejected?: InputMaybe<Scalars['Boolean']>
}

export type QueryLoadingEventsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  date?: InputMaybe<Scalars['ISO8601Date']>
  disables?: InputMaybe<Scalars['Boolean']>
  employeeIds?: InputMaybe<Array<Scalars['String']>>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
  orderByDate?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<Array<State>>
  text?: InputMaybe<Scalars['String']>
  truckIds?: InputMaybe<Array<Scalars['String']>>
}

export type QueryNodeArgs = {
  id: Scalars['ID']
}

export type QueryNodesArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryRoutesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

export type QueryTimelineDriverEmployeesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  carTypeIds?: InputMaybe<Array<Scalars['ID']>>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type QueryTimelineEmployeeBackgroundsArgs = {
  date?: InputMaybe<Scalars['ISO8601DateTime']>
  dates?: InputMaybe<Iso8601DatePeriodInput>
}

export type QueryTimelineTruckBackgroundsArgs = {
  date?: InputMaybe<Scalars['ISO8601DateTime']>
  dates?: InputMaybe<Iso8601DatePeriodInput>
}

export type QueryTimelineTrucksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  carTypeIds?: InputMaybe<Array<Scalars['ID']>>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type QueryTruckUnavailablePeriodsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  date?: InputMaybe<Scalars['ISO8601DateTime']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

export type QueryTrucksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  carNumber?: InputMaybe<Scalars['String']>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

export type QueryUnitsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  date?: InputMaybe<Scalars['ISO8601DateTime']>
  dates?: InputMaybe<Iso8601DatePeriodInput>
  disables?: InputMaybe<Scalars['Boolean']>
  enables?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  hasManyOrderBy?: InputMaybe<RelationalOrderByInput>
  hasOneOrderBy?: InputMaybe<RelationalOrderByInput>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<OrderByInput>
}

/** Autogenerated input type of ReadEmployeeNotification */
export type ReadEmployeeNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of ReadEmployeeNotification */
export type ReadEmployeeNotificationPayload = {
  __typename?: 'ReadEmployeeNotificationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employeeNotification: EmployeeNotification
}

/** Autogenerated input type of RefreshResourceFeasibility */
export type RefreshResourceFeasibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  endOn: Scalars['ISO8601DateTime']
  startOn: Scalars['ISO8601DateTime']
}

/** Autogenerated return type of RefreshResourceFeasibility */
export type RefreshResourceFeasibilityPayload = {
  __typename?: 'RefreshResourceFeasibilityPayload'
  asyncStatus: AsyncStatus
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated input type of RejectExternalScrapCollectionRequest */
export type RejectExternalScrapCollectionRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  externalScrapCollectionRequestId: Scalars['ID']
}

/** Autogenerated return type of RejectExternalScrapCollectionRequest */
export type RejectExternalScrapCollectionRequestPayload = {
  __typename?: 'RejectExternalScrapCollectionRequestPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  externalScrapCollectionRequest: ExternalScrapCollectionRequest
}

export type RelationalOrderByInput = {
  /** 並び順 */
  direction: OrderDirection
  /** カラム名 */
  field: BaseOrderField
  /** 関連テーブル指定 */
  relationalTable: Scalars['String']
}

/** Autogenerated input type of RemoveAttachedFile */
export type RemoveAttachedFileInput = {
  /** 添付ファイルID */
  attachedFileId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of RemoveAttachedFile */
export type RemoveAttachedFilePayload = {
  __typename?: 'RemoveAttachedFilePayload'
  attachment: Attachment
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

export type RequestVehicleAllocationEventDetailInput = {
  /** 住所 */
  address?: InputMaybe<Scalars['String']>
  /** 荷物 */
  cargo?: InputMaybe<Scalars['String']>
  /** カテゴリ */
  category?: InputMaybe<Category>
  /** 取引関係(既存時) */
  companyRelationId?: InputMaybe<Scalars['ID']>
  /** 契約(既存時) */
  contractId?: InputMaybe<Scalars['ID']>
  /** 契約書状況 */
  contractPaperStatus?: InputMaybe<ContractPaperStatus>
  /** 所要時間 */
  loadingTime?: InputMaybe<Scalars['Int']>
  /** マニフェスト */
  manifest?: InputMaybe<Manifest>
  /** 現場名 */
  name: Scalars['String']
  /** メモ */
  note?: InputMaybe<Scalars['String']>
  /** 作業員数 */
  operatorCount?: InputMaybe<Scalars['String']>
  /** 顧客名(新規時) */
  relatedCompanyName?: InputMaybe<Scalars['String']>
  /** 希望到着日付条件 */
  requestArrivalDates?: InputMaybe<Array<Scalars['ISO8601Date']>>
  /** 希望到着時刻条件 */
  requestArrivalTime?: InputMaybe<Scalars['String']>
  /** 希望車種条件 */
  requestCarTypeIds?: InputMaybe<Array<Scalars['ID']>>
  /** 営業担当者 */
  salesEmployeeId?: InputMaybe<Scalars['ID']>
  /** 先方担当者名 */
  staffName?: InputMaybe<Scalars['String']>
  /** 下ろし場所または荷受け契約 */
  subContractId?: InputMaybe<Scalars['ID']>
  /** 先方連絡先 */
  tel?: InputMaybe<Scalars['String']>
}

export type Route = Node & {
  __typename?: 'Route'
  createdAt: Scalars['ISO8601DateTime']
  /** 終了日時 */
  endOn: Scalars['ISO8601DateTime']
  /** 終了時刻 */
  endTime: Scalars['EventTime']
  event: RouteEvent
  eventOrder: Scalars['Int']
  gid: Scalars['ID']
  id: Scalars['ID']
  /** 所要時間 */
  loadingTime: Scalars['EventTime']
  order: Scalars['Int']
  /** ユニット作成時の終了日時 */
  originalEndOn: Scalars['ISO8601DateTime']
  /** ユニット作成時の終了時刻 */
  originalEndTime: Scalars['EventTime']
  /** ユニット作成時の所要時間 */
  originalLoadingTime: Scalars['EventTime']
  /** ユニット作成時の開始日時 */
  originalStartOn: Scalars['ISO8601DateTime']
  /** ユニット作成時の開始時刻 */
  originalStartTime: Scalars['EventTime']
  positionType: PositionType
  /** 開始日時 */
  startOn: Scalars['ISO8601DateTime']
  /** 開始時刻 */
  startTime: Scalars['EventTime']
  unit: Unit
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for Route. */
export type RouteConnection = {
  __typename?: 'RouteConnection'
  /** A list of edges. */
  edges: Array<RouteEdge>
  /** A list of nodes. */
  nodes: Array<Route>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type RouteEdge = {
  __typename?: 'RouteEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<Route>
}

export type RouteEvent = CompanySiteEvent | LoadingEvent | TransferEvent

/** Autogenerated input type of SeparateUnit */
export type SeparateUnitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  loadingEventOrder: Scalars['Int']
}

/** Autogenerated return type of SeparateUnit */
export type SeparateUnitPayload = {
  __typename?: 'SeparateUnitPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  newUnit: Unit
  unit: Unit
}

/** Autogenerated input type of ShiftContractToUnit */
export type ShiftContractToUnitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  contractId: Scalars['ID']
  id: Scalars['ID']
}

/** Autogenerated return type of ShiftContractToUnit */
export type ShiftContractToUnitPayload = {
  __typename?: 'ShiftContractToUnitPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contract: Contract
  loadingEvent: LoadingEvent
  unit: Unit
}

export type State = 'approving' | 'cancelled' | 'conditional' | 'confirmed' | 'no_condition'

export type Subscription = {
  __typename?: 'Subscription'
  /** ユーザの状況が変更された通知 */
  currentUpdate: CurrentUpdatePayload
  /** 所属会社のイベントが更新されたことを通知 */
  eventCreate: EventCreatePayload
  /** 所属会社のイベントが更新されたことを通知 */
  eventDestroy: EventDestroyPayload
  /** 所属会社のイベントが更新されたことを通知 */
  eventUpdate: EventUpdatePayload
  /** 配車表関連のデータが更新されたことを通知する */
  timelineUpdate: TimelineUpdatePayload
  /** 所属会社のユニットが更新されたことを通知 */
  unitCreate: UnitCreatePayload
  /** 所属会社のユニットが更新されたことを通知 */
  unitDestroy: UnitDestroyPayload
  /** 所属会社のユニットが更新されたことを通知 */
  unitUpdate: UnitUpdatePayload
}

export type SubscriptionEventUpdateArgs = {
  id: Scalars['ID']
}

export type SubscriptionUnitUpdateArgs = {
  id: Scalars['ID']
}

export type SystemSetting = 'manage'

export type TemporaryAttachedFile = Node & {
  __typename?: 'TemporaryAttachedFile'
  contentType: Scalars['String']
  createdAt: Scalars['ISO8601DateTime']
  employee: Company
  filename: Scalars['String']
  gid: Scalars['ID']
  id: Scalars['ID']
  originalFilename: Scalars['String']
  updatedAt: Scalars['ISO8601DateTime']
  uploadSignedUrl: Scalars['String']
}

export type TemporaryVehicleAllocationEventDetailInput = {
  /** 住所 */
  address?: InputMaybe<Scalars['String']>
  /** 荷物 */
  cargo?: InputMaybe<Scalars['String']>
  /** カテゴリ */
  category?: InputMaybe<Category>
  /** 取引関係(既存時) */
  companyRelationId?: InputMaybe<Scalars['ID']>
  /** 契約(既存時) */
  contractId?: InputMaybe<Scalars['ID']>
  /** 契約書状況 */
  contractPaperStatus?: InputMaybe<ContractPaperStatus>
  /** 所要時間 */
  loadingTime?: InputMaybe<Scalars['Int']>
  /** マニフェスト */
  manifest?: InputMaybe<Manifest>
  /** 現場名 */
  name: Scalars['String']
  /** 終了拠点での所要時間 */
  nextCompanySiteEventTime?: InputMaybe<Scalars['Int']>
  /** メモ */
  note?: InputMaybe<Scalars['String']>
  /** 作業員数 */
  operatorCount?: InputMaybe<Scalars['String']>
  /** 開始拠点での所要時間 */
  prevCompanySiteEventTime?: InputMaybe<Scalars['Int']>
  /** 顧客名(新規時) */
  relatedCompanyName?: InputMaybe<Scalars['String']>
  /** 希望到着日付条件 */
  requestArrivalDates?: InputMaybe<Array<Scalars['ISO8601Date']>>
  /** 希望到着時刻条件 */
  requestArrivalTime?: InputMaybe<Scalars['String']>
  /** 希望車種条件 */
  requestCarTypeIds?: InputMaybe<Array<Scalars['ID']>>
  /** 営業担当者 */
  salesEmployeeId?: InputMaybe<Scalars['ID']>
  /** 先方担当者名 */
  staffName?: InputMaybe<Scalars['String']>
  /** 下ろし場所または荷受け契約 */
  subContractId?: InputMaybe<Scalars['ID']>
  /** 先方連絡先 */
  tel?: InputMaybe<Scalars['String']>
}

export type TemporaryVehicleAllocationEventInput = {
  /** 履行する従業員 */
  employeeId?: InputMaybe<Scalars['ID']>
  /** 開始日付 */
  startDate: Scalars['ISO8601Date']
  /** 開始時刻 */
  startTime: Scalars['EventTime']
  /** 履行するトラック */
  truckId?: InputMaybe<Scalars['ID']>
}

export type TemporaryVehicleAllocationEventOptionInput = {
  /** 承認済であるか否か */
  confirmed?: InputMaybe<Scalars['Boolean']>
  /** 高速道路を使用するか */
  fast?: InputMaybe<Scalars['Boolean']>
  /** 必ずユニットにする必要があるか */
  onlyUnitable?: InputMaybe<Scalars['Boolean']>
}

export type TemporaryVehicleAllocationEventOrUnitInput = {
  /** 到着日付 */
  arrivalDate: Scalars['ISO8601Date']
  /** 到着時刻 */
  arrivalTime: Scalars['EventTime']
  /** 履行する従業員 */
  employeeId?: InputMaybe<Scalars['ID']>
  /** 履行するトラック */
  truckId?: InputMaybe<Scalars['ID']>
}

/** Autogenerated return type of TimelineUpdate */
export type TimelineUpdatePayload = {
  __typename?: 'TimelineUpdatePayload'
  events: EventConnection
  units: UnitConnection
}

/** Autogenerated return type of TimelineUpdate */
export type TimelineUpdatePayloadEventsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

/** Autogenerated return type of TimelineUpdate */
export type TimelineUpdatePayloadUnitsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type TransferEvent = Node & {
  __typename?: 'TransferEvent'
  createdAt: Scalars['ISO8601DateTime']
  fast: Scalars['Boolean']
  gid: Scalars['ID']
  id: Scalars['ID']
  route: Route
  /** 最低移動分数 */
  travelTime: Scalars['EventTime']
  updatedAt: Scalars['ISO8601DateTime']
}

export type Truck = Node & {
  __typename?: 'Truck'
  carNumber: Scalars['String']
  carType: CarType
  company: Company
  companySite: CompanySite
  createdAt: Scalars['ISO8601DateTime']
  employeeDrivableTrucks: EmployeeDrivableTruckConnection
  gid: Scalars['ID']
  id: Scalars['ID']
  note?: Maybe<Scalars['String']>
  order?: Maybe<Scalars['Int']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type TruckEmployeeDrivableTrucksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

/** The connection type for Truck. */
export type TruckConnection = {
  __typename?: 'TruckConnection'
  /** A list of edges. */
  edges: Array<TruckEdge>
  /** A list of nodes. */
  nodes: Array<Truck>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type TruckEdge = {
  __typename?: 'TruckEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<Truck>
}

export type TruckUnavailablePeriod = Node & {
  __typename?: 'TruckUnavailablePeriod'
  createdAt: Scalars['ISO8601DateTime']
  endOn: Scalars['ISO8601DateTime']
  gid: Scalars['ID']
  id: Scalars['ID']
  startOn: Scalars['ISO8601DateTime']
  truck?: Maybe<Truck>
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for TruckUnavailablePeriod. */
export type TruckUnavailablePeriodConnection = {
  __typename?: 'TruckUnavailablePeriodConnection'
  /** A list of edges. */
  edges: Array<TruckUnavailablePeriodEdge>
  /** A list of nodes. */
  nodes: Array<TruckUnavailablePeriod>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type TruckUnavailablePeriodEdge = {
  __typename?: 'TruckUnavailablePeriodEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<TruckUnavailablePeriod>
}

export type Unit = Node & {
  __typename?: 'Unit'
  createdAt: Scalars['ISO8601DateTime']
  driverEmployee?: Maybe<Employee>
  endOn: Scalars['ISO8601DateTime']
  endTime: Scalars['EventTime']
  feasible: Scalars['Boolean']
  fixed: Scalars['Boolean']
  gid: Scalars['ID']
  id: Scalars['ID']
  infeasibles: Array<UnitInfeasible>
  nextUnit?: Maybe<Unit>
  own: Scalars['Boolean']
  routes: RouteConnection
  startOn: Scalars['ISO8601DateTime']
  startTime: Scalars['EventTime']
  subcontractor?: Maybe<CompanyRelation>
  truck?: Maybe<Truck>
  updatedAt: Scalars['ISO8601DateTime']
}

export type UnitRoutesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

/** The connection type for Unit. */
export type UnitConnection = {
  __typename?: 'UnitConnection'
  /** A list of edges. */
  edges: Array<UnitEdge>
  /** A list of nodes. */
  nodes: Array<Unit>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of UnitCreate */
export type UnitCreatePayload = {
  __typename?: 'UnitCreatePayload'
  unit?: Maybe<Unit>
}

/** Autogenerated return type of UnitDestroy */
export type UnitDestroyPayload = {
  __typename?: 'UnitDestroyPayload'
  destroiedUnitId?: Maybe<Scalars['ID']>
}

/** An edge in a connection. */
export type UnitEdge = {
  __typename?: 'UnitEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<Unit>
}

export type UnitInfeasible = Node & {
  __typename?: 'UnitInfeasible'
  createdAt: Scalars['ISO8601DateTime']
  gid: Scalars['ID']
  id: Scalars['ID']
  /** 実行不可の理由 */
  reason: InfeasibleReason
  unit: Unit
  updatedAt: Scalars['ISO8601DateTime']
}

/** Autogenerated return type of UnitUpdate */
export type UnitUpdatePayload = {
  __typename?: 'UnitUpdatePayload'
  unit?: Maybe<Unit>
}

/** Autogenerated input type of UpdateCompanySite */
export type UpdateCompanySiteInput = {
  address?: InputMaybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  endTime?: InputMaybe<Scalars['EventTime']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  startTime?: InputMaybe<Scalars['EventTime']>
  tel?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of UpdateCompanySite */
export type UpdateCompanySitePayload = {
  __typename?: 'UpdateCompanySitePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  companySite: CompanySite
}

/** Autogenerated input type of UpdateContract */
export type UpdateContractInput = {
  address?: InputMaybe<Scalars['String']>
  carTypeIds?: InputMaybe<Array<Scalars['ID']>>
  cargo?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Category>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  companyRelationId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  loadingTime?: InputMaybe<Scalars['EventTime']>
  name?: InputMaybe<Scalars['String']>
  note?: InputMaybe<Scalars['String']>
  salesEmployeeId?: InputMaybe<Scalars['ID']>
  staffName?: InputMaybe<Scalars['String']>
  tel?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of UpdateContract */
export type UpdateContractPayload = {
  __typename?: 'UpdateContractPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contract: Contract
}

/** Autogenerated input type of UpdateEmployeeDrivableTruck */
export type UpdateEmployeeDrivableTruckInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 運転可能運転手 */
  drivers: Array<EmployeeDrivableTruckInput>
  /** トラック */
  id: Scalars['ID']
}

/** Autogenerated return type of UpdateEmployeeDrivableTruck */
export type UpdateEmployeeDrivableTruckPayload = {
  __typename?: 'UpdateEmployeeDrivableTruckPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  truck: Truck
}

/** Autogenerated input type of UpdateEmployee */
export type UpdateEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  companySiteId: Scalars['ID']
  email?: InputMaybe<Scalars['String']>
  employeeRoleId: Scalars['ID']
  enableEmailNotification?: InputMaybe<Scalars['Boolean']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  tel?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of UpdateEmployee */
export type UpdateEmployeePayload = {
  __typename?: 'UpdateEmployeePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee: Employee
}

/** Autogenerated input type of UpdateEventEmployee */
export type UpdateEventEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 従業員 */
  employeeId?: InputMaybe<Scalars['ID']>
  /** 終了日 */
  endOn?: InputMaybe<Scalars['ISO8601Date']>
  /** 終了時刻 */
  endTime?: InputMaybe<Scalars['EventTime']>
  id: Scalars['ID']
  /** メモ */
  note?: InputMaybe<Scalars['String']>
  /** 理由 */
  reasonType?: InputMaybe<EventEmployeeReasonType>
  /** 開始日 */
  startOn?: InputMaybe<Scalars['ISO8601Date']>
  /** 開始時刻 */
  startTime?: InputMaybe<Scalars['EventTime']>
}

/** Autogenerated return type of UpdateEventEmployee */
export type UpdateEventEmployeePayload = {
  __typename?: 'UpdateEventEmployeePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  event: Event
}

/** Autogenerated input type of UpdateEvent */
export type UpdateEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  employeeId?: InputMaybe<Scalars['ID']>
  /** 終了日時 */
  endOn: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  /** 開始日時 */
  startOn: Scalars['ISO8601DateTime']
  truckId?: InputMaybe<Scalars['ID']>
}

/** Autogenerated return type of UpdateEvent */
export type UpdateEventPayload = {
  __typename?: 'UpdateEventPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  event: Event
}

/** Autogenerated input type of UpdateEventTruck */
export type UpdateEventTruckInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 終了日 */
  endOn?: InputMaybe<Scalars['ISO8601Date']>
  /** 終了時刻 */
  endTime?: InputMaybe<Scalars['EventTime']>
  id: Scalars['ID']
  /** メモ */
  note?: InputMaybe<Scalars['String']>
  /** 理由 */
  reasonType?: InputMaybe<EventTruckReasonType>
  /** 開始日 */
  startOn?: InputMaybe<Scalars['ISO8601Date']>
  /** 開始時刻 */
  startTime?: InputMaybe<Scalars['EventTime']>
  /** トラック */
  truckId?: InputMaybe<Scalars['ID']>
}

/** Autogenerated return type of UpdateEventTruck */
export type UpdateEventTruckPayload = {
  __typename?: 'UpdateEventTruckPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  event: Event
}

/** Autogenerated input type of UpdateLoadingEvent */
export type UpdateLoadingEventInput = {
  address?: InputMaybe<Scalars['String']>
  cargo?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Category>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 契約書状況 */
  contractPaperStatus?: InputMaybe<ContractPaperStatus>
  id: Scalars['ID']
  /** 所要時間 */
  loadingTime?: InputMaybe<Scalars['EventTime']>
  /** マニフェスト */
  manifest?: InputMaybe<Manifest>
  name?: InputMaybe<Scalars['String']>
  note?: InputMaybe<Scalars['String']>
  /** 作業員数 */
  operatorCount?: InputMaybe<Scalars['String']>
  requestArrivalNote?: InputMaybe<Scalars['String']>
  /** 希望車種条件 */
  requestCarTypeIds?: InputMaybe<Array<Scalars['ID']>>
  staffName?: InputMaybe<Scalars['String']>
  subContractId?: InputMaybe<Scalars['ID']>
  tel?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of UpdateLoadingEvent */
export type UpdateLoadingEventPayload = {
  __typename?: 'UpdateLoadingEventPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  loadingEvent: LoadingEvent
}

/** Autogenerated input type of UpdateOwnUnit */
export type UpdateOwnUnitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  driverEmployeeId: Scalars['ID']
  id: Scalars['ID']
  startOn: Scalars['ISO8601DateTime']
  truckId: Scalars['ID']
}

/** Autogenerated return type of UpdateOwnUnit */
export type UpdateOwnUnitPayload = {
  __typename?: 'UpdateOwnUnitPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  unit: Unit
}

/** Autogenerated input type of UpdateRelatedCompany */
export type UpdateRelatedCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  companyRelationId: Scalars['ID']
  involvement: Involvement
  name: Scalars['String']
  tel?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of UpdateRelatedCompany */
export type UpdateRelatedCompanyPayload = {
  __typename?: 'UpdateRelatedCompanyPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  companyRelation: CompanyRelation
  relatedCompany: Company
}

/** Autogenerated input type of UpdateSubcontractUnit */
export type UpdateSubcontractUnitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  startOn: Scalars['ISO8601DateTime']
  subcontractorId: Scalars['ID']
}

/** Autogenerated return type of UpdateSubcontractUnit */
export type UpdateSubcontractUnitPayload = {
  __typename?: 'UpdateSubcontractUnitPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  unit: Unit
}

/** Autogenerated input type of UpdateTemporaryVehicleAllocationEvent */
export type UpdateTemporaryVehicleAllocationEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  event: TemporaryVehicleAllocationEventInput
  eventDetail: TemporaryVehicleAllocationEventDetailInput
  eventOption?: InputMaybe<TemporaryVehicleAllocationEventOptionInput>
  id: Scalars['ID']
}

/** Autogenerated return type of UpdateTemporaryVehicleAllocationEvent */
export type UpdateTemporaryVehicleAllocationEventPayload = {
  __typename?: 'UpdateTemporaryVehicleAllocationEventPayload'
  basedContract?: Maybe<Scalars['Boolean']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  event?: Maybe<Event>
  unit?: Maybe<Unit>
}

/** Autogenerated input type of UpdateTruck */
export type UpdateTruckInput = {
  carNumber?: InputMaybe<Scalars['String']>
  carTypeId?: InputMaybe<Scalars['ID']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  companySiteId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  note?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of UpdateTruck */
export type UpdateTruckPayload = {
  __typename?: 'UpdateTruckPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  truck: Truck
}

export type ContainerCompaniesCompanyDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>
}>

export type ContainerCompaniesCompanyDetailQuery = {
  __typename?: 'Query'
  companyRelations: {
    __typename?: 'CompanyRelationConnection'
    nodes: Array<{
      __typename?: 'CompanyRelation'
      id: string
      involvement: Involvement
      relatedCompany: {
        __typename?: 'Company'
        id: string
        name: string
        tel?: string | null | undefined
      }
      contracts: {
        __typename?: 'ContractConnection'
        nodes: Array<{
          __typename?: 'Contract'
          id: string
          name: string
          address: string
          category: Category
        }>
      }
    }>
  }
}

export type ContainerCompanyEditUpdateRelatedCompanyMutationVariables = Exact<{
  input: UpdateRelatedCompanyInput
}>

export type ContainerCompanyEditUpdateRelatedCompanyMutation = {
  __typename?: 'Mutation'
  updateRelatedCompany?:
    | {
        __typename?: 'UpdateRelatedCompanyPayload'
        companyRelation: {
          __typename?: 'CompanyRelation'
          id: string
          involvement: Involvement
          relatedCompany: {
            __typename?: 'Company'
            id: string
            name: string
            tel?: string | null | undefined
          }
        }
      }
    | null
    | undefined
}

export type ContainerCompanyEditDisableRelatedCompanyMutationVariables = Exact<{
  input: DisableRelatedCompanyInput
}>

export type ContainerCompanyEditDisableRelatedCompanyMutation = {
  __typename?: 'Mutation'
  disableRelatedCompany?:
    | {
        __typename?: 'DisableRelatedCompanyPayload'
        companyRelation: {
          __typename?: 'CompanyRelation'
          id: string
          involvement: Involvement
          relatedCompany: {
            __typename?: 'Company'
            id: string
            name: string
            tel?: string | null | undefined
          }
        }
      }
    | null
    | undefined
}

export type ContainerCompanyEditQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>
}>

export type ContainerCompanyEditQuery = {
  __typename?: 'Query'
  companyRelations: {
    __typename?: 'CompanyRelationConnection'
    nodes: Array<{
      __typename?: 'CompanyRelation'
      id: string
      involvement: Involvement
      relatedCompany: {
        __typename?: 'Company'
        id: string
        name: string
        tel?: string | null | undefined
      }
    }>
  }
}

export type ContainerCompaniesCompanyFilterQueryVariables = Exact<{
  text?: InputMaybe<Scalars['String']>
  after?: InputMaybe<Scalars['String']>
  first: Scalars['Int']
}>

export type ContainerCompaniesCompanyFilterQuery = {
  __typename?: 'Query'
  companyRelations: {
    __typename?: 'CompanyRelationConnection'
    edges: Array<{
      __typename?: 'CompanyRelationEdge'
      node?:
        | {
            __typename?: 'CompanyRelation'
            id: string
            involvement: Involvement
            relatedCompany: {
              __typename?: 'Company'
              id: string
              name: string
              tel?: string | null | undefined
            }
          }
        | null
        | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
}

export type ContainerCompanyNewCreateRelatedCompanyMutationVariables = Exact<{
  input: CreateRelatedCompanyInput
}>

export type ContainerCompanyNewCreateRelatedCompanyMutation = {
  __typename?: 'Mutation'
  createRelatedCompany?:
    | {
        __typename?: 'CreateRelatedCompanyPayload'
        companyRelation: {
          __typename?: 'CompanyRelation'
          id: string
          involvement: Involvement
          relatedCompany: {
            __typename?: 'Company'
            id: string
            name: string
            tel?: string | null | undefined
          }
        }
      }
    | null
    | undefined
}

export type ContainerContractDetailPrepareUploadAttachedFileMutationVariables = Exact<{
  input: PrepareUploadAttachedFileInput
}>

export type ContainerContractDetailPrepareUploadAttachedFileMutation = {
  __typename?: 'Mutation'
  prepareUploadAttachedFile?:
    | {
        __typename?: 'PrepareUploadAttachedFilePayload'
        temporaryAttachedFile: {
          __typename?: 'TemporaryAttachedFile'
          id: string
          filename: string
          originalFilename: string
          contentType: string
          uploadSignedUrl: string
          createdAt: any
        }
      }
    | null
    | undefined
}

export type ContainerContractDetailAttachContractAttachedFileMutationVariables = Exact<{
  input: AttachContractAttachedFileInput
}>

export type ContainerContractDetailAttachContractAttachedFileMutation = {
  __typename?: 'Mutation'
  attachContractAttachedFile?:
    | {
        __typename?: 'AttachContractAttachedFilePayload'
        attachedFile: {
          __typename?: 'AttachedFile'
          id: string
          originalFilename: string
          downloadSignedUrl: string
          createdAt: any
        }
        contract: {
          __typename?: 'Contract'
          id: string
          name: string
          staffName?: string | null | undefined
          tel?: string | null | undefined
          address: string
          loadingTime: any
          cargo?: string | null | undefined
          note?: string | null | undefined
          category: Category
          attachedFiles: {
            __typename?: 'AttachedFileConnection'
            nodes: Array<{
              __typename?: 'AttachedFile'
              id: string
              downloadSignedUrl: string
              originalFilename: string
              filename: string
              createdAt: any
              employee: { __typename?: 'Company'; name: string }
            }>
          }
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{ __typename?: 'CarType'; id: string; name: string }>
          }
          salesEmployee: { __typename?: 'Employee'; name: string }
          relatedCompany: { __typename?: 'Company'; id: string; name: string }
          loadingEvents: {
            __typename?: 'LoadingEventConnection'
            nodes: Array<{
              __typename?: 'LoadingEvent'
              id: string
              loadingTime: any
              route?:
                | {
                    __typename?: 'Route'
                    id: string
                    startOn: any
                    endOn: any
                    unit: {
                      __typename?: 'Unit'
                      truck?:
                        | {
                            __typename?: 'Truck'
                            carType: { __typename?: 'CarType'; name: string }
                          }
                        | null
                        | undefined
                      driverEmployee?: { __typename?: 'Employee'; name: string } | null | undefined
                    }
                  }
                | null
                | undefined
            }>
          }
        }
      }
    | null
    | undefined
}

export type ContainerContractDetailRemoveAttachedFileMutationVariables = Exact<{
  input: RemoveAttachedFileInput
}>

export type ContainerContractDetailRemoveAttachedFileMutation = {
  __typename?: 'Mutation'
  removeAttachedFile?:
    | {
        __typename?: 'RemoveAttachedFilePayload'
        attachment:
          | {
              __typename?: 'Contract'
              id: string
              name: string
              staffName?: string | null | undefined
              tel?: string | null | undefined
              address: string
              loadingTime: any
              cargo?: string | null | undefined
              note?: string | null | undefined
              category: Category
              attachedFiles: {
                __typename?: 'AttachedFileConnection'
                nodes: Array<{
                  __typename?: 'AttachedFile'
                  id: string
                  downloadSignedUrl: string
                  originalFilename: string
                  filename: string
                  createdAt: any
                  employee: { __typename?: 'Company'; name: string }
                }>
              }
              carTypes: {
                __typename?: 'CarTypeConnection'
                nodes: Array<{ __typename?: 'CarType'; id: string; name: string }>
              }
              salesEmployee: { __typename?: 'Employee'; name: string }
              relatedCompany: { __typename?: 'Company'; id: string; name: string }
              loadingEvents: {
                __typename?: 'LoadingEventConnection'
                nodes: Array<{
                  __typename?: 'LoadingEvent'
                  id: string
                  loadingTime: any
                  route?:
                    | {
                        __typename?: 'Route'
                        id: string
                        startOn: any
                        endOn: any
                        unit: {
                          __typename?: 'Unit'
                          truck?:
                            | {
                                __typename?: 'Truck'
                                carType: { __typename?: 'CarType'; name: string }
                              }
                            | null
                            | undefined
                          driverEmployee?:
                            | { __typename?: 'Employee'; name: string }
                            | null
                            | undefined
                        }
                      }
                    | null
                    | undefined
                }>
              }
            }
          | { __typename?: 'LoadingEvent' }
      }
    | null
    | undefined
}

export type ContainerContractsContractDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>
}>

export type ContainerContractsContractDetailQuery = {
  __typename?: 'Query'
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      staffName?: string | null | undefined
      tel?: string | null | undefined
      address: string
      loadingTime: any
      cargo?: string | null | undefined
      note?: string | null | undefined
      category: Category
      attachedFiles: {
        __typename?: 'AttachedFileConnection'
        nodes: Array<{
          __typename?: 'AttachedFile'
          id: string
          downloadSignedUrl: string
          originalFilename: string
          filename: string
          createdAt: any
          employee: { __typename?: 'Company'; name: string }
        }>
      }
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{ __typename?: 'CarType'; id: string; name: string }>
      }
      salesEmployee: { __typename?: 'Employee'; name: string }
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
      loadingEvents: {
        __typename?: 'LoadingEventConnection'
        nodes: Array<{
          __typename?: 'LoadingEvent'
          id: string
          loadingTime: any
          route?:
            | {
                __typename?: 'Route'
                id: string
                startOn: any
                endOn: any
                unit: {
                  __typename?: 'Unit'
                  truck?:
                    | { __typename?: 'Truck'; carType: { __typename?: 'CarType'; name: string } }
                    | null
                    | undefined
                  driverEmployee?: { __typename?: 'Employee'; name: string } | null | undefined
                }
              }
            | null
            | undefined
        }>
      }
    }>
  }
}

export type ContainerContractUpdateContractMutationVariables = Exact<{
  input: UpdateContractInput
}>

export type ContainerContractUpdateContractMutation = {
  __typename?: 'Mutation'
  updateContract?:
    | {
        __typename?: 'UpdateContractPayload'
        contract: {
          __typename?: 'Contract'
          id: string
          name: string
          address: string
          loadingTime: any
          category: Category
          cargo?: string | null | undefined
          note?: string | null | undefined
          staffName?: string | null | undefined
          tel?: string | null | undefined
          companyRelation: { __typename?: 'CompanyRelation'; id: string }
          salesEmployee: {
            __typename?: 'Employee'
            id: string
            name: string
            email: string
            tel?: string | null | undefined
            employeeRole?:
              | {
                  __typename?: 'EmployeeRole'
                  id: string
                  freightage: Array<Freightage>
                  systemSetting: Array<SystemSetting>
                }
              | null
              | undefined
          }
          company: { __typename?: 'Company'; id: string; name: string }
          relatedCompany: { __typename?: 'Company'; id: string; name: string }
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{ __typename?: 'CarType'; id: string; name: string }>
          }
        }
      }
    | null
    | undefined
}

export type ContainerContractDisableContractMutationVariables = Exact<{
  input: DisableContractInput
}>

export type ContainerContractDisableContractMutation = {
  __typename?: 'Mutation'
  disableContract?:
    | { __typename?: 'DisableContractPayload'; contract: { __typename?: 'Contract'; id: string } }
    | null
    | undefined
}

export type ContainerContractEditQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type ContainerContractEditQuery = {
  __typename?: 'Query'
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      address: string
      loadingTime: any
      category: Category
      cargo?: string | null | undefined
      note?: string | null | undefined
      staffName?: string | null | undefined
      tel?: string | null | undefined
      companyRelation: { __typename?: 'CompanyRelation'; id: string }
      salesEmployee: {
        __typename?: 'Employee'
        id: string
        name: string
        email: string
        tel?: string | null | undefined
        employeeRole?:
          | {
              __typename?: 'EmployeeRole'
              id: string
              freightage: Array<Freightage>
              systemSetting: Array<SystemSetting>
            }
          | null
          | undefined
      }
      company: { __typename?: 'Company'; id: string; name: string }
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{ __typename?: 'CarType'; id: string; name: string }>
      }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  salesEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      email: string
      tel?: string | null | undefined
      employeeRole?:
        | {
            __typename?: 'EmployeeRole'
            id: string
            freightage: Array<Freightage>
            systemSetting: Array<SystemSetting>
          }
        | null
        | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  companyRelations: {
    __typename?: 'CompanyRelationConnection'
    nodes: Array<{
      __typename?: 'CompanyRelation'
      id: string
      involvement: Involvement
      company: { __typename?: 'Company'; id: string; name: string }
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
}

export type ContainerContractsFilterQueryVariables = Exact<{
  text?: InputMaybe<Scalars['String']>
  after?: InputMaybe<Scalars['String']>
  first: Scalars['Int']
}>

export type ContainerContractsFilterQuery = {
  __typename?: 'Query'
  contracts: {
    __typename?: 'ContractConnection'
    edges: Array<{
      __typename?: 'ContractEdge'
      node?:
        | {
            __typename?: 'Contract'
            id: string
            name: string
            category: Category
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
          }
        | null
        | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
}

export type ContainerContractNewCreateContractMutationVariables = Exact<{
  input: CreateContractInput
}>

export type ContainerContractNewCreateContractMutation = {
  __typename?: 'Mutation'
  createContract?:
    | {
        __typename?: 'CreateContractPayload'
        contract: { __typename?: 'Contract'; id: string; name: string }
      }
    | null
    | undefined
}

export type ContainerContractNewCreateContractAndRelatedCompanyMutationVariables = Exact<{
  input: CreateContractAndRelatedCompanyInput
}>

export type ContainerContractNewCreateContractAndRelatedCompanyMutation = {
  __typename?: 'Mutation'
  createContractAndRelatedCompany?:
    | {
        __typename?: 'CreateContractAndRelatedCompanyPayload'
        contract: { __typename?: 'Contract'; id: string; name: string }
        companyRelation: {
          __typename?: 'CompanyRelation'
          id: string
          involvement: Involvement
          company: { __typename?: 'Company'; id: string; name: string }
          relatedCompany: { __typename?: 'Company'; id: string; name: string }
        }
      }
    | null
    | undefined
}

export type ContainerContractNewQueryVariables = Exact<{ [key: string]: never }>

export type ContainerContractNewQuery = {
  __typename?: 'Query'
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  salesEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      email: string
      tel?: string | null | undefined
      employeeRole?:
        | {
            __typename?: 'EmployeeRole'
            id: string
            freightage: Array<Freightage>
            systemSetting: Array<SystemSetting>
          }
        | null
        | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  companyRelations: {
    __typename?: 'CompanyRelationConnection'
    nodes: Array<{
      __typename?: 'CompanyRelation'
      id: string
      involvement: Involvement
      company: { __typename?: 'Company'; id: string; name: string }
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
}

export type EmployeeDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>
}>

export type EmployeeDetailQuery = {
  __typename?: 'Query'
  employees: {
    __typename?: 'EmployeeConnection'
    edges: Array<{
      __typename?: 'EmployeeEdge'
      node?:
        | {
            __typename?: 'Employee'
            id: string
            name: string
            tel?: string | null | undefined
            email: string
            emailVerifiedAt?: any | null | undefined
            enableEmailNotification: boolean
            employeeRole?:
              | { __typename?: 'EmployeeRole'; id: string; name: string }
              | null
              | undefined
            companySite: { __typename?: 'CompanySite'; id: string; name: string }
            lineRelationship?: { __typename?: 'LineRelationship'; id: string } | null | undefined
          }
        | null
        | undefined
    }>
  }
}

export type ChangeEmployeeOrderMutationVariables = Exact<{
  input: ChangeEmployeeOrderInput
}>

export type ChangeEmployeeOrderMutation = {
  __typename?: 'Mutation'
  changeEmployeeOrder?:
    | { __typename?: 'ChangeEmployeeOrderPayload'; clientMutationId?: string | null | undefined }
    | null
    | undefined
}

export type ContainerEmployeesFilterQueryVariables = Exact<{ [key: string]: never }>

export type ContainerEmployeesFilterQuery = {
  __typename?: 'Query'
  employees: {
    __typename?: 'EmployeeConnection'
    edges: Array<{
      __typename?: 'EmployeeEdge'
      node?:
        | {
            __typename?: 'Employee'
            id: string
            name: string
            order?: number | null | undefined
            emailVerifiedAt?: any | null | undefined
            lineRelationship?:
              | { __typename?: 'LineRelationship'; id: string; gid: string }
              | null
              | undefined
            companySite: { __typename?: 'CompanySite'; id: string; name: string }
          }
        | null
        | undefined
    }>
  }
}

export type CreateEmployeeMutationVariables = Exact<{
  input: CreateEmployeeInput
}>

export type CreateEmployeeMutation = {
  __typename?: 'Mutation'
  createEmployee?:
    | { __typename?: 'CreateEmployeePayload'; employee: { __typename?: 'Employee'; id: string } }
    | null
    | undefined
}

export type UpdateEmployeeMutationVariables = Exact<{
  input: UpdateEmployeeInput
}>

export type UpdateEmployeeMutation = {
  __typename?: 'Mutation'
  updateEmployee?:
    | {
        __typename?: 'UpdateEmployeePayload'
        employee: {
          __typename?: 'Employee'
          id: string
          name: string
          tel?: string | null | undefined
          email: string
          emailVerifiedAt?: any | null | undefined
          enableEmailNotification: boolean
          employeeRole?:
            | { __typename?: 'EmployeeRole'; id: string; name: string }
            | null
            | undefined
          companySite: { __typename?: 'CompanySite'; id: string; name: string }
          lineRelationship?: { __typename?: 'LineRelationship'; id: string } | null | undefined
        }
      }
    | null
    | undefined
}

export type DisableEmployeeMutationVariables = Exact<{
  input: DisableEmployeeInput
}>

export type DisableEmployeeMutation = {
  __typename?: 'Mutation'
  disableEmployee?:
    | {
        __typename?: 'DisableEmployeePayload'
        employee: { __typename?: 'Employee'; id: string; name: string }
      }
    | null
    | undefined
}

export type EmployeeNewCompanySiteFragment = {
  __typename?: 'CompanySite'
  id: string
  name: string
}

export type EmployeeNewEmployeeRoleFragment = {
  __typename?: 'EmployeeRole'
  id: string
  name: string
}

export type ContainerEmployeeNewQueryVariables = Exact<{ [key: string]: never }>

export type ContainerEmployeeNewQuery = {
  __typename?: 'Query'
  companySites: {
    __typename?: 'CompanySiteConnection'
    nodes: Array<{ __typename?: 'CompanySite'; id: string; name: string }>
  }
  employeeRoles: {
    __typename?: 'EmployeeRoleConnection'
    nodes: Array<{ __typename?: 'EmployeeRole'; id: string; name: string }>
  }
}

export type ContainerEventUpdateEmployeeEventMutationVariables = Exact<{
  input: UpdateEventEmployeeInput
}>

export type ContainerEventUpdateEmployeeEventMutation = {
  __typename?: 'Mutation'
  updateEventEmployee?:
    | {
        __typename?: 'UpdateEventEmployeePayload'
        event:
          | {
              __typename?: 'EventEmployee'
              id: string
              startOn: any
              startTime: any
              endOn: any
              endTime: any
              createdAt: any
              updatedAt: any
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                  }
                | null
                | undefined
              createEmployee: {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
              }
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventEmployeeDetail'
                id: string
                note?: string | null | undefined
                employeeReasonType: EventEmployeeReasonType
              }
            }
          | { __typename?: 'EventTemporaryVehicleAllocation' }
          | { __typename?: 'EventTruck' }
      }
    | null
    | undefined
}

export type ContainerEventUpdateMutationVariables = Exact<{
  input: UpdateTemporaryVehicleAllocationEventInput
}>

export type ContainerEventUpdateMutation = {
  __typename?: 'Mutation'
  updateTemporaryVehicleAllocationEvent?:
    | {
        __typename?: 'UpdateTemporaryVehicleAllocationEventPayload'
        basedContract?: boolean | null | undefined
        unit?:
          | {
              __typename?: 'Unit'
              id: string
              routes: {
                __typename?: 'RouteConnection'
                nodes: Array<{
                  __typename?: 'Route'
                  id: string
                  event:
                    | { __typename?: 'CompanySiteEvent' }
                    | {
                        __typename?: 'LoadingEvent'
                        id: string
                        name: string
                        staffName?: string | null | undefined
                        tel?: string | null | undefined
                        address: string
                        loadingTime: any
                        cargo?: string | null | undefined
                        note?: string | null | undefined
                        category: Category
                        contract: { __typename?: 'Contract'; id: string }
                        salesEmployee: { __typename?: 'Employee'; id: string }
                      }
                    | { __typename?: 'TransferEvent' }
                }>
              }
            }
          | null
          | undefined
        event?:
          | { __typename?: 'EventEmployee' }
          | {
              __typename?: 'EventTemporaryVehicleAllocation'
              id: string
              startOn: any
              startTime: any
              endOn: any
              endTime: any
              createdAt: any
              updatedAt: any
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                  }
                | null
                | undefined
              createEmployee: {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
              }
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventTemporaryVehicleAllocationDetail'
                id: string
                name: string
                address?: string | null | undefined
                category?: Category | null | undefined
                loadingTime?: any | null | undefined
                cargo?: string | null | undefined
                note?: string | null | undefined
                manifest: Manifest
                operatorCount?: string | null | undefined
                contractPaperStatus?: ContractPaperStatus | null | undefined
                relatedCompanyName?: string | null | undefined
                requestArrivalTime?: string | null | undefined
                staffName?: string | null | undefined
                tel?: string | null | undefined
                prevCompanySiteEventTime?: any | null | undefined
                nextCompanySiteEventTime?: any | null | undefined
                requestCarTypes: {
                  __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarTypeConnection'
                  nodes: Array<{
                    __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarType'
                    carType: { __typename?: 'CarType'; id: string }
                  }>
                }
                requestArrivals: {
                  __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrivalConnection'
                  nodes: Array<{
                    __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrival'
                    date: any
                  }>
                }
                companyRelation?: { __typename?: 'CompanyRelation'; id: string } | null | undefined
                contract?:
                  | {
                      __typename?: 'Contract'
                      id: string
                      carTypes: {
                        __typename?: 'CarTypeConnection'
                        nodes: Array<{ __typename?: 'CarType'; id: string }>
                      }
                    }
                  | null
                  | undefined
                subContract?:
                  | {
                      __typename?: 'Contract'
                      id: string
                      name: string
                      address: string
                      category: Category
                      companyRelation: {
                        __typename?: 'CompanyRelation'
                        id: string
                        relatedCompany: { __typename?: 'Company'; id: string; name: string }
                      }
                    }
                  | null
                  | undefined
                salesEmployee?: { __typename?: 'Employee'; id: string } | null | undefined
              }
            }
          | { __typename?: 'EventTruck' }
          | null
          | undefined
      }
    | null
    | undefined
}

export type ContainerEventDetailOverwriteContractMutationVariables = Exact<{
  input: UpdateContractInput
}>

export type ContainerEventDetailOverwriteContractMutation = {
  __typename?: 'Mutation'
  updateContract?:
    | {
        __typename?: 'UpdateContractPayload'
        contract: {
          __typename?: 'Contract'
          id: string
          name: string
          category: Category
          address: string
          loadingTime: any
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{
              __typename?: 'CarType'
              id: string
              name: string
              order?: number | null | undefined
            }>
          }
          salesEmployee: { __typename?: 'Employee'; id: string; name: string }
          companyRelation: {
            __typename?: 'CompanyRelation'
            id: string
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
          }
        }
      }
    | null
    | undefined
}

export type ContainerEventUpdateTruckEventMutationVariables = Exact<{
  input: UpdateEventTruckInput
}>

export type ContainerEventUpdateTruckEventMutation = {
  __typename?: 'Mutation'
  updateEventTruck?:
    | {
        __typename?: 'UpdateEventTruckPayload'
        event:
          | { __typename?: 'EventEmployee' }
          | { __typename?: 'EventTemporaryVehicleAllocation' }
          | {
              __typename?: 'EventTruck'
              id: string
              startOn: any
              startTime: any
              endOn: any
              endTime: any
              createdAt: any
              updatedAt: any
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                  }
                | null
                | undefined
              createEmployee: {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
              }
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventTruckDetail'
                id: string
                note?: string | null | undefined
                truckReasonType: EventTruckReasonType
              }
            }
      }
    | null
    | undefined
}

export type ContainerEventDestroyMutationVariables = Exact<{
  input: DestroyEventInput
}>

export type ContainerEventDestroyMutation = {
  __typename?: 'Mutation'
  destroyEvent?:
    | {
        __typename?: 'DestroyEventPayload'
        event:
          | { __typename?: 'EventEmployee'; id: string }
          | { __typename?: 'EventTemporaryVehicleAllocation'; id: string }
          | { __typename?: 'EventTruck'; id: string }
      }
    | null
    | undefined
}

export type ContainerEventDetailQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type ContainerEventDetailQuery = {
  __typename?: 'Query'
  events: {
    __typename?: 'EventConnection'
    nodes?:
      | Array<
          | {
              __typename?: 'EventEmployee'
              id: string
              startOn: any
              startTime: any
              endOn: any
              endTime: any
              createdAt: any
              updatedAt: any
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                  }
                | null
                | undefined
              createEmployee: {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
              }
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventEmployeeDetail'
                id: string
                note?: string | null | undefined
                employeeReasonType: EventEmployeeReasonType
              }
            }
          | {
              __typename?: 'EventTemporaryVehicleAllocation'
              id: string
              startOn: any
              startTime: any
              endOn: any
              endTime: any
              createdAt: any
              updatedAt: any
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                  }
                | null
                | undefined
              createEmployee: {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
              }
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventTemporaryVehicleAllocationDetail'
                id: string
                name: string
                address?: string | null | undefined
                category?: Category | null | undefined
                loadingTime?: any | null | undefined
                cargo?: string | null | undefined
                note?: string | null | undefined
                manifest: Manifest
                operatorCount?: string | null | undefined
                contractPaperStatus?: ContractPaperStatus | null | undefined
                relatedCompanyName?: string | null | undefined
                requestArrivalTime?: string | null | undefined
                staffName?: string | null | undefined
                tel?: string | null | undefined
                prevCompanySiteEventTime?: any | null | undefined
                nextCompanySiteEventTime?: any | null | undefined
                requestCarTypes: {
                  __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarTypeConnection'
                  nodes: Array<{
                    __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarType'
                    carType: { __typename?: 'CarType'; id: string }
                  }>
                }
                requestArrivals: {
                  __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrivalConnection'
                  nodes: Array<{
                    __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrival'
                    date: any
                  }>
                }
                companyRelation?: { __typename?: 'CompanyRelation'; id: string } | null | undefined
                contract?:
                  | {
                      __typename?: 'Contract'
                      id: string
                      carTypes: {
                        __typename?: 'CarTypeConnection'
                        nodes: Array<{ __typename?: 'CarType'; id: string }>
                      }
                    }
                  | null
                  | undefined
                subContract?:
                  | {
                      __typename?: 'Contract'
                      id: string
                      name: string
                      address: string
                      category: Category
                      companyRelation: {
                        __typename?: 'CompanyRelation'
                        id: string
                        relatedCompany: { __typename?: 'Company'; id: string; name: string }
                      }
                    }
                  | null
                  | undefined
                salesEmployee?: { __typename?: 'Employee'; id: string } | null | undefined
              }
            }
          | {
              __typename?: 'EventTruck'
              id: string
              startOn: any
              startTime: any
              endOn: any
              endTime: any
              createdAt: any
              updatedAt: any
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                  }
                | null
                | undefined
              createEmployee: {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
              }
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventTruckDetail'
                id: string
                note?: string | null | undefined
                truckReasonType: EventTruckReasonType
              }
            }
          | null
          | undefined
        >
      | null
      | undefined
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      category: Category
      address: string
      loadingTime: any
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }>
      }
      salesEmployee: { __typename?: 'Employee'; id: string; name: string }
      companyRelation: {
        __typename?: 'CompanyRelation'
        id: string
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    }>
  }
  companyRelations: {
    __typename?: 'CompanyRelationConnection'
    nodes: Array<{
      __typename?: 'CompanyRelation'
      id: string
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
    }>
  }
  salesEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  driverEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  trucks: {
    __typename?: 'TruckConnection'
    nodes: Array<{
      __typename?: 'Truck'
      id: string
      carNumber: string
      order?: number | null | undefined
      carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
    }>
  }
  employeeDrivableTrucks: {
    __typename?: 'EmployeeDrivableTruckConnection'
    nodes: Array<{
      __typename?: 'EmployeeDrivableTruck'
      id: string
      priority: Priority
      employee: { __typename?: 'Employee'; id: string }
      truck: { __typename?: 'Truck'; id: string }
    }>
  }
}

export type ContainerEventDetailContractsQueryVariables = Exact<{
  text: Scalars['String']
}>

export type ContainerEventDetailContractsQuery = {
  __typename?: 'Query'
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      category: Category
      address: string
      loadingTime: any
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }>
      }
      salesEmployee: { __typename?: 'Employee'; id: string; name: string }
      companyRelation: {
        __typename?: 'CompanyRelation'
        id: string
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    }>
  }
}

export type ContainerEventNewEventEmployeeMutationVariables = Exact<{
  input: CreateEventEmployeeInput
}>

export type ContainerEventNewEventEmployeeMutation = {
  __typename?: 'Mutation'
  createEventEmployee?:
    | {
        __typename?: 'CreateEventEmployeePayload'
        event:
          | {
              __typename?: 'EventEmployee'
              id: string
              startOn: any
              startTime: any
              endOn: any
              endTime: any
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                  }
                | null
                | undefined
              createEmployee: {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
              }
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventEmployeeDetail'
                id: string
                note?: string | null | undefined
                employeeReasonType: EventEmployeeReasonType
              }
            }
          | { __typename?: 'EventTemporaryVehicleAllocation' }
          | { __typename?: 'EventTruck' }
      }
    | null
    | undefined
}

export type ContainerEventNewEmployeeQueryVariables = Exact<{ [key: string]: never }>

export type ContainerEventNewEmployeeQuery = {
  __typename?: 'Query'
  driverEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
}

export type ContainerEventNewExternalScrapCollectionRequestCreateMutationVariables = Exact<{
  input: CreateTemporaryVehicleAllocationEventOrUnitInput
}>

export type ContainerEventNewExternalScrapCollectionRequestCreateMutation = {
  __typename?: 'Mutation'
  createTemporaryVehicleAllocationEventOrUnit?:
    | {
        __typename?: 'CreateTemporaryVehicleAllocationEventOrUnitPayload'
        basedContract?: boolean | null | undefined
        unit?:
          | {
              __typename?: 'Unit'
              id: string
              startOn: any
              routes: {
                __typename?: 'RouteConnection'
                nodes: Array<{
                  __typename?: 'Route'
                  id: string
                  event:
                    | { __typename?: 'CompanySiteEvent' }
                    | {
                        __typename?: 'LoadingEvent'
                        id: string
                        name: string
                        staffName?: string | null | undefined
                        tel?: string | null | undefined
                        address: string
                        loadingTime: any
                        cargo?: string | null | undefined
                        note?: string | null | undefined
                        category: Category
                        contract: { __typename?: 'Contract'; id: string }
                        salesEmployee: { __typename?: 'Employee'; id: string }
                      }
                    | { __typename?: 'TransferEvent' }
                }>
              }
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutationVariables =
  Exact<{
    input: UpdateContractInput
  }>

export type ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutation = {
  __typename?: 'Mutation'
  updateContract?:
    | {
        __typename?: 'UpdateContractPayload'
        contract: {
          __typename?: 'Contract'
          id: string
          name: string
          category: Category
          address: string
          loadingTime: any
          cargo?: string | null | undefined
          note?: string | null | undefined
          tel?: string | null | undefined
          staffName?: string | null | undefined
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{
              __typename?: 'CarType'
              id: string
              name: string
              order?: number | null | undefined
            }>
          }
          salesEmployee: { __typename?: 'Employee'; id: string; name: string }
          companyRelation: {
            __typename?: 'CompanyRelation'
            id: string
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
          }
        }
      }
    | null
    | undefined
}

export type ContainerEventNewExternalScrapCollectionRequestAcceptMutationVariables = Exact<{
  input: AcceptExternalScrapCollectionRequestInput
}>

export type ContainerEventNewExternalScrapCollectionRequestAcceptMutation = {
  __typename?: 'Mutation'
  acceptExternalScrapCollectionRequest?:
    | {
        __typename?: 'AcceptExternalScrapCollectionRequestPayload'
        externalScrapCollectionRequest: {
          __typename?: 'ExternalScrapCollectionRequest'
          id: string
          requesterName: string
          requesterCompanyName: string
          requesterEmail: string
          requesterPhone: string
          siteName: string
          siteAddress: string
          cargoDetails: string
          desiredPickupDate: string
          desiredPickupPeriod: DesiredPickupPeriod
          numberOfTrucks: number
          kindOfTruck: string
          siteContactName?: string | null | undefined
          siteContactPhone?: string | null | undefined
          comment?: string | null | undefined
          acceptedAt?: any | null | undefined
          rejectedAt?: any | null | undefined
          createdAt: any
          updatedAt: any
          estimatedContracts: {
            __typename?: 'ContractConnection'
            nodes: Array<{
              __typename?: 'Contract'
              id: string
              name: string
              category: Category
              address: string
              loadingTime: any
              cargo?: string | null | undefined
              note?: string | null | undefined
              tel?: string | null | undefined
              staffName?: string | null | undefined
              carTypes: {
                __typename?: 'CarTypeConnection'
                nodes: Array<{
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }>
              }
              salesEmployee: { __typename?: 'Employee'; id: string; name: string }
              companyRelation: {
                __typename?: 'CompanyRelation'
                id: string
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            }>
          }
        }
      }
    | null
    | undefined
}

export type ContainerEventNewExternalScrapCollectionRequestRejectMutationVariables = Exact<{
  input: RejectExternalScrapCollectionRequestInput
}>

export type ContainerEventNewExternalScrapCollectionRequestRejectMutation = {
  __typename?: 'Mutation'
  rejectExternalScrapCollectionRequest?:
    | {
        __typename?: 'RejectExternalScrapCollectionRequestPayload'
        externalScrapCollectionRequest: {
          __typename?: 'ExternalScrapCollectionRequest'
          id: string
          requesterName: string
          requesterCompanyName: string
          requesterEmail: string
          requesterPhone: string
          siteName: string
          siteAddress: string
          cargoDetails: string
          desiredPickupDate: string
          desiredPickupPeriod: DesiredPickupPeriod
          numberOfTrucks: number
          kindOfTruck: string
          siteContactName?: string | null | undefined
          siteContactPhone?: string | null | undefined
          comment?: string | null | undefined
          acceptedAt?: any | null | undefined
          rejectedAt?: any | null | undefined
          createdAt: any
          updatedAt: any
          estimatedContracts: {
            __typename?: 'ContractConnection'
            nodes: Array<{
              __typename?: 'Contract'
              id: string
              name: string
              category: Category
              address: string
              loadingTime: any
              cargo?: string | null | undefined
              note?: string | null | undefined
              tel?: string | null | undefined
              staffName?: string | null | undefined
              carTypes: {
                __typename?: 'CarTypeConnection'
                nodes: Array<{
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }>
              }
              salesEmployee: { __typename?: 'Employee'; id: string; name: string }
              companyRelation: {
                __typename?: 'CompanyRelation'
                id: string
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            }>
          }
        }
      }
    | null
    | undefined
}

export type ContainerEventNewExternalScrapCollectionRequestDetailQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type ContainerEventNewExternalScrapCollectionRequestDetailQuery = {
  __typename?: 'Query'
  externalScrapCollectionRequests: {
    __typename?: 'ExternalScrapCollectionRequestConnection'
    nodes: Array<{
      __typename?: 'ExternalScrapCollectionRequest'
      id: string
      requesterName: string
      requesterCompanyName: string
      requesterEmail: string
      requesterPhone: string
      siteName: string
      siteAddress: string
      cargoDetails: string
      desiredPickupDate: string
      desiredPickupPeriod: DesiredPickupPeriod
      numberOfTrucks: number
      kindOfTruck: string
      siteContactName?: string | null | undefined
      siteContactPhone?: string | null | undefined
      comment?: string | null | undefined
      acceptedAt?: any | null | undefined
      rejectedAt?: any | null | undefined
      createdAt: any
      updatedAt: any
      estimatedContracts: {
        __typename?: 'ContractConnection'
        nodes: Array<{
          __typename?: 'Contract'
          id: string
          name: string
          category: Category
          address: string
          loadingTime: any
          cargo?: string | null | undefined
          note?: string | null | undefined
          tel?: string | null | undefined
          staffName?: string | null | undefined
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{
              __typename?: 'CarType'
              id: string
              name: string
              order?: number | null | undefined
            }>
          }
          salesEmployee: { __typename?: 'Employee'; id: string; name: string }
          companyRelation: {
            __typename?: 'CompanyRelation'
            id: string
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
          }
        }>
      }
    }>
  }
  salesEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  driverEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  trucks: {
    __typename?: 'TruckConnection'
    nodes: Array<{
      __typename?: 'Truck'
      id: string
      order?: number | null | undefined
      carNumber: string
      carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
    }>
  }
  employeeDrivableTrucks: {
    __typename?: 'EmployeeDrivableTruckConnection'
    nodes: Array<{
      __typename?: 'EmployeeDrivableTruck'
      id: string
      priority: Priority
      employee: { __typename?: 'Employee'; id: string }
      truck: { __typename?: 'Truck'; id: string }
    }>
  }
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      category: Category
      address: string
      loadingTime: any
      cargo?: string | null | undefined
      note?: string | null | undefined
      tel?: string | null | undefined
      staffName?: string | null | undefined
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }>
      }
      salesEmployee: { __typename?: 'Employee'; id: string; name: string }
      companyRelation: {
        __typename?: 'CompanyRelation'
        id: string
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    }>
  }
  companyRelations: {
    __typename?: 'CompanyRelationConnection'
    nodes: Array<{
      __typename?: 'CompanyRelation'
      id: string
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
    }>
  }
}

export type ContainerEventNewExternalScrapCollectionRequestContractsQueryVariables = Exact<{
  text: Scalars['String']
}>

export type ContainerEventNewExternalScrapCollectionRequestContractsQuery = {
  __typename?: 'Query'
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      category: Category
      address: string
      loadingTime: any
      cargo?: string | null | undefined
      note?: string | null | undefined
      tel?: string | null | undefined
      staffName?: string | null | undefined
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }>
      }
      salesEmployee: { __typename?: 'Employee'; id: string; name: string }
      companyRelation: {
        __typename?: 'CompanyRelation'
        id: string
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    }>
  }
}

export type ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQueryVariables = Exact<{
  input: EventFeasibilityCheckInput
}>

export type ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQuery = {
  __typename?: 'Query'
  eventFeasibilityCheck: {
    __typename?: 'EventFeasible'
    feasible: boolean
    truckUnavailablePeriods: Array<{ __typename?: 'TruckUnavailablePeriod'; id: string }>
    employeeUnavailablePeriods: Array<{ __typename?: 'EmployeeUnavailablePeriod'; id: string }>
  }
}

export type ContainerEventNewEventTruckMutationVariables = Exact<{
  input: CreateEventTruckInput
}>

export type ContainerEventNewEventTruckMutation = {
  __typename?: 'Mutation'
  createEventTruck?:
    | {
        __typename?: 'CreateEventTruckPayload'
        event:
          | { __typename?: 'EventEmployee' }
          | { __typename?: 'EventTemporaryVehicleAllocation' }
          | {
              __typename?: 'EventTruck'
              id: string
              startOn: any
              startTime: any
              endOn: any
              endTime: any
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                  }
                | null
                | undefined
              createEmployee: {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
              }
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventTruckDetail'
                id: string
                note?: string | null | undefined
                truckReasonType: EventTruckReasonType
              }
            }
      }
    | null
    | undefined
}

export type ContainerEventNewTruckQueryVariables = Exact<{ [key: string]: never }>

export type ContainerEventNewTruckQuery = {
  __typename?: 'Query'
  driverEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  trucks: {
    __typename?: 'TruckConnection'
    nodes: Array<{
      __typename?: 'Truck'
      id: string
      order?: number | null | undefined
      carNumber: string
      carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
    }>
  }
}

export type ContainerEventNewCreateMutationVariables = Exact<{
  input: CreateTemporaryVehicleAllocationEventOrUnitInput
}>

export type ContainerEventNewCreateMutation = {
  __typename?: 'Mutation'
  createTemporaryVehicleAllocationEventOrUnit?:
    | {
        __typename?: 'CreateTemporaryVehicleAllocationEventOrUnitPayload'
        basedContract?: boolean | null | undefined
        unit?:
          | {
              __typename?: 'Unit'
              id: string
              startOn: any
              routes: {
                __typename?: 'RouteConnection'
                nodes: Array<{
                  __typename?: 'Route'
                  id: string
                  event:
                    | { __typename?: 'CompanySiteEvent' }
                    | {
                        __typename?: 'LoadingEvent'
                        id: string
                        name: string
                        staffName?: string | null | undefined
                        tel?: string | null | undefined
                        address: string
                        loadingTime: any
                        cargo?: string | null | undefined
                        note?: string | null | undefined
                        category: Category
                        contract: { __typename?: 'Contract'; id: string }
                        salesEmployee: { __typename?: 'Employee'; id: string }
                      }
                    | { __typename?: 'TransferEvent' }
                }>
              }
            }
          | null
          | undefined
        event?:
          | { __typename?: 'EventEmployee' }
          | {
              __typename?: 'EventTemporaryVehicleAllocation'
              id: string
              startOn: any
              startTime: any
              endOn: any
              endTime: any
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                  }
                | null
                | undefined
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    order?: number | null | undefined
                    carNumber: string
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventTemporaryVehicleAllocationDetail'
                id: string
                name: string
                address?: string | null | undefined
                category?: Category | null | undefined
                loadingTime?: any | null | undefined
                cargo?: string | null | undefined
                note?: string | null | undefined
                manifest: Manifest
                operatorCount?: string | null | undefined
                contractPaperStatus?: ContractPaperStatus | null | undefined
                relatedCompanyName?: string | null | undefined
                requestArrivalTime?: string | null | undefined
                staffName?: string | null | undefined
                tel?: string | null | undefined
                requestCarTypes: {
                  __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarTypeConnection'
                  nodes: Array<{
                    __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarType'
                    carType: { __typename?: 'CarType'; id: string }
                  }>
                }
                requestArrivals: {
                  __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrivalConnection'
                  nodes: Array<{
                    __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrival'
                    date: any
                  }>
                }
                companyRelation?: { __typename?: 'CompanyRelation'; id: string } | null | undefined
                contract?:
                  | {
                      __typename?: 'Contract'
                      id: string
                      carTypes: {
                        __typename?: 'CarTypeConnection'
                        nodes: Array<{ __typename?: 'CarType'; id: string }>
                      }
                    }
                  | null
                  | undefined
                salesEmployee?: { __typename?: 'Employee'; id: string } | null | undefined
              }
            }
          | { __typename?: 'EventTruck' }
          | null
          | undefined
      }
    | null
    | undefined
}

export type ContainerEventNewOverwriteContractMutationVariables = Exact<{
  input: UpdateContractInput
}>

export type ContainerEventNewOverwriteContractMutation = {
  __typename?: 'Mutation'
  updateContract?:
    | {
        __typename?: 'UpdateContractPayload'
        contract: {
          __typename?: 'Contract'
          id: string
          name: string
          category: Category
          address: string
          loadingTime: any
          cargo?: string | null | undefined
          note?: string | null | undefined
          tel?: string | null | undefined
          staffName?: string | null | undefined
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{
              __typename?: 'CarType'
              id: string
              name: string
              order?: number | null | undefined
            }>
          }
          salesEmployee: { __typename?: 'Employee'; id: string; name: string }
          companyRelation: {
            __typename?: 'CompanyRelation'
            id: string
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
          }
        }
      }
    | null
    | undefined
}

export type ContainerEventNewVehicleAllocationQueryVariables = Exact<{ [key: string]: never }>

export type ContainerEventNewVehicleAllocationQuery = {
  __typename?: 'Query'
  salesEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  driverEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  trucks: {
    __typename?: 'TruckConnection'
    nodes: Array<{
      __typename?: 'Truck'
      id: string
      order?: number | null | undefined
      carNumber: string
      carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
    }>
  }
  employeeDrivableTrucks: {
    __typename?: 'EmployeeDrivableTruckConnection'
    nodes: Array<{
      __typename?: 'EmployeeDrivableTruck'
      id: string
      priority: Priority
      employee: { __typename?: 'Employee'; id: string }
      truck: { __typename?: 'Truck'; id: string }
    }>
  }
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      category: Category
      address: string
      loadingTime: any
      cargo?: string | null | undefined
      note?: string | null | undefined
      tel?: string | null | undefined
      staffName?: string | null | undefined
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }>
      }
      salesEmployee: { __typename?: 'Employee'; id: string; name: string }
      companyRelation: {
        __typename?: 'CompanyRelation'
        id: string
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    }>
  }
  companyRelations: {
    __typename?: 'CompanyRelationConnection'
    nodes: Array<{
      __typename?: 'CompanyRelation'
      id: string
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
    }>
  }
}

export type ContainerEventNewVehicleAllocationContractsQueryVariables = Exact<{
  text: Scalars['String']
}>

export type ContainerEventNewVehicleAllocationContractsQuery = {
  __typename?: 'Query'
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      category: Category
      address: string
      loadingTime: any
      cargo?: string | null | undefined
      note?: string | null | undefined
      tel?: string | null | undefined
      staffName?: string | null | undefined
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }>
      }
      salesEmployee: { __typename?: 'Employee'; id: string; name: string }
      companyRelation: {
        __typename?: 'CompanyRelation'
        id: string
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    }>
  }
}

export type ContainerEventNewVehicleAllocationEventFeasibilityCheckQueryVariables = Exact<{
  input: EventFeasibilityCheckInput
}>

export type ContainerEventNewVehicleAllocationEventFeasibilityCheckQuery = {
  __typename?: 'Query'
  eventFeasibilityCheck: {
    __typename?: 'EventFeasible'
    feasible: boolean
    truckUnavailablePeriods: Array<{ __typename?: 'TruckUnavailablePeriod'; id: string }>
    employeeUnavailablePeriods: Array<{ __typename?: 'EmployeeUnavailablePeriod'; id: string }>
  }
}

export type ContainerEventRequestCreateMutationVariables = Exact<{
  input: CreateRequestVehicleAllocationEventInput
}>

export type ContainerEventRequestCreateMutation = {
  __typename?: 'Mutation'
  createRequestVehicleAllocationEvent?:
    | {
        __typename?: 'CreateRequestVehicleAllocationEventPayload'
        basedContract: boolean
        loadingEvents: Array<{
          __typename?: 'LoadingEvent'
          id: string
          name: string
          address: string
          staffName?: string | null | undefined
          tel?: string | null | undefined
          requestArrivalNote: string
          cargo?: string | null | undefined
          note?: string | null | undefined
          manifest: Manifest
          operatorCount?: string | null | undefined
          contractPaperStatus?: ContractPaperStatus | null | undefined
          category: Category
          currentState: State
          loadingTime: any
          contract: {
            __typename?: 'Contract'
            id: string
            carTypes: {
              __typename?: 'CarTypeConnection'
              nodes: Array<{ __typename?: 'CarType'; id: string; name: string }>
            }
          }
          route?:
            | {
                __typename?: 'Route'
                id: string
                order: number
                eventOrder: number
                loadingTime: any
                startOn: any
                endOn: any
                positionType: PositionType
                unit: {
                  __typename?: 'Unit'
                  id: string
                  startOn: any
                  endOn: any
                  startTime: any
                  endTime: any
                }
              }
            | null
            | undefined
          company: { __typename?: 'Company'; id: string; name: string }
          relatedCompany: { __typename?: 'Company'; id: string; name: string }
          salesEmployee: { __typename?: 'Employee'; id: string; name: string }
          createdEmployee: { __typename?: 'Employee'; id: string; name: string }
          attachedFiles: {
            __typename?: 'AttachedFileConnection'
            nodes: Array<{
              __typename?: 'AttachedFile'
              id: string
              originalFilename: string
              downloadSignedUrl: string
              createdAt: any
            }>
          }
        }>
      }
    | null
    | undefined
}

export type ContainerEventRequestOverwriteContractMutationVariables = Exact<{
  input: UpdateContractInput
}>

export type ContainerEventRequestOverwriteContractMutation = {
  __typename?: 'Mutation'
  updateContract?:
    | {
        __typename?: 'UpdateContractPayload'
        contract: {
          __typename?: 'Contract'
          id: string
          name: string
          category: Category
          address: string
          loadingTime: any
          cargo?: string | null | undefined
          note?: string | null | undefined
          tel?: string | null | undefined
          staffName?: string | null | undefined
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{
              __typename?: 'CarType'
              id: string
              name: string
              order?: number | null | undefined
            }>
          }
          salesEmployee: { __typename?: 'Employee'; id: string; name: string }
          companyRelation: {
            __typename?: 'CompanyRelation'
            id: string
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
          }
        }
      }
    | null
    | undefined
}

export type ContainerEventRequestQueryVariables = Exact<{ [key: string]: never }>

export type ContainerEventRequestQuery = {
  __typename?: 'Query'
  salesEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  driverEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  trucks: {
    __typename?: 'TruckConnection'
    nodes: Array<{
      __typename?: 'Truck'
      id: string
      order?: number | null | undefined
      carNumber: string
      carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
    }>
  }
  employeeDrivableTrucks: {
    __typename?: 'EmployeeDrivableTruckConnection'
    nodes: Array<{
      __typename?: 'EmployeeDrivableTruck'
      id: string
      priority: Priority
      employee: { __typename?: 'Employee'; id: string }
      truck: { __typename?: 'Truck'; id: string }
    }>
  }
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      category: Category
      address: string
      loadingTime: any
      cargo?: string | null | undefined
      note?: string | null | undefined
      tel?: string | null | undefined
      staffName?: string | null | undefined
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }>
      }
      salesEmployee: { __typename?: 'Employee'; id: string; name: string }
      companyRelation: {
        __typename?: 'CompanyRelation'
        id: string
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    }>
  }
  companyRelations: {
    __typename?: 'CompanyRelationConnection'
    nodes: Array<{
      __typename?: 'CompanyRelation'
      id: string
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
    }>
  }
}

export type ContainerEventRequestContractsQueryVariables = Exact<{
  text: Scalars['String']
}>

export type ContainerEventRequestContractsQuery = {
  __typename?: 'Query'
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      category: Category
      address: string
      loadingTime: any
      cargo?: string | null | undefined
      note?: string | null | undefined
      tel?: string | null | undefined
      staffName?: string | null | undefined
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }>
      }
      salesEmployee: { __typename?: 'Employee'; id: string; name: string }
      companyRelation: {
        __typename?: 'CompanyRelation'
        id: string
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    }>
  }
}

export type ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutationVariables =
  Exact<{
    input: ChangeRequestVehicleAllocationEventToUnitInput
  }>

export type ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation = {
  __typename?: 'Mutation'
  changeRequestVehicleAllocationEventToUnit?:
    | {
        __typename?: 'ChangeRequestVehicleAllocationEventToUnitPayload'
        loadingEvent: {
          __typename?: 'LoadingEvent'
          id: string
          name: string
          address: string
          staffName?: string | null | undefined
          tel?: string | null | undefined
          requestArrivalNote: string
          cargo?: string | null | undefined
          note?: string | null | undefined
          manifest: Manifest
          operatorCount?: string | null | undefined
          contractPaperStatus?: ContractPaperStatus | null | undefined
          category: Category
          currentState: State
          loadingTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          externalScrapCollectionRequest?:
            | {
                __typename?: 'ExternalScrapCollectionRequest'
                id: string
                requesterName: string
                requesterCompanyName: string
                requesterEmail: string
                requesterPhone: string
                siteName: string
                siteAddress: string
                cargoDetails: string
                desiredPickupDate: string
                desiredPickupPeriod: DesiredPickupPeriod
                numberOfTrucks: number
                kindOfTruck: string
                siteContactName?: string | null | undefined
                siteContactPhone?: string | null | undefined
                comment?: string | null | undefined
                acceptedAt?: any | null | undefined
                rejectedAt?: any | null | undefined
                createdAt: any
                updatedAt: any
              }
            | null
            | undefined
          subContract?:
            | {
                __typename?: 'Contract'
                id: string
                name: string
                address: string
                category: Category
                companyRelation: {
                  __typename?: 'CompanyRelation'
                  id: string
                  relatedCompany: { __typename?: 'Company'; id: string; name: string }
                }
              }
            | null
            | undefined
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{
              __typename?: 'CarType'
              id: string
              name: string
              order?: number | null | undefined
            }>
          }
          route?:
            | {
                __typename?: 'Route'
                id: string
                loadingTime: any
                startOn: any
                endOn: any
                unit: {
                  __typename?: 'Unit'
                  id: string
                  startOn: any
                  endOn: any
                  startTime: any
                  endTime: any
                  truck?:
                    | { __typename?: 'Truck'; carType: { __typename?: 'CarType'; name: string } }
                    | null
                    | undefined
                  driverEmployee?: { __typename?: 'Employee'; name: string } | null | undefined
                }
              }
            | null
            | undefined
          relatedCompany: { __typename?: 'Company'; id: string; name: string }
          salesEmployee: { __typename?: 'Employee'; id: string; name: string }
          createdEmployee: { __typename?: 'Employee'; id: string; name: string }
          attachedFiles: {
            __typename?: 'AttachedFileConnection'
            nodes: Array<{
              __typename?: 'AttachedFile'
              id: string
              originalFilename: string
              downloadSignedUrl: string
              createdAt: any
            }>
          }
        }
      }
    | null
    | undefined
}

export type UpdateLoadingEventMutationVariables = Exact<{
  input: UpdateLoadingEventInput
}>

export type UpdateLoadingEventMutation = {
  __typename?: 'Mutation'
  updateLoadingEvent?:
    | {
        __typename?: 'UpdateLoadingEventPayload'
        loadingEvent: {
          __typename?: 'LoadingEvent'
          id: string
          name: string
          address: string
          staffName?: string | null | undefined
          tel?: string | null | undefined
          requestArrivalNote: string
          cargo?: string | null | undefined
          note?: string | null | undefined
          manifest: Manifest
          operatorCount?: string | null | undefined
          contractPaperStatus?: ContractPaperStatus | null | undefined
          category: Category
          currentState: State
          loadingTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          externalScrapCollectionRequest?:
            | {
                __typename?: 'ExternalScrapCollectionRequest'
                id: string
                requesterName: string
                requesterCompanyName: string
                requesterEmail: string
                requesterPhone: string
                siteName: string
                siteAddress: string
                cargoDetails: string
                desiredPickupDate: string
                desiredPickupPeriod: DesiredPickupPeriod
                numberOfTrucks: number
                kindOfTruck: string
                siteContactName?: string | null | undefined
                siteContactPhone?: string | null | undefined
                comment?: string | null | undefined
                acceptedAt?: any | null | undefined
                rejectedAt?: any | null | undefined
                createdAt: any
                updatedAt: any
              }
            | null
            | undefined
          subContract?:
            | {
                __typename?: 'Contract'
                id: string
                name: string
                address: string
                category: Category
                companyRelation: {
                  __typename?: 'CompanyRelation'
                  id: string
                  relatedCompany: { __typename?: 'Company'; id: string; name: string }
                }
              }
            | null
            | undefined
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{
              __typename?: 'CarType'
              id: string
              name: string
              order?: number | null | undefined
            }>
          }
          route?:
            | {
                __typename?: 'Route'
                id: string
                loadingTime: any
                startOn: any
                endOn: any
                unit: {
                  __typename?: 'Unit'
                  id: string
                  startOn: any
                  endOn: any
                  startTime: any
                  endTime: any
                  truck?:
                    | { __typename?: 'Truck'; carType: { __typename?: 'CarType'; name: string } }
                    | null
                    | undefined
                  driverEmployee?: { __typename?: 'Employee'; name: string } | null | undefined
                }
              }
            | null
            | undefined
          relatedCompany: { __typename?: 'Company'; id: string; name: string }
          salesEmployee: { __typename?: 'Employee'; id: string; name: string }
          createdEmployee: { __typename?: 'Employee'; id: string; name: string }
          attachedFiles: {
            __typename?: 'AttachedFileConnection'
            nodes: Array<{
              __typename?: 'AttachedFile'
              id: string
              originalFilename: string
              downloadSignedUrl: string
              createdAt: any
            }>
          }
        }
      }
    | null
    | undefined
}

export type ContainerLoadingEventDetailChangeLoadingEventDetailStateMutationVariables = Exact<{
  input: ChangeLoadingEventStateInput
}>

export type ContainerLoadingEventDetailChangeLoadingEventDetailStateMutation = {
  __typename?: 'Mutation'
  changeLoadingEventState?:
    | {
        __typename?: 'ChangeLoadingEventStatePayload'
        currentState: State
        loadingEvent: {
          __typename?: 'LoadingEvent'
          id: string
          name: string
          address: string
          staffName?: string | null | undefined
          tel?: string | null | undefined
          requestArrivalNote: string
          cargo?: string | null | undefined
          note?: string | null | undefined
          manifest: Manifest
          operatorCount?: string | null | undefined
          contractPaperStatus?: ContractPaperStatus | null | undefined
          category: Category
          currentState: State
          loadingTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          externalScrapCollectionRequest?:
            | {
                __typename?: 'ExternalScrapCollectionRequest'
                id: string
                requesterName: string
                requesterCompanyName: string
                requesterEmail: string
                requesterPhone: string
                siteName: string
                siteAddress: string
                cargoDetails: string
                desiredPickupDate: string
                desiredPickupPeriod: DesiredPickupPeriod
                numberOfTrucks: number
                kindOfTruck: string
                siteContactName?: string | null | undefined
                siteContactPhone?: string | null | undefined
                comment?: string | null | undefined
                acceptedAt?: any | null | undefined
                rejectedAt?: any | null | undefined
                createdAt: any
                updatedAt: any
              }
            | null
            | undefined
          subContract?:
            | {
                __typename?: 'Contract'
                id: string
                name: string
                address: string
                category: Category
                companyRelation: {
                  __typename?: 'CompanyRelation'
                  id: string
                  relatedCompany: { __typename?: 'Company'; id: string; name: string }
                }
              }
            | null
            | undefined
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{
              __typename?: 'CarType'
              id: string
              name: string
              order?: number | null | undefined
            }>
          }
          route?:
            | {
                __typename?: 'Route'
                id: string
                loadingTime: any
                startOn: any
                endOn: any
                unit: {
                  __typename?: 'Unit'
                  id: string
                  startOn: any
                  endOn: any
                  startTime: any
                  endTime: any
                  truck?:
                    | { __typename?: 'Truck'; carType: { __typename?: 'CarType'; name: string } }
                    | null
                    | undefined
                  driverEmployee?: { __typename?: 'Employee'; name: string } | null | undefined
                }
              }
            | null
            | undefined
          relatedCompany: { __typename?: 'Company'; id: string; name: string }
          salesEmployee: { __typename?: 'Employee'; id: string; name: string }
          createdEmployee: { __typename?: 'Employee'; id: string; name: string }
          attachedFiles: {
            __typename?: 'AttachedFileConnection'
            nodes: Array<{
              __typename?: 'AttachedFile'
              id: string
              originalFilename: string
              downloadSignedUrl: string
              createdAt: any
            }>
          }
        }
      }
    | null
    | undefined
}

export type ContainerLoadingEventDetailPrepareUploadAttachedFileMutationVariables = Exact<{
  input: PrepareUploadAttachedFileInput
}>

export type ContainerLoadingEventDetailPrepareUploadAttachedFileMutation = {
  __typename?: 'Mutation'
  prepareUploadAttachedFile?:
    | {
        __typename?: 'PrepareUploadAttachedFilePayload'
        temporaryAttachedFile: {
          __typename?: 'TemporaryAttachedFile'
          id: string
          filename: string
          originalFilename: string
          contentType: string
          uploadSignedUrl: string
          createdAt: any
        }
      }
    | null
    | undefined
}

export type ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutationVariables = Exact<{
  input: AttachLoadingEventAttachedFileInput
}>

export type ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutation = {
  __typename?: 'Mutation'
  attachLoadingEventAttachedFile?:
    | {
        __typename?: 'AttachLoadingEventAttachedFilePayload'
        attachedFile: {
          __typename?: 'AttachedFile'
          id: string
          originalFilename: string
          downloadSignedUrl: string
          createdAt: any
        }
        loadingEvent: {
          __typename?: 'LoadingEvent'
          id: string
          name: string
          address: string
          staffName?: string | null | undefined
          tel?: string | null | undefined
          requestArrivalNote: string
          cargo?: string | null | undefined
          note?: string | null | undefined
          manifest: Manifest
          operatorCount?: string | null | undefined
          contractPaperStatus?: ContractPaperStatus | null | undefined
          category: Category
          currentState: State
          loadingTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          externalScrapCollectionRequest?:
            | {
                __typename?: 'ExternalScrapCollectionRequest'
                id: string
                requesterName: string
                requesterCompanyName: string
                requesterEmail: string
                requesterPhone: string
                siteName: string
                siteAddress: string
                cargoDetails: string
                desiredPickupDate: string
                desiredPickupPeriod: DesiredPickupPeriod
                numberOfTrucks: number
                kindOfTruck: string
                siteContactName?: string | null | undefined
                siteContactPhone?: string | null | undefined
                comment?: string | null | undefined
                acceptedAt?: any | null | undefined
                rejectedAt?: any | null | undefined
                createdAt: any
                updatedAt: any
              }
            | null
            | undefined
          subContract?:
            | {
                __typename?: 'Contract'
                id: string
                name: string
                address: string
                category: Category
                companyRelation: {
                  __typename?: 'CompanyRelation'
                  id: string
                  relatedCompany: { __typename?: 'Company'; id: string; name: string }
                }
              }
            | null
            | undefined
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{
              __typename?: 'CarType'
              id: string
              name: string
              order?: number | null | undefined
            }>
          }
          route?:
            | {
                __typename?: 'Route'
                id: string
                loadingTime: any
                startOn: any
                endOn: any
                unit: {
                  __typename?: 'Unit'
                  id: string
                  startOn: any
                  endOn: any
                  startTime: any
                  endTime: any
                  truck?:
                    | { __typename?: 'Truck'; carType: { __typename?: 'CarType'; name: string } }
                    | null
                    | undefined
                  driverEmployee?: { __typename?: 'Employee'; name: string } | null | undefined
                }
              }
            | null
            | undefined
          relatedCompany: { __typename?: 'Company'; id: string; name: string }
          salesEmployee: { __typename?: 'Employee'; id: string; name: string }
          createdEmployee: { __typename?: 'Employee'; id: string; name: string }
          attachedFiles: {
            __typename?: 'AttachedFileConnection'
            nodes: Array<{
              __typename?: 'AttachedFile'
              id: string
              originalFilename: string
              downloadSignedUrl: string
              createdAt: any
            }>
          }
        }
      }
    | null
    | undefined
}

export type ContainerLoadingEventDetailRemoveAttachedFileMutationVariables = Exact<{
  input: RemoveAttachedFileInput
}>

export type ContainerLoadingEventDetailRemoveAttachedFileMutation = {
  __typename?: 'Mutation'
  removeAttachedFile?:
    | {
        __typename?: 'RemoveAttachedFilePayload'
        attachment:
          | { __typename?: 'Contract'; id: string; name: string }
          | {
              __typename?: 'LoadingEvent'
              id: string
              name: string
              attachedFiles: {
                __typename?: 'AttachedFileConnection'
                nodes: Array<{
                  __typename?: 'AttachedFile'
                  id: string
                  originalFilename: string
                  downloadSignedUrl: string
                  createdAt: any
                }>
              }
            }
      }
    | null
    | undefined
}

export type ContainerLoadingEventDetailDestroyMutationVariables = Exact<{
  input: DestroyLoadingEventInput
}>

export type ContainerLoadingEventDetailDestroyMutation = {
  __typename?: 'Mutation'
  destroyLoadingEvent?:
    | {
        __typename?: 'DestroyLoadingEventPayload'
        loadingEvent: { __typename?: 'LoadingEvent'; id: string }
      }
    | null
    | undefined
}

export type ContainerLoadingEventDetailFixedMutationVariables = Exact<{
  input: ChangeLoadingEventFixedInput
}>

export type ContainerLoadingEventDetailFixedMutation = {
  __typename?: 'Mutation'
  changeLoadingEventFixed?:
    | {
        __typename?: 'ChangeLoadingEventFixedPayload'
        loadingEvent?:
          | {
              __typename?: 'LoadingEvent'
              id: string
              name: string
              address: string
              staffName?: string | null | undefined
              tel?: string | null | undefined
              requestArrivalNote: string
              cargo?: string | null | undefined
              note?: string | null | undefined
              manifest: Manifest
              operatorCount?: string | null | undefined
              contractPaperStatus?: ContractPaperStatus | null | undefined
              category: Category
              currentState: State
              loadingTime: any
              fixed: boolean
              createdAt: any
              updatedAt: any
              externalScrapCollectionRequest?:
                | {
                    __typename?: 'ExternalScrapCollectionRequest'
                    id: string
                    requesterName: string
                    requesterCompanyName: string
                    requesterEmail: string
                    requesterPhone: string
                    siteName: string
                    siteAddress: string
                    cargoDetails: string
                    desiredPickupDate: string
                    desiredPickupPeriod: DesiredPickupPeriod
                    numberOfTrucks: number
                    kindOfTruck: string
                    siteContactName?: string | null | undefined
                    siteContactPhone?: string | null | undefined
                    comment?: string | null | undefined
                    acceptedAt?: any | null | undefined
                    rejectedAt?: any | null | undefined
                    createdAt: any
                    updatedAt: any
                  }
                | null
                | undefined
              subContract?:
                | {
                    __typename?: 'Contract'
                    id: string
                    name: string
                    address: string
                    category: Category
                    companyRelation: {
                      __typename?: 'CompanyRelation'
                      id: string
                      relatedCompany: { __typename?: 'Company'; id: string; name: string }
                    }
                  }
                | null
                | undefined
              carTypes: {
                __typename?: 'CarTypeConnection'
                nodes: Array<{
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }>
              }
              route?:
                | {
                    __typename?: 'Route'
                    id: string
                    loadingTime: any
                    startOn: any
                    endOn: any
                    unit: {
                      __typename?: 'Unit'
                      id: string
                      startOn: any
                      endOn: any
                      startTime: any
                      endTime: any
                      truck?:
                        | {
                            __typename?: 'Truck'
                            carType: { __typename?: 'CarType'; name: string }
                          }
                        | null
                        | undefined
                      driverEmployee?: { __typename?: 'Employee'; name: string } | null | undefined
                    }
                  }
                | null
                | undefined
              relatedCompany: { __typename?: 'Company'; id: string; name: string }
              salesEmployee: { __typename?: 'Employee'; id: string; name: string }
              createdEmployee: { __typename?: 'Employee'; id: string; name: string }
              attachedFiles: {
                __typename?: 'AttachedFileConnection'
                nodes: Array<{
                  __typename?: 'AttachedFile'
                  id: string
                  originalFilename: string
                  downloadSignedUrl: string
                  createdAt: any
                }>
              }
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type ContainerLoadingEventDetailContractsQueryVariables = Exact<{
  text: Scalars['String']
}>

export type ContainerLoadingEventDetailContractsQuery = {
  __typename?: 'Query'
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      address: string
      category: Category
      companyRelation: {
        __typename?: 'CompanyRelation'
        id: string
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    }>
  }
}

export type ContainerLoadingEventDetailQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type ContainerLoadingEventDetailQuery = {
  __typename?: 'Query'
  loadingEvents: {
    __typename?: 'LoadingEventConnection'
    nodes: Array<{
      __typename?: 'LoadingEvent'
      id: string
      name: string
      address: string
      staffName?: string | null | undefined
      tel?: string | null | undefined
      requestArrivalNote: string
      cargo?: string | null | undefined
      note?: string | null | undefined
      manifest: Manifest
      operatorCount?: string | null | undefined
      contractPaperStatus?: ContractPaperStatus | null | undefined
      category: Category
      currentState: State
      loadingTime: any
      fixed: boolean
      createdAt: any
      updatedAt: any
      externalScrapCollectionRequest?:
        | {
            __typename?: 'ExternalScrapCollectionRequest'
            id: string
            requesterName: string
            requesterCompanyName: string
            requesterEmail: string
            requesterPhone: string
            siteName: string
            siteAddress: string
            cargoDetails: string
            desiredPickupDate: string
            desiredPickupPeriod: DesiredPickupPeriod
            numberOfTrucks: number
            kindOfTruck: string
            siteContactName?: string | null | undefined
            siteContactPhone?: string | null | undefined
            comment?: string | null | undefined
            acceptedAt?: any | null | undefined
            rejectedAt?: any | null | undefined
            createdAt: any
            updatedAt: any
          }
        | null
        | undefined
      subContract?:
        | {
            __typename?: 'Contract'
            id: string
            name: string
            address: string
            category: Category
            companyRelation: {
              __typename?: 'CompanyRelation'
              id: string
              relatedCompany: { __typename?: 'Company'; id: string; name: string }
            }
          }
        | null
        | undefined
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }>
      }
      route?:
        | {
            __typename?: 'Route'
            id: string
            loadingTime: any
            startOn: any
            endOn: any
            unit: {
              __typename?: 'Unit'
              id: string
              startOn: any
              endOn: any
              startTime: any
              endTime: any
              truck?:
                | { __typename?: 'Truck'; carType: { __typename?: 'CarType'; name: string } }
                | null
                | undefined
              driverEmployee?: { __typename?: 'Employee'; name: string } | null | undefined
            }
          }
        | null
        | undefined
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
      salesEmployee: { __typename?: 'Employee'; id: string; name: string }
      createdEmployee: { __typename?: 'Employee'; id: string; name: string }
      attachedFiles: {
        __typename?: 'AttachedFileConnection'
        nodes: Array<{
          __typename?: 'AttachedFile'
          id: string
          originalFilename: string
          downloadSignedUrl: string
          createdAt: any
        }>
      }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  trucks: {
    __typename?: 'TruckConnection'
    nodes: Array<{
      __typename?: 'Truck'
      id: string
      carNumber: string
      order?: number | null | undefined
      carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
    }>
  }
  driverEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  employeeDrivableTrucks: {
    __typename?: 'EmployeeDrivableTruckConnection'
    nodes: Array<{
      __typename?: 'EmployeeDrivableTruck'
      id: string
      priority: Priority
      employee: { __typename?: 'Employee'; id: string }
      truck: { __typename?: 'Truck'; id: string }
    }>
  }
}

export type ContainerLoadingEventListQueryVariables = Exact<{
  text?: InputMaybe<Scalars['String']>
  employeeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  truckIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  date?: InputMaybe<Scalars['ISO8601Date']>
  after?: InputMaybe<Scalars['String']>
  first: Scalars['Int']
}>

export type ContainerLoadingEventListQuery = {
  __typename?: 'Query'
  loadingEvents: {
    __typename?: 'LoadingEventConnection'
    edges: Array<{
      __typename?: 'LoadingEventEdge'
      node?:
        | {
            __typename?: 'LoadingEvent'
            id: string
            name: string
            address: string
            staffName?: string | null | undefined
            tel?: string | null | undefined
            requestArrivalNote: string
            cargo?: string | null | undefined
            note?: string | null | undefined
            category: Category
            currentState: State
            loadingTime: any
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
            route?:
              | {
                  __typename?: 'Route'
                  id: string
                  order: number
                  loadingTime: any
                  startOn: any
                  endOn: any
                  positionType: PositionType
                  eventOrder: number
                  event:
                    | {
                        __typename?: 'CompanySiteEvent'
                        id: string
                        loadingTime: any
                        companySite: { __typename?: 'CompanySite'; id: string; name: string }
                      }
                    | {
                        __typename?: 'LoadingEvent'
                        id: string
                        name: string
                        address: string
                        staffName?: string | null | undefined
                        tel?: string | null | undefined
                        requestArrivalNote: string
                        cargo?: string | null | undefined
                        note?: string | null | undefined
                        category: Category
                        currentState: State
                        loadingTime: any
                        relatedCompany: { __typename?: 'Company'; id: string; name: string }
                      }
                    | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
                  unit: {
                    __typename?: 'Unit'
                    id: string
                    startOn: any
                    endOn: any
                    startTime: any
                    endTime: any
                    own: boolean
                    fixed: boolean
                    truck?:
                      | {
                          __typename?: 'Truck'
                          id: string
                          carNumber: string
                          carType: { __typename?: 'CarType'; id: string; name: string }
                        }
                      | null
                      | undefined
                    driverEmployee?:
                      | {
                          __typename?: 'Employee'
                          id: string
                          name: string
                          email: string
                          tel?: string | null | undefined
                          employeeRole?:
                            | {
                                __typename?: 'EmployeeRole'
                                id: string
                                freightage: Array<Freightage>
                                systemSetting: Array<SystemSetting>
                              }
                            | null
                            | undefined
                        }
                      | null
                      | undefined
                    subcontractor?:
                      | {
                          __typename?: 'CompanyRelation'
                          id: string
                          relatedCompany: { __typename?: 'Company'; id: string; name: string }
                        }
                      | null
                      | undefined
                  }
                }
              | null
              | undefined
          }
        | null
        | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  employees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      email: string
      tel?: string | null | undefined
      employeeRole?:
        | {
            __typename?: 'EmployeeRole'
            id: string
            freightage: Array<Freightage>
            systemSetting: Array<SystemSetting>
          }
        | null
        | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  trucks: {
    __typename?: 'TruckConnection'
    nodes: Array<{
      __typename?: 'Truck'
      id: string
      carNumber: string
      carType: { __typename?: 'CarType'; id: string; name: string }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
}

export type ModuleVeactleAllocationStateFragment = {
  __typename?: 'LoadingEvent'
  id: string
  name: string
  address: string
  staffName?: string | null | undefined
  tel?: string | null | undefined
  requestArrivalNote: string
  cargo?: string | null | undefined
  note?: string | null | undefined
  category: Category
  currentState: State
  loadingTime: any
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
  route?:
    | {
        __typename?: 'Route'
        id: string
        order: number
        loadingTime: any
        startOn: any
        endOn: any
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
        }
      }
    | null
    | undefined
}

export type ContainerLoadingEventStatesQueryVariables = Exact<{
  status: Array<State> | State
  after?: InputMaybe<Scalars['String']>
  first: Scalars['Int']
}>

export type ContainerLoadingEventStatesQuery = {
  __typename?: 'Query'
  loadingEvents: {
    __typename?: 'LoadingEventConnection'
    edges: Array<{
      __typename?: 'LoadingEventEdge'
      node?:
        | {
            __typename?: 'LoadingEvent'
            id: string
            name: string
            address: string
            staffName?: string | null | undefined
            tel?: string | null | undefined
            requestArrivalNote: string
            cargo?: string | null | undefined
            note?: string | null | undefined
            category: Category
            currentState: State
            loadingTime: any
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
            route?:
              | {
                  __typename?: 'Route'
                  id: string
                  order: number
                  loadingTime: any
                  startOn: any
                  endOn: any
                  unit: {
                    __typename?: 'Unit'
                    id: string
                    startOn: any
                    endOn: any
                    startTime: any
                    endTime: any
                  }
                }
              | null
              | undefined
          }
        | null
        | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  externalScrapCollectionRequests: {
    __typename?: 'ExternalScrapCollectionRequestConnection'
    edges: Array<{
      __typename?: 'ExternalScrapCollectionRequestEdge'
      node?:
        | {
            __typename?: 'ExternalScrapCollectionRequest'
            id: string
            requesterName: string
            requesterCompanyName: string
            requesterEmail: string
            requesterPhone: string
            siteName: string
            siteAddress: string
            cargoDetails: string
            desiredPickupDate: string
            desiredPickupPeriod: DesiredPickupPeriod
            numberOfTrucks: number
            kindOfTruck: string
            siteContactName?: string | null | undefined
            siteContactPhone?: string | null | undefined
            comment?: string | null | undefined
            acceptedAt?: any | null | undefined
            rejectedAt?: any | null | undefined
            createdAt: any
            updatedAt: any
          }
        | null
        | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
}

export type CreateUnitsRecursivelyMutationVariables = Exact<{
  input: CreateUnitRecurringInput
}>

export type CreateUnitsRecursivelyMutation = {
  __typename?: 'Mutation'
  createUnitRecurring?:
    | { __typename?: 'CreateUnitRecurringPayload'; clientMutationId?: string | null | undefined }
    | null
    | undefined
}

export type CreateEventsRecursivelyMutationVariables = Exact<{
  input: CreateEventRecurringInput
}>

export type CreateEventsRecursivelyMutation = {
  __typename?: 'Mutation'
  createEventRecurring?:
    | { __typename?: 'CreateEventRecurringPayload'; clientMutationId?: string | null | undefined }
    | null
    | undefined
}

export type RecursiveDuplicationUnitDetailLoadingEventFragment = {
  __typename?: 'LoadingEvent'
  id: string
  name: string
}

export type RecursiveDuplicationUnitDetailQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type RecursiveDuplicationUnitDetailQuery = {
  __typename?: 'Query'
  units: {
    __typename?: 'UnitConnection'
    nodes: Array<{
      __typename?: 'Unit'
      id: string
      routes: {
        __typename?: 'RouteConnection'
        nodes: Array<{
          __typename?: 'Route'
          id: string
          positionType: PositionType
          event:
            | { __typename: 'CompanySiteEvent' }
            | { __typename: 'LoadingEvent'; id: string; name: string }
            | { __typename: 'TransferEvent' }
        }>
      }
    }>
  }
}

export type RecursiveDuplicationEventDetailQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type RecursiveDuplicationEventDetailQuery = {
  __typename?: 'Query'
  events: {
    __typename?: 'EventConnection'
    nodes?:
      | Array<
          | {
              __typename?: 'EventEmployee'
              employee?: { __typename?: 'Employee'; id: string; name: string } | null | undefined
            }
          | {
              __typename?: 'EventTemporaryVehicleAllocation'
              detail: {
                __typename?: 'EventTemporaryVehicleAllocationDetail'
                id: string
                name: string
              }
            }
          | {
              __typename?: 'EventTruck'
              truck?: { __typename?: 'Truck'; id: string; carNumber: string } | null | undefined
            }
          | null
          | undefined
        >
      | null
      | undefined
  }
}

export type ContainerTimelineChangeTimeUnitMutationVariables = Exact<{
  input: ChangeTimeUnitInput
}>

export type ContainerTimelineChangeTimeUnitMutation = {
  __typename?: 'Mutation'
  changeTimeUnit?:
    | {
        __typename?: 'ChangeTimeUnitPayload'
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          feasible: boolean
          fixed: boolean
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              order: number
              startOn: any
              loadingTime: any
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    cargo?: string | null | undefined
                    fixed: boolean
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
        }
      }
    | null
    | undefined
}

export type ContainerTimelineUpdateOwnUnitMutationVariables = Exact<{
  input: UpdateOwnUnitInput
}>

export type ContainerTimelineUpdateOwnUnitMutation = {
  __typename?: 'Mutation'
  updateOwnUnit?:
    | {
        __typename?: 'UpdateOwnUnitPayload'
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          feasible: boolean
          fixed: boolean
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              order: number
              startOn: any
              loadingTime: any
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    cargo?: string | null | undefined
                    fixed: boolean
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
        }
      }
    | null
    | undefined
}

export type ContainerTimelineUpdateSubcontractUnitMutationVariables = Exact<{
  input: UpdateSubcontractUnitInput
}>

export type ContainerTimelineUpdateSubcontractUnitMutation = {
  __typename?: 'Mutation'
  updateSubcontractUnit?:
    | {
        __typename?: 'UpdateSubcontractUnitPayload'
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          feasible: boolean
          fixed: boolean
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              order: number
              startOn: any
              loadingTime: any
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    cargo?: string | null | undefined
                    fixed: boolean
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
        }
      }
    | null
    | undefined
}

export type ContainerTimelineUpdateEventMutationVariables = Exact<{
  input: UpdateEventInput
}>

export type ContainerTimelineUpdateEventMutation = {
  __typename?: 'Mutation'
  updateEvent?:
    | {
        __typename?: 'UpdateEventPayload'
        event:
          | {
              __typename?: 'EventEmployee'
              id: string
              startOn: any
              endOn: any
              startTime: any
              endTime: any
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      name: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventEmployeeDetail'
                id: string
                note?: string | null | undefined
                employeeReasonType: EventEmployeeReasonType
              }
            }
          | {
              __typename?: 'EventTemporaryVehicleAllocation'
              id: string
              startOn: any
              endOn: any
              startTime: any
              endTime: any
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      name: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventTemporaryVehicleAllocationDetail'
                id: string
                name: string
                category?: Category | null | undefined
                cargo?: string | null | undefined
              }
            }
          | {
              __typename?: 'EventTruck'
              id: string
              startOn: any
              endOn: any
              startTime: any
              endTime: any
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      name: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventTruckDetail'
                id: string
                note?: string | null | undefined
                truckReasonType: EventTruckReasonType
              }
            }
      }
    | null
    | undefined
}

export type ContainerTimelineMainBackgroundQueryVariables = Exact<{
  date?: InputMaybe<Scalars['ISO8601DateTime']>
  dates?: InputMaybe<Iso8601DatePeriodInput>
}>

export type ContainerTimelineMainBackgroundQuery = {
  __typename?: 'Query'
  timelineTruckBackgrounds: Array<{
    __typename?: 'TruckUnavailablePeriod'
    id: string
    startOn: any
    endOn: any
    truck?: { __typename?: 'Truck'; id: string } | null | undefined
  }>
  timelineEmployeeBackgrounds: Array<{
    __typename?: 'EmployeeUnavailablePeriod'
    id: string
    startOn: any
    endOn: any
    employee?: { __typename?: 'Employee'; id: string } | null | undefined
  }>
}

export type ContainerTimelineUnitCreateSubscriptionVariables = Exact<{ [key: string]: never }>

export type ContainerTimelineUnitCreateSubscription = {
  __typename?: 'Subscription'
  unitCreate: {
    __typename?: 'UnitCreatePayload'
    unit?:
      | {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          feasible: boolean
          fixed: boolean
          nextUnit?:
            | {
                __typename?: 'Unit'
                id: string
                startOn: any
                endOn: any
                startTime: any
                endTime: any
                feasible: boolean
                fixed: boolean
                truck?:
                  | {
                      __typename?: 'Truck'
                      id: string
                      carNumber: string
                      order?: number | null | undefined
                      companySite: { __typename?: 'CompanySite'; id: string; name: string }
                      carType: {
                        __typename?: 'CarType'
                        id: string
                        name: string
                        order?: number | null | undefined
                      }
                    }
                  | null
                  | undefined
                driverEmployee?:
                  | {
                      __typename?: 'Employee'
                      id: string
                      name: string
                      order?: number | null | undefined
                      companySite: { __typename?: 'CompanySite'; id: string; name: string }
                    }
                  | null
                  | undefined
                subcontractor?:
                  | {
                      __typename?: 'CompanyRelation'
                      id: string
                      involvement: Involvement
                      relatedCompany: { __typename?: 'Company'; id: string; name: string }
                    }
                  | null
                  | undefined
                routes: {
                  __typename?: 'RouteConnection'
                  nodes: Array<{
                    __typename?: 'Route'
                    id: string
                    order: number
                    startOn: any
                    loadingTime: any
                    event:
                      | {
                          __typename?: 'CompanySiteEvent'
                          id: string
                          loadingTime: any
                          companySite: { __typename?: 'CompanySite'; id: string; name: string }
                        }
                      | {
                          __typename?: 'LoadingEvent'
                          id: string
                          name: string
                          category: Category
                          currentState: State
                          cargo?: string | null | undefined
                          fixed: boolean
                          relatedCompany: { __typename?: 'Company'; id: string; name: string }
                        }
                      | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
                  }>
                }
              }
            | null
            | undefined
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              order: number
              startOn: any
              loadingTime: any
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    cargo?: string | null | undefined
                    fixed: boolean
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
        }
      | null
      | undefined
  }
}

export type ContainerTimelineEventCreateSubscriptionVariables = Exact<{ [key: string]: never }>

export type ContainerTimelineEventCreateSubscription = {
  __typename?: 'Subscription'
  eventCreate: {
    __typename?: 'EventCreatePayload'
    event?:
      | {
          __typename?: 'EventEmployee'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          employee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
              }
            | null
            | undefined
          detail: {
            __typename?: 'EventEmployeeDetail'
            id: string
            note?: string | null | undefined
            employeeReasonType: EventEmployeeReasonType
          }
        }
      | {
          __typename?: 'EventTemporaryVehicleAllocation'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          employee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
              }
            | null
            | undefined
          detail: {
            __typename?: 'EventTemporaryVehicleAllocationDetail'
            id: string
            name: string
            category?: Category | null | undefined
            cargo?: string | null | undefined
          }
        }
      | {
          __typename?: 'EventTruck'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          employee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                order?: number | null | undefined
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
              }
            | null
            | undefined
          detail: {
            __typename?: 'EventTruckDetail'
            id: string
            note?: string | null | undefined
            truckReasonType: EventTruckReasonType
          }
        }
      | null
      | undefined
  }
}

export type ContainerTimelineUnitDestroySubscriptionVariables = Exact<{ [key: string]: never }>

export type ContainerTimelineUnitDestroySubscription = {
  __typename?: 'Subscription'
  unitDestroy: { __typename?: 'UnitDestroyPayload'; destroiedUnitId?: string | null | undefined }
}

export type ContainerTimelineEventDestroySubscriptionVariables = Exact<{ [key: string]: never }>

export type ContainerTimelineEventDestroySubscription = {
  __typename?: 'Subscription'
  eventDestroy: { __typename?: 'EventDestroyPayload'; destroiedEventId?: string | null | undefined }
}

export type ContainerTimelineTimelineUpdateSubscriptionVariables = Exact<{ [key: string]: never }>

export type ContainerTimelineTimelineUpdateSubscription = {
  __typename?: 'Subscription'
  timelineUpdate: {
    __typename?: 'TimelineUpdatePayload'
    units: {
      __typename?: 'UnitConnection'
      nodes: Array<{
        __typename?: 'Unit'
        id: string
        startOn: any
        endOn: any
        startTime: any
        endTime: any
        feasible: boolean
        fixed: boolean
        nextUnit?:
          | {
              __typename?: 'Unit'
              id: string
              startOn: any
              endOn: any
              startTime: any
              endTime: any
              feasible: boolean
              fixed: boolean
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      name: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              driverEmployee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | null
                | undefined
              subcontractor?:
                | {
                    __typename?: 'CompanyRelation'
                    id: string
                    involvement: Involvement
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | null
                | undefined
              routes: {
                __typename?: 'RouteConnection'
                nodes: Array<{
                  __typename?: 'Route'
                  id: string
                  order: number
                  startOn: any
                  loadingTime: any
                  event:
                    | {
                        __typename?: 'CompanySiteEvent'
                        id: string
                        loadingTime: any
                        companySite: { __typename?: 'CompanySite'; id: string; name: string }
                      }
                    | {
                        __typename?: 'LoadingEvent'
                        id: string
                        name: string
                        category: Category
                        currentState: State
                        cargo?: string | null | undefined
                        fixed: boolean
                        relatedCompany: { __typename?: 'Company'; id: string; name: string }
                      }
                    | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
                }>
              }
            }
          | null
          | undefined
        truck?:
          | {
              __typename?: 'Truck'
              id: string
              carNumber: string
              order?: number | null | undefined
              companySite: { __typename?: 'CompanySite'; id: string; name: string }
              carType: {
                __typename?: 'CarType'
                id: string
                name: string
                order?: number | null | undefined
              }
            }
          | null
          | undefined
        driverEmployee?:
          | {
              __typename?: 'Employee'
              id: string
              name: string
              order?: number | null | undefined
              companySite: { __typename?: 'CompanySite'; id: string; name: string }
            }
          | null
          | undefined
        subcontractor?:
          | {
              __typename?: 'CompanyRelation'
              id: string
              involvement: Involvement
              relatedCompany: { __typename?: 'Company'; id: string; name: string }
            }
          | null
          | undefined
        routes: {
          __typename?: 'RouteConnection'
          nodes: Array<{
            __typename?: 'Route'
            id: string
            order: number
            startOn: any
            loadingTime: any
            event:
              | {
                  __typename?: 'CompanySiteEvent'
                  id: string
                  loadingTime: any
                  companySite: { __typename?: 'CompanySite'; id: string; name: string }
                }
              | {
                  __typename?: 'LoadingEvent'
                  id: string
                  name: string
                  category: Category
                  currentState: State
                  cargo?: string | null | undefined
                  fixed: boolean
                  relatedCompany: { __typename?: 'Company'; id: string; name: string }
                }
              | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
          }>
        }
      }>
    }
    events: {
      __typename?: 'EventConnection'
      nodes?:
        | Array<
            | {
                __typename?: 'EventEmployee'
                id: string
                startOn: any
                endOn: any
                startTime: any
                endTime: any
                truck?:
                  | {
                      __typename?: 'Truck'
                      id: string
                      carNumber: string
                      order?: number | null | undefined
                      companySite: { __typename?: 'CompanySite'; id: string; name: string }
                      carType: {
                        __typename?: 'CarType'
                        id: string
                        name: string
                        order?: number | null | undefined
                      }
                    }
                  | null
                  | undefined
                employee?:
                  | {
                      __typename?: 'Employee'
                      id: string
                      name: string
                      order?: number | null | undefined
                      companySite: { __typename?: 'CompanySite'; id: string; name: string }
                    }
                  | null
                  | undefined
                detail: {
                  __typename?: 'EventEmployeeDetail'
                  id: string
                  note?: string | null | undefined
                  employeeReasonType: EventEmployeeReasonType
                }
              }
            | {
                __typename?: 'EventTemporaryVehicleAllocation'
                id: string
                startOn: any
                endOn: any
                startTime: any
                endTime: any
                truck?:
                  | {
                      __typename?: 'Truck'
                      id: string
                      carNumber: string
                      order?: number | null | undefined
                      companySite: { __typename?: 'CompanySite'; id: string; name: string }
                      carType: {
                        __typename?: 'CarType'
                        id: string
                        name: string
                        order?: number | null | undefined
                      }
                    }
                  | null
                  | undefined
                employee?:
                  | {
                      __typename?: 'Employee'
                      id: string
                      name: string
                      order?: number | null | undefined
                      companySite: { __typename?: 'CompanySite'; id: string; name: string }
                    }
                  | null
                  | undefined
                detail: {
                  __typename?: 'EventTemporaryVehicleAllocationDetail'
                  id: string
                  name: string
                  category?: Category | null | undefined
                  cargo?: string | null | undefined
                }
              }
            | {
                __typename?: 'EventTruck'
                id: string
                startOn: any
                endOn: any
                startTime: any
                endTime: any
                truck?:
                  | {
                      __typename?: 'Truck'
                      id: string
                      carNumber: string
                      order?: number | null | undefined
                      companySite: { __typename?: 'CompanySite'; id: string; name: string }
                      carType: {
                        __typename?: 'CarType'
                        id: string
                        name: string
                        order?: number | null | undefined
                      }
                    }
                  | null
                  | undefined
                employee?:
                  | {
                      __typename?: 'Employee'
                      id: string
                      name: string
                      order?: number | null | undefined
                      companySite: { __typename?: 'CompanySite'; id: string; name: string }
                    }
                  | null
                  | undefined
                detail: {
                  __typename?: 'EventTruckDetail'
                  id: string
                  note?: string | null | undefined
                  truckReasonType: EventTruckReasonType
                }
              }
            | null
            | undefined
          >
        | null
        | undefined
    }
  }
}

export type ContainerTimelineToolbarQueryVariables = Exact<{ [key: string]: never }>

export type ContainerTimelineToolbarQuery = {
  __typename?: 'Query'
  companySites: {
    __typename?: 'CompanySiteConnection'
    nodes: Array<{ __typename?: 'CompanySite'; id: string; name: string }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  trucks: {
    __typename?: 'TruckConnection'
    nodes: Array<{
      __typename?: 'Truck'
      id: string
      carNumber: string
      carType: { __typename?: 'CarType'; id: string }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
}

export type ContainerTimelineRefreshResourceFeasibilityMutationVariables = Exact<{
  input: RefreshResourceFeasibilityInput
}>

export type ContainerTimelineRefreshResourceFeasibilityMutation = {
  __typename?: 'Mutation'
  refreshResourceFeasibility?:
    | { __typename?: 'RefreshResourceFeasibilityPayload'; asyncStatus: AsyncStatus }
    | null
    | undefined
}

export type ContainerTimelineQueryVariables = Exact<{
  date?: InputMaybe<Scalars['ISO8601DateTime']>
  dates?: InputMaybe<Iso8601DatePeriodInput>
}>

export type ContainerTimelineQuery = {
  __typename?: 'Query'
  units: {
    __typename?: 'UnitConnection'
    nodes: Array<{
      __typename?: 'Unit'
      id: string
      startOn: any
      endOn: any
      startTime: any
      endTime: any
      feasible: boolean
      fixed: boolean
      truck?:
        | {
            __typename?: 'Truck'
            id: string
            carNumber: string
            order?: number | null | undefined
            companySite: { __typename?: 'CompanySite'; id: string; name: string }
            carType: {
              __typename?: 'CarType'
              id: string
              name: string
              order?: number | null | undefined
            }
          }
        | null
        | undefined
      driverEmployee?:
        | {
            __typename?: 'Employee'
            id: string
            name: string
            order?: number | null | undefined
            companySite: { __typename?: 'CompanySite'; id: string; name: string }
          }
        | null
        | undefined
      subcontractor?:
        | {
            __typename?: 'CompanyRelation'
            id: string
            involvement: Involvement
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
          }
        | null
        | undefined
      routes: {
        __typename?: 'RouteConnection'
        nodes: Array<{
          __typename?: 'Route'
          id: string
          order: number
          startOn: any
          loadingTime: any
          event:
            | {
                __typename?: 'CompanySiteEvent'
                id: string
                loadingTime: any
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
              }
            | {
                __typename?: 'LoadingEvent'
                id: string
                name: string
                category: Category
                currentState: State
                cargo?: string | null | undefined
                fixed: boolean
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
        }>
      }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  events: {
    __typename?: 'EventConnection'
    nodes?:
      | Array<
          | {
              __typename?: 'EventEmployee'
              id: string
              startOn: any
              endOn: any
              startTime: any
              endTime: any
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      name: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventEmployeeDetail'
                id: string
                note?: string | null | undefined
                employeeReasonType: EventEmployeeReasonType
              }
            }
          | {
              __typename?: 'EventTemporaryVehicleAllocation'
              id: string
              startOn: any
              endOn: any
              startTime: any
              endTime: any
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      name: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventTemporaryVehicleAllocationDetail'
                id: string
                name: string
                category?: Category | null | undefined
                cargo?: string | null | undefined
              }
            }
          | {
              __typename?: 'EventTruck'
              id: string
              startOn: any
              endOn: any
              startTime: any
              endTime: any
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      name: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              employee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    order?: number | null | undefined
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | null
                | undefined
              detail: {
                __typename?: 'EventTruckDetail'
                id: string
                note?: string | null | undefined
                truckReasonType: EventTruckReasonType
              }
            }
          | null
          | undefined
        >
      | null
      | undefined
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  driverEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      order?: number | null | undefined
      companySite: { __typename?: 'CompanySite'; id: string; name: string }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  subcontractors: {
    __typename?: 'CompanyRelationConnection'
    nodes: Array<{
      __typename?: 'CompanyRelation'
      id: string
      involvement: Involvement
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  trucks: {
    __typename?: 'TruckConnection'
    nodes: Array<{
      __typename?: 'Truck'
      id: string
      carNumber: string
      order?: number | null | undefined
      companySite: { __typename?: 'CompanySite'; id: string; name: string }
      carType: {
        __typename?: 'CarType'
        id: string
        name: string
        order?: number | null | undefined
      }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
}

export type TruckDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>
}>

export type TruckDetailQuery = {
  __typename?: 'Query'
  trucks: {
    __typename?: 'TruckConnection'
    edges: Array<{
      __typename?: 'TruckEdge'
      node?:
        | {
            __typename?: 'Truck'
            id: string
            carNumber: string
            note?: string | null | undefined
            carType: { __typename?: 'CarType'; id: string; name: string }
            companySite: { __typename?: 'CompanySite'; id: string; name: string }
            employeeDrivableTrucks: {
              __typename?: 'EmployeeDrivableTruckConnection'
              edges: Array<{
                __typename?: 'EmployeeDrivableTruckEdge'
                node?:
                  | {
                      __typename?: 'EmployeeDrivableTruck'
                      id: string
                      priority: Priority
                      employee: { __typename?: 'Employee'; id: string; name: string }
                    }
                  | null
                  | undefined
              }>
            }
          }
        | null
        | undefined
    }>
  }
}

export type ChangeTruckOrderMutationVariables = Exact<{
  input: ChangeTruckOrderInput
}>

export type ChangeTruckOrderMutation = {
  __typename?: 'Mutation'
  changeTruckOrder?:
    | { __typename?: 'ChangeTruckOrderPayload'; clientMutationId?: string | null | undefined }
    | null
    | undefined
}

export type ContainerTrucksFilterQueryVariables = Exact<{ [key: string]: never }>

export type ContainerTrucksFilterQuery = {
  __typename?: 'Query'
  trucks: {
    __typename?: 'TruckConnection'
    edges: Array<{
      __typename?: 'TruckEdge'
      node?:
        | {
            __typename?: 'Truck'
            id: string
            carNumber: string
            order?: number | null | undefined
            carType: { __typename?: 'CarType'; id: string; name: string }
            companySite: { __typename?: 'CompanySite'; id: string; name: string }
          }
        | null
        | undefined
    }>
  }
}

export type CreateCarTypeMutationVariables = Exact<{
  input: CreateCarInput
}>

export type CreateCarTypeMutation = {
  __typename?: 'Mutation'
  createCarType?:
    | {
        __typename?: 'CreateCarPayload'
        carType: { __typename?: 'CarType'; id: string; name: string }
      }
    | null
    | undefined
}

export type CreateTruckMutationVariables = Exact<{
  input: CreateTruckInput
}>

export type CreateTruckMutation = {
  __typename?: 'Mutation'
  createTruck?:
    | { __typename?: 'CreateTruckPayload'; truck: { __typename?: 'Truck'; id: string } }
    | null
    | undefined
}

export type UpdateTruckMutationVariables = Exact<{
  input: UpdateTruckInput
}>

export type UpdateTruckMutation = {
  __typename?: 'Mutation'
  updateTruck?:
    | {
        __typename?: 'UpdateTruckPayload'
        truck: {
          __typename?: 'Truck'
          id: string
          carNumber: string
          note?: string | null | undefined
          carType: { __typename?: 'CarType'; id: string; name: string }
          companySite: { __typename?: 'CompanySite'; id: string; name: string }
          employeeDrivableTrucks: {
            __typename?: 'EmployeeDrivableTruckConnection'
            edges: Array<{
              __typename?: 'EmployeeDrivableTruckEdge'
              node?:
                | {
                    __typename?: 'EmployeeDrivableTruck'
                    id: string
                    priority: Priority
                    employee: { __typename?: 'Employee'; id: string; name: string }
                  }
                | null
                | undefined
            }>
          }
        }
      }
    | null
    | undefined
}

export type UpdateEmployeeDrivableTruckMutationVariables = Exact<{
  input: UpdateEmployeeDrivableTruckInput
}>

export type UpdateEmployeeDrivableTruckMutation = {
  __typename?: 'Mutation'
  updateEmployeeDrivableTruck?:
    | {
        __typename?: 'UpdateEmployeeDrivableTruckPayload'
        truck: {
          __typename?: 'Truck'
          id: string
          carNumber: string
          note?: string | null | undefined
          carType: { __typename?: 'CarType'; id: string; name: string }
          companySite: { __typename?: 'CompanySite'; id: string; name: string }
          employeeDrivableTrucks: {
            __typename?: 'EmployeeDrivableTruckConnection'
            edges: Array<{
              __typename?: 'EmployeeDrivableTruckEdge'
              node?:
                | {
                    __typename?: 'EmployeeDrivableTruck'
                    id: string
                    priority: Priority
                    employee: { __typename?: 'Employee'; id: string; name: string }
                  }
                | null
                | undefined
            }>
          }
        }
      }
    | null
    | undefined
}

export type DisableTruckMutationVariables = Exact<{
  input: DisableTruckInput
}>

export type DisableTruckMutation = {
  __typename?: 'Mutation'
  disableTruck?:
    | {
        __typename?: 'DisableTruckPayload'
        truck: { __typename?: 'Truck'; id: string; carNumber: string }
      }
    | null
    | undefined
}

export type TruckNewCarTypeFragment = { __typename?: 'CarType'; id: string; name: string }

export type TruckNewEmployeeFragment = { __typename?: 'Employee'; id: string; name: string }

export type TruckNewCompanySiteFragment = { __typename?: 'CompanySite'; id: string; name: string }

export type ContainerTruckNewQueryVariables = Exact<{ [key: string]: never }>

export type ContainerTruckNewQuery = {
  __typename?: 'Query'
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{ __typename?: 'CarType'; id: string; name: string }>
  }
  employees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{ __typename?: 'Employee'; id: string; name: string }>
  }
  companySites: {
    __typename?: 'CompanySiteConnection'
    edges: Array<{
      __typename?: 'CompanySiteEdge'
      node?: { __typename?: 'CompanySite'; id: string; name: string } | null | undefined
    }>
  }
}

export type ContainerUnitDetailFixedMutationVariables = Exact<{
  input: ChangeUnitFixedInput
}>

export type ContainerUnitDetailFixedMutation = {
  __typename?: 'Mutation'
  changeUnitFixed?:
    | {
        __typename?: 'ChangeUnitFixedPayload'
        unit?:
          | {
              __typename?: 'Unit'
              id: string
              startOn: any
              endOn: any
              startTime: any
              endTime: any
              fixed: boolean
              createdAt: any
              updatedAt: any
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      name: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              driverEmployee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    email: string
                    order?: number | null | undefined
                    employeeRole?:
                      | {
                          __typename?: 'EmployeeRole'
                          id: string
                          freightage: Array<Freightage>
                          systemSetting: Array<SystemSetting>
                        }
                      | null
                      | undefined
                  }
                | null
                | undefined
              subcontractor?:
                | {
                    __typename?: 'CompanyRelation'
                    id: string
                    involvement: Involvement
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | null
                | undefined
              routes: {
                __typename?: 'RouteConnection'
                nodes: Array<{
                  __typename?: 'Route'
                  id: string
                  startOn: any
                  endOn: any
                  originalLoadingTime: any
                  order: number
                  loadingTime: any
                  eventOrder: number
                  positionType: PositionType
                  event:
                    | {
                        __typename?: 'CompanySiteEvent'
                        id: string
                        loadingTime: any
                        companySite: { __typename?: 'CompanySite'; id: string; name: string }
                      }
                    | {
                        __typename?: 'LoadingEvent'
                        id: string
                        name: string
                        category: Category
                        currentState: State
                        loadingTime: any
                        address: string
                        cargo?: string | null | undefined
                        requestArrivalNote: string
                        note?: string | null | undefined
                        relatedCompany: { __typename?: 'Company'; id: string; name: string }
                      }
                    | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
                }>
              }
              infeasibles: Array<{
                __typename?: 'UnitInfeasible'
                id: string
                reason: InfeasibleReason
              }>
              nextUnit?:
                | {
                    __typename?: 'Unit'
                    id: string
                    routes: {
                      __typename?: 'RouteConnection'
                      nodes: Array<{
                        __typename?: 'Route'
                        id: string
                        event:
                          | { __typename?: 'CompanySiteEvent' }
                          | { __typename?: 'LoadingEvent'; id: string; name: string }
                          | { __typename?: 'TransferEvent' }
                      }>
                    }
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type ContainerUnitDetailUpdateOwnUnitMutationVariables = Exact<{
  input: UpdateOwnUnitInput
}>

export type ContainerUnitDetailUpdateOwnUnitMutation = {
  __typename?: 'Mutation'
  updateOwnUnit?:
    | {
        __typename?: 'UpdateOwnUnitPayload'
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                email: string
                order?: number | null | undefined
                employeeRole?:
                  | {
                      __typename?: 'EmployeeRole'
                      id: string
                      freightage: Array<Freightage>
                      systemSetting: Array<SystemSetting>
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              startOn: any
              endOn: any
              originalLoadingTime: any
              order: number
              loadingTime: any
              eventOrder: number
              positionType: PositionType
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    loadingTime: any
                    address: string
                    cargo?: string | null | undefined
                    requestArrivalNote: string
                    note?: string | null | undefined
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
          infeasibles: Array<{
            __typename?: 'UnitInfeasible'
            id: string
            reason: InfeasibleReason
          }>
          nextUnit?:
            | {
                __typename?: 'Unit'
                id: string
                routes: {
                  __typename?: 'RouteConnection'
                  nodes: Array<{
                    __typename?: 'Route'
                    id: string
                    event:
                      | { __typename?: 'CompanySiteEvent' }
                      | { __typename?: 'LoadingEvent'; id: string; name: string }
                      | { __typename?: 'TransferEvent' }
                  }>
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ContainerUnitDetailUpdateSubcontractUnitMutationVariables = Exact<{
  input: UpdateSubcontractUnitInput
}>

export type ContainerUnitDetailUpdateSubcontractUnitMutation = {
  __typename?: 'Mutation'
  updateSubcontractUnit?:
    | {
        __typename?: 'UpdateSubcontractUnitPayload'
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                email: string
                order?: number | null | undefined
                employeeRole?:
                  | {
                      __typename?: 'EmployeeRole'
                      id: string
                      freightage: Array<Freightage>
                      systemSetting: Array<SystemSetting>
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              startOn: any
              endOn: any
              originalLoadingTime: any
              order: number
              loadingTime: any
              eventOrder: number
              positionType: PositionType
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    loadingTime: any
                    address: string
                    cargo?: string | null | undefined
                    requestArrivalNote: string
                    note?: string | null | undefined
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
          infeasibles: Array<{
            __typename?: 'UnitInfeasible'
            id: string
            reason: InfeasibleReason
          }>
          nextUnit?:
            | {
                __typename?: 'Unit'
                id: string
                routes: {
                  __typename?: 'RouteConnection'
                  nodes: Array<{
                    __typename?: 'Route'
                    id: string
                    event:
                      | { __typename?: 'CompanySiteEvent' }
                      | { __typename?: 'LoadingEvent'; id: string; name: string }
                      | { __typename?: 'TransferEvent' }
                  }>
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ContainerUnitDetailJointUnitMutationVariables = Exact<{
  input: JointUnitInput
}>

export type ContainerUnitDetailJointUnitMutation = {
  __typename?: 'Mutation'
  jointUnit?:
    | {
        __typename?: 'JointUnitPayload'
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                email: string
                order?: number | null | undefined
                employeeRole?:
                  | {
                      __typename?: 'EmployeeRole'
                      id: string
                      freightage: Array<Freightage>
                      systemSetting: Array<SystemSetting>
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              startOn: any
              endOn: any
              originalLoadingTime: any
              order: number
              loadingTime: any
              eventOrder: number
              positionType: PositionType
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    loadingTime: any
                    address: string
                    cargo?: string | null | undefined
                    requestArrivalNote: string
                    note?: string | null | undefined
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
          infeasibles: Array<{
            __typename?: 'UnitInfeasible'
            id: string
            reason: InfeasibleReason
          }>
          nextUnit?:
            | {
                __typename?: 'Unit'
                id: string
                routes: {
                  __typename?: 'RouteConnection'
                  nodes: Array<{
                    __typename?: 'Route'
                    id: string
                    event:
                      | { __typename?: 'CompanySiteEvent' }
                      | { __typename?: 'LoadingEvent'; id: string; name: string }
                      | { __typename?: 'TransferEvent' }
                  }>
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ContainerUnitDetailSeparateUnitMutationVariables = Exact<{
  input: SeparateUnitInput
}>

export type ContainerUnitDetailSeparateUnitMutation = {
  __typename?: 'Mutation'
  separateUnit?:
    | {
        __typename?: 'SeparateUnitPayload'
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                email: string
                order?: number | null | undefined
                employeeRole?:
                  | {
                      __typename?: 'EmployeeRole'
                      id: string
                      freightage: Array<Freightage>
                      systemSetting: Array<SystemSetting>
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              startOn: any
              endOn: any
              originalLoadingTime: any
              order: number
              loadingTime: any
              eventOrder: number
              positionType: PositionType
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    loadingTime: any
                    address: string
                    cargo?: string | null | undefined
                    requestArrivalNote: string
                    note?: string | null | undefined
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
          infeasibles: Array<{
            __typename?: 'UnitInfeasible'
            id: string
            reason: InfeasibleReason
          }>
          nextUnit?:
            | {
                __typename?: 'Unit'
                id: string
                routes: {
                  __typename?: 'RouteConnection'
                  nodes: Array<{
                    __typename?: 'Route'
                    id: string
                    event:
                      | { __typename?: 'CompanySiteEvent' }
                      | { __typename?: 'LoadingEvent'; id: string; name: string }
                      | { __typename?: 'TransferEvent' }
                  }>
                }
              }
            | null
            | undefined
        }
        newUnit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                email: string
                order?: number | null | undefined
                employeeRole?:
                  | {
                      __typename?: 'EmployeeRole'
                      id: string
                      freightage: Array<Freightage>
                      systemSetting: Array<SystemSetting>
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              startOn: any
              endOn: any
              originalLoadingTime: any
              order: number
              loadingTime: any
              eventOrder: number
              positionType: PositionType
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    loadingTime: any
                    address: string
                    cargo?: string | null | undefined
                    requestArrivalNote: string
                    note?: string | null | undefined
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
          infeasibles: Array<{
            __typename?: 'UnitInfeasible'
            id: string
            reason: InfeasibleReason
          }>
          nextUnit?:
            | {
                __typename?: 'Unit'
                id: string
                routes: {
                  __typename?: 'RouteConnection'
                  nodes: Array<{
                    __typename?: 'Route'
                    id: string
                    event:
                      | { __typename?: 'CompanySiteEvent' }
                      | { __typename?: 'LoadingEvent'; id: string; name: string }
                      | { __typename?: 'TransferEvent' }
                  }>
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ContainerUnitDetailDestroyUnitMutationVariables = Exact<{
  input: DestroyUnitInput
}>

export type ContainerUnitDetailDestroyUnitMutation = {
  __typename?: 'Mutation'
  destroyUnit?:
    | {
        __typename?: 'DestroyUnitPayload'
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                email: string
                order?: number | null | undefined
                employeeRole?:
                  | {
                      __typename?: 'EmployeeRole'
                      id: string
                      freightage: Array<Freightage>
                      systemSetting: Array<SystemSetting>
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              startOn: any
              endOn: any
              originalLoadingTime: any
              order: number
              loadingTime: any
              eventOrder: number
              positionType: PositionType
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    loadingTime: any
                    address: string
                    cargo?: string | null | undefined
                    requestArrivalNote: string
                    note?: string | null | undefined
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
          infeasibles: Array<{
            __typename?: 'UnitInfeasible'
            id: string
            reason: InfeasibleReason
          }>
          nextUnit?:
            | {
                __typename?: 'Unit'
                id: string
                routes: {
                  __typename?: 'RouteConnection'
                  nodes: Array<{
                    __typename?: 'Route'
                    id: string
                    event:
                      | { __typename?: 'CompanySiteEvent' }
                      | { __typename?: 'LoadingEvent'; id: string; name: string }
                      | { __typename?: 'TransferEvent' }
                  }>
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ContainerUnitDetailPushContractToUnitMutationVariables = Exact<{
  input: PushContractToUnitInput
}>

export type ContainerUnitDetailPushContractToUnitMutation = {
  __typename?: 'Mutation'
  pushContractToUnit?:
    | {
        __typename?: 'PushContractToUnitPayload'
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                email: string
                order?: number | null | undefined
                employeeRole?:
                  | {
                      __typename?: 'EmployeeRole'
                      id: string
                      freightage: Array<Freightage>
                      systemSetting: Array<SystemSetting>
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              startOn: any
              endOn: any
              originalLoadingTime: any
              order: number
              loadingTime: any
              eventOrder: number
              positionType: PositionType
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    loadingTime: any
                    address: string
                    cargo?: string | null | undefined
                    requestArrivalNote: string
                    note?: string | null | undefined
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
          infeasibles: Array<{
            __typename?: 'UnitInfeasible'
            id: string
            reason: InfeasibleReason
          }>
          nextUnit?:
            | {
                __typename?: 'Unit'
                id: string
                routes: {
                  __typename?: 'RouteConnection'
                  nodes: Array<{
                    __typename?: 'Route'
                    id: string
                    event:
                      | { __typename?: 'CompanySiteEvent' }
                      | { __typename?: 'LoadingEvent'; id: string; name: string }
                      | { __typename?: 'TransferEvent' }
                  }>
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ContainerUnitDetailShiftContractToUnitMutationVariables = Exact<{
  input: ShiftContractToUnitInput
}>

export type ContainerUnitDetailShiftContractToUnitMutation = {
  __typename?: 'Mutation'
  shiftContractToUnit?:
    | {
        __typename?: 'ShiftContractToUnitPayload'
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                email: string
                order?: number | null | undefined
                employeeRole?:
                  | {
                      __typename?: 'EmployeeRole'
                      id: string
                      freightage: Array<Freightage>
                      systemSetting: Array<SystemSetting>
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              startOn: any
              endOn: any
              originalLoadingTime: any
              order: number
              loadingTime: any
              eventOrder: number
              positionType: PositionType
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    loadingTime: any
                    address: string
                    cargo?: string | null | undefined
                    requestArrivalNote: string
                    note?: string | null | undefined
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
          infeasibles: Array<{
            __typename?: 'UnitInfeasible'
            id: string
            reason: InfeasibleReason
          }>
          nextUnit?:
            | {
                __typename?: 'Unit'
                id: string
                routes: {
                  __typename?: 'RouteConnection'
                  nodes: Array<{
                    __typename?: 'Route'
                    id: string
                    event:
                      | { __typename?: 'CompanySiteEvent' }
                      | { __typename?: 'LoadingEvent'; id: string; name: string }
                      | { __typename?: 'TransferEvent' }
                  }>
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ContainerUnitDetailNoticeUnitMutationVariables = Exact<{
  input: NoticeUnitInput
}>

export type ContainerUnitDetailNoticeUnitMutation = {
  __typename?: 'Mutation'
  noticeUnit?:
    | {
        __typename?: 'NoticeUnitPayload'
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                email: string
                order?: number | null | undefined
                employeeRole?:
                  | {
                      __typename?: 'EmployeeRole'
                      id: string
                      freightage: Array<Freightage>
                      systemSetting: Array<SystemSetting>
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              startOn: any
              endOn: any
              originalLoadingTime: any
              order: number
              loadingTime: any
              eventOrder: number
              positionType: PositionType
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    loadingTime: any
                    address: string
                    cargo?: string | null | undefined
                    requestArrivalNote: string
                    note?: string | null | undefined
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
          infeasibles: Array<{
            __typename?: 'UnitInfeasible'
            id: string
            reason: InfeasibleReason
          }>
          nextUnit?:
            | {
                __typename?: 'Unit'
                id: string
                routes: {
                  __typename?: 'RouteConnection'
                  nodes: Array<{
                    __typename?: 'Route'
                    id: string
                    event:
                      | { __typename?: 'CompanySiteEvent' }
                      | { __typename?: 'LoadingEvent'; id: string; name: string }
                      | { __typename?: 'TransferEvent' }
                  }>
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ContainerUnitDetailChangeLoadingEventStartOnMutationVariables = Exact<{
  input: ChangeLoadingEventStartOnInput
}>

export type ContainerUnitDetailChangeLoadingEventStartOnMutation = {
  __typename?: 'Mutation'
  changeLoadingEventStartOn?:
    | {
        __typename?: 'ChangeLoadingEventStartOnPayload'
        loadingEvent: {
          __typename?: 'LoadingEvent'
          route?:
            | {
                __typename?: 'Route'
                unit: {
                  __typename?: 'Unit'
                  id: string
                  startOn: any
                  endOn: any
                  startTime: any
                  endTime: any
                  fixed: boolean
                  createdAt: any
                  updatedAt: any
                  truck?:
                    | {
                        __typename?: 'Truck'
                        id: string
                        carNumber: string
                        order?: number | null | undefined
                        carType: {
                          __typename?: 'CarType'
                          id: string
                          name: string
                          order?: number | null | undefined
                        }
                      }
                    | null
                    | undefined
                  driverEmployee?:
                    | {
                        __typename?: 'Employee'
                        id: string
                        name: string
                        email: string
                        order?: number | null | undefined
                        employeeRole?:
                          | {
                              __typename?: 'EmployeeRole'
                              id: string
                              freightage: Array<Freightage>
                              systemSetting: Array<SystemSetting>
                            }
                          | null
                          | undefined
                      }
                    | null
                    | undefined
                  subcontractor?:
                    | {
                        __typename?: 'CompanyRelation'
                        id: string
                        involvement: Involvement
                        relatedCompany: { __typename?: 'Company'; id: string; name: string }
                      }
                    | null
                    | undefined
                  routes: {
                    __typename?: 'RouteConnection'
                    nodes: Array<{
                      __typename?: 'Route'
                      id: string
                      startOn: any
                      endOn: any
                      originalLoadingTime: any
                      order: number
                      loadingTime: any
                      eventOrder: number
                      positionType: PositionType
                      event:
                        | {
                            __typename?: 'CompanySiteEvent'
                            id: string
                            loadingTime: any
                            companySite: { __typename?: 'CompanySite'; id: string; name: string }
                          }
                        | {
                            __typename?: 'LoadingEvent'
                            id: string
                            name: string
                            category: Category
                            currentState: State
                            loadingTime: any
                            address: string
                            cargo?: string | null | undefined
                            requestArrivalNote: string
                            note?: string | null | undefined
                            relatedCompany: { __typename?: 'Company'; id: string; name: string }
                          }
                        | {
                            __typename?: 'TransferEvent'
                            id: string
                            travelTime: any
                            fast: boolean
                          }
                    }>
                  }
                  infeasibles: Array<{
                    __typename?: 'UnitInfeasible'
                    id: string
                    reason: InfeasibleReason
                  }>
                  nextUnit?:
                    | {
                        __typename?: 'Unit'
                        id: string
                        routes: {
                          __typename?: 'RouteConnection'
                          nodes: Array<{
                            __typename?: 'Route'
                            id: string
                            event:
                              | { __typename?: 'CompanySiteEvent' }
                              | { __typename?: 'LoadingEvent'; id: string; name: string }
                              | { __typename?: 'TransferEvent' }
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ContainerUnitDetailUpdateCompanySiteEventMutationVariables = Exact<{
  input: ChangeCompanySiteEventLoadingTimeInput
}>

export type ContainerUnitDetailUpdateCompanySiteEventMutation = {
  __typename?: 'Mutation'
  changeCompanySiteEventLoadingTime?:
    | {
        __typename?: 'ChangeCompanySiteEventLoadingTimePayload'
        companySiteEvent: {
          __typename?: 'CompanySiteEvent'
          route: {
            __typename?: 'Route'
            unit: {
              __typename?: 'Unit'
              id: string
              startOn: any
              endOn: any
              startTime: any
              endTime: any
              fixed: boolean
              createdAt: any
              updatedAt: any
              truck?:
                | {
                    __typename?: 'Truck'
                    id: string
                    carNumber: string
                    order?: number | null | undefined
                    carType: {
                      __typename?: 'CarType'
                      id: string
                      name: string
                      order?: number | null | undefined
                    }
                  }
                | null
                | undefined
              driverEmployee?:
                | {
                    __typename?: 'Employee'
                    id: string
                    name: string
                    email: string
                    order?: number | null | undefined
                    employeeRole?:
                      | {
                          __typename?: 'EmployeeRole'
                          id: string
                          freightage: Array<Freightage>
                          systemSetting: Array<SystemSetting>
                        }
                      | null
                      | undefined
                  }
                | null
                | undefined
              subcontractor?:
                | {
                    __typename?: 'CompanyRelation'
                    id: string
                    involvement: Involvement
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | null
                | undefined
              routes: {
                __typename?: 'RouteConnection'
                nodes: Array<{
                  __typename?: 'Route'
                  id: string
                  startOn: any
                  endOn: any
                  originalLoadingTime: any
                  order: number
                  loadingTime: any
                  eventOrder: number
                  positionType: PositionType
                  event:
                    | {
                        __typename?: 'CompanySiteEvent'
                        id: string
                        loadingTime: any
                        companySite: { __typename?: 'CompanySite'; id: string; name: string }
                      }
                    | {
                        __typename?: 'LoadingEvent'
                        id: string
                        name: string
                        category: Category
                        currentState: State
                        loadingTime: any
                        address: string
                        cargo?: string | null | undefined
                        requestArrivalNote: string
                        note?: string | null | undefined
                        relatedCompany: { __typename?: 'Company'; id: string; name: string }
                      }
                    | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
                }>
              }
              infeasibles: Array<{
                __typename?: 'UnitInfeasible'
                id: string
                reason: InfeasibleReason
              }>
              nextUnit?:
                | {
                    __typename?: 'Unit'
                    id: string
                    routes: {
                      __typename?: 'RouteConnection'
                      nodes: Array<{
                        __typename?: 'Route'
                        id: string
                        event:
                          | { __typename?: 'CompanySiteEvent' }
                          | { __typename?: 'LoadingEvent'; id: string; name: string }
                          | { __typename?: 'TransferEvent' }
                      }>
                    }
                  }
                | null
                | undefined
            }
          }
        }
      }
    | null
    | undefined
}

export type ContainerUnitDetailQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type ContainerUnitDetailQuery = {
  __typename?: 'Query'
  units: {
    __typename?: 'UnitConnection'
    nodes: Array<{
      __typename?: 'Unit'
      id: string
      startOn: any
      endOn: any
      startTime: any
      endTime: any
      fixed: boolean
      createdAt: any
      updatedAt: any
      truck?:
        | {
            __typename?: 'Truck'
            id: string
            carNumber: string
            order?: number | null | undefined
            carType: {
              __typename?: 'CarType'
              id: string
              name: string
              order?: number | null | undefined
            }
          }
        | null
        | undefined
      driverEmployee?:
        | {
            __typename?: 'Employee'
            id: string
            name: string
            email: string
            order?: number | null | undefined
            employeeRole?:
              | {
                  __typename?: 'EmployeeRole'
                  id: string
                  freightage: Array<Freightage>
                  systemSetting: Array<SystemSetting>
                }
              | null
              | undefined
          }
        | null
        | undefined
      subcontractor?:
        | {
            __typename?: 'CompanyRelation'
            id: string
            involvement: Involvement
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
          }
        | null
        | undefined
      routes: {
        __typename?: 'RouteConnection'
        nodes: Array<{
          __typename?: 'Route'
          id: string
          startOn: any
          endOn: any
          originalLoadingTime: any
          order: number
          loadingTime: any
          eventOrder: number
          positionType: PositionType
          event:
            | {
                __typename?: 'CompanySiteEvent'
                id: string
                loadingTime: any
                companySite: { __typename?: 'CompanySite'; id: string; name: string }
              }
            | {
                __typename?: 'LoadingEvent'
                id: string
                name: string
                category: Category
                currentState: State
                loadingTime: any
                address: string
                cargo?: string | null | undefined
                requestArrivalNote: string
                note?: string | null | undefined
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
        }>
      }
      infeasibles: Array<{ __typename?: 'UnitInfeasible'; id: string; reason: InfeasibleReason }>
      nextUnit?:
        | {
            __typename?: 'Unit'
            id: string
            routes: {
              __typename?: 'RouteConnection'
              nodes: Array<{
                __typename?: 'Route'
                id: string
                event:
                  | { __typename?: 'CompanySiteEvent' }
                  | { __typename?: 'LoadingEvent'; id: string; name: string }
                  | { __typename?: 'TransferEvent' }
              }>
            }
          }
        | null
        | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      category: Category
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
    }>
  }
  trucks: {
    __typename?: 'TruckConnection'
    nodes: Array<{
      __typename?: 'Truck'
      id: string
      carNumber: string
      order?: number | null | undefined
      carType: {
        __typename?: 'CarType'
        id: string
        name: string
        order?: number | null | undefined
      }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  driversEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      email: string
      order?: number | null | undefined
      employeeRole?:
        | {
            __typename?: 'EmployeeRole'
            id: string
            freightage: Array<Freightage>
            systemSetting: Array<SystemSetting>
          }
        | null
        | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  employeeDrivableTrucks: {
    __typename?: 'EmployeeDrivableTruckConnection'
    nodes: Array<{
      __typename?: 'EmployeeDrivableTruck'
      id: string
      priority: Priority
      employee: {
        __typename?: 'Employee'
        id: string
        name: string
        email: string
        order?: number | null | undefined
        employeeRole?:
          | {
              __typename?: 'EmployeeRole'
              id: string
              freightage: Array<Freightage>
              systemSetting: Array<SystemSetting>
            }
          | null
          | undefined
      }
      truck: {
        __typename?: 'Truck'
        id: string
        carNumber: string
        order?: number | null | undefined
        carType: {
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }
      }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  subcontractors: {
    __typename?: 'CompanyRelationConnection'
    nodes: Array<{
      __typename?: 'CompanyRelation'
      id: string
      involvement: Involvement
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
}

export type ContainerUnitDetailContractsQueryVariables = Exact<{
  text: Scalars['String']
}>

export type ContainerUnitDetailContractsQuery = {
  __typename?: 'Query'
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      category: Category
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
}

export type ContainerUnitDetailUnitUpdateSubscriptionVariables = Exact<{
  id: Scalars['ID']
}>

export type ContainerUnitDetailUnitUpdateSubscription = {
  __typename?: 'Subscription'
  unitUpdate: {
    __typename?: 'UnitUpdatePayload'
    unit?:
      | {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          fixed: boolean
          createdAt: any
          updatedAt: any
          nextUnit?:
            | {
                __typename?: 'Unit'
                id: string
                startOn: any
                endOn: any
                startTime: any
                endTime: any
                fixed: boolean
                createdAt: any
                updatedAt: any
                routes: {
                  __typename?: 'RouteConnection'
                  nodes: Array<{
                    __typename?: 'Route'
                    id: string
                    startOn: any
                    endOn: any
                    originalLoadingTime: any
                    order: number
                    loadingTime: any
                    eventOrder: number
                    positionType: PositionType
                    event:
                      | {
                          __typename?: 'CompanySiteEvent'
                          id: string
                          loadingTime: any
                          companySite: { __typename?: 'CompanySite'; id: string; name: string }
                        }
                      | {
                          __typename?: 'LoadingEvent'
                          id: string
                          name: string
                          category: Category
                          currentState: State
                          loadingTime: any
                          address: string
                          cargo?: string | null | undefined
                          requestArrivalNote: string
                          note?: string | null | undefined
                          relatedCompany: { __typename?: 'Company'; id: string; name: string }
                        }
                      | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
                  }>
                }
                truck?:
                  | {
                      __typename?: 'Truck'
                      id: string
                      carNumber: string
                      order?: number | null | undefined
                      carType: {
                        __typename?: 'CarType'
                        id: string
                        name: string
                        order?: number | null | undefined
                      }
                    }
                  | null
                  | undefined
                driverEmployee?:
                  | {
                      __typename?: 'Employee'
                      id: string
                      name: string
                      email: string
                      order?: number | null | undefined
                      employeeRole?:
                        | {
                            __typename?: 'EmployeeRole'
                            id: string
                            freightage: Array<Freightage>
                            systemSetting: Array<SystemSetting>
                          }
                        | null
                        | undefined
                    }
                  | null
                  | undefined
                subcontractor?:
                  | {
                      __typename?: 'CompanyRelation'
                      id: string
                      involvement: Involvement
                      relatedCompany: { __typename?: 'Company'; id: string; name: string }
                    }
                  | null
                  | undefined
                infeasibles: Array<{
                  __typename?: 'UnitInfeasible'
                  id: string
                  reason: InfeasibleReason
                }>
                nextUnit?:
                  | {
                      __typename?: 'Unit'
                      id: string
                      routes: {
                        __typename?: 'RouteConnection'
                        nodes: Array<{
                          __typename?: 'Route'
                          id: string
                          event:
                            | { __typename?: 'CompanySiteEvent' }
                            | { __typename?: 'LoadingEvent'; id: string; name: string }
                            | { __typename?: 'TransferEvent' }
                        }>
                      }
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                order?: number | null | undefined
                carType: {
                  __typename?: 'CarType'
                  id: string
                  name: string
                  order?: number | null | undefined
                }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                email: string
                order?: number | null | undefined
                employeeRole?:
                  | {
                      __typename?: 'EmployeeRole'
                      id: string
                      freightage: Array<Freightage>
                      systemSetting: Array<SystemSetting>
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                involvement: Involvement
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
          routes: {
            __typename?: 'RouteConnection'
            nodes: Array<{
              __typename?: 'Route'
              id: string
              startOn: any
              endOn: any
              originalLoadingTime: any
              order: number
              loadingTime: any
              eventOrder: number
              positionType: PositionType
              event:
                | {
                    __typename?: 'CompanySiteEvent'
                    id: string
                    loadingTime: any
                    companySite: { __typename?: 'CompanySite'; id: string; name: string }
                  }
                | {
                    __typename?: 'LoadingEvent'
                    id: string
                    name: string
                    category: Category
                    currentState: State
                    loadingTime: any
                    address: string
                    cargo?: string | null | undefined
                    requestArrivalNote: string
                    note?: string | null | undefined
                    relatedCompany: { __typename?: 'Company'; id: string; name: string }
                  }
                | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
            }>
          }
          infeasibles: Array<{
            __typename?: 'UnitInfeasible'
            id: string
            reason: InfeasibleReason
          }>
        }
      | null
      | undefined
  }
}

export type ContainerUnitDetailUnitDestroySubscriptionVariables = Exact<{ [key: string]: never }>

export type ContainerUnitDetailUnitDestroySubscription = {
  __typename?: 'Subscription'
  unitDestroy: { __typename?: 'UnitDestroyPayload'; destroiedUnitId?: string | null | undefined }
}

export type ModuleCompanyDetailContentContactListItemFragment = {
  __typename?: 'Contract'
  id: string
  name: string
  address: string
  category: Category
}

export type ModuleCompanyDetailContentFragment = {
  __typename?: 'CompanyRelation'
  id: string
  involvement: Involvement
  relatedCompany: {
    __typename?: 'Company'
    id: string
    name: string
    tel?: string | null | undefined
  }
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      address: string
      category: Category
    }>
  }
}

export type ModuleCompanyDetailFragment = {
  __typename?: 'CompanyRelationConnection'
  nodes: Array<{
    __typename?: 'CompanyRelation'
    id: string
    involvement: Involvement
    relatedCompany: {
      __typename?: 'Company'
      id: string
      name: string
      tel?: string | null | undefined
    }
    contracts: {
      __typename?: 'ContractConnection'
      nodes: Array<{
        __typename?: 'Contract'
        id: string
        name: string
        address: string
        category: Category
      }>
    }
  }>
}

export type ModuleCompanyEditCompanyFragment = {
  __typename?: 'CompanyRelationConnection'
  nodes: Array<{
    __typename?: 'CompanyRelation'
    id: string
    involvement: Involvement
    relatedCompany: {
      __typename?: 'Company'
      id: string
      name: string
      tel?: string | null | undefined
    }
  }>
}

export type ModuleCompanyEditEmployeeFragment = {
  __typename?: 'EmployeeConnection'
  nodes: Array<{
    __typename?: 'Employee'
    id: string
    name: string
    email: string
    tel?: string | null | undefined
  }>
}

export type ModuleCompanyFilterListFragment = {
  __typename?: 'CompanyRelation'
  id: string
  involvement: Involvement
  relatedCompany: {
    __typename?: 'Company'
    id: string
    name: string
    tel?: string | null | undefined
  }
}

export type ModuleCompanyFilterFragment = {
  __typename?: 'CompanyRelationConnection'
  edges: Array<{
    __typename?: 'CompanyRelationEdge'
    node?:
      | {
          __typename?: 'CompanyRelation'
          id: string
          involvement: Involvement
          relatedCompany: {
            __typename?: 'Company'
            id: string
            name: string
            tel?: string | null | undefined
          }
        }
      | null
      | undefined
  }>
  pageInfo: {
    __typename?: 'PageInfo'
    startCursor?: string | null | undefined
    endCursor?: string | null | undefined
    hasNextPage: boolean
    hasPreviousPage: boolean
  }
}

export type ModuleCompanyNewEmployeeFragment = {
  __typename?: 'EmployeeConnection'
  nodes: Array<{
    __typename?: 'Employee'
    id: string
    name: string
    email: string
    tel?: string | null | undefined
  }>
}

export type ModuleContractDetailContentFragment = {
  __typename?: 'Contract'
  id: string
  name: string
  staffName?: string | null | undefined
  tel?: string | null | undefined
  address: string
  loadingTime: any
  cargo?: string | null | undefined
  note?: string | null | undefined
  category: Category
  attachedFiles: {
    __typename?: 'AttachedFileConnection'
    nodes: Array<{
      __typename?: 'AttachedFile'
      id: string
      downloadSignedUrl: string
      originalFilename: string
      filename: string
      createdAt: any
      employee: { __typename?: 'Company'; name: string }
    }>
  }
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{ __typename?: 'CarType'; id: string; name: string }>
  }
  salesEmployee: { __typename?: 'Employee'; name: string }
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
  loadingEvents: {
    __typename?: 'LoadingEventConnection'
    nodes: Array<{
      __typename?: 'LoadingEvent'
      id: string
      loadingTime: any
      route?:
        | {
            __typename?: 'Route'
            id: string
            startOn: any
            endOn: any
            unit: {
              __typename?: 'Unit'
              truck?:
                | { __typename?: 'Truck'; carType: { __typename?: 'CarType'; name: string } }
                | null
                | undefined
              driverEmployee?: { __typename?: 'Employee'; name: string } | null | undefined
            }
          }
        | null
        | undefined
    }>
  }
}

export type ModuleContractDetailFragment = {
  __typename?: 'ContractConnection'
  nodes: Array<{
    __typename?: 'Contract'
    id: string
    name: string
    staffName?: string | null | undefined
    tel?: string | null | undefined
    address: string
    loadingTime: any
    cargo?: string | null | undefined
    note?: string | null | undefined
    category: Category
    attachedFiles: {
      __typename?: 'AttachedFileConnection'
      nodes: Array<{
        __typename?: 'AttachedFile'
        id: string
        downloadSignedUrl: string
        originalFilename: string
        filename: string
        createdAt: any
        employee: { __typename?: 'Company'; name: string }
      }>
    }
    carTypes: {
      __typename?: 'CarTypeConnection'
      nodes: Array<{ __typename?: 'CarType'; id: string; name: string }>
    }
    salesEmployee: { __typename?: 'Employee'; name: string }
    relatedCompany: { __typename?: 'Company'; id: string; name: string }
    loadingEvents: {
      __typename?: 'LoadingEventConnection'
      nodes: Array<{
        __typename?: 'LoadingEvent'
        id: string
        loadingTime: any
        route?:
          | {
              __typename?: 'Route'
              id: string
              startOn: any
              endOn: any
              unit: {
                __typename?: 'Unit'
                truck?:
                  | { __typename?: 'Truck'; carType: { __typename?: 'CarType'; name: string } }
                  | null
                  | undefined
                driverEmployee?: { __typename?: 'Employee'; name: string } | null | undefined
              }
            }
          | null
          | undefined
      }>
    }
  }>
}

export type ModuleContractEditFragment = {
  __typename?: 'Query'
  contracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      address: string
      loadingTime: any
      category: Category
      cargo?: string | null | undefined
      note?: string | null | undefined
      staffName?: string | null | undefined
      tel?: string | null | undefined
      companyRelation: { __typename?: 'CompanyRelation'; id: string }
      salesEmployee: {
        __typename?: 'Employee'
        id: string
        name: string
        email: string
        tel?: string | null | undefined
        employeeRole?:
          | {
              __typename?: 'EmployeeRole'
              id: string
              freightage: Array<Freightage>
              systemSetting: Array<SystemSetting>
            }
          | null
          | undefined
      }
      company: { __typename?: 'Company'; id: string; name: string }
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{ __typename?: 'CarType'; id: string; name: string }>
      }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  salesEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      email: string
      tel?: string | null | undefined
      employeeRole?:
        | {
            __typename?: 'EmployeeRole'
            id: string
            freightage: Array<Freightage>
            systemSetting: Array<SystemSetting>
          }
        | null
        | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  companyRelations: {
    __typename?: 'CompanyRelationConnection'
    nodes: Array<{
      __typename?: 'CompanyRelation'
      id: string
      involvement: Involvement
      company: { __typename?: 'Company'; id: string; name: string }
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
}

export type ModuleContractEditContractFragment = {
  __typename?: 'Contract'
  id: string
  name: string
  address: string
  loadingTime: any
  category: Category
  cargo?: string | null | undefined
  note?: string | null | undefined
  staffName?: string | null | undefined
  tel?: string | null | undefined
  companyRelation: { __typename?: 'CompanyRelation'; id: string }
  salesEmployee: {
    __typename?: 'Employee'
    id: string
    name: string
    email: string
    tel?: string | null | undefined
    employeeRole?:
      | {
          __typename?: 'EmployeeRole'
          id: string
          freightage: Array<Freightage>
          systemSetting: Array<SystemSetting>
        }
      | null
      | undefined
  }
  company: { __typename?: 'Company'; id: string; name: string }
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{ __typename?: 'CarType'; id: string; name: string }>
  }
}

export type ModuleContractEditCompanyRelationFragment = {
  __typename?: 'CompanyRelation'
  id: string
  involvement: Involvement
  company: { __typename?: 'Company'; id: string; name: string }
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
}

export type ModuleContractEditCarTypeFragment = {
  __typename?: 'CarType'
  id: string
  name: string
  order?: number | null | undefined
}

export type ModuleContractEditEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  name: string
  email: string
  tel?: string | null | undefined
  employeeRole?:
    | {
        __typename?: 'EmployeeRole'
        id: string
        freightage: Array<Freightage>
        systemSetting: Array<SystemSetting>
      }
    | null
    | undefined
}

export type ModuleContractFilterListFragment = {
  __typename?: 'Contract'
  id: string
  name: string
  category: Category
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
}

export type ModuleContractFilterFragment = {
  __typename?: 'ContractConnection'
  edges: Array<{
    __typename?: 'ContractEdge'
    node?:
      | {
          __typename?: 'Contract'
          id: string
          name: string
          category: Category
          relatedCompany: { __typename?: 'Company'; id: string; name: string }
        }
      | null
      | undefined
  }>
  pageInfo: {
    __typename?: 'PageInfo'
    startCursor?: string | null | undefined
    endCursor?: string | null | undefined
    hasNextPage: boolean
    hasPreviousPage: boolean
  }
}

export type ModuleContractNewFragment = {
  __typename?: 'Query'
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  salesEmployees: {
    __typename?: 'EmployeeConnection'
    nodes: Array<{
      __typename?: 'Employee'
      id: string
      name: string
      email: string
      tel?: string | null | undefined
      employeeRole?:
        | {
            __typename?: 'EmployeeRole'
            id: string
            freightage: Array<Freightage>
            systemSetting: Array<SystemSetting>
          }
        | null
        | undefined
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
  companyRelations: {
    __typename?: 'CompanyRelationConnection'
    nodes: Array<{
      __typename?: 'CompanyRelation'
      id: string
      involvement: Involvement
      company: { __typename?: 'Company'; id: string; name: string }
      relatedCompany: { __typename?: 'Company'; id: string; name: string }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null | undefined
      endCursor?: string | null | undefined
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
  }
}

export type ModuleContractNewCompanyRelationFragment = {
  __typename?: 'CompanyRelation'
  id: string
  involvement: Involvement
  company: { __typename?: 'Company'; id: string; name: string }
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
}

export type ModuleContractNewCarTypeFragment = {
  __typename?: 'CarType'
  id: string
  name: string
  order?: number | null | undefined
}

export type ModuleContractNewEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  name: string
  email: string
  tel?: string | null | undefined
  employeeRole?:
    | {
        __typename?: 'EmployeeRole'
        id: string
        freightage: Array<Freightage>
        systemSetting: Array<SystemSetting>
      }
    | null
    | undefined
}

export type EmployeeManagementDetailFragment = {
  __typename?: 'Employee'
  id: string
  name: string
  tel?: string | null | undefined
  email: string
  emailVerifiedAt?: any | null | undefined
  enableEmailNotification: boolean
  employeeRole?: { __typename?: 'EmployeeRole'; id: string; name: string } | null | undefined
  companySite: { __typename?: 'CompanySite'; id: string; name: string }
  lineRelationship?: { __typename?: 'LineRelationship'; id: string } | null | undefined
}

export type EmployeeManagementListFragment = {
  __typename?: 'Employee'
  id: string
  name: string
  order?: number | null | undefined
  emailVerifiedAt?: any | null | undefined
  lineRelationship?: { __typename?: 'LineRelationship'; id: string; gid: string } | null | undefined
  companySite: { __typename?: 'CompanySite'; id: string; name: string }
}

export type ModuleEventDetailEventEmployeeFragment = {
  __typename?: 'EventEmployee'
  id: string
  startOn: any
  startTime: any
  endOn: any
  endTime: any
  createdAt: any
  updatedAt: any
  employee?:
    | { __typename?: 'Employee'; id: string; name: string; order?: number | null | undefined }
    | null
    | undefined
  createEmployee: {
    __typename?: 'Employee'
    id: string
    name: string
    order?: number | null | undefined
  }
  truck?:
    | {
        __typename?: 'Truck'
        id: string
        carNumber: string
        order?: number | null | undefined
        carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
      }
    | null
    | undefined
  detail: {
    __typename?: 'EventEmployeeDetail'
    id: string
    note?: string | null | undefined
    employeeReasonType: EventEmployeeReasonType
  }
}

export type ModuleEventDetailEventTemporaryVehicleAllocationContractFragment = {
  __typename?: 'Contract'
  id: string
  name: string
  address: string
  category: Category
  companyRelation: {
    __typename?: 'CompanyRelation'
    id: string
    relatedCompany: { __typename?: 'Company'; id: string; name: string }
  }
}

export type ModuleEventDetailEventTemporaryVehicleAllocationFragment = {
  __typename?: 'EventTemporaryVehicleAllocation'
  id: string
  startOn: any
  startTime: any
  endOn: any
  endTime: any
  createdAt: any
  updatedAt: any
  employee?:
    | { __typename?: 'Employee'; id: string; name: string; order?: number | null | undefined }
    | null
    | undefined
  createEmployee: {
    __typename?: 'Employee'
    id: string
    name: string
    order?: number | null | undefined
  }
  truck?:
    | {
        __typename?: 'Truck'
        id: string
        carNumber: string
        order?: number | null | undefined
        carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
      }
    | null
    | undefined
  detail: {
    __typename?: 'EventTemporaryVehicleAllocationDetail'
    id: string
    name: string
    address?: string | null | undefined
    category?: Category | null | undefined
    loadingTime?: any | null | undefined
    cargo?: string | null | undefined
    note?: string | null | undefined
    manifest: Manifest
    operatorCount?: string | null | undefined
    contractPaperStatus?: ContractPaperStatus | null | undefined
    relatedCompanyName?: string | null | undefined
    requestArrivalTime?: string | null | undefined
    staffName?: string | null | undefined
    tel?: string | null | undefined
    prevCompanySiteEventTime?: any | null | undefined
    nextCompanySiteEventTime?: any | null | undefined
    requestCarTypes: {
      __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarTypeConnection'
      nodes: Array<{
        __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarType'
        carType: { __typename?: 'CarType'; id: string }
      }>
    }
    requestArrivals: {
      __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrivalConnection'
      nodes: Array<{
        __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrival'
        date: any
      }>
    }
    companyRelation?: { __typename?: 'CompanyRelation'; id: string } | null | undefined
    contract?:
      | {
          __typename?: 'Contract'
          id: string
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{ __typename?: 'CarType'; id: string }>
          }
        }
      | null
      | undefined
    subContract?:
      | {
          __typename?: 'Contract'
          id: string
          name: string
          address: string
          category: Category
          companyRelation: {
            __typename?: 'CompanyRelation'
            id: string
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
          }
        }
      | null
      | undefined
    salesEmployee?: { __typename?: 'Employee'; id: string } | null | undefined
  }
}

export type ModuleEventDetailUnitFragment = {
  __typename?: 'Unit'
  id: string
  routes: {
    __typename?: 'RouteConnection'
    nodes: Array<{
      __typename?: 'Route'
      id: string
      event:
        | { __typename?: 'CompanySiteEvent' }
        | {
            __typename?: 'LoadingEvent'
            id: string
            name: string
            staffName?: string | null | undefined
            tel?: string | null | undefined
            address: string
            loadingTime: any
            cargo?: string | null | undefined
            note?: string | null | undefined
            category: Category
            contract: { __typename?: 'Contract'; id: string }
            salesEmployee: { __typename?: 'Employee'; id: string }
          }
        | { __typename?: 'TransferEvent' }
    }>
  }
}

export type ModuleEventDetailEventTruckFragment = {
  __typename?: 'EventTruck'
  id: string
  startOn: any
  startTime: any
  endOn: any
  endTime: any
  createdAt: any
  updatedAt: any
  employee?:
    | { __typename?: 'Employee'; id: string; name: string; order?: number | null | undefined }
    | null
    | undefined
  createEmployee: {
    __typename?: 'Employee'
    id: string
    name: string
    order?: number | null | undefined
  }
  truck?:
    | {
        __typename?: 'Truck'
        id: string
        carNumber: string
        order?: number | null | undefined
        carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
      }
    | null
    | undefined
  detail: {
    __typename?: 'EventTruckDetail'
    id: string
    note?: string | null | undefined
    truckReasonType: EventTruckReasonType
  }
}

export type ModuleEventDetailContractFragment = {
  __typename?: 'Contract'
  id: string
  name: string
  category: Category
  address: string
  loadingTime: any
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  salesEmployee: { __typename?: 'Employee'; id: string; name: string }
  companyRelation: {
    __typename?: 'CompanyRelation'
    id: string
    relatedCompany: { __typename?: 'Company'; id: string; name: string }
  }
}

export type ModuleEventDetailCompanyRelationFragment = {
  __typename?: 'CompanyRelation'
  id: string
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
}

export type ModuleEventDetailEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  name: string
  order?: number | null | undefined
}

export type ModuleEventDetailTruckFragment = {
  __typename?: 'Truck'
  id: string
  carNumber: string
  order?: number | null | undefined
  carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
}

export type ModuleEventDetailEmployeeDrivableTruckFragment = {
  __typename?: 'EmployeeDrivableTruck'
  id: string
  priority: Priority
  employee: { __typename?: 'Employee'; id: string }
  truck: { __typename?: 'Truck'; id: string }
}

export type ModuleEventDetailCarTypeFragment = {
  __typename?: 'CarType'
  id: string
  name: string
  order?: number | null | undefined
}

export type ModuleEventNewEventEmployeeFragment = {
  __typename?: 'EventEmployee'
  id: string
  startOn: any
  startTime: any
  endOn: any
  endTime: any
  employee?:
    | { __typename?: 'Employee'; id: string; name: string; order?: number | null | undefined }
    | null
    | undefined
  createEmployee: {
    __typename?: 'Employee'
    id: string
    name: string
    order?: number | null | undefined
  }
  truck?:
    | {
        __typename?: 'Truck'
        id: string
        carNumber: string
        order?: number | null | undefined
        carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
      }
    | null
    | undefined
  detail: {
    __typename?: 'EventEmployeeDetail'
    id: string
    note?: string | null | undefined
    employeeReasonType: EventEmployeeReasonType
  }
}

export type ModuleEventNewExternalScrapCollectionRequestFragment = {
  __typename?: 'ExternalScrapCollectionRequest'
  id: string
  requesterName: string
  requesterCompanyName: string
  requesterEmail: string
  requesterPhone: string
  siteName: string
  siteAddress: string
  cargoDetails: string
  desiredPickupDate: string
  desiredPickupPeriod: DesiredPickupPeriod
  numberOfTrucks: number
  kindOfTruck: string
  siteContactName?: string | null | undefined
  siteContactPhone?: string | null | undefined
  comment?: string | null | undefined
  acceptedAt?: any | null | undefined
  rejectedAt?: any | null | undefined
  createdAt: any
  updatedAt: any
  estimatedContracts: {
    __typename?: 'ContractConnection'
    nodes: Array<{
      __typename?: 'Contract'
      id: string
      name: string
      category: Category
      address: string
      loadingTime: any
      cargo?: string | null | undefined
      note?: string | null | undefined
      tel?: string | null | undefined
      staffName?: string | null | undefined
      carTypes: {
        __typename?: 'CarTypeConnection'
        nodes: Array<{
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }>
      }
      salesEmployee: { __typename?: 'Employee'; id: string; name: string }
      companyRelation: {
        __typename?: 'CompanyRelation'
        id: string
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    }>
  }
}

export type ModuleEventNewEventTruckFragment = {
  __typename?: 'EventTruck'
  id: string
  startOn: any
  startTime: any
  endOn: any
  endTime: any
  employee?:
    | { __typename?: 'Employee'; id: string; name: string; order?: number | null | undefined }
    | null
    | undefined
  createEmployee: {
    __typename?: 'Employee'
    id: string
    name: string
    order?: number | null | undefined
  }
  truck?:
    | {
        __typename?: 'Truck'
        id: string
        carNumber: string
        order?: number | null | undefined
        carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
      }
    | null
    | undefined
  detail: {
    __typename?: 'EventTruckDetail'
    id: string
    note?: string | null | undefined
    truckReasonType: EventTruckReasonType
  }
}

export type ModuleEventNewEventTemporaryVehicleAllocationFragment = {
  __typename?: 'EventTemporaryVehicleAllocation'
  id: string
  startOn: any
  startTime: any
  endOn: any
  endTime: any
  employee?:
    | { __typename?: 'Employee'; id: string; name: string; order?: number | null | undefined }
    | null
    | undefined
  truck?:
    | {
        __typename?: 'Truck'
        id: string
        order?: number | null | undefined
        carNumber: string
        carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
      }
    | null
    | undefined
  detail: {
    __typename?: 'EventTemporaryVehicleAllocationDetail'
    id: string
    name: string
    address?: string | null | undefined
    category?: Category | null | undefined
    loadingTime?: any | null | undefined
    cargo?: string | null | undefined
    note?: string | null | undefined
    manifest: Manifest
    operatorCount?: string | null | undefined
    contractPaperStatus?: ContractPaperStatus | null | undefined
    relatedCompanyName?: string | null | undefined
    requestArrivalTime?: string | null | undefined
    staffName?: string | null | undefined
    tel?: string | null | undefined
    requestCarTypes: {
      __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarTypeConnection'
      nodes: Array<{
        __typename?: 'EventTemporaryVehicleAllocationDetailRequestCarType'
        carType: { __typename?: 'CarType'; id: string }
      }>
    }
    requestArrivals: {
      __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrivalConnection'
      nodes: Array<{
        __typename?: 'EventTemporaryVehicleAllocationDetailRequestArrival'
        date: any
      }>
    }
    companyRelation?: { __typename?: 'CompanyRelation'; id: string } | null | undefined
    contract?:
      | {
          __typename?: 'Contract'
          id: string
          carTypes: {
            __typename?: 'CarTypeConnection'
            nodes: Array<{ __typename?: 'CarType'; id: string }>
          }
        }
      | null
      | undefined
    salesEmployee?: { __typename?: 'Employee'; id: string } | null | undefined
  }
}

export type ModuleEventNewUnitFragment = {
  __typename?: 'Unit'
  id: string
  startOn: any
  routes: {
    __typename?: 'RouteConnection'
    nodes: Array<{
      __typename?: 'Route'
      id: string
      event:
        | { __typename?: 'CompanySiteEvent' }
        | {
            __typename?: 'LoadingEvent'
            id: string
            name: string
            staffName?: string | null | undefined
            tel?: string | null | undefined
            address: string
            loadingTime: any
            cargo?: string | null | undefined
            note?: string | null | undefined
            category: Category
            contract: { __typename?: 'Contract'; id: string }
            salesEmployee: { __typename?: 'Employee'; id: string }
          }
        | { __typename?: 'TransferEvent' }
    }>
  }
}

export type ModuleEventNewContractFragment = {
  __typename?: 'Contract'
  id: string
  name: string
  category: Category
  address: string
  loadingTime: any
  cargo?: string | null | undefined
  note?: string | null | undefined
  tel?: string | null | undefined
  staffName?: string | null | undefined
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  salesEmployee: { __typename?: 'Employee'; id: string; name: string }
  companyRelation: {
    __typename?: 'CompanyRelation'
    id: string
    relatedCompany: { __typename?: 'Company'; id: string; name: string }
  }
}

export type ModuleEventNewCompanyRelationFragment = {
  __typename?: 'CompanyRelation'
  id: string
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
}

export type ModuleEventNewEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  name: string
  order?: number | null | undefined
}

export type ModuleEventNewTruckFragment = {
  __typename?: 'Truck'
  id: string
  order?: number | null | undefined
  carNumber: string
  carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
}

export type ModuleEventNewEmployeeDrivableTruckFragment = {
  __typename?: 'EmployeeDrivableTruck'
  id: string
  priority: Priority
  employee: { __typename?: 'Employee'; id: string }
  truck: { __typename?: 'Truck'; id: string }
}

export type ModuleEventNewCarTypeFragment = {
  __typename?: 'CarType'
  id: string
  name: string
  order?: number | null | undefined
}

export type ModuleEventRequestLoadingEventFragment = {
  __typename?: 'LoadingEvent'
  id: string
  name: string
  address: string
  staffName?: string | null | undefined
  tel?: string | null | undefined
  requestArrivalNote: string
  cargo?: string | null | undefined
  note?: string | null | undefined
  manifest: Manifest
  operatorCount?: string | null | undefined
  contractPaperStatus?: ContractPaperStatus | null | undefined
  category: Category
  currentState: State
  loadingTime: any
  contract: {
    __typename?: 'Contract'
    id: string
    carTypes: {
      __typename?: 'CarTypeConnection'
      nodes: Array<{ __typename?: 'CarType'; id: string; name: string }>
    }
  }
  route?:
    | {
        __typename?: 'Route'
        id: string
        order: number
        eventOrder: number
        loadingTime: any
        startOn: any
        endOn: any
        positionType: PositionType
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
        }
      }
    | null
    | undefined
  company: { __typename?: 'Company'; id: string; name: string }
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
  salesEmployee: { __typename?: 'Employee'; id: string; name: string }
  createdEmployee: { __typename?: 'Employee'; id: string; name: string }
  attachedFiles: {
    __typename?: 'AttachedFileConnection'
    nodes: Array<{
      __typename?: 'AttachedFile'
      id: string
      originalFilename: string
      downloadSignedUrl: string
      createdAt: any
    }>
  }
}

export type ModuleEventRequestContractFragment = {
  __typename?: 'Contract'
  id: string
  name: string
  category: Category
  address: string
  loadingTime: any
  cargo?: string | null | undefined
  note?: string | null | undefined
  tel?: string | null | undefined
  staffName?: string | null | undefined
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  salesEmployee: { __typename?: 'Employee'; id: string; name: string }
  companyRelation: {
    __typename?: 'CompanyRelation'
    id: string
    relatedCompany: { __typename?: 'Company'; id: string; name: string }
  }
}

export type ModuleEventRequestCompanyRelationFragment = {
  __typename?: 'CompanyRelation'
  id: string
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
}

export type ModuleEventRequestEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  name: string
  order?: number | null | undefined
}

export type ModuleEventRequestTruckFragment = {
  __typename?: 'Truck'
  id: string
  order?: number | null | undefined
  carNumber: string
  carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
}

export type ModuleEventRequestEmployeeDrivableTruckFragment = {
  __typename?: 'EmployeeDrivableTruck'
  id: string
  priority: Priority
  employee: { __typename?: 'Employee'; id: string }
  truck: { __typename?: 'Truck'; id: string }
}

export type ModuleEventRequestCarTypeFragment = {
  __typename?: 'CarType'
  id: string
  name: string
  order?: number | null | undefined
}

export type ModuleExternalScrapCollectionRequestDetailFragment = {
  __typename?: 'ExternalScrapCollectionRequest'
  id: string
  requesterName: string
  requesterCompanyName: string
  requesterEmail: string
  requesterPhone: string
  siteName: string
  siteAddress: string
  cargoDetails: string
  desiredPickupDate: string
  desiredPickupPeriod: DesiredPickupPeriod
  numberOfTrucks: number
  kindOfTruck: string
  siteContactName?: string | null | undefined
  siteContactPhone?: string | null | undefined
  comment?: string | null | undefined
  acceptedAt?: any | null | undefined
  rejectedAt?: any | null | undefined
  createdAt: any
  updatedAt: any
}

export type ModuleLoadingEventDetailContractFragment = {
  __typename?: 'Contract'
  id: string
  name: string
  address: string
  category: Category
  companyRelation: {
    __typename?: 'CompanyRelation'
    id: string
    relatedCompany: { __typename?: 'Company'; id: string; name: string }
  }
}

export type ModuleLoadingEventDetailFragment = {
  __typename?: 'LoadingEvent'
  id: string
  name: string
  address: string
  staffName?: string | null | undefined
  tel?: string | null | undefined
  requestArrivalNote: string
  cargo?: string | null | undefined
  note?: string | null | undefined
  manifest: Manifest
  operatorCount?: string | null | undefined
  contractPaperStatus?: ContractPaperStatus | null | undefined
  category: Category
  currentState: State
  loadingTime: any
  fixed: boolean
  createdAt: any
  updatedAt: any
  externalScrapCollectionRequest?:
    | {
        __typename?: 'ExternalScrapCollectionRequest'
        id: string
        requesterName: string
        requesterCompanyName: string
        requesterEmail: string
        requesterPhone: string
        siteName: string
        siteAddress: string
        cargoDetails: string
        desiredPickupDate: string
        desiredPickupPeriod: DesiredPickupPeriod
        numberOfTrucks: number
        kindOfTruck: string
        siteContactName?: string | null | undefined
        siteContactPhone?: string | null | undefined
        comment?: string | null | undefined
        acceptedAt?: any | null | undefined
        rejectedAt?: any | null | undefined
        createdAt: any
        updatedAt: any
      }
    | null
    | undefined
  subContract?:
    | {
        __typename?: 'Contract'
        id: string
        name: string
        address: string
        category: Category
        companyRelation: {
          __typename?: 'CompanyRelation'
          id: string
          relatedCompany: { __typename?: 'Company'; id: string; name: string }
        }
      }
    | null
    | undefined
  carTypes: {
    __typename?: 'CarTypeConnection'
    nodes: Array<{
      __typename?: 'CarType'
      id: string
      name: string
      order?: number | null | undefined
    }>
  }
  route?:
    | {
        __typename?: 'Route'
        id: string
        loadingTime: any
        startOn: any
        endOn: any
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          truck?:
            | { __typename?: 'Truck'; carType: { __typename?: 'CarType'; name: string } }
            | null
            | undefined
          driverEmployee?: { __typename?: 'Employee'; name: string } | null | undefined
        }
      }
    | null
    | undefined
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
  salesEmployee: { __typename?: 'Employee'; id: string; name: string }
  createdEmployee: { __typename?: 'Employee'; id: string; name: string }
  attachedFiles: {
    __typename?: 'AttachedFileConnection'
    nodes: Array<{
      __typename?: 'AttachedFile'
      id: string
      originalFilename: string
      downloadSignedUrl: string
      createdAt: any
    }>
  }
}

export type ModuleUnitListLoadingEventFragment = {
  __typename?: 'LoadingEvent'
  id: string
  name: string
  address: string
  staffName?: string | null | undefined
  tel?: string | null | undefined
  requestArrivalNote: string
  cargo?: string | null | undefined
  note?: string | null | undefined
  category: Category
  currentState: State
  loadingTime: any
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
  route?:
    | {
        __typename?: 'Route'
        id: string
        order: number
        loadingTime: any
        startOn: any
        endOn: any
        positionType: PositionType
        eventOrder: number
        event:
          | {
              __typename?: 'CompanySiteEvent'
              id: string
              loadingTime: any
              companySite: { __typename?: 'CompanySite'; id: string; name: string }
            }
          | {
              __typename?: 'LoadingEvent'
              id: string
              name: string
              address: string
              staffName?: string | null | undefined
              tel?: string | null | undefined
              requestArrivalNote: string
              cargo?: string | null | undefined
              note?: string | null | undefined
              category: Category
              currentState: State
              loadingTime: any
              relatedCompany: { __typename?: 'Company'; id: string; name: string }
            }
          | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
        unit: {
          __typename?: 'Unit'
          id: string
          startOn: any
          endOn: any
          startTime: any
          endTime: any
          own: boolean
          fixed: boolean
          truck?:
            | {
                __typename?: 'Truck'
                id: string
                carNumber: string
                carType: { __typename?: 'CarType'; id: string; name: string }
              }
            | null
            | undefined
          driverEmployee?:
            | {
                __typename?: 'Employee'
                id: string
                name: string
                email: string
                tel?: string | null | undefined
                employeeRole?:
                  | {
                      __typename?: 'EmployeeRole'
                      id: string
                      freightage: Array<Freightage>
                      systemSetting: Array<SystemSetting>
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          subcontractor?:
            | {
                __typename?: 'CompanyRelation'
                id: string
                relatedCompany: { __typename?: 'Company'; id: string; name: string }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ModuleSelectCarTypeFragment = {
  __typename?: 'CarType'
  id: string
  name: string
  order?: number | null | undefined
}

export type ModuleSelectDriverEmployeeEmployeeDrivableTruckFragment = {
  __typename?: 'EmployeeDrivableTruck'
  id: string
  priority: Priority
  employee: { __typename?: 'Employee'; id: string }
  truck: { __typename?: 'Truck'; id: string }
}

export type ModuleSelectDriverEmployeeDriverEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  name: string
  order?: number | null | undefined
}

export type ModuleSelectDriverEmployeeTruckFragment = {
  __typename?: 'Truck'
  id: string
  carNumber: string
  order?: number | null | undefined
  carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
}

export type ModuleSelectTruckEmployeeDrivableTruckFragment = {
  __typename?: 'EmployeeDrivableTruck'
  id: string
  priority: Priority
  employee: { __typename?: 'Employee'; id: string }
  truck: { __typename?: 'Truck'; id: string }
}

export type ModuleSelectTruckDriverEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  name: string
  order?: number | null | undefined
}

export type ModuleSelectTruckTruckFragment = {
  __typename?: 'Truck'
  id: string
  carNumber: string
  order?: number | null | undefined
  carType: { __typename?: 'CarType'; id: string; order?: number | null | undefined }
}

export type ModuleTimelineEventRouteFragment = {
  __typename?: 'Route'
  id: string
  order: number
  startOn: any
  loadingTime: any
  event:
    | {
        __typename?: 'CompanySiteEvent'
        id: string
        loadingTime: any
        companySite: { __typename?: 'CompanySite'; id: string; name: string }
      }
    | {
        __typename?: 'LoadingEvent'
        id: string
        name: string
        category: Category
        currentState: State
        cargo?: string | null | undefined
        fixed: boolean
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
}

export type ModuleTimelineEventUnitFragment = {
  __typename?: 'Unit'
  id: string
  startOn: any
  endOn: any
  startTime: any
  endTime: any
  feasible: boolean
  fixed: boolean
  truck?:
    | {
        __typename?: 'Truck'
        id: string
        carNumber: string
        order?: number | null | undefined
        companySite: { __typename?: 'CompanySite'; id: string; name: string }
        carType: {
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }
      }
    | null
    | undefined
  driverEmployee?:
    | {
        __typename?: 'Employee'
        id: string
        name: string
        order?: number | null | undefined
        companySite: { __typename?: 'CompanySite'; id: string; name: string }
      }
    | null
    | undefined
  subcontractor?:
    | {
        __typename?: 'CompanyRelation'
        id: string
        involvement: Involvement
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    | null
    | undefined
  routes: {
    __typename?: 'RouteConnection'
    nodes: Array<{
      __typename?: 'Route'
      id: string
      order: number
      startOn: any
      loadingTime: any
      event:
        | {
            __typename?: 'CompanySiteEvent'
            id: string
            loadingTime: any
            companySite: { __typename?: 'CompanySite'; id: string; name: string }
          }
        | {
            __typename?: 'LoadingEvent'
            id: string
            name: string
            category: Category
            currentState: State
            cargo?: string | null | undefined
            fixed: boolean
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
          }
        | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
    }>
  }
}

export type ModuleTimelineEventEventTemporaryVehicleAllocationFragment = {
  __typename?: 'EventTemporaryVehicleAllocation'
  id: string
  startOn: any
  endOn: any
  startTime: any
  endTime: any
  truck?:
    | {
        __typename?: 'Truck'
        id: string
        carNumber: string
        order?: number | null | undefined
        companySite: { __typename?: 'CompanySite'; id: string; name: string }
        carType: {
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }
      }
    | null
    | undefined
  employee?:
    | {
        __typename?: 'Employee'
        id: string
        name: string
        order?: number | null | undefined
        companySite: { __typename?: 'CompanySite'; id: string; name: string }
      }
    | null
    | undefined
  detail: {
    __typename?: 'EventTemporaryVehicleAllocationDetail'
    id: string
    name: string
    category?: Category | null | undefined
    cargo?: string | null | undefined
  }
}

export type ModuleTimelineEventEventTruckFragment = {
  __typename?: 'EventTruck'
  id: string
  startOn: any
  endOn: any
  startTime: any
  endTime: any
  truck?:
    | {
        __typename?: 'Truck'
        id: string
        carNumber: string
        order?: number | null | undefined
        companySite: { __typename?: 'CompanySite'; id: string; name: string }
        carType: {
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }
      }
    | null
    | undefined
  employee?:
    | {
        __typename?: 'Employee'
        id: string
        name: string
        order?: number | null | undefined
        companySite: { __typename?: 'CompanySite'; id: string; name: string }
      }
    | null
    | undefined
  detail: {
    __typename?: 'EventTruckDetail'
    id: string
    note?: string | null | undefined
    truckReasonType: EventTruckReasonType
  }
}

export type ModuleTimelineEventEventEmployeeFragment = {
  __typename?: 'EventEmployee'
  id: string
  startOn: any
  endOn: any
  startTime: any
  endTime: any
  truck?:
    | {
        __typename?: 'Truck'
        id: string
        carNumber: string
        order?: number | null | undefined
        companySite: { __typename?: 'CompanySite'; id: string; name: string }
        carType: {
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }
      }
    | null
    | undefined
  employee?:
    | {
        __typename?: 'Employee'
        id: string
        name: string
        order?: number | null | undefined
        companySite: { __typename?: 'CompanySite'; id: string; name: string }
      }
    | null
    | undefined
  detail: {
    __typename?: 'EventEmployeeDetail'
    id: string
    note?: string | null | undefined
    employeeReasonType: EventEmployeeReasonType
  }
}

export type ModuleTimelineTruckResourceFragment = {
  __typename?: 'Truck'
  id: string
  carNumber: string
  order?: number | null | undefined
  companySite: { __typename?: 'CompanySite'; id: string; name: string }
  carType: { __typename?: 'CarType'; id: string; name: string; order?: number | null | undefined }
}

export type ModuleTimelineDriverEmployeeResourceFragment = {
  __typename?: 'Employee'
  id: string
  name: string
  order?: number | null | undefined
  companySite: { __typename?: 'CompanySite'; id: string; name: string }
}

export type ModuleTimelineSubcontractorResourceFragment = {
  __typename?: 'CompanyRelation'
  id: string
  involvement: Involvement
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
}

export type ModuleTimelineTruckBackgroundFragment = {
  __typename?: 'TruckUnavailablePeriod'
  id: string
  startOn: any
  endOn: any
  truck?: { __typename?: 'Truck'; id: string } | null | undefined
}

export type ModuleTimelineEmployeeBackgroundFragment = {
  __typename?: 'EmployeeUnavailablePeriod'
  id: string
  startOn: any
  endOn: any
  employee?: { __typename?: 'Employee'; id: string } | null | undefined
}

export type ModuleTimelineToolbarFilterCompanySiteFragment = {
  __typename?: 'CompanySite'
  id: string
  name: string
}

export type ModuleTimelineToolbarFilterCarTypeFragment = {
  __typename?: 'CarType'
  id: string
  name: string
  order?: number | null | undefined
}

export type ModuleTimelineToolbarFilterTruckFragment = {
  __typename?: 'Truck'
  id: string
  carNumber: string
  carType: { __typename?: 'CarType'; id: string }
}

export type TruckManagementEmployeeDrivableTruckFragment = {
  __typename?: 'EmployeeDrivableTruck'
  id: string
  priority: Priority
  employee: { __typename?: 'Employee'; id: string; name: string }
}

export type TruckManagementDetailFragment = {
  __typename?: 'Truck'
  id: string
  carNumber: string
  note?: string | null | undefined
  carType: { __typename?: 'CarType'; id: string; name: string }
  companySite: { __typename?: 'CompanySite'; id: string; name: string }
  employeeDrivableTrucks: {
    __typename?: 'EmployeeDrivableTruckConnection'
    edges: Array<{
      __typename?: 'EmployeeDrivableTruckEdge'
      node?:
        | {
            __typename?: 'EmployeeDrivableTruck'
            id: string
            priority: Priority
            employee: { __typename?: 'Employee'; id: string; name: string }
          }
        | null
        | undefined
    }>
  }
}

export type TruckManagementListFragment = {
  __typename?: 'Truck'
  id: string
  carNumber: string
  order?: number | null | undefined
  carType: { __typename?: 'CarType'; id: string; name: string }
  companySite: { __typename?: 'CompanySite'; id: string; name: string }
}

export type ModuleUnitDetailEmployeeDrivableTruckFragment = {
  __typename?: 'EmployeeDrivableTruck'
  id: string
  priority: Priority
  employee: {
    __typename?: 'Employee'
    id: string
    name: string
    email: string
    order?: number | null | undefined
    employeeRole?:
      | {
          __typename?: 'EmployeeRole'
          id: string
          freightage: Array<Freightage>
          systemSetting: Array<SystemSetting>
        }
      | null
      | undefined
  }
  truck: {
    __typename?: 'Truck'
    id: string
    carNumber: string
    order?: number | null | undefined
    carType: { __typename?: 'CarType'; id: string; name: string; order?: number | null | undefined }
  }
}

export type ModuleUnitDetailCompanySiteEventFragment = {
  __typename?: 'CompanySiteEvent'
  id: string
  loadingTime: any
  companySite: { __typename?: 'CompanySite'; id: string; name: string }
}

export type ModuleUnitDetailTransferEventFragment = {
  __typename?: 'TransferEvent'
  id: string
  travelTime: any
  fast: boolean
}

export type ModuleUnitDetailLoadingEventFragment = {
  __typename?: 'LoadingEvent'
  id: string
  name: string
  category: Category
  currentState: State
  loadingTime: any
  address: string
  cargo?: string | null | undefined
  requestArrivalNote: string
  note?: string | null | undefined
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
}

export type ModuleUnitDetailRouteFragment = {
  __typename?: 'Route'
  id: string
  startOn: any
  endOn: any
  originalLoadingTime: any
  order: number
  loadingTime: any
  eventOrder: number
  positionType: PositionType
  event:
    | {
        __typename?: 'CompanySiteEvent'
        id: string
        loadingTime: any
        companySite: { __typename?: 'CompanySite'; id: string; name: string }
      }
    | {
        __typename?: 'LoadingEvent'
        id: string
        name: string
        category: Category
        currentState: State
        loadingTime: any
        address: string
        cargo?: string | null | undefined
        requestArrivalNote: string
        note?: string | null | undefined
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
}

export type ModuleUnitDetailSubconratctorFragment = {
  __typename?: 'CompanyRelation'
  id: string
  involvement: Involvement
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
}

export type ModuleUnitDetailDriverEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  name: string
  email: string
  order?: number | null | undefined
  employeeRole?:
    | {
        __typename?: 'EmployeeRole'
        id: string
        freightage: Array<Freightage>
        systemSetting: Array<SystemSetting>
      }
    | null
    | undefined
}

export type ModuleUnitDetailTruckFragment = {
  __typename?: 'Truck'
  id: string
  carNumber: string
  order?: number | null | undefined
  carType: { __typename?: 'CarType'; id: string; name: string; order?: number | null | undefined }
}

export type ModuleUnitDetailContractFragment = {
  __typename?: 'Contract'
  id: string
  name: string
  category: Category
  relatedCompany: { __typename?: 'Company'; id: string; name: string }
}

export type ModuleUnitDetailUnitInfeasibleFragment = {
  __typename?: 'UnitInfeasible'
  id: string
  reason: InfeasibleReason
}

export type ModuleUnitDetailUnitFragment = {
  __typename?: 'Unit'
  id: string
  startOn: any
  endOn: any
  startTime: any
  endTime: any
  fixed: boolean
  createdAt: any
  updatedAt: any
  truck?:
    | {
        __typename?: 'Truck'
        id: string
        carNumber: string
        order?: number | null | undefined
        carType: {
          __typename?: 'CarType'
          id: string
          name: string
          order?: number | null | undefined
        }
      }
    | null
    | undefined
  driverEmployee?:
    | {
        __typename?: 'Employee'
        id: string
        name: string
        email: string
        order?: number | null | undefined
        employeeRole?:
          | {
              __typename?: 'EmployeeRole'
              id: string
              freightage: Array<Freightage>
              systemSetting: Array<SystemSetting>
            }
          | null
          | undefined
      }
    | null
    | undefined
  subcontractor?:
    | {
        __typename?: 'CompanyRelation'
        id: string
        involvement: Involvement
        relatedCompany: { __typename?: 'Company'; id: string; name: string }
      }
    | null
    | undefined
  routes: {
    __typename?: 'RouteConnection'
    nodes: Array<{
      __typename?: 'Route'
      id: string
      startOn: any
      endOn: any
      originalLoadingTime: any
      order: number
      loadingTime: any
      eventOrder: number
      positionType: PositionType
      event:
        | {
            __typename?: 'CompanySiteEvent'
            id: string
            loadingTime: any
            companySite: { __typename?: 'CompanySite'; id: string; name: string }
          }
        | {
            __typename?: 'LoadingEvent'
            id: string
            name: string
            category: Category
            currentState: State
            loadingTime: any
            address: string
            cargo?: string | null | undefined
            requestArrivalNote: string
            note?: string | null | undefined
            relatedCompany: { __typename?: 'Company'; id: string; name: string }
          }
        | { __typename?: 'TransferEvent'; id: string; travelTime: any; fast: boolean }
    }>
  }
  infeasibles: Array<{ __typename?: 'UnitInfeasible'; id: string; reason: InfeasibleReason }>
  nextUnit?:
    | {
        __typename?: 'Unit'
        id: string
        routes: {
          __typename?: 'RouteConnection'
          nodes: Array<{
            __typename?: 'Route'
            id: string
            event:
              | { __typename?: 'CompanySiteEvent' }
              | { __typename?: 'LoadingEvent'; id: string; name: string }
              | { __typename?: 'TransferEvent' }
          }>
        }
      }
    | null
    | undefined
}

export type UiFileUploaderAttachedFileFragment = {
  __typename?: 'AttachedFile'
  id: string
  originalFilename: string
  downloadSignedUrl: string
  createdAt: any
}

export type UiFileUploaderTemporaryAttachedFileFragment = {
  __typename?: 'TemporaryAttachedFile'
  id: string
  filename: string
  originalFilename: string
  contentType: string
  uploadSignedUrl: string
  createdAt: any
}

export type ContextServiceCurrentFragment = {
  __typename?: 'Current'
  notificationCount: number
  requestCount?: number | null | undefined
  externalRequestCount?: number | null | undefined
  employee: {
    __typename?: 'Employee'
    id: string
    name: string
    email: string
    tel?: string | null | undefined
    employeeRole?:
      | {
          __typename?: 'EmployeeRole'
          id: string
          freightage: Array<Freightage>
          systemSetting: Array<SystemSetting>
        }
      | null
      | undefined
    companySite: {
      __typename?: 'CompanySite'
      id: string
      name: string
      startTime: any
      endTime: any
    }
  }
  company: {
    __typename?: 'Company'
    id: string
    name: string
    noteTemplate?: string | null | undefined
    companySettings?:
      | {
          __typename?: 'CompanySettingConnection'
          edges: Array<{
            __typename?: 'CompanySettingEdge'
            node?:
              | {
                  __typename?: 'CompanySetting'
                  id: string
                  kind: CompanySettingKind
                  scope: CompanySettingScope
                }
              | null
              | undefined
          }>
        }
      | null
      | undefined
  }
}

export type ContextServiceEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  name: string
  email: string
  tel?: string | null | undefined
  employeeRole?:
    | {
        __typename?: 'EmployeeRole'
        id: string
        freightage: Array<Freightage>
        systemSetting: Array<SystemSetting>
      }
    | null
    | undefined
  companySite: {
    __typename?: 'CompanySite'
    id: string
    name: string
    startTime: any
    endTime: any
  }
}

export type ContextServiceCompanyFragment = {
  __typename?: 'Company'
  id: string
  name: string
  noteTemplate?: string | null | undefined
  companySettings?:
    | {
        __typename?: 'CompanySettingConnection'
        edges: Array<{
          __typename?: 'CompanySettingEdge'
          node?:
            | {
                __typename?: 'CompanySetting'
                id: string
                kind: CompanySettingKind
                scope: CompanySettingScope
              }
            | null
            | undefined
        }>
      }
    | null
    | undefined
}

export type ContextServiceQueryVariables = Exact<{ [key: string]: never }>

export type ContextServiceQuery = {
  __typename?: 'Query'
  current: {
    __typename?: 'Current'
    notificationCount: number
    requestCount?: number | null | undefined
    externalRequestCount?: number | null | undefined
    employee: {
      __typename?: 'Employee'
      id: string
      name: string
      email: string
      tel?: string | null | undefined
      employeeRole?:
        | {
            __typename?: 'EmployeeRole'
            id: string
            freightage: Array<Freightage>
            systemSetting: Array<SystemSetting>
          }
        | null
        | undefined
      companySite: {
        __typename?: 'CompanySite'
        id: string
        name: string
        startTime: any
        endTime: any
      }
    }
    company: {
      __typename?: 'Company'
      id: string
      name: string
      noteTemplate?: string | null | undefined
      companySettings?:
        | {
            __typename?: 'CompanySettingConnection'
            edges: Array<{
              __typename?: 'CompanySettingEdge'
              node?:
                | {
                    __typename?: 'CompanySetting'
                    id: string
                    kind: CompanySettingKind
                    scope: CompanySettingScope
                  }
                | null
                | undefined
            }>
          }
        | null
        | undefined
    }
  }
}

export type ContextServiceCurrentUpdateSubscriptionVariables = Exact<{ [key: string]: never }>

export type ContextServiceCurrentUpdateSubscription = {
  __typename?: 'Subscription'
  currentUpdate: {
    __typename?: 'CurrentUpdatePayload'
    current: {
      __typename?: 'Current'
      notificationCount: number
      requestCount?: number | null | undefined
      externalRequestCount?: number | null | undefined
      employee: {
        __typename?: 'Employee'
        id: string
        name: string
        email: string
        tel?: string | null | undefined
        employeeRole?:
          | {
              __typename?: 'EmployeeRole'
              id: string
              freightage: Array<Freightage>
              systemSetting: Array<SystemSetting>
            }
          | null
          | undefined
        companySite: {
          __typename?: 'CompanySite'
          id: string
          name: string
          startTime: any
          endTime: any
        }
      }
      company: {
        __typename?: 'Company'
        id: string
        name: string
        noteTemplate?: string | null | undefined
        companySettings?:
          | {
              __typename?: 'CompanySettingConnection'
              edges: Array<{
                __typename?: 'CompanySettingEdge'
                node?:
                  | {
                      __typename?: 'CompanySetting'
                      id: string
                      kind: CompanySettingKind
                      scope: CompanySettingScope
                    }
                  | null
                  | undefined
              }>
            }
          | null
          | undefined
      }
    }
  }
}

export type PageInfoFieldFragment = {
  __typename?: 'PageInfo'
  startCursor?: string | null | undefined
  endCursor?: string | null | undefined
  hasNextPage: boolean
  hasPreviousPage: boolean
}

export const EmployeeNewCompanySiteFragmentDoc = gql`
  fragment EmployeeNewCompanySite on CompanySite {
    id
    name
  }
`
export const EmployeeNewEmployeeRoleFragmentDoc = gql`
  fragment EmployeeNewEmployeeRole on EmployeeRole {
    id
    name
  }
`
export const ModuleVeactleAllocationStateFragmentDoc = gql`
  fragment ModuleVeactleAllocationState on LoadingEvent {
    id
    name
    address
    staffName
    tel
    requestArrivalNote
    cargo
    note
    category
    currentState
    loadingTime
    relatedCompany {
      id
      name
    }
    route {
      id
      order
      loadingTime
      startOn
      endOn
      unit {
        id
        startOn
        endOn
        startTime
        endTime
      }
    }
  }
`
export const RecursiveDuplicationUnitDetailLoadingEventFragmentDoc = gql`
  fragment RecursiveDuplicationUnitDetailLoadingEvent on LoadingEvent {
    id
    name
  }
`
export const TruckNewCarTypeFragmentDoc = gql`
  fragment TruckNewCarType on CarType {
    id
    name
  }
`
export const TruckNewEmployeeFragmentDoc = gql`
  fragment TruckNewEmployee on Employee {
    id
    name
  }
`
export const TruckNewCompanySiteFragmentDoc = gql`
  fragment TruckNewCompanySite on CompanySite {
    id
    name
  }
`
export const ModuleCompanyDetailContentContactListItemFragmentDoc = gql`
  fragment ModuleCompanyDetailContentContactListItem on Contract {
    id
    name
    address
    category
  }
`
export const ModuleCompanyDetailContentFragmentDoc = gql`
  fragment ModuleCompanyDetailContent on CompanyRelation {
    id
    involvement
    relatedCompany {
      id
      name
      tel
    }
    contracts {
      nodes {
        ...ModuleCompanyDetailContentContactListItem
      }
    }
  }
  ${ModuleCompanyDetailContentContactListItemFragmentDoc}
`
export const ModuleCompanyDetailFragmentDoc = gql`
  fragment ModuleCompanyDetail on CompanyRelationConnection {
    nodes {
      ...ModuleCompanyDetailContent
    }
  }
  ${ModuleCompanyDetailContentFragmentDoc}
`
export const ModuleCompanyEditCompanyFragmentDoc = gql`
  fragment ModuleCompanyEditCompany on CompanyRelationConnection {
    nodes {
      id
      involvement
      relatedCompany {
        id
        name
        tel
      }
    }
  }
`
export const ModuleCompanyEditEmployeeFragmentDoc = gql`
  fragment ModuleCompanyEditEmployee on EmployeeConnection {
    nodes {
      id
      name
      email
      tel
    }
  }
`
export const ModuleCompanyFilterListFragmentDoc = gql`
  fragment ModuleCompanyFilterList on CompanyRelation {
    id
    involvement
    relatedCompany {
      id
      name
      tel
    }
  }
`
export const PageInfoFieldFragmentDoc = gql`
  fragment PageInfoField on PageInfo {
    startCursor
    endCursor
    hasNextPage
    hasPreviousPage
  }
`
export const ModuleCompanyFilterFragmentDoc = gql`
  fragment ModuleCompanyFilter on CompanyRelationConnection {
    edges {
      node {
        ...ModuleCompanyFilterList
      }
    }
    pageInfo {
      ...PageInfoField
    }
  }
  ${ModuleCompanyFilterListFragmentDoc}
  ${PageInfoFieldFragmentDoc}
`
export const ModuleCompanyNewEmployeeFragmentDoc = gql`
  fragment ModuleCompanyNewEmployee on EmployeeConnection {
    nodes {
      id
      name
      email
      tel
    }
  }
`
export const ModuleContractDetailContentFragmentDoc = gql`
  fragment ModuleContractDetailContent on Contract {
    id
    name
    staffName
    tel
    address
    loadingTime
    cargo
    note
    category
    attachedFiles {
      nodes {
        id
        downloadSignedUrl
        originalFilename
        filename
        createdAt
        employee {
          name
        }
      }
    }
    carTypes {
      nodes {
        id
        name
      }
    }
    salesEmployee {
      name
    }
    relatedCompany {
      id
      name
    }
    loadingEvents {
      nodes {
        id
        loadingTime
        route {
          id
          startOn
          endOn
          unit {
            truck {
              carType {
                name
              }
            }
            driverEmployee {
              name
            }
          }
        }
      }
    }
  }
`
export const ModuleContractDetailFragmentDoc = gql`
  fragment ModuleContractDetail on ContractConnection {
    nodes {
      ...ModuleContractDetailContent
    }
  }
  ${ModuleContractDetailContentFragmentDoc}
`
export const ModuleContractEditContractFragmentDoc = gql`
  fragment ModuleContractEditContract on Contract {
    id
    name
    address
    loadingTime
    category
    cargo
    note
    staffName
    tel
    companyRelation {
      id
    }
    salesEmployee {
      id
      name
      email
      tel
      employeeRole {
        id
        freightage
        systemSetting
      }
    }
    company {
      id
      name
    }
    relatedCompany {
      id
      name
    }
    carTypes {
      nodes {
        id
        name
      }
    }
  }
`
export const ModuleContractEditCarTypeFragmentDoc = gql`
  fragment ModuleContractEditCarType on CarType {
    id
    name
    order
  }
`
export const ModuleContractEditEmployeeFragmentDoc = gql`
  fragment ModuleContractEditEmployee on Employee {
    id
    name
    email
    tel
    employeeRole {
      id
      freightage
      systemSetting
    }
  }
`
export const ModuleContractEditCompanyRelationFragmentDoc = gql`
  fragment ModuleContractEditCompanyRelation on CompanyRelation {
    id
    involvement
    company {
      id
      name
    }
    relatedCompany {
      id
      name
    }
  }
`
export const ModuleContractEditFragmentDoc = gql`
  fragment ModuleContractEdit on Query {
    contracts(id: $id) {
      nodes {
        ...ModuleContractEditContract
      }
      pageInfo {
        ...PageInfoField
      }
    }
    carTypes {
      nodes {
        ...ModuleContractEditCarType
      }
      pageInfo {
        ...PageInfoField
      }
    }
    salesEmployees: employees(
      freightageRoles: [request, add]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleContractEditEmployee
      }
      pageInfo {
        ...PageInfoField
      }
    }
    companyRelations(enables: true, involvements: [customer]) {
      nodes {
        ...ModuleContractEditCompanyRelation
      }
      pageInfo {
        ...PageInfoField
      }
    }
  }
  ${ModuleContractEditContractFragmentDoc}
  ${PageInfoFieldFragmentDoc}
  ${ModuleContractEditCarTypeFragmentDoc}
  ${ModuleContractEditEmployeeFragmentDoc}
  ${ModuleContractEditCompanyRelationFragmentDoc}
`
export const ModuleContractFilterListFragmentDoc = gql`
  fragment ModuleContractFilterList on Contract {
    id
    name
    category
    relatedCompany {
      id
      name
    }
  }
`
export const ModuleContractFilterFragmentDoc = gql`
  fragment ModuleContractFilter on ContractConnection {
    edges {
      node {
        ...ModuleContractFilterList
      }
    }
    pageInfo {
      ...PageInfoField
    }
  }
  ${ModuleContractFilterListFragmentDoc}
  ${PageInfoFieldFragmentDoc}
`
export const ModuleContractNewCarTypeFragmentDoc = gql`
  fragment ModuleContractNewCarType on CarType {
    id
    name
    order
  }
`
export const ModuleContractNewEmployeeFragmentDoc = gql`
  fragment ModuleContractNewEmployee on Employee {
    id
    name
    email
    tel
    employeeRole {
      id
      freightage
      systemSetting
    }
  }
`
export const ModuleContractNewCompanyRelationFragmentDoc = gql`
  fragment ModuleContractNewCompanyRelation on CompanyRelation {
    id
    involvement
    company {
      id
      name
    }
    relatedCompany {
      id
      name
    }
  }
`
export const ModuleContractNewFragmentDoc = gql`
  fragment ModuleContractNew on Query {
    carTypes {
      nodes {
        ...ModuleContractNewCarType
      }
      pageInfo {
        ...PageInfoField
      }
    }
    salesEmployees: employees(
      freightageRoles: [request, add]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleContractNewEmployee
      }
      pageInfo {
        ...PageInfoField
      }
    }
    companyRelations(enables: true, involvements: [customer]) {
      nodes {
        ...ModuleContractNewCompanyRelation
      }
      pageInfo {
        ...PageInfoField
      }
    }
  }
  ${ModuleContractNewCarTypeFragmentDoc}
  ${PageInfoFieldFragmentDoc}
  ${ModuleContractNewEmployeeFragmentDoc}
  ${ModuleContractNewCompanyRelationFragmentDoc}
`
export const EmployeeManagementDetailFragmentDoc = gql`
  fragment EmployeeManagementDetail on Employee {
    id
    name
    tel
    email
    emailVerifiedAt
    enableEmailNotification
    employeeRole {
      id
      name
    }
    companySite {
      id
      name
    }
    emailVerifiedAt
    lineRelationship {
      id
    }
  }
`
export const EmployeeManagementListFragmentDoc = gql`
  fragment EmployeeManagementList on Employee {
    id
    name
    order
    emailVerifiedAt
    lineRelationship {
      id
      gid
    }
    companySite {
      id
      name
    }
  }
`
export const ModuleEventDetailEmployeeFragmentDoc = gql`
  fragment ModuleEventDetailEmployee on Employee {
    id
    name
    order
  }
`
export const ModuleEventDetailTruckFragmentDoc = gql`
  fragment ModuleEventDetailTruck on Truck {
    id
    carNumber
    order
    carType {
      id
      order
    }
  }
`
export const ModuleEventDetailEventEmployeeFragmentDoc = gql`
  fragment ModuleEventDetailEventEmployee on EventEmployee {
    id
    startOn
    startTime
    endOn
    endTime
    createdAt
    updatedAt
    employee {
      ...ModuleEventDetailEmployee
    }
    createEmployee {
      ...ModuleEventDetailEmployee
    }
    truck {
      ...ModuleEventDetailTruck
    }
    detail {
      id
      note
      ... on EventEmployeeDetail {
        employeeReasonType: reasonType
      }
    }
  }
  ${ModuleEventDetailEmployeeFragmentDoc}
  ${ModuleEventDetailTruckFragmentDoc}
`
export const ModuleEventDetailEventTemporaryVehicleAllocationContractFragmentDoc = gql`
  fragment ModuleEventDetailEventTemporaryVehicleAllocationContract on Contract {
    id
    name
    companyRelation {
      id
      relatedCompany {
        id
        name
      }
    }
    address
    category
  }
`
export const ModuleEventDetailEventTemporaryVehicleAllocationFragmentDoc = gql`
  fragment ModuleEventDetailEventTemporaryVehicleAllocation on EventTemporaryVehicleAllocation {
    id
    startOn
    startTime
    endOn
    endTime
    createdAt
    updatedAt
    employee {
      ...ModuleEventDetailEmployee
    }
    createEmployee {
      ...ModuleEventDetailEmployee
    }
    truck {
      ...ModuleEventDetailTruck
    }
    detail {
      id
      name
      address
      category
      loadingTime
      cargo
      note
      manifest
      operatorCount
      contractPaperStatus
      relatedCompanyName
      requestArrivalTime
      staffName
      tel
      prevCompanySiteEventTime
      nextCompanySiteEventTime
      requestCarTypes {
        nodes {
          carType {
            id
          }
        }
      }
      requestArrivals {
        nodes {
          date
        }
      }
      companyRelation {
        id
      }
      contract {
        id
        carTypes {
          nodes {
            id
          }
        }
      }
      subContract {
        id
        name
        companyRelation {
          id
          relatedCompany {
            id
            name
          }
        }
        address
        category
      }
      salesEmployee {
        id
      }
    }
  }
  ${ModuleEventDetailEmployeeFragmentDoc}
  ${ModuleEventDetailTruckFragmentDoc}
`
export const ModuleEventDetailUnitFragmentDoc = gql`
  fragment ModuleEventDetailUnit on Unit {
    id
    routes {
      nodes {
        id
        event {
          ... on LoadingEvent {
            id
            name
            staffName
            tel
            address
            loadingTime
            cargo
            note
            category
            contract {
              id
            }
            salesEmployee {
              id
            }
          }
        }
      }
    }
  }
`
export const ModuleEventDetailEventTruckFragmentDoc = gql`
  fragment ModuleEventDetailEventTruck on EventTruck {
    id
    startOn
    startTime
    endOn
    endTime
    createdAt
    updatedAt
    employee {
      ...ModuleEventDetailEmployee
    }
    createEmployee {
      ...ModuleEventDetailEmployee
    }
    truck {
      ...ModuleEventDetailTruck
    }
    detail {
      id
      note
      ... on EventTruckDetail {
        truckReasonType: reasonType
      }
    }
  }
  ${ModuleEventDetailEmployeeFragmentDoc}
  ${ModuleEventDetailTruckFragmentDoc}
`
export const ModuleEventNewCarTypeFragmentDoc = gql`
  fragment ModuleEventNewCarType on CarType {
    id
    name
    order
  }
`
export const ModuleEventDetailCompanyRelationFragmentDoc = gql`
  fragment ModuleEventDetailCompanyRelation on CompanyRelation {
    id
    relatedCompany {
      id
      name
    }
  }
`
export const ModuleEventDetailContractFragmentDoc = gql`
  fragment ModuleEventDetailContract on Contract {
    id
    name
    category
    address
    loadingTime
    carTypes {
      nodes {
        ...ModuleEventNewCarType
      }
    }
    salesEmployee {
      id
      name
    }
    companyRelation {
      ...ModuleEventDetailCompanyRelation
    }
  }
  ${ModuleEventNewCarTypeFragmentDoc}
  ${ModuleEventDetailCompanyRelationFragmentDoc}
`
export const ModuleEventDetailEmployeeDrivableTruckFragmentDoc = gql`
  fragment ModuleEventDetailEmployeeDrivableTruck on EmployeeDrivableTruck {
    id
    priority
    employee {
      id
    }
    truck {
      id
    }
  }
`
export const ModuleEventDetailCarTypeFragmentDoc = gql`
  fragment ModuleEventDetailCarType on CarType {
    id
    name
    order
  }
`
export const ModuleEventNewEventEmployeeFragmentDoc = gql`
  fragment ModuleEventNewEventEmployee on EventEmployee {
    id
    startOn
    startTime
    endOn
    endTime
    employee {
      ...ModuleEventDetailEmployee
    }
    createEmployee {
      ...ModuleEventDetailEmployee
    }
    truck {
      ...ModuleEventDetailTruck
    }
    detail {
      id
      note
      ... on EventEmployeeDetail {
        employeeReasonType: reasonType
      }
    }
  }
  ${ModuleEventDetailEmployeeFragmentDoc}
  ${ModuleEventDetailTruckFragmentDoc}
`
export const ModuleEventNewCompanyRelationFragmentDoc = gql`
  fragment ModuleEventNewCompanyRelation on CompanyRelation {
    id
    relatedCompany {
      id
      name
    }
  }
`
export const ModuleEventNewContractFragmentDoc = gql`
  fragment ModuleEventNewContract on Contract {
    id
    name
    category
    address
    loadingTime
    cargo
    note
    tel
    staffName
    carTypes {
      nodes {
        ...ModuleEventNewCarType
      }
    }
    salesEmployee {
      id
      name
    }
    companyRelation {
      ...ModuleEventNewCompanyRelation
    }
  }
  ${ModuleEventNewCarTypeFragmentDoc}
  ${ModuleEventNewCompanyRelationFragmentDoc}
`
export const ModuleEventNewExternalScrapCollectionRequestFragmentDoc = gql`
  fragment ModuleEventNewExternalScrapCollectionRequest on ExternalScrapCollectionRequest {
    id
    requesterName
    requesterCompanyName
    requesterEmail
    requesterPhone
    siteName
    siteAddress
    cargoDetails
    desiredPickupDate
    desiredPickupPeriod
    numberOfTrucks
    kindOfTruck
    siteContactName
    siteContactPhone
    comment
    acceptedAt
    rejectedAt
    createdAt
    updatedAt
    estimatedContracts {
      nodes {
        ...ModuleEventNewContract
      }
    }
  }
  ${ModuleEventNewContractFragmentDoc}
`
export const ModuleEventNewEventTruckFragmentDoc = gql`
  fragment ModuleEventNewEventTruck on EventTruck {
    id
    startOn
    startTime
    endOn
    endTime
    employee {
      ...ModuleEventDetailEmployee
    }
    createEmployee {
      ...ModuleEventDetailEmployee
    }
    truck {
      ...ModuleEventDetailTruck
    }
    detail {
      id
      note
      ... on EventTruckDetail {
        truckReasonType: reasonType
      }
    }
  }
  ${ModuleEventDetailEmployeeFragmentDoc}
  ${ModuleEventDetailTruckFragmentDoc}
`
export const ModuleEventNewEmployeeFragmentDoc = gql`
  fragment ModuleEventNewEmployee on Employee {
    id
    name
    order
  }
`
export const ModuleEventNewTruckFragmentDoc = gql`
  fragment ModuleEventNewTruck on Truck {
    id
    order
    carNumber
    carType {
      id
      order
    }
  }
`
export const ModuleEventNewEventTemporaryVehicleAllocationFragmentDoc = gql`
  fragment ModuleEventNewEventTemporaryVehicleAllocation on EventTemporaryVehicleAllocation {
    id
    startOn
    startTime
    endOn
    endTime
    employee {
      ...ModuleEventNewEmployee
    }
    truck {
      ...ModuleEventNewTruck
    }
    detail {
      id
      name
      address
      category
      loadingTime
      cargo
      note
      manifest
      operatorCount
      contractPaperStatus
      relatedCompanyName
      requestArrivalTime
      staffName
      tel
      requestCarTypes {
        nodes {
          carType {
            id
          }
        }
      }
      requestArrivals {
        nodes {
          date
        }
      }
      companyRelation {
        id
      }
      contract {
        id
        carTypes {
          nodes {
            id
          }
        }
      }
      salesEmployee {
        id
      }
    }
  }
  ${ModuleEventNewEmployeeFragmentDoc}
  ${ModuleEventNewTruckFragmentDoc}
`
export const ModuleEventNewUnitFragmentDoc = gql`
  fragment ModuleEventNewUnit on Unit {
    id
    startOn
    routes {
      nodes {
        id
        event {
          ... on LoadingEvent {
            id
            name
            staffName
            tel
            address
            loadingTime
            cargo
            note
            category
            contract {
              id
            }
            salesEmployee {
              id
            }
          }
        }
      }
    }
  }
`
export const ModuleEventNewEmployeeDrivableTruckFragmentDoc = gql`
  fragment ModuleEventNewEmployeeDrivableTruck on EmployeeDrivableTruck {
    id
    priority
    employee {
      id
    }
    truck {
      id
    }
  }
`
export const UiFileUploaderAttachedFileFragmentDoc = gql`
  fragment UiFileUploaderAttachedFile on AttachedFile {
    id
    originalFilename
    downloadSignedUrl
    createdAt
  }
`
export const ModuleEventRequestLoadingEventFragmentDoc = gql`
  fragment ModuleEventRequestLoadingEvent on LoadingEvent {
    id
    name
    address
    staffName
    tel
    requestArrivalNote
    cargo
    note
    manifest
    operatorCount
    contractPaperStatus
    category
    currentState
    loadingTime
    contract {
      id
      carTypes {
        nodes {
          id
          name
        }
      }
    }
    route {
      id
      order
      eventOrder
      loadingTime
      startOn
      endOn
      positionType
      unit {
        id
        startOn
        endOn
        startTime
        endTime
      }
    }
    company {
      id
      name
    }
    relatedCompany {
      id
      name
    }
    salesEmployee {
      id
      name
    }
    createdEmployee {
      id
      name
    }
    attachedFiles {
      nodes {
        ...UiFileUploaderAttachedFile
      }
    }
  }
  ${UiFileUploaderAttachedFileFragmentDoc}
`
export const ModuleEventRequestContractFragmentDoc = gql`
  fragment ModuleEventRequestContract on Contract {
    id
    name
    category
    address
    loadingTime
    cargo
    note
    tel
    staffName
    carTypes {
      nodes {
        ...ModuleEventNewCarType
      }
    }
    salesEmployee {
      id
      name
    }
    companyRelation {
      ...ModuleEventNewCompanyRelation
    }
  }
  ${ModuleEventNewCarTypeFragmentDoc}
  ${ModuleEventNewCompanyRelationFragmentDoc}
`
export const ModuleEventRequestCompanyRelationFragmentDoc = gql`
  fragment ModuleEventRequestCompanyRelation on CompanyRelation {
    id
    relatedCompany {
      id
      name
    }
  }
`
export const ModuleEventRequestEmployeeFragmentDoc = gql`
  fragment ModuleEventRequestEmployee on Employee {
    id
    name
    order
  }
`
export const ModuleEventRequestTruckFragmentDoc = gql`
  fragment ModuleEventRequestTruck on Truck {
    id
    order
    carNumber
    carType {
      id
      order
    }
  }
`
export const ModuleEventRequestEmployeeDrivableTruckFragmentDoc = gql`
  fragment ModuleEventRequestEmployeeDrivableTruck on EmployeeDrivableTruck {
    id
    priority
    employee {
      id
    }
    truck {
      id
    }
  }
`
export const ModuleEventRequestCarTypeFragmentDoc = gql`
  fragment ModuleEventRequestCarType on CarType {
    id
    name
    order
  }
`
export const ModuleLoadingEventDetailContractFragmentDoc = gql`
  fragment ModuleLoadingEventDetailContract on Contract {
    id
    name
    companyRelation {
      id
      relatedCompany {
        id
        name
      }
    }
    address
    category
  }
`
export const ModuleExternalScrapCollectionRequestDetailFragmentDoc = gql`
  fragment ModuleExternalScrapCollectionRequestDetail on ExternalScrapCollectionRequest {
    id
    requesterName
    requesterCompanyName
    requesterEmail
    requesterPhone
    siteName
    siteAddress
    cargoDetails
    desiredPickupDate
    desiredPickupPeriod
    numberOfTrucks
    kindOfTruck
    siteContactName
    siteContactPhone
    comment
    acceptedAt
    rejectedAt
    createdAt
    updatedAt
  }
`
export const ModuleLoadingEventDetailFragmentDoc = gql`
  fragment ModuleLoadingEventDetail on LoadingEvent {
    id
    name
    address
    staffName
    tel
    requestArrivalNote
    cargo
    note
    manifest
    operatorCount
    contractPaperStatus
    category
    currentState
    loadingTime
    fixed
    createdAt
    updatedAt
    externalScrapCollectionRequest {
      ...ModuleExternalScrapCollectionRequestDetail
    }
    subContract {
      id
      name
      companyRelation {
        id
        relatedCompany {
          id
          name
        }
      }
      address
      category
    }
    carTypes {
      nodes {
        id
        name
        order
      }
    }
    route {
      id
      loadingTime
      startOn
      endOn
      unit {
        id
        startOn
        endOn
        startTime
        endTime
        truck {
          carType {
            name
          }
        }
        driverEmployee {
          name
        }
      }
    }
    relatedCompany {
      id
      name
    }
    salesEmployee {
      id
      name
    }
    createdEmployee {
      id
      name
    }
    attachedFiles {
      nodes {
        ...UiFileUploaderAttachedFile
      }
    }
  }
  ${ModuleExternalScrapCollectionRequestDetailFragmentDoc}
  ${UiFileUploaderAttachedFileFragmentDoc}
`
export const ModuleUnitListLoadingEventFragmentDoc = gql`
  fragment ModuleUnitListLoadingEvent on LoadingEvent {
    id
    name
    address
    staffName
    tel
    requestArrivalNote
    cargo
    note
    category
    currentState
    loadingTime
    relatedCompany {
      id
      name
    }
    route {
      id
      order
      loadingTime
      startOn
      endOn
      positionType
      eventOrder
      event {
        ... on LoadingEvent {
          id
          name
          address
          staffName
          tel
          requestArrivalNote
          cargo
          note
          category
          currentState
          loadingTime
          relatedCompany {
            id
            name
          }
        }
        ... on TransferEvent {
          id
          travelTime
          fast
        }
        ... on CompanySiteEvent {
          id
          loadingTime
          companySite {
            id
            name
          }
        }
      }
      unit {
        id
        startOn
        endOn
        startTime
        endTime
        own
        fixed
        truck {
          id
          carNumber
          carType {
            id
            name
          }
        }
        driverEmployee {
          id
          name
          email
          tel
          employeeRole {
            id
            freightage
            systemSetting
          }
        }
        subcontractor {
          id
          relatedCompany {
            id
            name
          }
        }
      }
    }
  }
`
export const ModuleSelectCarTypeFragmentDoc = gql`
  fragment ModuleSelectCarType on CarType {
    id
    name
    order
  }
`
export const ModuleSelectDriverEmployeeEmployeeDrivableTruckFragmentDoc = gql`
  fragment ModuleSelectDriverEmployeeEmployeeDrivableTruck on EmployeeDrivableTruck {
    id
    priority
    employee {
      id
    }
    truck {
      id
    }
  }
`
export const ModuleSelectDriverEmployeeDriverEmployeeFragmentDoc = gql`
  fragment ModuleSelectDriverEmployeeDriverEmployee on Employee {
    id
    name
    order
  }
`
export const ModuleSelectDriverEmployeeTruckFragmentDoc = gql`
  fragment ModuleSelectDriverEmployeeTruck on Truck {
    id
    carNumber
    order
    carType {
      id
      order
    }
  }
`
export const ModuleSelectTruckEmployeeDrivableTruckFragmentDoc = gql`
  fragment ModuleSelectTruckEmployeeDrivableTruck on EmployeeDrivableTruck {
    id
    priority
    employee {
      id
    }
    truck {
      id
    }
  }
`
export const ModuleSelectTruckDriverEmployeeFragmentDoc = gql`
  fragment ModuleSelectTruckDriverEmployee on Employee {
    id
    name
    order
  }
`
export const ModuleSelectTruckTruckFragmentDoc = gql`
  fragment ModuleSelectTruckTruck on Truck {
    id
    carNumber
    order
    carType {
      id
      order
    }
  }
`
export const ModuleTimelineTruckResourceFragmentDoc = gql`
  fragment ModuleTimelineTruckResource on Truck {
    id
    carNumber
    order
    companySite {
      id
      name
    }
    carType {
      id
      name
      order
    }
  }
`
export const ModuleTimelineDriverEmployeeResourceFragmentDoc = gql`
  fragment ModuleTimelineDriverEmployeeResource on Employee {
    id
    name
    order
    companySite {
      id
      name
    }
  }
`
export const ModuleTimelineSubcontractorResourceFragmentDoc = gql`
  fragment ModuleTimelineSubcontractorResource on CompanyRelation {
    id
    involvement
    relatedCompany {
      id
      name
    }
  }
`
export const ModuleTimelineEventRouteFragmentDoc = gql`
  fragment ModuleTimelineEventRoute on Route {
    id
    order
    startOn
    loadingTime
    event {
      ... on LoadingEvent {
        id
        name
        category
        currentState
        cargo
        fixed
        relatedCompany {
          id
          name
        }
      }
      ... on TransferEvent {
        id
        travelTime
        fast
      }
      ... on CompanySiteEvent {
        id
        loadingTime
        companySite {
          id
          name
        }
      }
    }
  }
`
export const ModuleTimelineEventUnitFragmentDoc = gql`
  fragment ModuleTimelineEventUnit on Unit {
    id
    startOn
    endOn
    startTime
    endTime
    feasible
    fixed
    truck {
      ...ModuleTimelineTruckResource
    }
    driverEmployee {
      ...ModuleTimelineDriverEmployeeResource
    }
    subcontractor {
      ...ModuleTimelineSubcontractorResource
    }
    routes {
      nodes {
        ...ModuleTimelineEventRoute
      }
    }
  }
  ${ModuleTimelineTruckResourceFragmentDoc}
  ${ModuleTimelineDriverEmployeeResourceFragmentDoc}
  ${ModuleTimelineSubcontractorResourceFragmentDoc}
  ${ModuleTimelineEventRouteFragmentDoc}
`
export const ModuleTimelineEventEventTemporaryVehicleAllocationFragmentDoc = gql`
  fragment ModuleTimelineEventEventTemporaryVehicleAllocation on EventTemporaryVehicleAllocation {
    id
    startOn
    endOn
    startTime
    endTime
    truck {
      ...ModuleTimelineTruckResource
    }
    employee {
      ...ModuleTimelineDriverEmployeeResource
    }
    detail {
      id
      name
      category
      cargo
    }
  }
  ${ModuleTimelineTruckResourceFragmentDoc}
  ${ModuleTimelineDriverEmployeeResourceFragmentDoc}
`
export const ModuleTimelineEventEventTruckFragmentDoc = gql`
  fragment ModuleTimelineEventEventTruck on EventTruck {
    id
    startOn
    endOn
    startTime
    endTime
    truck {
      ...ModuleTimelineTruckResource
    }
    employee {
      ...ModuleTimelineDriverEmployeeResource
    }
    detail {
      id
      truckReasonType: reasonType
      note
    }
  }
  ${ModuleTimelineTruckResourceFragmentDoc}
  ${ModuleTimelineDriverEmployeeResourceFragmentDoc}
`
export const ModuleTimelineEventEventEmployeeFragmentDoc = gql`
  fragment ModuleTimelineEventEventEmployee on EventEmployee {
    id
    startOn
    endOn
    startTime
    endTime
    truck {
      ...ModuleTimelineTruckResource
    }
    employee {
      ...ModuleTimelineDriverEmployeeResource
    }
    detail {
      id
      employeeReasonType: reasonType
      note
    }
  }
  ${ModuleTimelineTruckResourceFragmentDoc}
  ${ModuleTimelineDriverEmployeeResourceFragmentDoc}
`
export const ModuleTimelineTruckBackgroundFragmentDoc = gql`
  fragment ModuleTimelineTruckBackground on TruckUnavailablePeriod {
    id
    startOn
    endOn
    truck {
      id
    }
  }
`
export const ModuleTimelineEmployeeBackgroundFragmentDoc = gql`
  fragment ModuleTimelineEmployeeBackground on EmployeeUnavailablePeriod {
    id
    startOn
    endOn
    employee {
      id
    }
  }
`
export const ModuleTimelineToolbarFilterCompanySiteFragmentDoc = gql`
  fragment ModuleTimelineToolbarFilterCompanySite on CompanySite {
    id
    name
  }
`
export const ModuleTimelineToolbarFilterCarTypeFragmentDoc = gql`
  fragment ModuleTimelineToolbarFilterCarType on CarType {
    id
    name
    order
  }
`
export const ModuleTimelineToolbarFilterTruckFragmentDoc = gql`
  fragment ModuleTimelineToolbarFilterTruck on Truck {
    id
    carNumber
    carType {
      id
    }
  }
`
export const TruckManagementEmployeeDrivableTruckFragmentDoc = gql`
  fragment TruckManagementEmployeeDrivableTruck on EmployeeDrivableTruck {
    id
    priority
    employee {
      id
      name
    }
  }
`
export const TruckManagementDetailFragmentDoc = gql`
  fragment TruckManagementDetail on Truck {
    id
    carNumber
    note
    carType {
      id
      name
    }
    companySite {
      id
      name
    }
    employeeDrivableTrucks {
      edges {
        node {
          ...TruckManagementEmployeeDrivableTruck
        }
      }
    }
  }
  ${TruckManagementEmployeeDrivableTruckFragmentDoc}
`
export const TruckManagementListFragmentDoc = gql`
  fragment TruckManagementList on Truck {
    id
    carNumber
    order
    carType {
      id
      name
    }
    companySite {
      id
      name
    }
  }
`
export const ModuleUnitDetailDriverEmployeeFragmentDoc = gql`
  fragment ModuleUnitDetailDriverEmployee on Employee {
    id
    name
    email
    order
    employeeRole {
      id
      freightage
      systemSetting
    }
  }
`
export const ModuleUnitDetailTruckFragmentDoc = gql`
  fragment ModuleUnitDetailTruck on Truck {
    id
    carNumber
    order
    carType {
      id
      name
      order
    }
  }
`
export const ModuleUnitDetailEmployeeDrivableTruckFragmentDoc = gql`
  fragment ModuleUnitDetailEmployeeDrivableTruck on EmployeeDrivableTruck {
    id
    priority
    employee {
      ...ModuleUnitDetailDriverEmployee
    }
    truck {
      ...ModuleUnitDetailTruck
    }
  }
  ${ModuleUnitDetailDriverEmployeeFragmentDoc}
  ${ModuleUnitDetailTruckFragmentDoc}
`
export const ModuleUnitDetailContractFragmentDoc = gql`
  fragment ModuleUnitDetailContract on Contract {
    id
    name
    category
    relatedCompany {
      id
      name
    }
  }
`
export const ModuleUnitDetailSubconratctorFragmentDoc = gql`
  fragment ModuleUnitDetailSubconratctor on CompanyRelation {
    id
    involvement
    relatedCompany {
      id
      name
    }
  }
`
export const ModuleUnitDetailLoadingEventFragmentDoc = gql`
  fragment ModuleUnitDetailLoadingEvent on LoadingEvent {
    id
    name
    category
    currentState
    loadingTime
    address
    cargo
    requestArrivalNote
    note
    relatedCompany {
      id
      name
    }
  }
`
export const ModuleUnitDetailTransferEventFragmentDoc = gql`
  fragment ModuleUnitDetailTransferEvent on TransferEvent {
    id
    travelTime
    fast
  }
`
export const ModuleUnitDetailCompanySiteEventFragmentDoc = gql`
  fragment ModuleUnitDetailCompanySiteEvent on CompanySiteEvent {
    id
    companySite {
      id
      name
    }
    loadingTime
  }
`
export const ModuleUnitDetailRouteFragmentDoc = gql`
  fragment ModuleUnitDetailRoute on Route {
    id
    startOn
    endOn
    originalLoadingTime
    order
    loadingTime
    eventOrder
    positionType
    event {
      ...ModuleUnitDetailLoadingEvent
      ...ModuleUnitDetailTransferEvent
      ...ModuleUnitDetailCompanySiteEvent
    }
  }
  ${ModuleUnitDetailLoadingEventFragmentDoc}
  ${ModuleUnitDetailTransferEventFragmentDoc}
  ${ModuleUnitDetailCompanySiteEventFragmentDoc}
`
export const ModuleUnitDetailUnitInfeasibleFragmentDoc = gql`
  fragment ModuleUnitDetailUnitInfeasible on UnitInfeasible {
    id
    reason
  }
`
export const ModuleUnitDetailUnitFragmentDoc = gql`
  fragment ModuleUnitDetailUnit on Unit {
    id
    startOn
    endOn
    startTime
    endTime
    fixed
    createdAt
    updatedAt
    truck {
      ...ModuleUnitDetailTruck
    }
    driverEmployee {
      ...ModuleUnitDetailDriverEmployee
    }
    subcontractor {
      ...ModuleUnitDetailSubconratctor
    }
    routes {
      nodes {
        ...ModuleUnitDetailRoute
      }
    }
    infeasibles {
      ...ModuleUnitDetailUnitInfeasible
    }
    nextUnit {
      id
      routes {
        nodes {
          id
          event {
            ... on LoadingEvent {
              id
              name
            }
          }
        }
      }
    }
  }
  ${ModuleUnitDetailTruckFragmentDoc}
  ${ModuleUnitDetailDriverEmployeeFragmentDoc}
  ${ModuleUnitDetailSubconratctorFragmentDoc}
  ${ModuleUnitDetailRouteFragmentDoc}
  ${ModuleUnitDetailUnitInfeasibleFragmentDoc}
`
export const UiFileUploaderTemporaryAttachedFileFragmentDoc = gql`
  fragment UiFileUploaderTemporaryAttachedFile on TemporaryAttachedFile {
    id
    filename
    originalFilename
    contentType
    uploadSignedUrl
    createdAt
  }
`
export const ContextServiceEmployeeFragmentDoc = gql`
  fragment ContextServiceEmployee on Employee {
    id
    name
    email
    tel
    employeeRole {
      id
      freightage
      systemSetting
    }
    companySite {
      id
      name
      startTime
      endTime
    }
  }
`
export const ContextServiceCompanyFragmentDoc = gql`
  fragment ContextServiceCompany on Company {
    id
    name
    noteTemplate
    companySettings {
      edges {
        node {
          id
          kind
          scope
        }
      }
    }
  }
`
export const ContextServiceCurrentFragmentDoc = gql`
  fragment ContextServiceCurrent on Current {
    employee {
      ...ContextServiceEmployee
    }
    company {
      ...ContextServiceCompany
    }
    notificationCount
    requestCount
    externalRequestCount
  }
  ${ContextServiceEmployeeFragmentDoc}
  ${ContextServiceCompanyFragmentDoc}
`
export const ContainerCompaniesCompanyDetailDocument = gql`
  query ContainerCompaniesCompanyDetail($id: ID) {
    companyRelations(enables: true, id: $id) {
      ...ModuleCompanyDetail
    }
  }
  ${ModuleCompanyDetailFragmentDoc}
`

/**
 * __useContainerCompaniesCompanyDetailQuery__
 *
 * To run a query within a React component, call `useContainerCompaniesCompanyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerCompaniesCompanyDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerCompaniesCompanyDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContainerCompaniesCompanyDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerCompaniesCompanyDetailQuery,
    ContainerCompaniesCompanyDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerCompaniesCompanyDetailQuery,
    ContainerCompaniesCompanyDetailQueryVariables
  >(ContainerCompaniesCompanyDetailDocument, options)
}
export function useContainerCompaniesCompanyDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerCompaniesCompanyDetailQuery,
    ContainerCompaniesCompanyDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerCompaniesCompanyDetailQuery,
    ContainerCompaniesCompanyDetailQueryVariables
  >(ContainerCompaniesCompanyDetailDocument, options)
}
export type ContainerCompaniesCompanyDetailQueryHookResult = ReturnType<
  typeof useContainerCompaniesCompanyDetailQuery
>
export type ContainerCompaniesCompanyDetailLazyQueryHookResult = ReturnType<
  typeof useContainerCompaniesCompanyDetailLazyQuery
>
export type ContainerCompaniesCompanyDetailQueryResult = Apollo.QueryResult<
  ContainerCompaniesCompanyDetailQuery,
  ContainerCompaniesCompanyDetailQueryVariables
>
export const ContainerCompanyEditUpdateRelatedCompanyDocument = gql`
  mutation ContainerCompanyEditUpdateRelatedCompany($input: UpdateRelatedCompanyInput!) {
    updateRelatedCompany(input: $input) {
      companyRelation {
        ...ModuleCompanyFilterList
      }
    }
  }
  ${ModuleCompanyFilterListFragmentDoc}
`
export type ContainerCompanyEditUpdateRelatedCompanyMutationFn = Apollo.MutationFunction<
  ContainerCompanyEditUpdateRelatedCompanyMutation,
  ContainerCompanyEditUpdateRelatedCompanyMutationVariables
>

/**
 * __useContainerCompanyEditUpdateRelatedCompanyMutation__
 *
 * To run a mutation, you first call `useContainerCompanyEditUpdateRelatedCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerCompanyEditUpdateRelatedCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerCompanyEditUpdateRelatedCompanyMutation, { data, loading, error }] = useContainerCompanyEditUpdateRelatedCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerCompanyEditUpdateRelatedCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerCompanyEditUpdateRelatedCompanyMutation,
    ContainerCompanyEditUpdateRelatedCompanyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerCompanyEditUpdateRelatedCompanyMutation,
    ContainerCompanyEditUpdateRelatedCompanyMutationVariables
  >(ContainerCompanyEditUpdateRelatedCompanyDocument, options)
}
export type ContainerCompanyEditUpdateRelatedCompanyMutationHookResult = ReturnType<
  typeof useContainerCompanyEditUpdateRelatedCompanyMutation
>
export type ContainerCompanyEditUpdateRelatedCompanyMutationResult =
  Apollo.MutationResult<ContainerCompanyEditUpdateRelatedCompanyMutation>
export type ContainerCompanyEditUpdateRelatedCompanyMutationOptions = Apollo.BaseMutationOptions<
  ContainerCompanyEditUpdateRelatedCompanyMutation,
  ContainerCompanyEditUpdateRelatedCompanyMutationVariables
>
export const ContainerCompanyEditDisableRelatedCompanyDocument = gql`
  mutation ContainerCompanyEditDisableRelatedCompany($input: DisableRelatedCompanyInput!) {
    disableRelatedCompany(input: $input) {
      companyRelation {
        ...ModuleCompanyFilterList
      }
    }
  }
  ${ModuleCompanyFilterListFragmentDoc}
`
export type ContainerCompanyEditDisableRelatedCompanyMutationFn = Apollo.MutationFunction<
  ContainerCompanyEditDisableRelatedCompanyMutation,
  ContainerCompanyEditDisableRelatedCompanyMutationVariables
>

/**
 * __useContainerCompanyEditDisableRelatedCompanyMutation__
 *
 * To run a mutation, you first call `useContainerCompanyEditDisableRelatedCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerCompanyEditDisableRelatedCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerCompanyEditDisableRelatedCompanyMutation, { data, loading, error }] = useContainerCompanyEditDisableRelatedCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerCompanyEditDisableRelatedCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerCompanyEditDisableRelatedCompanyMutation,
    ContainerCompanyEditDisableRelatedCompanyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerCompanyEditDisableRelatedCompanyMutation,
    ContainerCompanyEditDisableRelatedCompanyMutationVariables
  >(ContainerCompanyEditDisableRelatedCompanyDocument, options)
}
export type ContainerCompanyEditDisableRelatedCompanyMutationHookResult = ReturnType<
  typeof useContainerCompanyEditDisableRelatedCompanyMutation
>
export type ContainerCompanyEditDisableRelatedCompanyMutationResult =
  Apollo.MutationResult<ContainerCompanyEditDisableRelatedCompanyMutation>
export type ContainerCompanyEditDisableRelatedCompanyMutationOptions = Apollo.BaseMutationOptions<
  ContainerCompanyEditDisableRelatedCompanyMutation,
  ContainerCompanyEditDisableRelatedCompanyMutationVariables
>
export const ContainerCompanyEditDocument = gql`
  query ContainerCompanyEdit($id: ID) {
    companyRelations(enables: true, id: $id) {
      ...ModuleCompanyEditCompany
    }
  }
  ${ModuleCompanyEditCompanyFragmentDoc}
`

/**
 * __useContainerCompanyEditQuery__
 *
 * To run a query within a React component, call `useContainerCompanyEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerCompanyEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerCompanyEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContainerCompanyEditQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerCompanyEditQuery,
    ContainerCompanyEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerCompanyEditQuery, ContainerCompanyEditQueryVariables>(
    ContainerCompanyEditDocument,
    options
  )
}
export function useContainerCompanyEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerCompanyEditQuery,
    ContainerCompanyEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerCompanyEditQuery, ContainerCompanyEditQueryVariables>(
    ContainerCompanyEditDocument,
    options
  )
}
export type ContainerCompanyEditQueryHookResult = ReturnType<typeof useContainerCompanyEditQuery>
export type ContainerCompanyEditLazyQueryHookResult = ReturnType<
  typeof useContainerCompanyEditLazyQuery
>
export type ContainerCompanyEditQueryResult = Apollo.QueryResult<
  ContainerCompanyEditQuery,
  ContainerCompanyEditQueryVariables
>
export const ContainerCompaniesCompanyFilterDocument = gql`
  query ContainerCompaniesCompanyFilter($text: String, $after: String, $first: Int!) {
    companyRelations(enables: true, text: $text, after: $after, first: $first) {
      ...ModuleCompanyFilter
    }
  }
  ${ModuleCompanyFilterFragmentDoc}
`

/**
 * __useContainerCompaniesCompanyFilterQuery__
 *
 * To run a query within a React component, call `useContainerCompaniesCompanyFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerCompaniesCompanyFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerCompaniesCompanyFilterQuery({
 *   variables: {
 *      text: // value for 'text'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useContainerCompaniesCompanyFilterQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerCompaniesCompanyFilterQuery,
    ContainerCompaniesCompanyFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerCompaniesCompanyFilterQuery,
    ContainerCompaniesCompanyFilterQueryVariables
  >(ContainerCompaniesCompanyFilterDocument, options)
}
export function useContainerCompaniesCompanyFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerCompaniesCompanyFilterQuery,
    ContainerCompaniesCompanyFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerCompaniesCompanyFilterQuery,
    ContainerCompaniesCompanyFilterQueryVariables
  >(ContainerCompaniesCompanyFilterDocument, options)
}
export type ContainerCompaniesCompanyFilterQueryHookResult = ReturnType<
  typeof useContainerCompaniesCompanyFilterQuery
>
export type ContainerCompaniesCompanyFilterLazyQueryHookResult = ReturnType<
  typeof useContainerCompaniesCompanyFilterLazyQuery
>
export type ContainerCompaniesCompanyFilterQueryResult = Apollo.QueryResult<
  ContainerCompaniesCompanyFilterQuery,
  ContainerCompaniesCompanyFilterQueryVariables
>
export const ContainerCompanyNewCreateRelatedCompanyDocument = gql`
  mutation ContainerCompanyNewCreateRelatedCompany($input: CreateRelatedCompanyInput!) {
    createRelatedCompany(input: $input) {
      companyRelation {
        ...ModuleCompanyFilterList
      }
    }
  }
  ${ModuleCompanyFilterListFragmentDoc}
`
export type ContainerCompanyNewCreateRelatedCompanyMutationFn = Apollo.MutationFunction<
  ContainerCompanyNewCreateRelatedCompanyMutation,
  ContainerCompanyNewCreateRelatedCompanyMutationVariables
>

/**
 * __useContainerCompanyNewCreateRelatedCompanyMutation__
 *
 * To run a mutation, you first call `useContainerCompanyNewCreateRelatedCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerCompanyNewCreateRelatedCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerCompanyNewCreateRelatedCompanyMutation, { data, loading, error }] = useContainerCompanyNewCreateRelatedCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerCompanyNewCreateRelatedCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerCompanyNewCreateRelatedCompanyMutation,
    ContainerCompanyNewCreateRelatedCompanyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerCompanyNewCreateRelatedCompanyMutation,
    ContainerCompanyNewCreateRelatedCompanyMutationVariables
  >(ContainerCompanyNewCreateRelatedCompanyDocument, options)
}
export type ContainerCompanyNewCreateRelatedCompanyMutationHookResult = ReturnType<
  typeof useContainerCompanyNewCreateRelatedCompanyMutation
>
export type ContainerCompanyNewCreateRelatedCompanyMutationResult =
  Apollo.MutationResult<ContainerCompanyNewCreateRelatedCompanyMutation>
export type ContainerCompanyNewCreateRelatedCompanyMutationOptions = Apollo.BaseMutationOptions<
  ContainerCompanyNewCreateRelatedCompanyMutation,
  ContainerCompanyNewCreateRelatedCompanyMutationVariables
>
export const ContainerContractDetailPrepareUploadAttachedFileDocument = gql`
  mutation ContainerContractDetailPrepareUploadAttachedFile(
    $input: PrepareUploadAttachedFileInput!
  ) {
    prepareUploadAttachedFile(input: $input) {
      temporaryAttachedFile {
        ...UiFileUploaderTemporaryAttachedFile
      }
    }
  }
  ${UiFileUploaderTemporaryAttachedFileFragmentDoc}
`
export type ContainerContractDetailPrepareUploadAttachedFileMutationFn = Apollo.MutationFunction<
  ContainerContractDetailPrepareUploadAttachedFileMutation,
  ContainerContractDetailPrepareUploadAttachedFileMutationVariables
>

/**
 * __useContainerContractDetailPrepareUploadAttachedFileMutation__
 *
 * To run a mutation, you first call `useContainerContractDetailPrepareUploadAttachedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerContractDetailPrepareUploadAttachedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerContractDetailPrepareUploadAttachedFileMutation, { data, loading, error }] = useContainerContractDetailPrepareUploadAttachedFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerContractDetailPrepareUploadAttachedFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerContractDetailPrepareUploadAttachedFileMutation,
    ContainerContractDetailPrepareUploadAttachedFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerContractDetailPrepareUploadAttachedFileMutation,
    ContainerContractDetailPrepareUploadAttachedFileMutationVariables
  >(ContainerContractDetailPrepareUploadAttachedFileDocument, options)
}
export type ContainerContractDetailPrepareUploadAttachedFileMutationHookResult = ReturnType<
  typeof useContainerContractDetailPrepareUploadAttachedFileMutation
>
export type ContainerContractDetailPrepareUploadAttachedFileMutationResult =
  Apollo.MutationResult<ContainerContractDetailPrepareUploadAttachedFileMutation>
export type ContainerContractDetailPrepareUploadAttachedFileMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerContractDetailPrepareUploadAttachedFileMutation,
    ContainerContractDetailPrepareUploadAttachedFileMutationVariables
  >
export const ContainerContractDetailAttachContractAttachedFileDocument = gql`
  mutation ContainerContractDetailAttachContractAttachedFile(
    $input: AttachContractAttachedFileInput!
  ) {
    attachContractAttachedFile(input: $input) {
      attachedFile {
        ...UiFileUploaderAttachedFile
      }
      contract {
        ...ModuleContractDetailContent
      }
    }
  }
  ${UiFileUploaderAttachedFileFragmentDoc}
  ${ModuleContractDetailContentFragmentDoc}
`
export type ContainerContractDetailAttachContractAttachedFileMutationFn = Apollo.MutationFunction<
  ContainerContractDetailAttachContractAttachedFileMutation,
  ContainerContractDetailAttachContractAttachedFileMutationVariables
>

/**
 * __useContainerContractDetailAttachContractAttachedFileMutation__
 *
 * To run a mutation, you first call `useContainerContractDetailAttachContractAttachedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerContractDetailAttachContractAttachedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerContractDetailAttachContractAttachedFileMutation, { data, loading, error }] = useContainerContractDetailAttachContractAttachedFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerContractDetailAttachContractAttachedFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerContractDetailAttachContractAttachedFileMutation,
    ContainerContractDetailAttachContractAttachedFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerContractDetailAttachContractAttachedFileMutation,
    ContainerContractDetailAttachContractAttachedFileMutationVariables
  >(ContainerContractDetailAttachContractAttachedFileDocument, options)
}
export type ContainerContractDetailAttachContractAttachedFileMutationHookResult = ReturnType<
  typeof useContainerContractDetailAttachContractAttachedFileMutation
>
export type ContainerContractDetailAttachContractAttachedFileMutationResult =
  Apollo.MutationResult<ContainerContractDetailAttachContractAttachedFileMutation>
export type ContainerContractDetailAttachContractAttachedFileMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerContractDetailAttachContractAttachedFileMutation,
    ContainerContractDetailAttachContractAttachedFileMutationVariables
  >
export const ContainerContractDetailRemoveAttachedFileDocument = gql`
  mutation ContainerContractDetailRemoveAttachedFile($input: RemoveAttachedFileInput!) {
    removeAttachedFile(input: $input) {
      attachment {
        ... on Contract {
          ...ModuleContractDetailContent
        }
      }
    }
  }
  ${ModuleContractDetailContentFragmentDoc}
`
export type ContainerContractDetailRemoveAttachedFileMutationFn = Apollo.MutationFunction<
  ContainerContractDetailRemoveAttachedFileMutation,
  ContainerContractDetailRemoveAttachedFileMutationVariables
>

/**
 * __useContainerContractDetailRemoveAttachedFileMutation__
 *
 * To run a mutation, you first call `useContainerContractDetailRemoveAttachedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerContractDetailRemoveAttachedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerContractDetailRemoveAttachedFileMutation, { data, loading, error }] = useContainerContractDetailRemoveAttachedFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerContractDetailRemoveAttachedFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerContractDetailRemoveAttachedFileMutation,
    ContainerContractDetailRemoveAttachedFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerContractDetailRemoveAttachedFileMutation,
    ContainerContractDetailRemoveAttachedFileMutationVariables
  >(ContainerContractDetailRemoveAttachedFileDocument, options)
}
export type ContainerContractDetailRemoveAttachedFileMutationHookResult = ReturnType<
  typeof useContainerContractDetailRemoveAttachedFileMutation
>
export type ContainerContractDetailRemoveAttachedFileMutationResult =
  Apollo.MutationResult<ContainerContractDetailRemoveAttachedFileMutation>
export type ContainerContractDetailRemoveAttachedFileMutationOptions = Apollo.BaseMutationOptions<
  ContainerContractDetailRemoveAttachedFileMutation,
  ContainerContractDetailRemoveAttachedFileMutationVariables
>
export const ContainerContractsContractDetailDocument = gql`
  query ContainerContractsContractDetail($id: ID) {
    contracts(id: $id, enables: true) {
      ...ModuleContractDetail
    }
  }
  ${ModuleContractDetailFragmentDoc}
`

/**
 * __useContainerContractsContractDetailQuery__
 *
 * To run a query within a React component, call `useContainerContractsContractDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerContractsContractDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerContractsContractDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContainerContractsContractDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerContractsContractDetailQuery,
    ContainerContractsContractDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerContractsContractDetailQuery,
    ContainerContractsContractDetailQueryVariables
  >(ContainerContractsContractDetailDocument, options)
}
export function useContainerContractsContractDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerContractsContractDetailQuery,
    ContainerContractsContractDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerContractsContractDetailQuery,
    ContainerContractsContractDetailQueryVariables
  >(ContainerContractsContractDetailDocument, options)
}
export type ContainerContractsContractDetailQueryHookResult = ReturnType<
  typeof useContainerContractsContractDetailQuery
>
export type ContainerContractsContractDetailLazyQueryHookResult = ReturnType<
  typeof useContainerContractsContractDetailLazyQuery
>
export type ContainerContractsContractDetailQueryResult = Apollo.QueryResult<
  ContainerContractsContractDetailQuery,
  ContainerContractsContractDetailQueryVariables
>
export const ContainerContractUpdateContractDocument = gql`
  mutation ContainerContractUpdateContract($input: UpdateContractInput!) {
    updateContract(input: $input) {
      contract {
        ...ModuleContractEditContract
      }
    }
  }
  ${ModuleContractEditContractFragmentDoc}
`
export type ContainerContractUpdateContractMutationFn = Apollo.MutationFunction<
  ContainerContractUpdateContractMutation,
  ContainerContractUpdateContractMutationVariables
>

/**
 * __useContainerContractUpdateContractMutation__
 *
 * To run a mutation, you first call `useContainerContractUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerContractUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerContractUpdateContractMutation, { data, loading, error }] = useContainerContractUpdateContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerContractUpdateContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerContractUpdateContractMutation,
    ContainerContractUpdateContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerContractUpdateContractMutation,
    ContainerContractUpdateContractMutationVariables
  >(ContainerContractUpdateContractDocument, options)
}
export type ContainerContractUpdateContractMutationHookResult = ReturnType<
  typeof useContainerContractUpdateContractMutation
>
export type ContainerContractUpdateContractMutationResult =
  Apollo.MutationResult<ContainerContractUpdateContractMutation>
export type ContainerContractUpdateContractMutationOptions = Apollo.BaseMutationOptions<
  ContainerContractUpdateContractMutation,
  ContainerContractUpdateContractMutationVariables
>
export const ContainerContractDisableContractDocument = gql`
  mutation ContainerContractDisableContract($input: DisableContractInput!) {
    disableContract(input: $input) {
      contract {
        id
      }
    }
  }
`
export type ContainerContractDisableContractMutationFn = Apollo.MutationFunction<
  ContainerContractDisableContractMutation,
  ContainerContractDisableContractMutationVariables
>

/**
 * __useContainerContractDisableContractMutation__
 *
 * To run a mutation, you first call `useContainerContractDisableContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerContractDisableContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerContractDisableContractMutation, { data, loading, error }] = useContainerContractDisableContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerContractDisableContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerContractDisableContractMutation,
    ContainerContractDisableContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerContractDisableContractMutation,
    ContainerContractDisableContractMutationVariables
  >(ContainerContractDisableContractDocument, options)
}
export type ContainerContractDisableContractMutationHookResult = ReturnType<
  typeof useContainerContractDisableContractMutation
>
export type ContainerContractDisableContractMutationResult =
  Apollo.MutationResult<ContainerContractDisableContractMutation>
export type ContainerContractDisableContractMutationOptions = Apollo.BaseMutationOptions<
  ContainerContractDisableContractMutation,
  ContainerContractDisableContractMutationVariables
>
export const ContainerContractEditDocument = gql`
  query ContainerContractEdit($id: ID!) {
    ...ModuleContractEdit
  }
  ${ModuleContractEditFragmentDoc}
`

/**
 * __useContainerContractEditQuery__
 *
 * To run a query within a React component, call `useContainerContractEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerContractEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerContractEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContainerContractEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerContractEditQuery,
    ContainerContractEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerContractEditQuery, ContainerContractEditQueryVariables>(
    ContainerContractEditDocument,
    options
  )
}
export function useContainerContractEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerContractEditQuery,
    ContainerContractEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerContractEditQuery, ContainerContractEditQueryVariables>(
    ContainerContractEditDocument,
    options
  )
}
export type ContainerContractEditQueryHookResult = ReturnType<typeof useContainerContractEditQuery>
export type ContainerContractEditLazyQueryHookResult = ReturnType<
  typeof useContainerContractEditLazyQuery
>
export type ContainerContractEditQueryResult = Apollo.QueryResult<
  ContainerContractEditQuery,
  ContainerContractEditQueryVariables
>
export const ContainerContractsFilterDocument = gql`
  query ContainerContractsFilter($text: String, $after: String, $first: Int!) {
    contracts(text: $text, after: $after, first: $first, enables: true) {
      ...ModuleContractFilter
    }
  }
  ${ModuleContractFilterFragmentDoc}
`

/**
 * __useContainerContractsFilterQuery__
 *
 * To run a query within a React component, call `useContainerContractsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerContractsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerContractsFilterQuery({
 *   variables: {
 *      text: // value for 'text'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useContainerContractsFilterQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerContractsFilterQuery,
    ContainerContractsFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerContractsFilterQuery, ContainerContractsFilterQueryVariables>(
    ContainerContractsFilterDocument,
    options
  )
}
export function useContainerContractsFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerContractsFilterQuery,
    ContainerContractsFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerContractsFilterQuery, ContainerContractsFilterQueryVariables>(
    ContainerContractsFilterDocument,
    options
  )
}
export type ContainerContractsFilterQueryHookResult = ReturnType<
  typeof useContainerContractsFilterQuery
>
export type ContainerContractsFilterLazyQueryHookResult = ReturnType<
  typeof useContainerContractsFilterLazyQuery
>
export type ContainerContractsFilterQueryResult = Apollo.QueryResult<
  ContainerContractsFilterQuery,
  ContainerContractsFilterQueryVariables
>
export const ContainerContractNewCreateContractDocument = gql`
  mutation ContainerContractNewCreateContract($input: CreateContractInput!) {
    createContract(input: $input) {
      contract {
        id
        name
      }
    }
  }
`
export type ContainerContractNewCreateContractMutationFn = Apollo.MutationFunction<
  ContainerContractNewCreateContractMutation,
  ContainerContractNewCreateContractMutationVariables
>

/**
 * __useContainerContractNewCreateContractMutation__
 *
 * To run a mutation, you first call `useContainerContractNewCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerContractNewCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerContractNewCreateContractMutation, { data, loading, error }] = useContainerContractNewCreateContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerContractNewCreateContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerContractNewCreateContractMutation,
    ContainerContractNewCreateContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerContractNewCreateContractMutation,
    ContainerContractNewCreateContractMutationVariables
  >(ContainerContractNewCreateContractDocument, options)
}
export type ContainerContractNewCreateContractMutationHookResult = ReturnType<
  typeof useContainerContractNewCreateContractMutation
>
export type ContainerContractNewCreateContractMutationResult =
  Apollo.MutationResult<ContainerContractNewCreateContractMutation>
export type ContainerContractNewCreateContractMutationOptions = Apollo.BaseMutationOptions<
  ContainerContractNewCreateContractMutation,
  ContainerContractNewCreateContractMutationVariables
>
export const ContainerContractNewCreateContractAndRelatedCompanyDocument = gql`
  mutation ContainerContractNewCreateContractAndRelatedCompany(
    $input: CreateContractAndRelatedCompanyInput!
  ) {
    createContractAndRelatedCompany(input: $input) {
      contract {
        id
        name
      }
      companyRelation {
        id
        involvement
        company {
          id
          name
        }
        relatedCompany {
          id
          name
        }
      }
    }
  }
`
export type ContainerContractNewCreateContractAndRelatedCompanyMutationFn = Apollo.MutationFunction<
  ContainerContractNewCreateContractAndRelatedCompanyMutation,
  ContainerContractNewCreateContractAndRelatedCompanyMutationVariables
>

/**
 * __useContainerContractNewCreateContractAndRelatedCompanyMutation__
 *
 * To run a mutation, you first call `useContainerContractNewCreateContractAndRelatedCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerContractNewCreateContractAndRelatedCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerContractNewCreateContractAndRelatedCompanyMutation, { data, loading, error }] = useContainerContractNewCreateContractAndRelatedCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerContractNewCreateContractAndRelatedCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerContractNewCreateContractAndRelatedCompanyMutation,
    ContainerContractNewCreateContractAndRelatedCompanyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerContractNewCreateContractAndRelatedCompanyMutation,
    ContainerContractNewCreateContractAndRelatedCompanyMutationVariables
  >(ContainerContractNewCreateContractAndRelatedCompanyDocument, options)
}
export type ContainerContractNewCreateContractAndRelatedCompanyMutationHookResult = ReturnType<
  typeof useContainerContractNewCreateContractAndRelatedCompanyMutation
>
export type ContainerContractNewCreateContractAndRelatedCompanyMutationResult =
  Apollo.MutationResult<ContainerContractNewCreateContractAndRelatedCompanyMutation>
export type ContainerContractNewCreateContractAndRelatedCompanyMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerContractNewCreateContractAndRelatedCompanyMutation,
    ContainerContractNewCreateContractAndRelatedCompanyMutationVariables
  >
export const ContainerContractNewDocument = gql`
  query ContainerContractNew {
    ...ModuleContractNew
  }
  ${ModuleContractNewFragmentDoc}
`

/**
 * __useContainerContractNewQuery__
 *
 * To run a query within a React component, call `useContainerContractNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerContractNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerContractNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useContainerContractNewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerContractNewQuery,
    ContainerContractNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerContractNewQuery, ContainerContractNewQueryVariables>(
    ContainerContractNewDocument,
    options
  )
}
export function useContainerContractNewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerContractNewQuery,
    ContainerContractNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerContractNewQuery, ContainerContractNewQueryVariables>(
    ContainerContractNewDocument,
    options
  )
}
export type ContainerContractNewQueryHookResult = ReturnType<typeof useContainerContractNewQuery>
export type ContainerContractNewLazyQueryHookResult = ReturnType<
  typeof useContainerContractNewLazyQuery
>
export type ContainerContractNewQueryResult = Apollo.QueryResult<
  ContainerContractNewQuery,
  ContainerContractNewQueryVariables
>
export const EmployeeDetailDocument = gql`
  query EmployeeDetail($id: ID) {
    employees(
      id: $id
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      edges {
        node {
          ...EmployeeManagementDetail
        }
      }
    }
  }
  ${EmployeeManagementDetailFragmentDoc}
`

/**
 * __useEmployeeDetailQuery__
 *
 * To run a query within a React component, call `useEmployeeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<EmployeeDetailQuery, EmployeeDetailQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<EmployeeDetailQuery, EmployeeDetailQueryVariables>(
    EmployeeDetailDocument,
    options
  )
}
export function useEmployeeDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EmployeeDetailQuery, EmployeeDetailQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<EmployeeDetailQuery, EmployeeDetailQueryVariables>(
    EmployeeDetailDocument,
    options
  )
}
export type EmployeeDetailQueryHookResult = ReturnType<typeof useEmployeeDetailQuery>
export type EmployeeDetailLazyQueryHookResult = ReturnType<typeof useEmployeeDetailLazyQuery>
export type EmployeeDetailQueryResult = Apollo.QueryResult<
  EmployeeDetailQuery,
  EmployeeDetailQueryVariables
>
export const ChangeEmployeeOrderDocument = gql`
  mutation ChangeEmployeeOrder($input: ChangeEmployeeOrderInput!) {
    changeEmployeeOrder(input: $input) {
      clientMutationId
    }
  }
`
export type ChangeEmployeeOrderMutationFn = Apollo.MutationFunction<
  ChangeEmployeeOrderMutation,
  ChangeEmployeeOrderMutationVariables
>

/**
 * __useChangeEmployeeOrderMutation__
 *
 * To run a mutation, you first call `useChangeEmployeeOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmployeeOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmployeeOrderMutation, { data, loading, error }] = useChangeEmployeeOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeEmployeeOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeEmployeeOrderMutation,
    ChangeEmployeeOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ChangeEmployeeOrderMutation, ChangeEmployeeOrderMutationVariables>(
    ChangeEmployeeOrderDocument,
    options
  )
}
export type ChangeEmployeeOrderMutationHookResult = ReturnType<
  typeof useChangeEmployeeOrderMutation
>
export type ChangeEmployeeOrderMutationResult = Apollo.MutationResult<ChangeEmployeeOrderMutation>
export type ChangeEmployeeOrderMutationOptions = Apollo.BaseMutationOptions<
  ChangeEmployeeOrderMutation,
  ChangeEmployeeOrderMutationVariables
>
export const ContainerEmployeesFilterDocument = gql`
  query ContainerEmployeesFilter {
    employees(
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      edges {
        node {
          ...EmployeeManagementList
        }
      }
    }
  }
  ${EmployeeManagementListFragmentDoc}
`

/**
 * __useContainerEmployeesFilterQuery__
 *
 * To run a query within a React component, call `useContainerEmployeesFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEmployeesFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEmployeesFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useContainerEmployeesFilterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerEmployeesFilterQuery,
    ContainerEmployeesFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerEmployeesFilterQuery, ContainerEmployeesFilterQueryVariables>(
    ContainerEmployeesFilterDocument,
    options
  )
}
export function useContainerEmployeesFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEmployeesFilterQuery,
    ContainerEmployeesFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerEmployeesFilterQuery, ContainerEmployeesFilterQueryVariables>(
    ContainerEmployeesFilterDocument,
    options
  )
}
export type ContainerEmployeesFilterQueryHookResult = ReturnType<
  typeof useContainerEmployeesFilterQuery
>
export type ContainerEmployeesFilterLazyQueryHookResult = ReturnType<
  typeof useContainerEmployeesFilterLazyQuery
>
export type ContainerEmployeesFilterQueryResult = Apollo.QueryResult<
  ContainerEmployeesFilterQuery,
  ContainerEmployeesFilterQueryVariables
>
export const CreateEmployeeDocument = gql`
  mutation CreateEmployee($input: CreateEmployeeInput!) {
    createEmployee(input: $input) {
      employee {
        id
      }
    }
  }
`
export type CreateEmployeeMutationFn = Apollo.MutationFunction<
  CreateEmployeeMutation,
  CreateEmployeeMutationVariables
>

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(
    CreateEmployeeDocument,
    options
  )
}
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<
  CreateEmployeeMutation,
  CreateEmployeeMutationVariables
>
export const UpdateEmployeeDocument = gql`
  mutation UpdateEmployee($input: UpdateEmployeeInput!) {
    updateEmployee(input: $input) {
      employee {
        ...EmployeeManagementDetail
      }
    }
  }
  ${EmployeeManagementDetailFragmentDoc}
`
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<
  UpdateEmployeeMutation,
  UpdateEmployeeMutationVariables
>

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(
    UpdateEmployeeDocument,
    options
  )
}
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmployeeMutation,
  UpdateEmployeeMutationVariables
>
export const DisableEmployeeDocument = gql`
  mutation DisableEmployee($input: DisableEmployeeInput!) {
    disableEmployee(input: $input) {
      employee {
        id
        name
      }
    }
  }
`
export type DisableEmployeeMutationFn = Apollo.MutationFunction<
  DisableEmployeeMutation,
  DisableEmployeeMutationVariables
>

/**
 * __useDisableEmployeeMutation__
 *
 * To run a mutation, you first call `useDisableEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableEmployeeMutation, { data, loading, error }] = useDisableEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableEmployeeMutation,
    DisableEmployeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DisableEmployeeMutation, DisableEmployeeMutationVariables>(
    DisableEmployeeDocument,
    options
  )
}
export type DisableEmployeeMutationHookResult = ReturnType<typeof useDisableEmployeeMutation>
export type DisableEmployeeMutationResult = Apollo.MutationResult<DisableEmployeeMutation>
export type DisableEmployeeMutationOptions = Apollo.BaseMutationOptions<
  DisableEmployeeMutation,
  DisableEmployeeMutationVariables
>
export const ContainerEmployeeNewDocument = gql`
  query ContainerEmployeeNew {
    companySites {
      nodes {
        ...EmployeeNewCompanySite
      }
    }
    employeeRoles {
      nodes {
        ...EmployeeNewEmployeeRole
      }
    }
  }
  ${EmployeeNewCompanySiteFragmentDoc}
  ${EmployeeNewEmployeeRoleFragmentDoc}
`

/**
 * __useContainerEmployeeNewQuery__
 *
 * To run a query within a React component, call `useContainerEmployeeNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEmployeeNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEmployeeNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useContainerEmployeeNewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerEmployeeNewQuery,
    ContainerEmployeeNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerEmployeeNewQuery, ContainerEmployeeNewQueryVariables>(
    ContainerEmployeeNewDocument,
    options
  )
}
export function useContainerEmployeeNewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEmployeeNewQuery,
    ContainerEmployeeNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerEmployeeNewQuery, ContainerEmployeeNewQueryVariables>(
    ContainerEmployeeNewDocument,
    options
  )
}
export type ContainerEmployeeNewQueryHookResult = ReturnType<typeof useContainerEmployeeNewQuery>
export type ContainerEmployeeNewLazyQueryHookResult = ReturnType<
  typeof useContainerEmployeeNewLazyQuery
>
export type ContainerEmployeeNewQueryResult = Apollo.QueryResult<
  ContainerEmployeeNewQuery,
  ContainerEmployeeNewQueryVariables
>
export const ContainerEventUpdateEmployeeEventDocument = gql`
  mutation ContainerEventUpdateEmployeeEvent($input: UpdateEventEmployeeInput!) {
    updateEventEmployee(input: $input) {
      event {
        ... on EventEmployee {
          ...ModuleEventDetailEventEmployee
        }
      }
    }
  }
  ${ModuleEventDetailEventEmployeeFragmentDoc}
`
export type ContainerEventUpdateEmployeeEventMutationFn = Apollo.MutationFunction<
  ContainerEventUpdateEmployeeEventMutation,
  ContainerEventUpdateEmployeeEventMutationVariables
>

/**
 * __useContainerEventUpdateEmployeeEventMutation__
 *
 * To run a mutation, you first call `useContainerEventUpdateEmployeeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventUpdateEmployeeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventUpdateEmployeeEventMutation, { data, loading, error }] = useContainerEventUpdateEmployeeEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventUpdateEmployeeEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventUpdateEmployeeEventMutation,
    ContainerEventUpdateEmployeeEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventUpdateEmployeeEventMutation,
    ContainerEventUpdateEmployeeEventMutationVariables
  >(ContainerEventUpdateEmployeeEventDocument, options)
}
export type ContainerEventUpdateEmployeeEventMutationHookResult = ReturnType<
  typeof useContainerEventUpdateEmployeeEventMutation
>
export type ContainerEventUpdateEmployeeEventMutationResult =
  Apollo.MutationResult<ContainerEventUpdateEmployeeEventMutation>
export type ContainerEventUpdateEmployeeEventMutationOptions = Apollo.BaseMutationOptions<
  ContainerEventUpdateEmployeeEventMutation,
  ContainerEventUpdateEmployeeEventMutationVariables
>
export const ContainerEventUpdateDocument = gql`
  mutation ContainerEventUpdate($input: UpdateTemporaryVehicleAllocationEventInput!) {
    updateTemporaryVehicleAllocationEvent(input: $input) {
      unit {
        ...ModuleEventDetailUnit
      }
      event {
        ... on EventTemporaryVehicleAllocation {
          ...ModuleEventDetailEventTemporaryVehicleAllocation
        }
      }
      basedContract
    }
  }
  ${ModuleEventDetailUnitFragmentDoc}
  ${ModuleEventDetailEventTemporaryVehicleAllocationFragmentDoc}
`
export type ContainerEventUpdateMutationFn = Apollo.MutationFunction<
  ContainerEventUpdateMutation,
  ContainerEventUpdateMutationVariables
>

/**
 * __useContainerEventUpdateMutation__
 *
 * To run a mutation, you first call `useContainerEventUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventUpdateMutation, { data, loading, error }] = useContainerEventUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventUpdateMutation,
    ContainerEventUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ContainerEventUpdateMutation, ContainerEventUpdateMutationVariables>(
    ContainerEventUpdateDocument,
    options
  )
}
export type ContainerEventUpdateMutationHookResult = ReturnType<
  typeof useContainerEventUpdateMutation
>
export type ContainerEventUpdateMutationResult = Apollo.MutationResult<ContainerEventUpdateMutation>
export type ContainerEventUpdateMutationOptions = Apollo.BaseMutationOptions<
  ContainerEventUpdateMutation,
  ContainerEventUpdateMutationVariables
>
export const ContainerEventDetailOverwriteContractDocument = gql`
  mutation ContainerEventDetailOverwriteContract($input: UpdateContractInput!) {
    updateContract(input: $input) {
      contract {
        ...ModuleEventDetailContract
      }
    }
  }
  ${ModuleEventDetailContractFragmentDoc}
`
export type ContainerEventDetailOverwriteContractMutationFn = Apollo.MutationFunction<
  ContainerEventDetailOverwriteContractMutation,
  ContainerEventDetailOverwriteContractMutationVariables
>

/**
 * __useContainerEventDetailOverwriteContractMutation__
 *
 * To run a mutation, you first call `useContainerEventDetailOverwriteContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventDetailOverwriteContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventDetailOverwriteContractMutation, { data, loading, error }] = useContainerEventDetailOverwriteContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventDetailOverwriteContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventDetailOverwriteContractMutation,
    ContainerEventDetailOverwriteContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventDetailOverwriteContractMutation,
    ContainerEventDetailOverwriteContractMutationVariables
  >(ContainerEventDetailOverwriteContractDocument, options)
}
export type ContainerEventDetailOverwriteContractMutationHookResult = ReturnType<
  typeof useContainerEventDetailOverwriteContractMutation
>
export type ContainerEventDetailOverwriteContractMutationResult =
  Apollo.MutationResult<ContainerEventDetailOverwriteContractMutation>
export type ContainerEventDetailOverwriteContractMutationOptions = Apollo.BaseMutationOptions<
  ContainerEventDetailOverwriteContractMutation,
  ContainerEventDetailOverwriteContractMutationVariables
>
export const ContainerEventUpdateTruckEventDocument = gql`
  mutation ContainerEventUpdateTruckEvent($input: UpdateEventTruckInput!) {
    updateEventTruck(input: $input) {
      event {
        ... on EventTruck {
          ...ModuleEventDetailEventTruck
        }
      }
    }
  }
  ${ModuleEventDetailEventTruckFragmentDoc}
`
export type ContainerEventUpdateTruckEventMutationFn = Apollo.MutationFunction<
  ContainerEventUpdateTruckEventMutation,
  ContainerEventUpdateTruckEventMutationVariables
>

/**
 * __useContainerEventUpdateTruckEventMutation__
 *
 * To run a mutation, you first call `useContainerEventUpdateTruckEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventUpdateTruckEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventUpdateTruckEventMutation, { data, loading, error }] = useContainerEventUpdateTruckEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventUpdateTruckEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventUpdateTruckEventMutation,
    ContainerEventUpdateTruckEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventUpdateTruckEventMutation,
    ContainerEventUpdateTruckEventMutationVariables
  >(ContainerEventUpdateTruckEventDocument, options)
}
export type ContainerEventUpdateTruckEventMutationHookResult = ReturnType<
  typeof useContainerEventUpdateTruckEventMutation
>
export type ContainerEventUpdateTruckEventMutationResult =
  Apollo.MutationResult<ContainerEventUpdateTruckEventMutation>
export type ContainerEventUpdateTruckEventMutationOptions = Apollo.BaseMutationOptions<
  ContainerEventUpdateTruckEventMutation,
  ContainerEventUpdateTruckEventMutationVariables
>
export const ContainerEventDestroyDocument = gql`
  mutation ContainerEventDestroy($input: DestroyEventInput!) {
    destroyEvent(input: $input) {
      event {
        ... on EventInterface {
          id
        }
      }
    }
  }
`
export type ContainerEventDestroyMutationFn = Apollo.MutationFunction<
  ContainerEventDestroyMutation,
  ContainerEventDestroyMutationVariables
>

/**
 * __useContainerEventDestroyMutation__
 *
 * To run a mutation, you first call `useContainerEventDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventDestroyMutation, { data, loading, error }] = useContainerEventDestroyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventDestroyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventDestroyMutation,
    ContainerEventDestroyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ContainerEventDestroyMutation, ContainerEventDestroyMutationVariables>(
    ContainerEventDestroyDocument,
    options
  )
}
export type ContainerEventDestroyMutationHookResult = ReturnType<
  typeof useContainerEventDestroyMutation
>
export type ContainerEventDestroyMutationResult =
  Apollo.MutationResult<ContainerEventDestroyMutation>
export type ContainerEventDestroyMutationOptions = Apollo.BaseMutationOptions<
  ContainerEventDestroyMutation,
  ContainerEventDestroyMutationVariables
>
export const ContainerEventDetailDocument = gql`
  query ContainerEventDetail($id: ID!) {
    events(id: $id) {
      nodes {
        ...ModuleEventDetailEventTemporaryVehicleAllocation
        ...ModuleEventDetailEventTruck
        ...ModuleEventDetailEventEmployee
      }
      pageInfo {
        ...PageInfoField
      }
    }
    contracts(enables: true, frequent: true) {
      nodes {
        ...ModuleEventDetailContract
      }
    }
    companyRelations(enables: true) {
      nodes {
        ...ModuleEventDetailCompanyRelation
      }
    }
    salesEmployees: employees(
      freightageRoles: [request, add]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventDetailEmployee
      }
    }
    driverEmployees: employees(
      freightageRoles: [execute]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventDetailEmployee
      }
    }
    carTypes {
      nodes {
        ...ModuleEventDetailCarType
      }
    }
    trucks(
      enables: true
      hasOneOrderBy: { relationalTable: "truck_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventDetailTruck
      }
    }
    employeeDrivableTrucks {
      nodes {
        ...ModuleEventDetailEmployeeDrivableTruck
      }
    }
  }
  ${ModuleEventDetailEventTemporaryVehicleAllocationFragmentDoc}
  ${ModuleEventDetailEventTruckFragmentDoc}
  ${ModuleEventDetailEventEmployeeFragmentDoc}
  ${PageInfoFieldFragmentDoc}
  ${ModuleEventDetailContractFragmentDoc}
  ${ModuleEventDetailCompanyRelationFragmentDoc}
  ${ModuleEventDetailEmployeeFragmentDoc}
  ${ModuleEventDetailCarTypeFragmentDoc}
  ${ModuleEventDetailTruckFragmentDoc}
  ${ModuleEventDetailEmployeeDrivableTruckFragmentDoc}
`

/**
 * __useContainerEventDetailQuery__
 *
 * To run a query within a React component, call `useContainerEventDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEventDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEventDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContainerEventDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerEventDetailQuery,
    ContainerEventDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerEventDetailQuery, ContainerEventDetailQueryVariables>(
    ContainerEventDetailDocument,
    options
  )
}
export function useContainerEventDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEventDetailQuery,
    ContainerEventDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerEventDetailQuery, ContainerEventDetailQueryVariables>(
    ContainerEventDetailDocument,
    options
  )
}
export type ContainerEventDetailQueryHookResult = ReturnType<typeof useContainerEventDetailQuery>
export type ContainerEventDetailLazyQueryHookResult = ReturnType<
  typeof useContainerEventDetailLazyQuery
>
export type ContainerEventDetailQueryResult = Apollo.QueryResult<
  ContainerEventDetailQuery,
  ContainerEventDetailQueryVariables
>
export const ContainerEventDetailContractsDocument = gql`
  query ContainerEventDetailContracts($text: String!) {
    contracts(enables: true, text: $text) {
      nodes {
        ...ModuleEventDetailContract
      }
    }
  }
  ${ModuleEventDetailContractFragmentDoc}
`

/**
 * __useContainerEventDetailContractsQuery__
 *
 * To run a query within a React component, call `useContainerEventDetailContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEventDetailContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEventDetailContractsQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useContainerEventDetailContractsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerEventDetailContractsQuery,
    ContainerEventDetailContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerEventDetailContractsQuery,
    ContainerEventDetailContractsQueryVariables
  >(ContainerEventDetailContractsDocument, options)
}
export function useContainerEventDetailContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEventDetailContractsQuery,
    ContainerEventDetailContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerEventDetailContractsQuery,
    ContainerEventDetailContractsQueryVariables
  >(ContainerEventDetailContractsDocument, options)
}
export type ContainerEventDetailContractsQueryHookResult = ReturnType<
  typeof useContainerEventDetailContractsQuery
>
export type ContainerEventDetailContractsLazyQueryHookResult = ReturnType<
  typeof useContainerEventDetailContractsLazyQuery
>
export type ContainerEventDetailContractsQueryResult = Apollo.QueryResult<
  ContainerEventDetailContractsQuery,
  ContainerEventDetailContractsQueryVariables
>
export const ContainerEventNewEventEmployeeDocument = gql`
  mutation ContainerEventNewEventEmployee($input: CreateEventEmployeeInput!) {
    createEventEmployee(input: $input) {
      event {
        ... on EventEmployee {
          ...ModuleEventNewEventEmployee
        }
      }
    }
  }
  ${ModuleEventNewEventEmployeeFragmentDoc}
`
export type ContainerEventNewEventEmployeeMutationFn = Apollo.MutationFunction<
  ContainerEventNewEventEmployeeMutation,
  ContainerEventNewEventEmployeeMutationVariables
>

/**
 * __useContainerEventNewEventEmployeeMutation__
 *
 * To run a mutation, you first call `useContainerEventNewEventEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewEventEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventNewEventEmployeeMutation, { data, loading, error }] = useContainerEventNewEventEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventNewEventEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventNewEventEmployeeMutation,
    ContainerEventNewEventEmployeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventNewEventEmployeeMutation,
    ContainerEventNewEventEmployeeMutationVariables
  >(ContainerEventNewEventEmployeeDocument, options)
}
export type ContainerEventNewEventEmployeeMutationHookResult = ReturnType<
  typeof useContainerEventNewEventEmployeeMutation
>
export type ContainerEventNewEventEmployeeMutationResult =
  Apollo.MutationResult<ContainerEventNewEventEmployeeMutation>
export type ContainerEventNewEventEmployeeMutationOptions = Apollo.BaseMutationOptions<
  ContainerEventNewEventEmployeeMutation,
  ContainerEventNewEventEmployeeMutationVariables
>
export const ContainerEventNewEmployeeDocument = gql`
  query ContainerEventNewEmployee {
    driverEmployees: employees(
      freightageRoles: [execute]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventNewEmployee
      }
    }
  }
  ${ModuleEventNewEmployeeFragmentDoc}
`

/**
 * __useContainerEventNewEmployeeQuery__
 *
 * To run a query within a React component, call `useContainerEventNewEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEventNewEmployeeQuery({
 *   variables: {
 *   },
 * });
 */
export function useContainerEventNewEmployeeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerEventNewEmployeeQuery,
    ContainerEventNewEmployeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerEventNewEmployeeQuery, ContainerEventNewEmployeeQueryVariables>(
    ContainerEventNewEmployeeDocument,
    options
  )
}
export function useContainerEventNewEmployeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEventNewEmployeeQuery,
    ContainerEventNewEmployeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerEventNewEmployeeQuery,
    ContainerEventNewEmployeeQueryVariables
  >(ContainerEventNewEmployeeDocument, options)
}
export type ContainerEventNewEmployeeQueryHookResult = ReturnType<
  typeof useContainerEventNewEmployeeQuery
>
export type ContainerEventNewEmployeeLazyQueryHookResult = ReturnType<
  typeof useContainerEventNewEmployeeLazyQuery
>
export type ContainerEventNewEmployeeQueryResult = Apollo.QueryResult<
  ContainerEventNewEmployeeQuery,
  ContainerEventNewEmployeeQueryVariables
>
export const ContainerEventNewExternalScrapCollectionRequestCreateDocument = gql`
  mutation ContainerEventNewExternalScrapCollectionRequestCreate(
    $input: CreateTemporaryVehicleAllocationEventOrUnitInput!
  ) {
    createTemporaryVehicleAllocationEventOrUnit(input: $input) {
      unit {
        ...ModuleEventNewUnit
      }
      basedContract
    }
  }
  ${ModuleEventNewUnitFragmentDoc}
`
export type ContainerEventNewExternalScrapCollectionRequestCreateMutationFn =
  Apollo.MutationFunction<
    ContainerEventNewExternalScrapCollectionRequestCreateMutation,
    ContainerEventNewExternalScrapCollectionRequestCreateMutationVariables
  >

/**
 * __useContainerEventNewExternalScrapCollectionRequestCreateMutation__
 *
 * To run a mutation, you first call `useContainerEventNewExternalScrapCollectionRequestCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewExternalScrapCollectionRequestCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventNewExternalScrapCollectionRequestCreateMutation, { data, loading, error }] = useContainerEventNewExternalScrapCollectionRequestCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventNewExternalScrapCollectionRequestCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventNewExternalScrapCollectionRequestCreateMutation,
    ContainerEventNewExternalScrapCollectionRequestCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventNewExternalScrapCollectionRequestCreateMutation,
    ContainerEventNewExternalScrapCollectionRequestCreateMutationVariables
  >(ContainerEventNewExternalScrapCollectionRequestCreateDocument, options)
}
export type ContainerEventNewExternalScrapCollectionRequestCreateMutationHookResult = ReturnType<
  typeof useContainerEventNewExternalScrapCollectionRequestCreateMutation
>
export type ContainerEventNewExternalScrapCollectionRequestCreateMutationResult =
  Apollo.MutationResult<ContainerEventNewExternalScrapCollectionRequestCreateMutation>
export type ContainerEventNewExternalScrapCollectionRequestCreateMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerEventNewExternalScrapCollectionRequestCreateMutation,
    ContainerEventNewExternalScrapCollectionRequestCreateMutationVariables
  >
export const ContainerEventNewExternalScrapCollectionRequestOverwriteContractDocument = gql`
  mutation ContainerEventNewExternalScrapCollectionRequestOverwriteContract(
    $input: UpdateContractInput!
  ) {
    updateContract(input: $input) {
      contract {
        ...ModuleEventNewContract
      }
    }
  }
  ${ModuleEventNewContractFragmentDoc}
`
export type ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutationFn =
  Apollo.MutationFunction<
    ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutation,
    ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutationVariables
  >

/**
 * __useContainerEventNewExternalScrapCollectionRequestOverwriteContractMutation__
 *
 * To run a mutation, you first call `useContainerEventNewExternalScrapCollectionRequestOverwriteContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewExternalScrapCollectionRequestOverwriteContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventNewExternalScrapCollectionRequestOverwriteContractMutation, { data, loading, error }] = useContainerEventNewExternalScrapCollectionRequestOverwriteContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventNewExternalScrapCollectionRequestOverwriteContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutation,
    ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutation,
    ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutationVariables
  >(ContainerEventNewExternalScrapCollectionRequestOverwriteContractDocument, options)
}
export type ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutationHookResult =
  ReturnType<typeof useContainerEventNewExternalScrapCollectionRequestOverwriteContractMutation>
export type ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutationResult =
  Apollo.MutationResult<ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutation>
export type ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutation,
    ContainerEventNewExternalScrapCollectionRequestOverwriteContractMutationVariables
  >
export const ContainerEventNewExternalScrapCollectionRequestAcceptDocument = gql`
  mutation ContainerEventNewExternalScrapCollectionRequestAccept(
    $input: AcceptExternalScrapCollectionRequestInput!
  ) {
    acceptExternalScrapCollectionRequest(input: $input) {
      externalScrapCollectionRequest {
        ...ModuleEventNewExternalScrapCollectionRequest
      }
    }
  }
  ${ModuleEventNewExternalScrapCollectionRequestFragmentDoc}
`
export type ContainerEventNewExternalScrapCollectionRequestAcceptMutationFn =
  Apollo.MutationFunction<
    ContainerEventNewExternalScrapCollectionRequestAcceptMutation,
    ContainerEventNewExternalScrapCollectionRequestAcceptMutationVariables
  >

/**
 * __useContainerEventNewExternalScrapCollectionRequestAcceptMutation__
 *
 * To run a mutation, you first call `useContainerEventNewExternalScrapCollectionRequestAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewExternalScrapCollectionRequestAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventNewExternalScrapCollectionRequestAcceptMutation, { data, loading, error }] = useContainerEventNewExternalScrapCollectionRequestAcceptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventNewExternalScrapCollectionRequestAcceptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventNewExternalScrapCollectionRequestAcceptMutation,
    ContainerEventNewExternalScrapCollectionRequestAcceptMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventNewExternalScrapCollectionRequestAcceptMutation,
    ContainerEventNewExternalScrapCollectionRequestAcceptMutationVariables
  >(ContainerEventNewExternalScrapCollectionRequestAcceptDocument, options)
}
export type ContainerEventNewExternalScrapCollectionRequestAcceptMutationHookResult = ReturnType<
  typeof useContainerEventNewExternalScrapCollectionRequestAcceptMutation
>
export type ContainerEventNewExternalScrapCollectionRequestAcceptMutationResult =
  Apollo.MutationResult<ContainerEventNewExternalScrapCollectionRequestAcceptMutation>
export type ContainerEventNewExternalScrapCollectionRequestAcceptMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerEventNewExternalScrapCollectionRequestAcceptMutation,
    ContainerEventNewExternalScrapCollectionRequestAcceptMutationVariables
  >
export const ContainerEventNewExternalScrapCollectionRequestRejectDocument = gql`
  mutation ContainerEventNewExternalScrapCollectionRequestReject(
    $input: RejectExternalScrapCollectionRequestInput!
  ) {
    rejectExternalScrapCollectionRequest(input: $input) {
      externalScrapCollectionRequest {
        ...ModuleEventNewExternalScrapCollectionRequest
      }
    }
  }
  ${ModuleEventNewExternalScrapCollectionRequestFragmentDoc}
`
export type ContainerEventNewExternalScrapCollectionRequestRejectMutationFn =
  Apollo.MutationFunction<
    ContainerEventNewExternalScrapCollectionRequestRejectMutation,
    ContainerEventNewExternalScrapCollectionRequestRejectMutationVariables
  >

/**
 * __useContainerEventNewExternalScrapCollectionRequestRejectMutation__
 *
 * To run a mutation, you first call `useContainerEventNewExternalScrapCollectionRequestRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewExternalScrapCollectionRequestRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventNewExternalScrapCollectionRequestRejectMutation, { data, loading, error }] = useContainerEventNewExternalScrapCollectionRequestRejectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventNewExternalScrapCollectionRequestRejectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventNewExternalScrapCollectionRequestRejectMutation,
    ContainerEventNewExternalScrapCollectionRequestRejectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventNewExternalScrapCollectionRequestRejectMutation,
    ContainerEventNewExternalScrapCollectionRequestRejectMutationVariables
  >(ContainerEventNewExternalScrapCollectionRequestRejectDocument, options)
}
export type ContainerEventNewExternalScrapCollectionRequestRejectMutationHookResult = ReturnType<
  typeof useContainerEventNewExternalScrapCollectionRequestRejectMutation
>
export type ContainerEventNewExternalScrapCollectionRequestRejectMutationResult =
  Apollo.MutationResult<ContainerEventNewExternalScrapCollectionRequestRejectMutation>
export type ContainerEventNewExternalScrapCollectionRequestRejectMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerEventNewExternalScrapCollectionRequestRejectMutation,
    ContainerEventNewExternalScrapCollectionRequestRejectMutationVariables
  >
export const ContainerEventNewExternalScrapCollectionRequestDetailDocument = gql`
  query ContainerEventNewExternalScrapCollectionRequestDetail($id: ID!) {
    externalScrapCollectionRequests(id: $id) {
      nodes {
        ...ModuleEventNewExternalScrapCollectionRequest
      }
    }
    salesEmployees: employees(
      freightageRoles: [request, add]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventNewEmployee
      }
    }
    driverEmployees: employees(
      freightageRoles: [execute]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventNewEmployee
      }
    }
    carTypes {
      nodes {
        ...ModuleEventNewCarType
      }
    }
    trucks(
      enables: true
      hasOneOrderBy: { relationalTable: "truck_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventNewTruck
      }
    }
    employeeDrivableTrucks {
      nodes {
        ...ModuleEventNewEmployeeDrivableTruck
      }
    }
    contracts(enables: true, frequent: true) {
      nodes {
        ...ModuleEventNewContract
      }
    }
    companyRelations(enables: true) {
      nodes {
        ...ModuleEventNewCompanyRelation
      }
    }
  }
  ${ModuleEventNewExternalScrapCollectionRequestFragmentDoc}
  ${ModuleEventNewEmployeeFragmentDoc}
  ${ModuleEventNewCarTypeFragmentDoc}
  ${ModuleEventNewTruckFragmentDoc}
  ${ModuleEventNewEmployeeDrivableTruckFragmentDoc}
  ${ModuleEventNewContractFragmentDoc}
  ${ModuleEventNewCompanyRelationFragmentDoc}
`

/**
 * __useContainerEventNewExternalScrapCollectionRequestDetailQuery__
 *
 * To run a query within a React component, call `useContainerEventNewExternalScrapCollectionRequestDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewExternalScrapCollectionRequestDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEventNewExternalScrapCollectionRequestDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContainerEventNewExternalScrapCollectionRequestDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerEventNewExternalScrapCollectionRequestDetailQuery,
    ContainerEventNewExternalScrapCollectionRequestDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerEventNewExternalScrapCollectionRequestDetailQuery,
    ContainerEventNewExternalScrapCollectionRequestDetailQueryVariables
  >(ContainerEventNewExternalScrapCollectionRequestDetailDocument, options)
}
export function useContainerEventNewExternalScrapCollectionRequestDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEventNewExternalScrapCollectionRequestDetailQuery,
    ContainerEventNewExternalScrapCollectionRequestDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerEventNewExternalScrapCollectionRequestDetailQuery,
    ContainerEventNewExternalScrapCollectionRequestDetailQueryVariables
  >(ContainerEventNewExternalScrapCollectionRequestDetailDocument, options)
}
export type ContainerEventNewExternalScrapCollectionRequestDetailQueryHookResult = ReturnType<
  typeof useContainerEventNewExternalScrapCollectionRequestDetailQuery
>
export type ContainerEventNewExternalScrapCollectionRequestDetailLazyQueryHookResult = ReturnType<
  typeof useContainerEventNewExternalScrapCollectionRequestDetailLazyQuery
>
export type ContainerEventNewExternalScrapCollectionRequestDetailQueryResult = Apollo.QueryResult<
  ContainerEventNewExternalScrapCollectionRequestDetailQuery,
  ContainerEventNewExternalScrapCollectionRequestDetailQueryVariables
>
export const ContainerEventNewExternalScrapCollectionRequestContractsDocument = gql`
  query ContainerEventNewExternalScrapCollectionRequestContracts($text: String!) {
    contracts(enables: true, text: $text) {
      nodes {
        ...ModuleEventNewContract
      }
    }
  }
  ${ModuleEventNewContractFragmentDoc}
`

/**
 * __useContainerEventNewExternalScrapCollectionRequestContractsQuery__
 *
 * To run a query within a React component, call `useContainerEventNewExternalScrapCollectionRequestContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewExternalScrapCollectionRequestContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEventNewExternalScrapCollectionRequestContractsQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useContainerEventNewExternalScrapCollectionRequestContractsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerEventNewExternalScrapCollectionRequestContractsQuery,
    ContainerEventNewExternalScrapCollectionRequestContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerEventNewExternalScrapCollectionRequestContractsQuery,
    ContainerEventNewExternalScrapCollectionRequestContractsQueryVariables
  >(ContainerEventNewExternalScrapCollectionRequestContractsDocument, options)
}
export function useContainerEventNewExternalScrapCollectionRequestContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEventNewExternalScrapCollectionRequestContractsQuery,
    ContainerEventNewExternalScrapCollectionRequestContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerEventNewExternalScrapCollectionRequestContractsQuery,
    ContainerEventNewExternalScrapCollectionRequestContractsQueryVariables
  >(ContainerEventNewExternalScrapCollectionRequestContractsDocument, options)
}
export type ContainerEventNewExternalScrapCollectionRequestContractsQueryHookResult = ReturnType<
  typeof useContainerEventNewExternalScrapCollectionRequestContractsQuery
>
export type ContainerEventNewExternalScrapCollectionRequestContractsLazyQueryHookResult =
  ReturnType<typeof useContainerEventNewExternalScrapCollectionRequestContractsLazyQuery>
export type ContainerEventNewExternalScrapCollectionRequestContractsQueryResult =
  Apollo.QueryResult<
    ContainerEventNewExternalScrapCollectionRequestContractsQuery,
    ContainerEventNewExternalScrapCollectionRequestContractsQueryVariables
  >
export const ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckDocument = gql`
  query ContainerEventNewExternalScrapCollectionRequestFeasibilityCheck(
    $input: EventFeasibilityCheckInput!
  ) {
    eventFeasibilityCheck(input: $input) {
      truckUnavailablePeriods {
        id
      }
      employeeUnavailablePeriods {
        id
      }
      feasible
    }
  }
`

/**
 * __useContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQuery__
 *
 * To run a query within a React component, call `useContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQuery,
    ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQuery,
    ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQueryVariables
  >(ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckDocument, options)
}
export function useContainerEventNewExternalScrapCollectionRequestFeasibilityCheckLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQuery,
    ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQuery,
    ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQueryVariables
  >(ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckDocument, options)
}
export type ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQueryHookResult =
  ReturnType<typeof useContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQuery>
export type ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckLazyQueryHookResult =
  ReturnType<typeof useContainerEventNewExternalScrapCollectionRequestFeasibilityCheckLazyQuery>
export type ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQueryResult =
  Apollo.QueryResult<
    ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQuery,
    ContainerEventNewExternalScrapCollectionRequestFeasibilityCheckQueryVariables
  >
export const ContainerEventNewEventTruckDocument = gql`
  mutation ContainerEventNewEventTruck($input: CreateEventTruckInput!) {
    createEventTruck(input: $input) {
      event {
        ... on EventTruck {
          ...ModuleEventNewEventTruck
        }
      }
    }
  }
  ${ModuleEventNewEventTruckFragmentDoc}
`
export type ContainerEventNewEventTruckMutationFn = Apollo.MutationFunction<
  ContainerEventNewEventTruckMutation,
  ContainerEventNewEventTruckMutationVariables
>

/**
 * __useContainerEventNewEventTruckMutation__
 *
 * To run a mutation, you first call `useContainerEventNewEventTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewEventTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventNewEventTruckMutation, { data, loading, error }] = useContainerEventNewEventTruckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventNewEventTruckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventNewEventTruckMutation,
    ContainerEventNewEventTruckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventNewEventTruckMutation,
    ContainerEventNewEventTruckMutationVariables
  >(ContainerEventNewEventTruckDocument, options)
}
export type ContainerEventNewEventTruckMutationHookResult = ReturnType<
  typeof useContainerEventNewEventTruckMutation
>
export type ContainerEventNewEventTruckMutationResult =
  Apollo.MutationResult<ContainerEventNewEventTruckMutation>
export type ContainerEventNewEventTruckMutationOptions = Apollo.BaseMutationOptions<
  ContainerEventNewEventTruckMutation,
  ContainerEventNewEventTruckMutationVariables
>
export const ContainerEventNewTruckDocument = gql`
  query ContainerEventNewTruck {
    driverEmployees: employees(
      freightageRoles: [execute]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventNewEmployee
      }
    }
    carTypes {
      nodes {
        ...ModuleEventNewCarType
      }
    }
    trucks(
      enables: true
      hasOneOrderBy: { relationalTable: "truck_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventNewTruck
      }
    }
  }
  ${ModuleEventNewEmployeeFragmentDoc}
  ${ModuleEventNewCarTypeFragmentDoc}
  ${ModuleEventNewTruckFragmentDoc}
`

/**
 * __useContainerEventNewTruckQuery__
 *
 * To run a query within a React component, call `useContainerEventNewTruckQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewTruckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEventNewTruckQuery({
 *   variables: {
 *   },
 * });
 */
export function useContainerEventNewTruckQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerEventNewTruckQuery,
    ContainerEventNewTruckQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerEventNewTruckQuery, ContainerEventNewTruckQueryVariables>(
    ContainerEventNewTruckDocument,
    options
  )
}
export function useContainerEventNewTruckLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEventNewTruckQuery,
    ContainerEventNewTruckQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerEventNewTruckQuery, ContainerEventNewTruckQueryVariables>(
    ContainerEventNewTruckDocument,
    options
  )
}
export type ContainerEventNewTruckQueryHookResult = ReturnType<
  typeof useContainerEventNewTruckQuery
>
export type ContainerEventNewTruckLazyQueryHookResult = ReturnType<
  typeof useContainerEventNewTruckLazyQuery
>
export type ContainerEventNewTruckQueryResult = Apollo.QueryResult<
  ContainerEventNewTruckQuery,
  ContainerEventNewTruckQueryVariables
>
export const ContainerEventNewCreateDocument = gql`
  mutation ContainerEventNewCreate($input: CreateTemporaryVehicleAllocationEventOrUnitInput!) {
    createTemporaryVehicleAllocationEventOrUnit(input: $input) {
      unit {
        ...ModuleEventNewUnit
      }
      event {
        ... on EventTemporaryVehicleAllocation {
          ...ModuleEventNewEventTemporaryVehicleAllocation
        }
      }
      basedContract
    }
  }
  ${ModuleEventNewUnitFragmentDoc}
  ${ModuleEventNewEventTemporaryVehicleAllocationFragmentDoc}
`
export type ContainerEventNewCreateMutationFn = Apollo.MutationFunction<
  ContainerEventNewCreateMutation,
  ContainerEventNewCreateMutationVariables
>

/**
 * __useContainerEventNewCreateMutation__
 *
 * To run a mutation, you first call `useContainerEventNewCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventNewCreateMutation, { data, loading, error }] = useContainerEventNewCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventNewCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventNewCreateMutation,
    ContainerEventNewCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventNewCreateMutation,
    ContainerEventNewCreateMutationVariables
  >(ContainerEventNewCreateDocument, options)
}
export type ContainerEventNewCreateMutationHookResult = ReturnType<
  typeof useContainerEventNewCreateMutation
>
export type ContainerEventNewCreateMutationResult =
  Apollo.MutationResult<ContainerEventNewCreateMutation>
export type ContainerEventNewCreateMutationOptions = Apollo.BaseMutationOptions<
  ContainerEventNewCreateMutation,
  ContainerEventNewCreateMutationVariables
>
export const ContainerEventNewOverwriteContractDocument = gql`
  mutation ContainerEventNewOverwriteContract($input: UpdateContractInput!) {
    updateContract(input: $input) {
      contract {
        ...ModuleEventNewContract
      }
    }
  }
  ${ModuleEventNewContractFragmentDoc}
`
export type ContainerEventNewOverwriteContractMutationFn = Apollo.MutationFunction<
  ContainerEventNewOverwriteContractMutation,
  ContainerEventNewOverwriteContractMutationVariables
>

/**
 * __useContainerEventNewOverwriteContractMutation__
 *
 * To run a mutation, you first call `useContainerEventNewOverwriteContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewOverwriteContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventNewOverwriteContractMutation, { data, loading, error }] = useContainerEventNewOverwriteContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventNewOverwriteContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventNewOverwriteContractMutation,
    ContainerEventNewOverwriteContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventNewOverwriteContractMutation,
    ContainerEventNewOverwriteContractMutationVariables
  >(ContainerEventNewOverwriteContractDocument, options)
}
export type ContainerEventNewOverwriteContractMutationHookResult = ReturnType<
  typeof useContainerEventNewOverwriteContractMutation
>
export type ContainerEventNewOverwriteContractMutationResult =
  Apollo.MutationResult<ContainerEventNewOverwriteContractMutation>
export type ContainerEventNewOverwriteContractMutationOptions = Apollo.BaseMutationOptions<
  ContainerEventNewOverwriteContractMutation,
  ContainerEventNewOverwriteContractMutationVariables
>
export const ContainerEventNewVehicleAllocationDocument = gql`
  query ContainerEventNewVehicleAllocation {
    salesEmployees: employees(
      freightageRoles: [request, add]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventNewEmployee
      }
    }
    driverEmployees: employees(
      freightageRoles: [execute]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventNewEmployee
      }
    }
    carTypes {
      nodes {
        ...ModuleEventNewCarType
      }
    }
    trucks(
      enables: true
      hasOneOrderBy: { relationalTable: "truck_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventNewTruck
      }
    }
    employeeDrivableTrucks {
      nodes {
        ...ModuleEventNewEmployeeDrivableTruck
      }
    }
    contracts(enables: true, frequent: true) {
      nodes {
        ...ModuleEventNewContract
      }
    }
    companyRelations(enables: true) {
      nodes {
        ...ModuleEventNewCompanyRelation
      }
    }
  }
  ${ModuleEventNewEmployeeFragmentDoc}
  ${ModuleEventNewCarTypeFragmentDoc}
  ${ModuleEventNewTruckFragmentDoc}
  ${ModuleEventNewEmployeeDrivableTruckFragmentDoc}
  ${ModuleEventNewContractFragmentDoc}
  ${ModuleEventNewCompanyRelationFragmentDoc}
`

/**
 * __useContainerEventNewVehicleAllocationQuery__
 *
 * To run a query within a React component, call `useContainerEventNewVehicleAllocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewVehicleAllocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEventNewVehicleAllocationQuery({
 *   variables: {
 *   },
 * });
 */
export function useContainerEventNewVehicleAllocationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerEventNewVehicleAllocationQuery,
    ContainerEventNewVehicleAllocationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerEventNewVehicleAllocationQuery,
    ContainerEventNewVehicleAllocationQueryVariables
  >(ContainerEventNewVehicleAllocationDocument, options)
}
export function useContainerEventNewVehicleAllocationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEventNewVehicleAllocationQuery,
    ContainerEventNewVehicleAllocationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerEventNewVehicleAllocationQuery,
    ContainerEventNewVehicleAllocationQueryVariables
  >(ContainerEventNewVehicleAllocationDocument, options)
}
export type ContainerEventNewVehicleAllocationQueryHookResult = ReturnType<
  typeof useContainerEventNewVehicleAllocationQuery
>
export type ContainerEventNewVehicleAllocationLazyQueryHookResult = ReturnType<
  typeof useContainerEventNewVehicleAllocationLazyQuery
>
export type ContainerEventNewVehicleAllocationQueryResult = Apollo.QueryResult<
  ContainerEventNewVehicleAllocationQuery,
  ContainerEventNewVehicleAllocationQueryVariables
>
export const ContainerEventNewVehicleAllocationContractsDocument = gql`
  query ContainerEventNewVehicleAllocationContracts($text: String!) {
    contracts(enables: true, text: $text) {
      nodes {
        ...ModuleEventNewContract
      }
    }
  }
  ${ModuleEventNewContractFragmentDoc}
`

/**
 * __useContainerEventNewVehicleAllocationContractsQuery__
 *
 * To run a query within a React component, call `useContainerEventNewVehicleAllocationContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewVehicleAllocationContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEventNewVehicleAllocationContractsQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useContainerEventNewVehicleAllocationContractsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerEventNewVehicleAllocationContractsQuery,
    ContainerEventNewVehicleAllocationContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerEventNewVehicleAllocationContractsQuery,
    ContainerEventNewVehicleAllocationContractsQueryVariables
  >(ContainerEventNewVehicleAllocationContractsDocument, options)
}
export function useContainerEventNewVehicleAllocationContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEventNewVehicleAllocationContractsQuery,
    ContainerEventNewVehicleAllocationContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerEventNewVehicleAllocationContractsQuery,
    ContainerEventNewVehicleAllocationContractsQueryVariables
  >(ContainerEventNewVehicleAllocationContractsDocument, options)
}
export type ContainerEventNewVehicleAllocationContractsQueryHookResult = ReturnType<
  typeof useContainerEventNewVehicleAllocationContractsQuery
>
export type ContainerEventNewVehicleAllocationContractsLazyQueryHookResult = ReturnType<
  typeof useContainerEventNewVehicleAllocationContractsLazyQuery
>
export type ContainerEventNewVehicleAllocationContractsQueryResult = Apollo.QueryResult<
  ContainerEventNewVehicleAllocationContractsQuery,
  ContainerEventNewVehicleAllocationContractsQueryVariables
>
export const ContainerEventNewVehicleAllocationEventFeasibilityCheckDocument = gql`
  query ContainerEventNewVehicleAllocationEventFeasibilityCheck(
    $input: EventFeasibilityCheckInput!
  ) {
    eventFeasibilityCheck(input: $input) {
      truckUnavailablePeriods {
        id
      }
      employeeUnavailablePeriods {
        id
      }
      feasible
    }
  }
`

/**
 * __useContainerEventNewVehicleAllocationEventFeasibilityCheckQuery__
 *
 * To run a query within a React component, call `useContainerEventNewVehicleAllocationEventFeasibilityCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEventNewVehicleAllocationEventFeasibilityCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEventNewVehicleAllocationEventFeasibilityCheckQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventNewVehicleAllocationEventFeasibilityCheckQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerEventNewVehicleAllocationEventFeasibilityCheckQuery,
    ContainerEventNewVehicleAllocationEventFeasibilityCheckQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerEventNewVehicleAllocationEventFeasibilityCheckQuery,
    ContainerEventNewVehicleAllocationEventFeasibilityCheckQueryVariables
  >(ContainerEventNewVehicleAllocationEventFeasibilityCheckDocument, options)
}
export function useContainerEventNewVehicleAllocationEventFeasibilityCheckLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEventNewVehicleAllocationEventFeasibilityCheckQuery,
    ContainerEventNewVehicleAllocationEventFeasibilityCheckQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerEventNewVehicleAllocationEventFeasibilityCheckQuery,
    ContainerEventNewVehicleAllocationEventFeasibilityCheckQueryVariables
  >(ContainerEventNewVehicleAllocationEventFeasibilityCheckDocument, options)
}
export type ContainerEventNewVehicleAllocationEventFeasibilityCheckQueryHookResult = ReturnType<
  typeof useContainerEventNewVehicleAllocationEventFeasibilityCheckQuery
>
export type ContainerEventNewVehicleAllocationEventFeasibilityCheckLazyQueryHookResult = ReturnType<
  typeof useContainerEventNewVehicleAllocationEventFeasibilityCheckLazyQuery
>
export type ContainerEventNewVehicleAllocationEventFeasibilityCheckQueryResult = Apollo.QueryResult<
  ContainerEventNewVehicleAllocationEventFeasibilityCheckQuery,
  ContainerEventNewVehicleAllocationEventFeasibilityCheckQueryVariables
>
export const ContainerEventRequestCreateDocument = gql`
  mutation ContainerEventRequestCreate($input: CreateRequestVehicleAllocationEventInput!) {
    createRequestVehicleAllocationEvent(input: $input) {
      loadingEvents {
        ...ModuleEventRequestLoadingEvent
      }
      basedContract
    }
  }
  ${ModuleEventRequestLoadingEventFragmentDoc}
`
export type ContainerEventRequestCreateMutationFn = Apollo.MutationFunction<
  ContainerEventRequestCreateMutation,
  ContainerEventRequestCreateMutationVariables
>

/**
 * __useContainerEventRequestCreateMutation__
 *
 * To run a mutation, you first call `useContainerEventRequestCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventRequestCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventRequestCreateMutation, { data, loading, error }] = useContainerEventRequestCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventRequestCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventRequestCreateMutation,
    ContainerEventRequestCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventRequestCreateMutation,
    ContainerEventRequestCreateMutationVariables
  >(ContainerEventRequestCreateDocument, options)
}
export type ContainerEventRequestCreateMutationHookResult = ReturnType<
  typeof useContainerEventRequestCreateMutation
>
export type ContainerEventRequestCreateMutationResult =
  Apollo.MutationResult<ContainerEventRequestCreateMutation>
export type ContainerEventRequestCreateMutationOptions = Apollo.BaseMutationOptions<
  ContainerEventRequestCreateMutation,
  ContainerEventRequestCreateMutationVariables
>
export const ContainerEventRequestOverwriteContractDocument = gql`
  mutation ContainerEventRequestOverwriteContract($input: UpdateContractInput!) {
    updateContract(input: $input) {
      contract {
        ...ModuleEventRequestContract
      }
    }
  }
  ${ModuleEventRequestContractFragmentDoc}
`
export type ContainerEventRequestOverwriteContractMutationFn = Apollo.MutationFunction<
  ContainerEventRequestOverwriteContractMutation,
  ContainerEventRequestOverwriteContractMutationVariables
>

/**
 * __useContainerEventRequestOverwriteContractMutation__
 *
 * To run a mutation, you first call `useContainerEventRequestOverwriteContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerEventRequestOverwriteContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerEventRequestOverwriteContractMutation, { data, loading, error }] = useContainerEventRequestOverwriteContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerEventRequestOverwriteContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerEventRequestOverwriteContractMutation,
    ContainerEventRequestOverwriteContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerEventRequestOverwriteContractMutation,
    ContainerEventRequestOverwriteContractMutationVariables
  >(ContainerEventRequestOverwriteContractDocument, options)
}
export type ContainerEventRequestOverwriteContractMutationHookResult = ReturnType<
  typeof useContainerEventRequestOverwriteContractMutation
>
export type ContainerEventRequestOverwriteContractMutationResult =
  Apollo.MutationResult<ContainerEventRequestOverwriteContractMutation>
export type ContainerEventRequestOverwriteContractMutationOptions = Apollo.BaseMutationOptions<
  ContainerEventRequestOverwriteContractMutation,
  ContainerEventRequestOverwriteContractMutationVariables
>
export const ContainerEventRequestDocument = gql`
  query ContainerEventRequest {
    salesEmployees: employees(
      freightageRoles: [request, add]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventNewEmployee
      }
    }
    driverEmployees: employees(
      freightageRoles: [execute]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventNewEmployee
      }
    }
    carTypes {
      nodes {
        ...ModuleEventNewCarType
      }
    }
    trucks(
      enables: true
      hasOneOrderBy: { relationalTable: "truck_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleEventNewTruck
      }
    }
    employeeDrivableTrucks {
      nodes {
        ...ModuleEventNewEmployeeDrivableTruck
      }
    }
    contracts(enables: true, frequent: true) {
      nodes {
        ...ModuleEventNewContract
      }
    }
    companyRelations(enables: true) {
      nodes {
        ...ModuleEventNewCompanyRelation
      }
    }
  }
  ${ModuleEventNewEmployeeFragmentDoc}
  ${ModuleEventNewCarTypeFragmentDoc}
  ${ModuleEventNewTruckFragmentDoc}
  ${ModuleEventNewEmployeeDrivableTruckFragmentDoc}
  ${ModuleEventNewContractFragmentDoc}
  ${ModuleEventNewCompanyRelationFragmentDoc}
`

/**
 * __useContainerEventRequestQuery__
 *
 * To run a query within a React component, call `useContainerEventRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEventRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEventRequestQuery({
 *   variables: {
 *   },
 * });
 */
export function useContainerEventRequestQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerEventRequestQuery,
    ContainerEventRequestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerEventRequestQuery, ContainerEventRequestQueryVariables>(
    ContainerEventRequestDocument,
    options
  )
}
export function useContainerEventRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEventRequestQuery,
    ContainerEventRequestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerEventRequestQuery, ContainerEventRequestQueryVariables>(
    ContainerEventRequestDocument,
    options
  )
}
export type ContainerEventRequestQueryHookResult = ReturnType<typeof useContainerEventRequestQuery>
export type ContainerEventRequestLazyQueryHookResult = ReturnType<
  typeof useContainerEventRequestLazyQuery
>
export type ContainerEventRequestQueryResult = Apollo.QueryResult<
  ContainerEventRequestQuery,
  ContainerEventRequestQueryVariables
>
export const ContainerEventRequestContractsDocument = gql`
  query ContainerEventRequestContracts($text: String!) {
    contracts(enables: true, text: $text) {
      nodes {
        ...ModuleEventNewContract
      }
    }
  }
  ${ModuleEventNewContractFragmentDoc}
`

/**
 * __useContainerEventRequestContractsQuery__
 *
 * To run a query within a React component, call `useContainerEventRequestContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerEventRequestContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerEventRequestContractsQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useContainerEventRequestContractsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerEventRequestContractsQuery,
    ContainerEventRequestContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerEventRequestContractsQuery,
    ContainerEventRequestContractsQueryVariables
  >(ContainerEventRequestContractsDocument, options)
}
export function useContainerEventRequestContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerEventRequestContractsQuery,
    ContainerEventRequestContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerEventRequestContractsQuery,
    ContainerEventRequestContractsQueryVariables
  >(ContainerEventRequestContractsDocument, options)
}
export type ContainerEventRequestContractsQueryHookResult = ReturnType<
  typeof useContainerEventRequestContractsQuery
>
export type ContainerEventRequestContractsLazyQueryHookResult = ReturnType<
  typeof useContainerEventRequestContractsLazyQuery
>
export type ContainerEventRequestContractsQueryResult = Apollo.QueryResult<
  ContainerEventRequestContractsQuery,
  ContainerEventRequestContractsQueryVariables
>
export const ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitDocument = gql`
  mutation ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnit(
    $input: ChangeRequestVehicleAllocationEventToUnitInput!
  ) {
    changeRequestVehicleAllocationEventToUnit(input: $input) {
      loadingEvent {
        ...ModuleLoadingEventDetail
      }
    }
  }
  ${ModuleLoadingEventDetailFragmentDoc}
`
export type ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutationFn =
  Apollo.MutationFunction<
    ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation,
    ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutationVariables
  >

/**
 * __useContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation__
 *
 * To run a mutation, you first call `useContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation, { data, loading, error }] = useContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation,
    ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation,
    ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutationVariables
  >(ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitDocument, options)
}
export type ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutationHookResult =
  ReturnType<typeof useContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation>
export type ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutationResult =
  Apollo.MutationResult<ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation>
export type ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutation,
    ContainerLoadingEventDetailChangeRequestVehicleAllocationEventToUnitMutationVariables
  >
export const UpdateLoadingEventDocument = gql`
  mutation UpdateLoadingEvent($input: UpdateLoadingEventInput!) {
    updateLoadingEvent(input: $input) {
      loadingEvent {
        ...ModuleLoadingEventDetail
      }
    }
  }
  ${ModuleLoadingEventDetailFragmentDoc}
`
export type UpdateLoadingEventMutationFn = Apollo.MutationFunction<
  UpdateLoadingEventMutation,
  UpdateLoadingEventMutationVariables
>

/**
 * __useUpdateLoadingEventMutation__
 *
 * To run a mutation, you first call `useUpdateLoadingEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoadingEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoadingEventMutation, { data, loading, error }] = useUpdateLoadingEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLoadingEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLoadingEventMutation,
    UpdateLoadingEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateLoadingEventMutation, UpdateLoadingEventMutationVariables>(
    UpdateLoadingEventDocument,
    options
  )
}
export type UpdateLoadingEventMutationHookResult = ReturnType<typeof useUpdateLoadingEventMutation>
export type UpdateLoadingEventMutationResult = Apollo.MutationResult<UpdateLoadingEventMutation>
export type UpdateLoadingEventMutationOptions = Apollo.BaseMutationOptions<
  UpdateLoadingEventMutation,
  UpdateLoadingEventMutationVariables
>
export const ContainerLoadingEventDetailChangeLoadingEventDetailStateDocument = gql`
  mutation ContainerLoadingEventDetailChangeLoadingEventDetailState(
    $input: ChangeLoadingEventStateInput!
  ) {
    changeLoadingEventState(input: $input) {
      loadingEvent {
        ...ModuleLoadingEventDetail
      }
      currentState
    }
  }
  ${ModuleLoadingEventDetailFragmentDoc}
`
export type ContainerLoadingEventDetailChangeLoadingEventDetailStateMutationFn =
  Apollo.MutationFunction<
    ContainerLoadingEventDetailChangeLoadingEventDetailStateMutation,
    ContainerLoadingEventDetailChangeLoadingEventDetailStateMutationVariables
  >

/**
 * __useContainerLoadingEventDetailChangeLoadingEventDetailStateMutation__
 *
 * To run a mutation, you first call `useContainerLoadingEventDetailChangeLoadingEventDetailStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerLoadingEventDetailChangeLoadingEventDetailStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerLoadingEventDetailChangeLoadingEventDetailStateMutation, { data, loading, error }] = useContainerLoadingEventDetailChangeLoadingEventDetailStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerLoadingEventDetailChangeLoadingEventDetailStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerLoadingEventDetailChangeLoadingEventDetailStateMutation,
    ContainerLoadingEventDetailChangeLoadingEventDetailStateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerLoadingEventDetailChangeLoadingEventDetailStateMutation,
    ContainerLoadingEventDetailChangeLoadingEventDetailStateMutationVariables
  >(ContainerLoadingEventDetailChangeLoadingEventDetailStateDocument, options)
}
export type ContainerLoadingEventDetailChangeLoadingEventDetailStateMutationHookResult = ReturnType<
  typeof useContainerLoadingEventDetailChangeLoadingEventDetailStateMutation
>
export type ContainerLoadingEventDetailChangeLoadingEventDetailStateMutationResult =
  Apollo.MutationResult<ContainerLoadingEventDetailChangeLoadingEventDetailStateMutation>
export type ContainerLoadingEventDetailChangeLoadingEventDetailStateMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerLoadingEventDetailChangeLoadingEventDetailStateMutation,
    ContainerLoadingEventDetailChangeLoadingEventDetailStateMutationVariables
  >
export const ContainerLoadingEventDetailPrepareUploadAttachedFileDocument = gql`
  mutation ContainerLoadingEventDetailPrepareUploadAttachedFile(
    $input: PrepareUploadAttachedFileInput!
  ) {
    prepareUploadAttachedFile(input: $input) {
      temporaryAttachedFile {
        ...UiFileUploaderTemporaryAttachedFile
      }
    }
  }
  ${UiFileUploaderTemporaryAttachedFileFragmentDoc}
`
export type ContainerLoadingEventDetailPrepareUploadAttachedFileMutationFn =
  Apollo.MutationFunction<
    ContainerLoadingEventDetailPrepareUploadAttachedFileMutation,
    ContainerLoadingEventDetailPrepareUploadAttachedFileMutationVariables
  >

/**
 * __useContainerLoadingEventDetailPrepareUploadAttachedFileMutation__
 *
 * To run a mutation, you first call `useContainerLoadingEventDetailPrepareUploadAttachedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerLoadingEventDetailPrepareUploadAttachedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerLoadingEventDetailPrepareUploadAttachedFileMutation, { data, loading, error }] = useContainerLoadingEventDetailPrepareUploadAttachedFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerLoadingEventDetailPrepareUploadAttachedFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerLoadingEventDetailPrepareUploadAttachedFileMutation,
    ContainerLoadingEventDetailPrepareUploadAttachedFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerLoadingEventDetailPrepareUploadAttachedFileMutation,
    ContainerLoadingEventDetailPrepareUploadAttachedFileMutationVariables
  >(ContainerLoadingEventDetailPrepareUploadAttachedFileDocument, options)
}
export type ContainerLoadingEventDetailPrepareUploadAttachedFileMutationHookResult = ReturnType<
  typeof useContainerLoadingEventDetailPrepareUploadAttachedFileMutation
>
export type ContainerLoadingEventDetailPrepareUploadAttachedFileMutationResult =
  Apollo.MutationResult<ContainerLoadingEventDetailPrepareUploadAttachedFileMutation>
export type ContainerLoadingEventDetailPrepareUploadAttachedFileMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerLoadingEventDetailPrepareUploadAttachedFileMutation,
    ContainerLoadingEventDetailPrepareUploadAttachedFileMutationVariables
  >
export const ContainerLoadingEventDetailAttachLoadingEventAttachedFileDocument = gql`
  mutation ContainerLoadingEventDetailAttachLoadingEventAttachedFile(
    $input: AttachLoadingEventAttachedFileInput!
  ) {
    attachLoadingEventAttachedFile(input: $input) {
      attachedFile {
        ...UiFileUploaderAttachedFile
      }
      loadingEvent {
        ...ModuleLoadingEventDetail
      }
    }
  }
  ${UiFileUploaderAttachedFileFragmentDoc}
  ${ModuleLoadingEventDetailFragmentDoc}
`
export type ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutationFn =
  Apollo.MutationFunction<
    ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutation,
    ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutationVariables
  >

/**
 * __useContainerLoadingEventDetailAttachLoadingEventAttachedFileMutation__
 *
 * To run a mutation, you first call `useContainerLoadingEventDetailAttachLoadingEventAttachedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerLoadingEventDetailAttachLoadingEventAttachedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerLoadingEventDetailAttachLoadingEventAttachedFileMutation, { data, loading, error }] = useContainerLoadingEventDetailAttachLoadingEventAttachedFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerLoadingEventDetailAttachLoadingEventAttachedFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutation,
    ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutation,
    ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutationVariables
  >(ContainerLoadingEventDetailAttachLoadingEventAttachedFileDocument, options)
}
export type ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutationHookResult =
  ReturnType<typeof useContainerLoadingEventDetailAttachLoadingEventAttachedFileMutation>
export type ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutationResult =
  Apollo.MutationResult<ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutation>
export type ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutation,
    ContainerLoadingEventDetailAttachLoadingEventAttachedFileMutationVariables
  >
export const ContainerLoadingEventDetailRemoveAttachedFileDocument = gql`
  mutation ContainerLoadingEventDetailRemoveAttachedFile($input: RemoveAttachedFileInput!) {
    removeAttachedFile(input: $input) {
      attachment {
        ... on LoadingEvent {
          id
          name
          attachedFiles {
            nodes {
              ...UiFileUploaderAttachedFile
            }
          }
        }
        ... on Contract {
          id
          name
        }
      }
    }
  }
  ${UiFileUploaderAttachedFileFragmentDoc}
`
export type ContainerLoadingEventDetailRemoveAttachedFileMutationFn = Apollo.MutationFunction<
  ContainerLoadingEventDetailRemoveAttachedFileMutation,
  ContainerLoadingEventDetailRemoveAttachedFileMutationVariables
>

/**
 * __useContainerLoadingEventDetailRemoveAttachedFileMutation__
 *
 * To run a mutation, you first call `useContainerLoadingEventDetailRemoveAttachedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerLoadingEventDetailRemoveAttachedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerLoadingEventDetailRemoveAttachedFileMutation, { data, loading, error }] = useContainerLoadingEventDetailRemoveAttachedFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerLoadingEventDetailRemoveAttachedFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerLoadingEventDetailRemoveAttachedFileMutation,
    ContainerLoadingEventDetailRemoveAttachedFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerLoadingEventDetailRemoveAttachedFileMutation,
    ContainerLoadingEventDetailRemoveAttachedFileMutationVariables
  >(ContainerLoadingEventDetailRemoveAttachedFileDocument, options)
}
export type ContainerLoadingEventDetailRemoveAttachedFileMutationHookResult = ReturnType<
  typeof useContainerLoadingEventDetailRemoveAttachedFileMutation
>
export type ContainerLoadingEventDetailRemoveAttachedFileMutationResult =
  Apollo.MutationResult<ContainerLoadingEventDetailRemoveAttachedFileMutation>
export type ContainerLoadingEventDetailRemoveAttachedFileMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerLoadingEventDetailRemoveAttachedFileMutation,
    ContainerLoadingEventDetailRemoveAttachedFileMutationVariables
  >
export const ContainerLoadingEventDetailDestroyDocument = gql`
  mutation ContainerLoadingEventDetailDestroy($input: DestroyLoadingEventInput!) {
    destroyLoadingEvent(input: $input) {
      loadingEvent {
        id
      }
    }
  }
`
export type ContainerLoadingEventDetailDestroyMutationFn = Apollo.MutationFunction<
  ContainerLoadingEventDetailDestroyMutation,
  ContainerLoadingEventDetailDestroyMutationVariables
>

/**
 * __useContainerLoadingEventDetailDestroyMutation__
 *
 * To run a mutation, you first call `useContainerLoadingEventDetailDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerLoadingEventDetailDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerLoadingEventDetailDestroyMutation, { data, loading, error }] = useContainerLoadingEventDetailDestroyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerLoadingEventDetailDestroyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerLoadingEventDetailDestroyMutation,
    ContainerLoadingEventDetailDestroyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerLoadingEventDetailDestroyMutation,
    ContainerLoadingEventDetailDestroyMutationVariables
  >(ContainerLoadingEventDetailDestroyDocument, options)
}
export type ContainerLoadingEventDetailDestroyMutationHookResult = ReturnType<
  typeof useContainerLoadingEventDetailDestroyMutation
>
export type ContainerLoadingEventDetailDestroyMutationResult =
  Apollo.MutationResult<ContainerLoadingEventDetailDestroyMutation>
export type ContainerLoadingEventDetailDestroyMutationOptions = Apollo.BaseMutationOptions<
  ContainerLoadingEventDetailDestroyMutation,
  ContainerLoadingEventDetailDestroyMutationVariables
>
export const ContainerLoadingEventDetailFixedDocument = gql`
  mutation ContainerLoadingEventDetailFixed($input: ChangeLoadingEventFixedInput!) {
    changeLoadingEventFixed(input: $input) {
      loadingEvent {
        ...ModuleLoadingEventDetail
      }
    }
  }
  ${ModuleLoadingEventDetailFragmentDoc}
`
export type ContainerLoadingEventDetailFixedMutationFn = Apollo.MutationFunction<
  ContainerLoadingEventDetailFixedMutation,
  ContainerLoadingEventDetailFixedMutationVariables
>

/**
 * __useContainerLoadingEventDetailFixedMutation__
 *
 * To run a mutation, you first call `useContainerLoadingEventDetailFixedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerLoadingEventDetailFixedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerLoadingEventDetailFixedMutation, { data, loading, error }] = useContainerLoadingEventDetailFixedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerLoadingEventDetailFixedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerLoadingEventDetailFixedMutation,
    ContainerLoadingEventDetailFixedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerLoadingEventDetailFixedMutation,
    ContainerLoadingEventDetailFixedMutationVariables
  >(ContainerLoadingEventDetailFixedDocument, options)
}
export type ContainerLoadingEventDetailFixedMutationHookResult = ReturnType<
  typeof useContainerLoadingEventDetailFixedMutation
>
export type ContainerLoadingEventDetailFixedMutationResult =
  Apollo.MutationResult<ContainerLoadingEventDetailFixedMutation>
export type ContainerLoadingEventDetailFixedMutationOptions = Apollo.BaseMutationOptions<
  ContainerLoadingEventDetailFixedMutation,
  ContainerLoadingEventDetailFixedMutationVariables
>
export const ContainerLoadingEventDetailContractsDocument = gql`
  query ContainerLoadingEventDetailContracts($text: String!) {
    contracts(enables: true, text: $text) {
      nodes {
        ...ModuleLoadingEventDetailContract
      }
    }
  }
  ${ModuleLoadingEventDetailContractFragmentDoc}
`

/**
 * __useContainerLoadingEventDetailContractsQuery__
 *
 * To run a query within a React component, call `useContainerLoadingEventDetailContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerLoadingEventDetailContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerLoadingEventDetailContractsQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useContainerLoadingEventDetailContractsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerLoadingEventDetailContractsQuery,
    ContainerLoadingEventDetailContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerLoadingEventDetailContractsQuery,
    ContainerLoadingEventDetailContractsQueryVariables
  >(ContainerLoadingEventDetailContractsDocument, options)
}
export function useContainerLoadingEventDetailContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerLoadingEventDetailContractsQuery,
    ContainerLoadingEventDetailContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerLoadingEventDetailContractsQuery,
    ContainerLoadingEventDetailContractsQueryVariables
  >(ContainerLoadingEventDetailContractsDocument, options)
}
export type ContainerLoadingEventDetailContractsQueryHookResult = ReturnType<
  typeof useContainerLoadingEventDetailContractsQuery
>
export type ContainerLoadingEventDetailContractsLazyQueryHookResult = ReturnType<
  typeof useContainerLoadingEventDetailContractsLazyQuery
>
export type ContainerLoadingEventDetailContractsQueryResult = Apollo.QueryResult<
  ContainerLoadingEventDetailContractsQuery,
  ContainerLoadingEventDetailContractsQueryVariables
>
export const ContainerLoadingEventDetailDocument = gql`
  query ContainerLoadingEventDetail($id: ID!) {
    loadingEvents(id: $id) {
      nodes {
        ...ModuleLoadingEventDetail
      }
      pageInfo {
        ...PageInfoField
      }
    }
    trucks(
      enables: true
      hasOneOrderBy: { relationalTable: "truck_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleSelectDriverEmployeeTruck
      }
    }
    driverEmployees: employees(
      freightageRoles: [execute]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleSelectDriverEmployeeDriverEmployee
      }
    }
    employeeDrivableTrucks {
      nodes {
        ...ModuleSelectDriverEmployeeEmployeeDrivableTruck
      }
    }
  }
  ${ModuleLoadingEventDetailFragmentDoc}
  ${PageInfoFieldFragmentDoc}
  ${ModuleSelectDriverEmployeeTruckFragmentDoc}
  ${ModuleSelectDriverEmployeeDriverEmployeeFragmentDoc}
  ${ModuleSelectDriverEmployeeEmployeeDrivableTruckFragmentDoc}
`

/**
 * __useContainerLoadingEventDetailQuery__
 *
 * To run a query within a React component, call `useContainerLoadingEventDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerLoadingEventDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerLoadingEventDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContainerLoadingEventDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerLoadingEventDetailQuery,
    ContainerLoadingEventDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerLoadingEventDetailQuery,
    ContainerLoadingEventDetailQueryVariables
  >(ContainerLoadingEventDetailDocument, options)
}
export function useContainerLoadingEventDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerLoadingEventDetailQuery,
    ContainerLoadingEventDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerLoadingEventDetailQuery,
    ContainerLoadingEventDetailQueryVariables
  >(ContainerLoadingEventDetailDocument, options)
}
export type ContainerLoadingEventDetailQueryHookResult = ReturnType<
  typeof useContainerLoadingEventDetailQuery
>
export type ContainerLoadingEventDetailLazyQueryHookResult = ReturnType<
  typeof useContainerLoadingEventDetailLazyQuery
>
export type ContainerLoadingEventDetailQueryResult = Apollo.QueryResult<
  ContainerLoadingEventDetailQuery,
  ContainerLoadingEventDetailQueryVariables
>
export const ContainerLoadingEventListDocument = gql`
  query ContainerLoadingEventList(
    $text: String
    $employeeIds: [String!]
    $truckIds: [String!]
    $date: ISO8601Date
    $after: String
    $first: Int!
  ) {
    loadingEvents(
      text: $text
      employeeIds: $employeeIds
      truckIds: $truckIds
      date: $date
      after: $after
      first: $first
      orderByDate: true
    ) {
      edges {
        node {
          ...ModuleUnitListLoadingEvent
        }
      }
      pageInfo {
        ...PageInfoField
      }
    }
    employees(
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        id
        name
        email
        tel
        employeeRole {
          id
          freightage
          systemSetting
        }
      }
      pageInfo {
        ...PageInfoField
      }
    }
    trucks(
      enables: true
      hasOneOrderBy: { relationalTable: "truck_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        id
        carNumber
        carType {
          id
          name
        }
      }
      pageInfo {
        ...PageInfoField
      }
    }
  }
  ${ModuleUnitListLoadingEventFragmentDoc}
  ${PageInfoFieldFragmentDoc}
`

/**
 * __useContainerLoadingEventListQuery__
 *
 * To run a query within a React component, call `useContainerLoadingEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerLoadingEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerLoadingEventListQuery({
 *   variables: {
 *      text: // value for 'text'
 *      employeeIds: // value for 'employeeIds'
 *      truckIds: // value for 'truckIds'
 *      date: // value for 'date'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useContainerLoadingEventListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerLoadingEventListQuery,
    ContainerLoadingEventListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerLoadingEventListQuery, ContainerLoadingEventListQueryVariables>(
    ContainerLoadingEventListDocument,
    options
  )
}
export function useContainerLoadingEventListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerLoadingEventListQuery,
    ContainerLoadingEventListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerLoadingEventListQuery,
    ContainerLoadingEventListQueryVariables
  >(ContainerLoadingEventListDocument, options)
}
export type ContainerLoadingEventListQueryHookResult = ReturnType<
  typeof useContainerLoadingEventListQuery
>
export type ContainerLoadingEventListLazyQueryHookResult = ReturnType<
  typeof useContainerLoadingEventListLazyQuery
>
export type ContainerLoadingEventListQueryResult = Apollo.QueryResult<
  ContainerLoadingEventListQuery,
  ContainerLoadingEventListQueryVariables
>
export const ContainerLoadingEventStatesDocument = gql`
  query ContainerLoadingEventStates($status: [State!]!, $after: String, $first: Int!) {
    loadingEvents(
      orderBy: { field: CREATED_AT, direction: ASC }
      status: $status
      after: $after
      first: $first
    ) {
      edges {
        node {
          ...ModuleVeactleAllocationState
        }
      }
      pageInfo {
        ...PageInfoField
      }
    }
    externalScrapCollectionRequests(progresses: true) {
      edges {
        node {
          ...ModuleExternalScrapCollectionRequestDetail
        }
      }
      pageInfo {
        ...PageInfoField
      }
    }
  }
  ${ModuleVeactleAllocationStateFragmentDoc}
  ${PageInfoFieldFragmentDoc}
  ${ModuleExternalScrapCollectionRequestDetailFragmentDoc}
`

/**
 * __useContainerLoadingEventStatesQuery__
 *
 * To run a query within a React component, call `useContainerLoadingEventStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerLoadingEventStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerLoadingEventStatesQuery({
 *   variables: {
 *      status: // value for 'status'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useContainerLoadingEventStatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerLoadingEventStatesQuery,
    ContainerLoadingEventStatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerLoadingEventStatesQuery,
    ContainerLoadingEventStatesQueryVariables
  >(ContainerLoadingEventStatesDocument, options)
}
export function useContainerLoadingEventStatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerLoadingEventStatesQuery,
    ContainerLoadingEventStatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerLoadingEventStatesQuery,
    ContainerLoadingEventStatesQueryVariables
  >(ContainerLoadingEventStatesDocument, options)
}
export type ContainerLoadingEventStatesQueryHookResult = ReturnType<
  typeof useContainerLoadingEventStatesQuery
>
export type ContainerLoadingEventStatesLazyQueryHookResult = ReturnType<
  typeof useContainerLoadingEventStatesLazyQuery
>
export type ContainerLoadingEventStatesQueryResult = Apollo.QueryResult<
  ContainerLoadingEventStatesQuery,
  ContainerLoadingEventStatesQueryVariables
>
export const CreateUnitsRecursivelyDocument = gql`
  mutation CreateUnitsRecursively($input: CreateUnitRecurringInput!) {
    createUnitRecurring(input: $input) {
      clientMutationId
    }
  }
`
export type CreateUnitsRecursivelyMutationFn = Apollo.MutationFunction<
  CreateUnitsRecursivelyMutation,
  CreateUnitsRecursivelyMutationVariables
>

/**
 * __useCreateUnitsRecursivelyMutation__
 *
 * To run a mutation, you first call `useCreateUnitsRecursivelyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnitsRecursivelyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnitsRecursivelyMutation, { data, loading, error }] = useCreateUnitsRecursivelyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUnitsRecursivelyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUnitsRecursivelyMutation,
    CreateUnitsRecursivelyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateUnitsRecursivelyMutation,
    CreateUnitsRecursivelyMutationVariables
  >(CreateUnitsRecursivelyDocument, options)
}
export type CreateUnitsRecursivelyMutationHookResult = ReturnType<
  typeof useCreateUnitsRecursivelyMutation
>
export type CreateUnitsRecursivelyMutationResult =
  Apollo.MutationResult<CreateUnitsRecursivelyMutation>
export type CreateUnitsRecursivelyMutationOptions = Apollo.BaseMutationOptions<
  CreateUnitsRecursivelyMutation,
  CreateUnitsRecursivelyMutationVariables
>
export const CreateEventsRecursivelyDocument = gql`
  mutation CreateEventsRecursively($input: CreateEventRecurringInput!) {
    createEventRecurring(input: $input) {
      clientMutationId
    }
  }
`
export type CreateEventsRecursivelyMutationFn = Apollo.MutationFunction<
  CreateEventsRecursivelyMutation,
  CreateEventsRecursivelyMutationVariables
>

/**
 * __useCreateEventsRecursivelyMutation__
 *
 * To run a mutation, you first call `useCreateEventsRecursivelyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventsRecursivelyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventsRecursivelyMutation, { data, loading, error }] = useCreateEventsRecursivelyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventsRecursivelyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEventsRecursivelyMutation,
    CreateEventsRecursivelyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateEventsRecursivelyMutation,
    CreateEventsRecursivelyMutationVariables
  >(CreateEventsRecursivelyDocument, options)
}
export type CreateEventsRecursivelyMutationHookResult = ReturnType<
  typeof useCreateEventsRecursivelyMutation
>
export type CreateEventsRecursivelyMutationResult =
  Apollo.MutationResult<CreateEventsRecursivelyMutation>
export type CreateEventsRecursivelyMutationOptions = Apollo.BaseMutationOptions<
  CreateEventsRecursivelyMutation,
  CreateEventsRecursivelyMutationVariables
>
export const RecursiveDuplicationUnitDetailDocument = gql`
  query RecursiveDuplicationUnitDetail($id: ID!) {
    units(id: $id) {
      nodes {
        id
        routes {
          nodes {
            id
            positionType
            event {
              __typename
              ...RecursiveDuplicationUnitDetailLoadingEvent
            }
          }
        }
      }
    }
  }
  ${RecursiveDuplicationUnitDetailLoadingEventFragmentDoc}
`

/**
 * __useRecursiveDuplicationUnitDetailQuery__
 *
 * To run a query within a React component, call `useRecursiveDuplicationUnitDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecursiveDuplicationUnitDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecursiveDuplicationUnitDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecursiveDuplicationUnitDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecursiveDuplicationUnitDetailQuery,
    RecursiveDuplicationUnitDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RecursiveDuplicationUnitDetailQuery,
    RecursiveDuplicationUnitDetailQueryVariables
  >(RecursiveDuplicationUnitDetailDocument, options)
}
export function useRecursiveDuplicationUnitDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecursiveDuplicationUnitDetailQuery,
    RecursiveDuplicationUnitDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RecursiveDuplicationUnitDetailQuery,
    RecursiveDuplicationUnitDetailQueryVariables
  >(RecursiveDuplicationUnitDetailDocument, options)
}
export type RecursiveDuplicationUnitDetailQueryHookResult = ReturnType<
  typeof useRecursiveDuplicationUnitDetailQuery
>
export type RecursiveDuplicationUnitDetailLazyQueryHookResult = ReturnType<
  typeof useRecursiveDuplicationUnitDetailLazyQuery
>
export type RecursiveDuplicationUnitDetailQueryResult = Apollo.QueryResult<
  RecursiveDuplicationUnitDetailQuery,
  RecursiveDuplicationUnitDetailQueryVariables
>
export const RecursiveDuplicationEventDetailDocument = gql`
  query RecursiveDuplicationEventDetail($id: ID!) {
    events(id: $id) {
      nodes {
        ... on EventEmployee {
          employee {
            id
            name
          }
        }
        ... on EventTemporaryVehicleAllocation {
          detail {
            id
            name
          }
        }
        ... on EventTruck {
          truck {
            id
            carNumber
          }
        }
      }
    }
  }
`

/**
 * __useRecursiveDuplicationEventDetailQuery__
 *
 * To run a query within a React component, call `useRecursiveDuplicationEventDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecursiveDuplicationEventDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecursiveDuplicationEventDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecursiveDuplicationEventDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecursiveDuplicationEventDetailQuery,
    RecursiveDuplicationEventDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RecursiveDuplicationEventDetailQuery,
    RecursiveDuplicationEventDetailQueryVariables
  >(RecursiveDuplicationEventDetailDocument, options)
}
export function useRecursiveDuplicationEventDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecursiveDuplicationEventDetailQuery,
    RecursiveDuplicationEventDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RecursiveDuplicationEventDetailQuery,
    RecursiveDuplicationEventDetailQueryVariables
  >(RecursiveDuplicationEventDetailDocument, options)
}
export type RecursiveDuplicationEventDetailQueryHookResult = ReturnType<
  typeof useRecursiveDuplicationEventDetailQuery
>
export type RecursiveDuplicationEventDetailLazyQueryHookResult = ReturnType<
  typeof useRecursiveDuplicationEventDetailLazyQuery
>
export type RecursiveDuplicationEventDetailQueryResult = Apollo.QueryResult<
  RecursiveDuplicationEventDetailQuery,
  RecursiveDuplicationEventDetailQueryVariables
>
export const ContainerTimelineChangeTimeUnitDocument = gql`
  mutation ContainerTimelineChangeTimeUnit($input: ChangeTimeUnitInput!) {
    changeTimeUnit(input: $input) {
      unit {
        ...ModuleTimelineEventUnit
      }
    }
  }
  ${ModuleTimelineEventUnitFragmentDoc}
`
export type ContainerTimelineChangeTimeUnitMutationFn = Apollo.MutationFunction<
  ContainerTimelineChangeTimeUnitMutation,
  ContainerTimelineChangeTimeUnitMutationVariables
>

/**
 * __useContainerTimelineChangeTimeUnitMutation__
 *
 * To run a mutation, you first call `useContainerTimelineChangeTimeUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineChangeTimeUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerTimelineChangeTimeUnitMutation, { data, loading, error }] = useContainerTimelineChangeTimeUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerTimelineChangeTimeUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerTimelineChangeTimeUnitMutation,
    ContainerTimelineChangeTimeUnitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerTimelineChangeTimeUnitMutation,
    ContainerTimelineChangeTimeUnitMutationVariables
  >(ContainerTimelineChangeTimeUnitDocument, options)
}
export type ContainerTimelineChangeTimeUnitMutationHookResult = ReturnType<
  typeof useContainerTimelineChangeTimeUnitMutation
>
export type ContainerTimelineChangeTimeUnitMutationResult =
  Apollo.MutationResult<ContainerTimelineChangeTimeUnitMutation>
export type ContainerTimelineChangeTimeUnitMutationOptions = Apollo.BaseMutationOptions<
  ContainerTimelineChangeTimeUnitMutation,
  ContainerTimelineChangeTimeUnitMutationVariables
>
export const ContainerTimelineUpdateOwnUnitDocument = gql`
  mutation ContainerTimelineUpdateOwnUnit($input: UpdateOwnUnitInput!) {
    updateOwnUnit(input: $input) {
      unit {
        ...ModuleTimelineEventUnit
      }
    }
  }
  ${ModuleTimelineEventUnitFragmentDoc}
`
export type ContainerTimelineUpdateOwnUnitMutationFn = Apollo.MutationFunction<
  ContainerTimelineUpdateOwnUnitMutation,
  ContainerTimelineUpdateOwnUnitMutationVariables
>

/**
 * __useContainerTimelineUpdateOwnUnitMutation__
 *
 * To run a mutation, you first call `useContainerTimelineUpdateOwnUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineUpdateOwnUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerTimelineUpdateOwnUnitMutation, { data, loading, error }] = useContainerTimelineUpdateOwnUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerTimelineUpdateOwnUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerTimelineUpdateOwnUnitMutation,
    ContainerTimelineUpdateOwnUnitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerTimelineUpdateOwnUnitMutation,
    ContainerTimelineUpdateOwnUnitMutationVariables
  >(ContainerTimelineUpdateOwnUnitDocument, options)
}
export type ContainerTimelineUpdateOwnUnitMutationHookResult = ReturnType<
  typeof useContainerTimelineUpdateOwnUnitMutation
>
export type ContainerTimelineUpdateOwnUnitMutationResult =
  Apollo.MutationResult<ContainerTimelineUpdateOwnUnitMutation>
export type ContainerTimelineUpdateOwnUnitMutationOptions = Apollo.BaseMutationOptions<
  ContainerTimelineUpdateOwnUnitMutation,
  ContainerTimelineUpdateOwnUnitMutationVariables
>
export const ContainerTimelineUpdateSubcontractUnitDocument = gql`
  mutation ContainerTimelineUpdateSubcontractUnit($input: UpdateSubcontractUnitInput!) {
    updateSubcontractUnit(input: $input) {
      unit {
        ...ModuleTimelineEventUnit
      }
    }
  }
  ${ModuleTimelineEventUnitFragmentDoc}
`
export type ContainerTimelineUpdateSubcontractUnitMutationFn = Apollo.MutationFunction<
  ContainerTimelineUpdateSubcontractUnitMutation,
  ContainerTimelineUpdateSubcontractUnitMutationVariables
>

/**
 * __useContainerTimelineUpdateSubcontractUnitMutation__
 *
 * To run a mutation, you first call `useContainerTimelineUpdateSubcontractUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineUpdateSubcontractUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerTimelineUpdateSubcontractUnitMutation, { data, loading, error }] = useContainerTimelineUpdateSubcontractUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerTimelineUpdateSubcontractUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerTimelineUpdateSubcontractUnitMutation,
    ContainerTimelineUpdateSubcontractUnitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerTimelineUpdateSubcontractUnitMutation,
    ContainerTimelineUpdateSubcontractUnitMutationVariables
  >(ContainerTimelineUpdateSubcontractUnitDocument, options)
}
export type ContainerTimelineUpdateSubcontractUnitMutationHookResult = ReturnType<
  typeof useContainerTimelineUpdateSubcontractUnitMutation
>
export type ContainerTimelineUpdateSubcontractUnitMutationResult =
  Apollo.MutationResult<ContainerTimelineUpdateSubcontractUnitMutation>
export type ContainerTimelineUpdateSubcontractUnitMutationOptions = Apollo.BaseMutationOptions<
  ContainerTimelineUpdateSubcontractUnitMutation,
  ContainerTimelineUpdateSubcontractUnitMutationVariables
>
export const ContainerTimelineUpdateEventDocument = gql`
  mutation ContainerTimelineUpdateEvent($input: UpdateEventInput!) {
    updateEvent(input: $input) {
      event {
        ...ModuleTimelineEventEventTemporaryVehicleAllocation
        ...ModuleTimelineEventEventTruck
        ...ModuleTimelineEventEventEmployee
      }
    }
  }
  ${ModuleTimelineEventEventTemporaryVehicleAllocationFragmentDoc}
  ${ModuleTimelineEventEventTruckFragmentDoc}
  ${ModuleTimelineEventEventEmployeeFragmentDoc}
`
export type ContainerTimelineUpdateEventMutationFn = Apollo.MutationFunction<
  ContainerTimelineUpdateEventMutation,
  ContainerTimelineUpdateEventMutationVariables
>

/**
 * __useContainerTimelineUpdateEventMutation__
 *
 * To run a mutation, you first call `useContainerTimelineUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerTimelineUpdateEventMutation, { data, loading, error }] = useContainerTimelineUpdateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerTimelineUpdateEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerTimelineUpdateEventMutation,
    ContainerTimelineUpdateEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerTimelineUpdateEventMutation,
    ContainerTimelineUpdateEventMutationVariables
  >(ContainerTimelineUpdateEventDocument, options)
}
export type ContainerTimelineUpdateEventMutationHookResult = ReturnType<
  typeof useContainerTimelineUpdateEventMutation
>
export type ContainerTimelineUpdateEventMutationResult =
  Apollo.MutationResult<ContainerTimelineUpdateEventMutation>
export type ContainerTimelineUpdateEventMutationOptions = Apollo.BaseMutationOptions<
  ContainerTimelineUpdateEventMutation,
  ContainerTimelineUpdateEventMutationVariables
>
export const ContainerTimelineMainBackgroundDocument = gql`
  query ContainerTimelineMainBackground($date: ISO8601DateTime, $dates: Iso8601DatePeriodInput) {
    timelineTruckBackgrounds(date: $date, dates: $dates) {
      ...ModuleTimelineTruckBackground
    }
    timelineEmployeeBackgrounds(date: $date, dates: $dates) {
      ...ModuleTimelineEmployeeBackground
    }
  }
  ${ModuleTimelineTruckBackgroundFragmentDoc}
  ${ModuleTimelineEmployeeBackgroundFragmentDoc}
`

/**
 * __useContainerTimelineMainBackgroundQuery__
 *
 * To run a query within a React component, call `useContainerTimelineMainBackgroundQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineMainBackgroundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerTimelineMainBackgroundQuery({
 *   variables: {
 *      date: // value for 'date'
 *      dates: // value for 'dates'
 *   },
 * });
 */
export function useContainerTimelineMainBackgroundQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerTimelineMainBackgroundQuery,
    ContainerTimelineMainBackgroundQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerTimelineMainBackgroundQuery,
    ContainerTimelineMainBackgroundQueryVariables
  >(ContainerTimelineMainBackgroundDocument, options)
}
export function useContainerTimelineMainBackgroundLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerTimelineMainBackgroundQuery,
    ContainerTimelineMainBackgroundQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerTimelineMainBackgroundQuery,
    ContainerTimelineMainBackgroundQueryVariables
  >(ContainerTimelineMainBackgroundDocument, options)
}
export type ContainerTimelineMainBackgroundQueryHookResult = ReturnType<
  typeof useContainerTimelineMainBackgroundQuery
>
export type ContainerTimelineMainBackgroundLazyQueryHookResult = ReturnType<
  typeof useContainerTimelineMainBackgroundLazyQuery
>
export type ContainerTimelineMainBackgroundQueryResult = Apollo.QueryResult<
  ContainerTimelineMainBackgroundQuery,
  ContainerTimelineMainBackgroundQueryVariables
>
export const ContainerTimelineUnitCreateDocument = gql`
  subscription ContainerTimelineUnitCreate {
    unitCreate {
      unit {
        ...ModuleTimelineEventUnit
        nextUnit {
          ...ModuleTimelineEventUnit
        }
      }
    }
  }
  ${ModuleTimelineEventUnitFragmentDoc}
`

/**
 * __useContainerTimelineUnitCreateSubscription__
 *
 * To run a query within a React component, call `useContainerTimelineUnitCreateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineUnitCreateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerTimelineUnitCreateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useContainerTimelineUnitCreateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ContainerTimelineUnitCreateSubscription,
    ContainerTimelineUnitCreateSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    ContainerTimelineUnitCreateSubscription,
    ContainerTimelineUnitCreateSubscriptionVariables
  >(ContainerTimelineUnitCreateDocument, options)
}
export type ContainerTimelineUnitCreateSubscriptionHookResult = ReturnType<
  typeof useContainerTimelineUnitCreateSubscription
>
export type ContainerTimelineUnitCreateSubscriptionResult =
  Apollo.SubscriptionResult<ContainerTimelineUnitCreateSubscription>
export const ContainerTimelineEventCreateDocument = gql`
  subscription ContainerTimelineEventCreate {
    eventCreate {
      event {
        ...ModuleTimelineEventEventTemporaryVehicleAllocation
        ...ModuleTimelineEventEventTruck
        ...ModuleTimelineEventEventEmployee
      }
    }
  }
  ${ModuleTimelineEventEventTemporaryVehicleAllocationFragmentDoc}
  ${ModuleTimelineEventEventTruckFragmentDoc}
  ${ModuleTimelineEventEventEmployeeFragmentDoc}
`

/**
 * __useContainerTimelineEventCreateSubscription__
 *
 * To run a query within a React component, call `useContainerTimelineEventCreateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineEventCreateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerTimelineEventCreateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useContainerTimelineEventCreateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ContainerTimelineEventCreateSubscription,
    ContainerTimelineEventCreateSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    ContainerTimelineEventCreateSubscription,
    ContainerTimelineEventCreateSubscriptionVariables
  >(ContainerTimelineEventCreateDocument, options)
}
export type ContainerTimelineEventCreateSubscriptionHookResult = ReturnType<
  typeof useContainerTimelineEventCreateSubscription
>
export type ContainerTimelineEventCreateSubscriptionResult =
  Apollo.SubscriptionResult<ContainerTimelineEventCreateSubscription>
export const ContainerTimelineUnitDestroyDocument = gql`
  subscription ContainerTimelineUnitDestroy {
    unitDestroy {
      destroiedUnitId
    }
  }
`

/**
 * __useContainerTimelineUnitDestroySubscription__
 *
 * To run a query within a React component, call `useContainerTimelineUnitDestroySubscription` and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineUnitDestroySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerTimelineUnitDestroySubscription({
 *   variables: {
 *   },
 * });
 */
export function useContainerTimelineUnitDestroySubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ContainerTimelineUnitDestroySubscription,
    ContainerTimelineUnitDestroySubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    ContainerTimelineUnitDestroySubscription,
    ContainerTimelineUnitDestroySubscriptionVariables
  >(ContainerTimelineUnitDestroyDocument, options)
}
export type ContainerTimelineUnitDestroySubscriptionHookResult = ReturnType<
  typeof useContainerTimelineUnitDestroySubscription
>
export type ContainerTimelineUnitDestroySubscriptionResult =
  Apollo.SubscriptionResult<ContainerTimelineUnitDestroySubscription>
export const ContainerTimelineEventDestroyDocument = gql`
  subscription ContainerTimelineEventDestroy {
    eventDestroy {
      destroiedEventId
    }
  }
`

/**
 * __useContainerTimelineEventDestroySubscription__
 *
 * To run a query within a React component, call `useContainerTimelineEventDestroySubscription` and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineEventDestroySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerTimelineEventDestroySubscription({
 *   variables: {
 *   },
 * });
 */
export function useContainerTimelineEventDestroySubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ContainerTimelineEventDestroySubscription,
    ContainerTimelineEventDestroySubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    ContainerTimelineEventDestroySubscription,
    ContainerTimelineEventDestroySubscriptionVariables
  >(ContainerTimelineEventDestroyDocument, options)
}
export type ContainerTimelineEventDestroySubscriptionHookResult = ReturnType<
  typeof useContainerTimelineEventDestroySubscription
>
export type ContainerTimelineEventDestroySubscriptionResult =
  Apollo.SubscriptionResult<ContainerTimelineEventDestroySubscription>
export const ContainerTimelineTimelineUpdateDocument = gql`
  subscription ContainerTimelineTimelineUpdate {
    timelineUpdate {
      units {
        nodes {
          ...ModuleTimelineEventUnit
          nextUnit {
            ...ModuleTimelineEventUnit
          }
        }
      }
      events {
        nodes {
          ...ModuleTimelineEventEventTemporaryVehicleAllocation
          ...ModuleTimelineEventEventTruck
          ...ModuleTimelineEventEventEmployee
        }
      }
    }
  }
  ${ModuleTimelineEventUnitFragmentDoc}
  ${ModuleTimelineEventEventTemporaryVehicleAllocationFragmentDoc}
  ${ModuleTimelineEventEventTruckFragmentDoc}
  ${ModuleTimelineEventEventEmployeeFragmentDoc}
`

/**
 * __useContainerTimelineTimelineUpdateSubscription__
 *
 * To run a query within a React component, call `useContainerTimelineTimelineUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineTimelineUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerTimelineTimelineUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useContainerTimelineTimelineUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ContainerTimelineTimelineUpdateSubscription,
    ContainerTimelineTimelineUpdateSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    ContainerTimelineTimelineUpdateSubscription,
    ContainerTimelineTimelineUpdateSubscriptionVariables
  >(ContainerTimelineTimelineUpdateDocument, options)
}
export type ContainerTimelineTimelineUpdateSubscriptionHookResult = ReturnType<
  typeof useContainerTimelineTimelineUpdateSubscription
>
export type ContainerTimelineTimelineUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ContainerTimelineTimelineUpdateSubscription>
export const ContainerTimelineToolbarDocument = gql`
  query ContainerTimelineToolbar {
    companySites {
      nodes {
        ...ModuleTimelineToolbarFilterCompanySite
      }
      pageInfo {
        ...PageInfoField
      }
    }
    carTypes {
      nodes {
        ...ModuleTimelineToolbarFilterCarType
      }
      pageInfo {
        ...PageInfoField
      }
    }
    trucks(
      enables: true
      hasOneOrderBy: { relationalTable: "truck_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleTimelineToolbarFilterTruck
      }
      pageInfo {
        ...PageInfoField
      }
    }
  }
  ${ModuleTimelineToolbarFilterCompanySiteFragmentDoc}
  ${PageInfoFieldFragmentDoc}
  ${ModuleTimelineToolbarFilterCarTypeFragmentDoc}
  ${ModuleTimelineToolbarFilterTruckFragmentDoc}
`

/**
 * __useContainerTimelineToolbarQuery__
 *
 * To run a query within a React component, call `useContainerTimelineToolbarQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineToolbarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerTimelineToolbarQuery({
 *   variables: {
 *   },
 * });
 */
export function useContainerTimelineToolbarQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerTimelineToolbarQuery,
    ContainerTimelineToolbarQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerTimelineToolbarQuery, ContainerTimelineToolbarQueryVariables>(
    ContainerTimelineToolbarDocument,
    options
  )
}
export function useContainerTimelineToolbarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerTimelineToolbarQuery,
    ContainerTimelineToolbarQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerTimelineToolbarQuery, ContainerTimelineToolbarQueryVariables>(
    ContainerTimelineToolbarDocument,
    options
  )
}
export type ContainerTimelineToolbarQueryHookResult = ReturnType<
  typeof useContainerTimelineToolbarQuery
>
export type ContainerTimelineToolbarLazyQueryHookResult = ReturnType<
  typeof useContainerTimelineToolbarLazyQuery
>
export type ContainerTimelineToolbarQueryResult = Apollo.QueryResult<
  ContainerTimelineToolbarQuery,
  ContainerTimelineToolbarQueryVariables
>
export const ContainerTimelineRefreshResourceFeasibilityDocument = gql`
  mutation ContainerTimelineRefreshResourceFeasibility($input: RefreshResourceFeasibilityInput!) {
    refreshResourceFeasibility(input: $input) {
      asyncStatus
    }
  }
`
export type ContainerTimelineRefreshResourceFeasibilityMutationFn = Apollo.MutationFunction<
  ContainerTimelineRefreshResourceFeasibilityMutation,
  ContainerTimelineRefreshResourceFeasibilityMutationVariables
>

/**
 * __useContainerTimelineRefreshResourceFeasibilityMutation__
 *
 * To run a mutation, you first call `useContainerTimelineRefreshResourceFeasibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineRefreshResourceFeasibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerTimelineRefreshResourceFeasibilityMutation, { data, loading, error }] = useContainerTimelineRefreshResourceFeasibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerTimelineRefreshResourceFeasibilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerTimelineRefreshResourceFeasibilityMutation,
    ContainerTimelineRefreshResourceFeasibilityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerTimelineRefreshResourceFeasibilityMutation,
    ContainerTimelineRefreshResourceFeasibilityMutationVariables
  >(ContainerTimelineRefreshResourceFeasibilityDocument, options)
}
export type ContainerTimelineRefreshResourceFeasibilityMutationHookResult = ReturnType<
  typeof useContainerTimelineRefreshResourceFeasibilityMutation
>
export type ContainerTimelineRefreshResourceFeasibilityMutationResult =
  Apollo.MutationResult<ContainerTimelineRefreshResourceFeasibilityMutation>
export type ContainerTimelineRefreshResourceFeasibilityMutationOptions = Apollo.BaseMutationOptions<
  ContainerTimelineRefreshResourceFeasibilityMutation,
  ContainerTimelineRefreshResourceFeasibilityMutationVariables
>
export const ContainerTimelineDocument = gql`
  query ContainerTimeline($date: ISO8601DateTime, $dates: Iso8601DatePeriodInput) {
    units(date: $date, dates: $dates) {
      nodes {
        ...ModuleTimelineEventUnit
      }
      pageInfo {
        ...PageInfoField
      }
    }
    events(date: $date, dates: $dates) {
      nodes {
        ...ModuleTimelineEventEventTemporaryVehicleAllocation
        ...ModuleTimelineEventEventTruck
        ...ModuleTimelineEventEventEmployee
      }
      pageInfo {
        ...PageInfoField
      }
    }
    driverEmployees: employees(
      freightageRoles: [execute]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleTimelineDriverEmployeeResource
      }
      pageInfo {
        ...PageInfoField
      }
    }
    subcontractors: companyRelations(enables: true, involvements: [subcontractor]) {
      nodes {
        ...ModuleTimelineSubcontractorResource
      }
      pageInfo {
        ...PageInfoField
      }
    }
    trucks(
      enables: true
      hasOneOrderBy: { relationalTable: "truck_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleTimelineTruckResource
      }
      pageInfo {
        ...PageInfoField
      }
    }
  }
  ${ModuleTimelineEventUnitFragmentDoc}
  ${PageInfoFieldFragmentDoc}
  ${ModuleTimelineEventEventTemporaryVehicleAllocationFragmentDoc}
  ${ModuleTimelineEventEventTruckFragmentDoc}
  ${ModuleTimelineEventEventEmployeeFragmentDoc}
  ${ModuleTimelineDriverEmployeeResourceFragmentDoc}
  ${ModuleTimelineSubcontractorResourceFragmentDoc}
  ${ModuleTimelineTruckResourceFragmentDoc}
`

/**
 * __useContainerTimelineQuery__
 *
 * To run a query within a React component, call `useContainerTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerTimelineQuery({
 *   variables: {
 *      date: // value for 'date'
 *      dates: // value for 'dates'
 *   },
 * });
 */
export function useContainerTimelineQuery(
  baseOptions?: Apollo.QueryHookOptions<ContainerTimelineQuery, ContainerTimelineQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerTimelineQuery, ContainerTimelineQueryVariables>(
    ContainerTimelineDocument,
    options
  )
}
export function useContainerTimelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContainerTimelineQuery, ContainerTimelineQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerTimelineQuery, ContainerTimelineQueryVariables>(
    ContainerTimelineDocument,
    options
  )
}
export type ContainerTimelineQueryHookResult = ReturnType<typeof useContainerTimelineQuery>
export type ContainerTimelineLazyQueryHookResult = ReturnType<typeof useContainerTimelineLazyQuery>
export type ContainerTimelineQueryResult = Apollo.QueryResult<
  ContainerTimelineQuery,
  ContainerTimelineQueryVariables
>
export const TruckDetailDocument = gql`
  query TruckDetail($id: ID) {
    trucks(id: $id, enables: true) {
      edges {
        node {
          ...TruckManagementDetail
        }
      }
    }
  }
  ${TruckManagementDetailFragmentDoc}
`

/**
 * __useTruckDetailQuery__
 *
 * To run a query within a React component, call `useTruckDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTruckDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTruckDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTruckDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<TruckDetailQuery, TruckDetailQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TruckDetailQuery, TruckDetailQueryVariables>(TruckDetailDocument, options)
}
export function useTruckDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TruckDetailQuery, TruckDetailQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TruckDetailQuery, TruckDetailQueryVariables>(
    TruckDetailDocument,
    options
  )
}
export type TruckDetailQueryHookResult = ReturnType<typeof useTruckDetailQuery>
export type TruckDetailLazyQueryHookResult = ReturnType<typeof useTruckDetailLazyQuery>
export type TruckDetailQueryResult = Apollo.QueryResult<TruckDetailQuery, TruckDetailQueryVariables>
export const ChangeTruckOrderDocument = gql`
  mutation ChangeTruckOrder($input: ChangeTruckOrderInput!) {
    changeTruckOrder(input: $input) {
      clientMutationId
    }
  }
`
export type ChangeTruckOrderMutationFn = Apollo.MutationFunction<
  ChangeTruckOrderMutation,
  ChangeTruckOrderMutationVariables
>

/**
 * __useChangeTruckOrderMutation__
 *
 * To run a mutation, you first call `useChangeTruckOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTruckOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTruckOrderMutation, { data, loading, error }] = useChangeTruckOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeTruckOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeTruckOrderMutation,
    ChangeTruckOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ChangeTruckOrderMutation, ChangeTruckOrderMutationVariables>(
    ChangeTruckOrderDocument,
    options
  )
}
export type ChangeTruckOrderMutationHookResult = ReturnType<typeof useChangeTruckOrderMutation>
export type ChangeTruckOrderMutationResult = Apollo.MutationResult<ChangeTruckOrderMutation>
export type ChangeTruckOrderMutationOptions = Apollo.BaseMutationOptions<
  ChangeTruckOrderMutation,
  ChangeTruckOrderMutationVariables
>
export const ContainerTrucksFilterDocument = gql`
  query ContainerTrucksFilter {
    trucks(
      enables: true
      hasOneOrderBy: { relationalTable: "truck_order", field: ORDER, direction: ASC }
    ) {
      edges {
        node {
          ...TruckManagementList
        }
      }
    }
  }
  ${TruckManagementListFragmentDoc}
`

/**
 * __useContainerTrucksFilterQuery__
 *
 * To run a query within a React component, call `useContainerTrucksFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerTrucksFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerTrucksFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useContainerTrucksFilterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContainerTrucksFilterQuery,
    ContainerTrucksFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerTrucksFilterQuery, ContainerTrucksFilterQueryVariables>(
    ContainerTrucksFilterDocument,
    options
  )
}
export function useContainerTrucksFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerTrucksFilterQuery,
    ContainerTrucksFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerTrucksFilterQuery, ContainerTrucksFilterQueryVariables>(
    ContainerTrucksFilterDocument,
    options
  )
}
export type ContainerTrucksFilterQueryHookResult = ReturnType<typeof useContainerTrucksFilterQuery>
export type ContainerTrucksFilterLazyQueryHookResult = ReturnType<
  typeof useContainerTrucksFilterLazyQuery
>
export type ContainerTrucksFilterQueryResult = Apollo.QueryResult<
  ContainerTrucksFilterQuery,
  ContainerTrucksFilterQueryVariables
>
export const CreateCarTypeDocument = gql`
  mutation CreateCarType($input: CreateCarInput!) {
    createCarType(input: $input) {
      carType {
        id
        name
      }
    }
  }
`
export type CreateCarTypeMutationFn = Apollo.MutationFunction<
  CreateCarTypeMutation,
  CreateCarTypeMutationVariables
>

/**
 * __useCreateCarTypeMutation__
 *
 * To run a mutation, you first call `useCreateCarTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarTypeMutation, { data, loading, error }] = useCreateCarTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCarTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCarTypeMutation, CreateCarTypeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCarTypeMutation, CreateCarTypeMutationVariables>(
    CreateCarTypeDocument,
    options
  )
}
export type CreateCarTypeMutationHookResult = ReturnType<typeof useCreateCarTypeMutation>
export type CreateCarTypeMutationResult = Apollo.MutationResult<CreateCarTypeMutation>
export type CreateCarTypeMutationOptions = Apollo.BaseMutationOptions<
  CreateCarTypeMutation,
  CreateCarTypeMutationVariables
>
export const CreateTruckDocument = gql`
  mutation CreateTruck($input: CreateTruckInput!) {
    createTruck(input: $input) {
      truck {
        id
      }
    }
  }
`
export type CreateTruckMutationFn = Apollo.MutationFunction<
  CreateTruckMutation,
  CreateTruckMutationVariables
>

/**
 * __useCreateTruckMutation__
 *
 * To run a mutation, you first call `useCreateTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTruckMutation, { data, loading, error }] = useCreateTruckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTruckMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTruckMutation, CreateTruckMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTruckMutation, CreateTruckMutationVariables>(
    CreateTruckDocument,
    options
  )
}
export type CreateTruckMutationHookResult = ReturnType<typeof useCreateTruckMutation>
export type CreateTruckMutationResult = Apollo.MutationResult<CreateTruckMutation>
export type CreateTruckMutationOptions = Apollo.BaseMutationOptions<
  CreateTruckMutation,
  CreateTruckMutationVariables
>
export const UpdateTruckDocument = gql`
  mutation UpdateTruck($input: UpdateTruckInput!) {
    updateTruck(input: $input) {
      truck {
        ...TruckManagementDetail
      }
    }
  }
  ${TruckManagementDetailFragmentDoc}
`
export type UpdateTruckMutationFn = Apollo.MutationFunction<
  UpdateTruckMutation,
  UpdateTruckMutationVariables
>

/**
 * __useUpdateTruckMutation__
 *
 * To run a mutation, you first call `useUpdateTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTruckMutation, { data, loading, error }] = useUpdateTruckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTruckMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTruckMutation, UpdateTruckMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTruckMutation, UpdateTruckMutationVariables>(
    UpdateTruckDocument,
    options
  )
}
export type UpdateTruckMutationHookResult = ReturnType<typeof useUpdateTruckMutation>
export type UpdateTruckMutationResult = Apollo.MutationResult<UpdateTruckMutation>
export type UpdateTruckMutationOptions = Apollo.BaseMutationOptions<
  UpdateTruckMutation,
  UpdateTruckMutationVariables
>
export const UpdateEmployeeDrivableTruckDocument = gql`
  mutation UpdateEmployeeDrivableTruck($input: UpdateEmployeeDrivableTruckInput!) {
    updateEmployeeDrivableTruck(input: $input) {
      truck {
        ...TruckManagementDetail
      }
    }
  }
  ${TruckManagementDetailFragmentDoc}
`
export type UpdateEmployeeDrivableTruckMutationFn = Apollo.MutationFunction<
  UpdateEmployeeDrivableTruckMutation,
  UpdateEmployeeDrivableTruckMutationVariables
>

/**
 * __useUpdateEmployeeDrivableTruckMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeDrivableTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeDrivableTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeDrivableTruckMutation, { data, loading, error }] = useUpdateEmployeeDrivableTruckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeDrivableTruckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmployeeDrivableTruckMutation,
    UpdateEmployeeDrivableTruckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateEmployeeDrivableTruckMutation,
    UpdateEmployeeDrivableTruckMutationVariables
  >(UpdateEmployeeDrivableTruckDocument, options)
}
export type UpdateEmployeeDrivableTruckMutationHookResult = ReturnType<
  typeof useUpdateEmployeeDrivableTruckMutation
>
export type UpdateEmployeeDrivableTruckMutationResult =
  Apollo.MutationResult<UpdateEmployeeDrivableTruckMutation>
export type UpdateEmployeeDrivableTruckMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmployeeDrivableTruckMutation,
  UpdateEmployeeDrivableTruckMutationVariables
>
export const DisableTruckDocument = gql`
  mutation DisableTruck($input: DisableTruckInput!) {
    disableTruck(input: $input) {
      truck {
        id
        carNumber
      }
    }
  }
`
export type DisableTruckMutationFn = Apollo.MutationFunction<
  DisableTruckMutation,
  DisableTruckMutationVariables
>

/**
 * __useDisableTruckMutation__
 *
 * To run a mutation, you first call `useDisableTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTruckMutation, { data, loading, error }] = useDisableTruckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableTruckMutation(
  baseOptions?: Apollo.MutationHookOptions<DisableTruckMutation, DisableTruckMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DisableTruckMutation, DisableTruckMutationVariables>(
    DisableTruckDocument,
    options
  )
}
export type DisableTruckMutationHookResult = ReturnType<typeof useDisableTruckMutation>
export type DisableTruckMutationResult = Apollo.MutationResult<DisableTruckMutation>
export type DisableTruckMutationOptions = Apollo.BaseMutationOptions<
  DisableTruckMutation,
  DisableTruckMutationVariables
>
export const ContainerTruckNewDocument = gql`
  query ContainerTruckNew {
    carTypes {
      nodes {
        ...TruckNewCarType
      }
    }
    employees(
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
      freightageRoles: [execute]
    ) {
      nodes {
        ...TruckNewEmployee
      }
    }
    companySites {
      edges {
        node {
          ...TruckNewCompanySite
        }
      }
    }
  }
  ${TruckNewCarTypeFragmentDoc}
  ${TruckNewEmployeeFragmentDoc}
  ${TruckNewCompanySiteFragmentDoc}
`

/**
 * __useContainerTruckNewQuery__
 *
 * To run a query within a React component, call `useContainerTruckNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerTruckNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerTruckNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useContainerTruckNewQuery(
  baseOptions?: Apollo.QueryHookOptions<ContainerTruckNewQuery, ContainerTruckNewQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerTruckNewQuery, ContainerTruckNewQueryVariables>(
    ContainerTruckNewDocument,
    options
  )
}
export function useContainerTruckNewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContainerTruckNewQuery, ContainerTruckNewQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerTruckNewQuery, ContainerTruckNewQueryVariables>(
    ContainerTruckNewDocument,
    options
  )
}
export type ContainerTruckNewQueryHookResult = ReturnType<typeof useContainerTruckNewQuery>
export type ContainerTruckNewLazyQueryHookResult = ReturnType<typeof useContainerTruckNewLazyQuery>
export type ContainerTruckNewQueryResult = Apollo.QueryResult<
  ContainerTruckNewQuery,
  ContainerTruckNewQueryVariables
>
export const ContainerUnitDetailFixedDocument = gql`
  mutation ContainerUnitDetailFixed($input: ChangeUnitFixedInput!) {
    changeUnitFixed(input: $input) {
      unit {
        ...ModuleUnitDetailUnit
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
`
export type ContainerUnitDetailFixedMutationFn = Apollo.MutationFunction<
  ContainerUnitDetailFixedMutation,
  ContainerUnitDetailFixedMutationVariables
>

/**
 * __useContainerUnitDetailFixedMutation__
 *
 * To run a mutation, you first call `useContainerUnitDetailFixedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailFixedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerUnitDetailFixedMutation, { data, loading, error }] = useContainerUnitDetailFixedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerUnitDetailFixedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerUnitDetailFixedMutation,
    ContainerUnitDetailFixedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerUnitDetailFixedMutation,
    ContainerUnitDetailFixedMutationVariables
  >(ContainerUnitDetailFixedDocument, options)
}
export type ContainerUnitDetailFixedMutationHookResult = ReturnType<
  typeof useContainerUnitDetailFixedMutation
>
export type ContainerUnitDetailFixedMutationResult =
  Apollo.MutationResult<ContainerUnitDetailFixedMutation>
export type ContainerUnitDetailFixedMutationOptions = Apollo.BaseMutationOptions<
  ContainerUnitDetailFixedMutation,
  ContainerUnitDetailFixedMutationVariables
>
export const ContainerUnitDetailUpdateOwnUnitDocument = gql`
  mutation ContainerUnitDetailUpdateOwnUnit($input: UpdateOwnUnitInput!) {
    updateOwnUnit(input: $input) {
      unit {
        ...ModuleUnitDetailUnit
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
`
export type ContainerUnitDetailUpdateOwnUnitMutationFn = Apollo.MutationFunction<
  ContainerUnitDetailUpdateOwnUnitMutation,
  ContainerUnitDetailUpdateOwnUnitMutationVariables
>

/**
 * __useContainerUnitDetailUpdateOwnUnitMutation__
 *
 * To run a mutation, you first call `useContainerUnitDetailUpdateOwnUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailUpdateOwnUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerUnitDetailUpdateOwnUnitMutation, { data, loading, error }] = useContainerUnitDetailUpdateOwnUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerUnitDetailUpdateOwnUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerUnitDetailUpdateOwnUnitMutation,
    ContainerUnitDetailUpdateOwnUnitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerUnitDetailUpdateOwnUnitMutation,
    ContainerUnitDetailUpdateOwnUnitMutationVariables
  >(ContainerUnitDetailUpdateOwnUnitDocument, options)
}
export type ContainerUnitDetailUpdateOwnUnitMutationHookResult = ReturnType<
  typeof useContainerUnitDetailUpdateOwnUnitMutation
>
export type ContainerUnitDetailUpdateOwnUnitMutationResult =
  Apollo.MutationResult<ContainerUnitDetailUpdateOwnUnitMutation>
export type ContainerUnitDetailUpdateOwnUnitMutationOptions = Apollo.BaseMutationOptions<
  ContainerUnitDetailUpdateOwnUnitMutation,
  ContainerUnitDetailUpdateOwnUnitMutationVariables
>
export const ContainerUnitDetailUpdateSubcontractUnitDocument = gql`
  mutation ContainerUnitDetailUpdateSubcontractUnit($input: UpdateSubcontractUnitInput!) {
    updateSubcontractUnit(input: $input) {
      unit {
        ...ModuleUnitDetailUnit
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
`
export type ContainerUnitDetailUpdateSubcontractUnitMutationFn = Apollo.MutationFunction<
  ContainerUnitDetailUpdateSubcontractUnitMutation,
  ContainerUnitDetailUpdateSubcontractUnitMutationVariables
>

/**
 * __useContainerUnitDetailUpdateSubcontractUnitMutation__
 *
 * To run a mutation, you first call `useContainerUnitDetailUpdateSubcontractUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailUpdateSubcontractUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerUnitDetailUpdateSubcontractUnitMutation, { data, loading, error }] = useContainerUnitDetailUpdateSubcontractUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerUnitDetailUpdateSubcontractUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerUnitDetailUpdateSubcontractUnitMutation,
    ContainerUnitDetailUpdateSubcontractUnitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerUnitDetailUpdateSubcontractUnitMutation,
    ContainerUnitDetailUpdateSubcontractUnitMutationVariables
  >(ContainerUnitDetailUpdateSubcontractUnitDocument, options)
}
export type ContainerUnitDetailUpdateSubcontractUnitMutationHookResult = ReturnType<
  typeof useContainerUnitDetailUpdateSubcontractUnitMutation
>
export type ContainerUnitDetailUpdateSubcontractUnitMutationResult =
  Apollo.MutationResult<ContainerUnitDetailUpdateSubcontractUnitMutation>
export type ContainerUnitDetailUpdateSubcontractUnitMutationOptions = Apollo.BaseMutationOptions<
  ContainerUnitDetailUpdateSubcontractUnitMutation,
  ContainerUnitDetailUpdateSubcontractUnitMutationVariables
>
export const ContainerUnitDetailJointUnitDocument = gql`
  mutation ContainerUnitDetailJointUnit($input: JointUnitInput!) {
    jointUnit(input: $input) {
      unit {
        ...ModuleUnitDetailUnit
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
`
export type ContainerUnitDetailJointUnitMutationFn = Apollo.MutationFunction<
  ContainerUnitDetailJointUnitMutation,
  ContainerUnitDetailJointUnitMutationVariables
>

/**
 * __useContainerUnitDetailJointUnitMutation__
 *
 * To run a mutation, you first call `useContainerUnitDetailJointUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailJointUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerUnitDetailJointUnitMutation, { data, loading, error }] = useContainerUnitDetailJointUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerUnitDetailJointUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerUnitDetailJointUnitMutation,
    ContainerUnitDetailJointUnitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerUnitDetailJointUnitMutation,
    ContainerUnitDetailJointUnitMutationVariables
  >(ContainerUnitDetailJointUnitDocument, options)
}
export type ContainerUnitDetailJointUnitMutationHookResult = ReturnType<
  typeof useContainerUnitDetailJointUnitMutation
>
export type ContainerUnitDetailJointUnitMutationResult =
  Apollo.MutationResult<ContainerUnitDetailJointUnitMutation>
export type ContainerUnitDetailJointUnitMutationOptions = Apollo.BaseMutationOptions<
  ContainerUnitDetailJointUnitMutation,
  ContainerUnitDetailJointUnitMutationVariables
>
export const ContainerUnitDetailSeparateUnitDocument = gql`
  mutation ContainerUnitDetailSeparateUnit($input: SeparateUnitInput!) {
    separateUnit(input: $input) {
      unit {
        ...ModuleUnitDetailUnit
      }
      newUnit {
        ...ModuleUnitDetailUnit
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
`
export type ContainerUnitDetailSeparateUnitMutationFn = Apollo.MutationFunction<
  ContainerUnitDetailSeparateUnitMutation,
  ContainerUnitDetailSeparateUnitMutationVariables
>

/**
 * __useContainerUnitDetailSeparateUnitMutation__
 *
 * To run a mutation, you first call `useContainerUnitDetailSeparateUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailSeparateUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerUnitDetailSeparateUnitMutation, { data, loading, error }] = useContainerUnitDetailSeparateUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerUnitDetailSeparateUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerUnitDetailSeparateUnitMutation,
    ContainerUnitDetailSeparateUnitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerUnitDetailSeparateUnitMutation,
    ContainerUnitDetailSeparateUnitMutationVariables
  >(ContainerUnitDetailSeparateUnitDocument, options)
}
export type ContainerUnitDetailSeparateUnitMutationHookResult = ReturnType<
  typeof useContainerUnitDetailSeparateUnitMutation
>
export type ContainerUnitDetailSeparateUnitMutationResult =
  Apollo.MutationResult<ContainerUnitDetailSeparateUnitMutation>
export type ContainerUnitDetailSeparateUnitMutationOptions = Apollo.BaseMutationOptions<
  ContainerUnitDetailSeparateUnitMutation,
  ContainerUnitDetailSeparateUnitMutationVariables
>
export const ContainerUnitDetailDestroyUnitDocument = gql`
  mutation ContainerUnitDetailDestroyUnit($input: DestroyUnitInput!) {
    destroyUnit(input: $input) {
      unit {
        ...ModuleUnitDetailUnit
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
`
export type ContainerUnitDetailDestroyUnitMutationFn = Apollo.MutationFunction<
  ContainerUnitDetailDestroyUnitMutation,
  ContainerUnitDetailDestroyUnitMutationVariables
>

/**
 * __useContainerUnitDetailDestroyUnitMutation__
 *
 * To run a mutation, you first call `useContainerUnitDetailDestroyUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailDestroyUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerUnitDetailDestroyUnitMutation, { data, loading, error }] = useContainerUnitDetailDestroyUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerUnitDetailDestroyUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerUnitDetailDestroyUnitMutation,
    ContainerUnitDetailDestroyUnitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerUnitDetailDestroyUnitMutation,
    ContainerUnitDetailDestroyUnitMutationVariables
  >(ContainerUnitDetailDestroyUnitDocument, options)
}
export type ContainerUnitDetailDestroyUnitMutationHookResult = ReturnType<
  typeof useContainerUnitDetailDestroyUnitMutation
>
export type ContainerUnitDetailDestroyUnitMutationResult =
  Apollo.MutationResult<ContainerUnitDetailDestroyUnitMutation>
export type ContainerUnitDetailDestroyUnitMutationOptions = Apollo.BaseMutationOptions<
  ContainerUnitDetailDestroyUnitMutation,
  ContainerUnitDetailDestroyUnitMutationVariables
>
export const ContainerUnitDetailPushContractToUnitDocument = gql`
  mutation ContainerUnitDetailPushContractToUnit($input: PushContractToUnitInput!) {
    pushContractToUnit(input: $input) {
      unit {
        ...ModuleUnitDetailUnit
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
`
export type ContainerUnitDetailPushContractToUnitMutationFn = Apollo.MutationFunction<
  ContainerUnitDetailPushContractToUnitMutation,
  ContainerUnitDetailPushContractToUnitMutationVariables
>

/**
 * __useContainerUnitDetailPushContractToUnitMutation__
 *
 * To run a mutation, you first call `useContainerUnitDetailPushContractToUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailPushContractToUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerUnitDetailPushContractToUnitMutation, { data, loading, error }] = useContainerUnitDetailPushContractToUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerUnitDetailPushContractToUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerUnitDetailPushContractToUnitMutation,
    ContainerUnitDetailPushContractToUnitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerUnitDetailPushContractToUnitMutation,
    ContainerUnitDetailPushContractToUnitMutationVariables
  >(ContainerUnitDetailPushContractToUnitDocument, options)
}
export type ContainerUnitDetailPushContractToUnitMutationHookResult = ReturnType<
  typeof useContainerUnitDetailPushContractToUnitMutation
>
export type ContainerUnitDetailPushContractToUnitMutationResult =
  Apollo.MutationResult<ContainerUnitDetailPushContractToUnitMutation>
export type ContainerUnitDetailPushContractToUnitMutationOptions = Apollo.BaseMutationOptions<
  ContainerUnitDetailPushContractToUnitMutation,
  ContainerUnitDetailPushContractToUnitMutationVariables
>
export const ContainerUnitDetailShiftContractToUnitDocument = gql`
  mutation ContainerUnitDetailShiftContractToUnit($input: ShiftContractToUnitInput!) {
    shiftContractToUnit(input: $input) {
      unit {
        ...ModuleUnitDetailUnit
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
`
export type ContainerUnitDetailShiftContractToUnitMutationFn = Apollo.MutationFunction<
  ContainerUnitDetailShiftContractToUnitMutation,
  ContainerUnitDetailShiftContractToUnitMutationVariables
>

/**
 * __useContainerUnitDetailShiftContractToUnitMutation__
 *
 * To run a mutation, you first call `useContainerUnitDetailShiftContractToUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailShiftContractToUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerUnitDetailShiftContractToUnitMutation, { data, loading, error }] = useContainerUnitDetailShiftContractToUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerUnitDetailShiftContractToUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerUnitDetailShiftContractToUnitMutation,
    ContainerUnitDetailShiftContractToUnitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerUnitDetailShiftContractToUnitMutation,
    ContainerUnitDetailShiftContractToUnitMutationVariables
  >(ContainerUnitDetailShiftContractToUnitDocument, options)
}
export type ContainerUnitDetailShiftContractToUnitMutationHookResult = ReturnType<
  typeof useContainerUnitDetailShiftContractToUnitMutation
>
export type ContainerUnitDetailShiftContractToUnitMutationResult =
  Apollo.MutationResult<ContainerUnitDetailShiftContractToUnitMutation>
export type ContainerUnitDetailShiftContractToUnitMutationOptions = Apollo.BaseMutationOptions<
  ContainerUnitDetailShiftContractToUnitMutation,
  ContainerUnitDetailShiftContractToUnitMutationVariables
>
export const ContainerUnitDetailNoticeUnitDocument = gql`
  mutation ContainerUnitDetailNoticeUnit($input: NoticeUnitInput!) {
    noticeUnit(input: $input) {
      unit {
        ...ModuleUnitDetailUnit
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
`
export type ContainerUnitDetailNoticeUnitMutationFn = Apollo.MutationFunction<
  ContainerUnitDetailNoticeUnitMutation,
  ContainerUnitDetailNoticeUnitMutationVariables
>

/**
 * __useContainerUnitDetailNoticeUnitMutation__
 *
 * To run a mutation, you first call `useContainerUnitDetailNoticeUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailNoticeUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerUnitDetailNoticeUnitMutation, { data, loading, error }] = useContainerUnitDetailNoticeUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerUnitDetailNoticeUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerUnitDetailNoticeUnitMutation,
    ContainerUnitDetailNoticeUnitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerUnitDetailNoticeUnitMutation,
    ContainerUnitDetailNoticeUnitMutationVariables
  >(ContainerUnitDetailNoticeUnitDocument, options)
}
export type ContainerUnitDetailNoticeUnitMutationHookResult = ReturnType<
  typeof useContainerUnitDetailNoticeUnitMutation
>
export type ContainerUnitDetailNoticeUnitMutationResult =
  Apollo.MutationResult<ContainerUnitDetailNoticeUnitMutation>
export type ContainerUnitDetailNoticeUnitMutationOptions = Apollo.BaseMutationOptions<
  ContainerUnitDetailNoticeUnitMutation,
  ContainerUnitDetailNoticeUnitMutationVariables
>
export const ContainerUnitDetailChangeLoadingEventStartOnDocument = gql`
  mutation ContainerUnitDetailChangeLoadingEventStartOn($input: ChangeLoadingEventStartOnInput!) {
    changeLoadingEventStartOn(input: $input) {
      loadingEvent {
        route {
          unit {
            ...ModuleUnitDetailUnit
          }
        }
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
`
export type ContainerUnitDetailChangeLoadingEventStartOnMutationFn = Apollo.MutationFunction<
  ContainerUnitDetailChangeLoadingEventStartOnMutation,
  ContainerUnitDetailChangeLoadingEventStartOnMutationVariables
>

/**
 * __useContainerUnitDetailChangeLoadingEventStartOnMutation__
 *
 * To run a mutation, you first call `useContainerUnitDetailChangeLoadingEventStartOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailChangeLoadingEventStartOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerUnitDetailChangeLoadingEventStartOnMutation, { data, loading, error }] = useContainerUnitDetailChangeLoadingEventStartOnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerUnitDetailChangeLoadingEventStartOnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerUnitDetailChangeLoadingEventStartOnMutation,
    ContainerUnitDetailChangeLoadingEventStartOnMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerUnitDetailChangeLoadingEventStartOnMutation,
    ContainerUnitDetailChangeLoadingEventStartOnMutationVariables
  >(ContainerUnitDetailChangeLoadingEventStartOnDocument, options)
}
export type ContainerUnitDetailChangeLoadingEventStartOnMutationHookResult = ReturnType<
  typeof useContainerUnitDetailChangeLoadingEventStartOnMutation
>
export type ContainerUnitDetailChangeLoadingEventStartOnMutationResult =
  Apollo.MutationResult<ContainerUnitDetailChangeLoadingEventStartOnMutation>
export type ContainerUnitDetailChangeLoadingEventStartOnMutationOptions =
  Apollo.BaseMutationOptions<
    ContainerUnitDetailChangeLoadingEventStartOnMutation,
    ContainerUnitDetailChangeLoadingEventStartOnMutationVariables
  >
export const ContainerUnitDetailUpdateCompanySiteEventDocument = gql`
  mutation ContainerUnitDetailUpdateCompanySiteEvent(
    $input: ChangeCompanySiteEventLoadingTimeInput!
  ) {
    changeCompanySiteEventLoadingTime(input: $input) {
      companySiteEvent {
        route {
          unit {
            ...ModuleUnitDetailUnit
          }
        }
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
`
export type ContainerUnitDetailUpdateCompanySiteEventMutationFn = Apollo.MutationFunction<
  ContainerUnitDetailUpdateCompanySiteEventMutation,
  ContainerUnitDetailUpdateCompanySiteEventMutationVariables
>

/**
 * __useContainerUnitDetailUpdateCompanySiteEventMutation__
 *
 * To run a mutation, you first call `useContainerUnitDetailUpdateCompanySiteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailUpdateCompanySiteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [containerUnitDetailUpdateCompanySiteEventMutation, { data, loading, error }] = useContainerUnitDetailUpdateCompanySiteEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContainerUnitDetailUpdateCompanySiteEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContainerUnitDetailUpdateCompanySiteEventMutation,
    ContainerUnitDetailUpdateCompanySiteEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContainerUnitDetailUpdateCompanySiteEventMutation,
    ContainerUnitDetailUpdateCompanySiteEventMutationVariables
  >(ContainerUnitDetailUpdateCompanySiteEventDocument, options)
}
export type ContainerUnitDetailUpdateCompanySiteEventMutationHookResult = ReturnType<
  typeof useContainerUnitDetailUpdateCompanySiteEventMutation
>
export type ContainerUnitDetailUpdateCompanySiteEventMutationResult =
  Apollo.MutationResult<ContainerUnitDetailUpdateCompanySiteEventMutation>
export type ContainerUnitDetailUpdateCompanySiteEventMutationOptions = Apollo.BaseMutationOptions<
  ContainerUnitDetailUpdateCompanySiteEventMutation,
  ContainerUnitDetailUpdateCompanySiteEventMutationVariables
>
export const ContainerUnitDetailDocument = gql`
  query ContainerUnitDetail($id: ID!) {
    units(id: $id) {
      nodes {
        ...ModuleUnitDetailUnit
      }
      pageInfo {
        ...PageInfoField
      }
    }
    contracts(enables: true, frequent: true) {
      nodes {
        ...ModuleUnitDetailContract
      }
    }
    trucks(
      enables: true
      hasOneOrderBy: { relationalTable: "truck_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleUnitDetailTruck
      }
      pageInfo {
        ...PageInfoField
      }
    }
    driversEmployees: employees(
      freightageRoles: [execute]
      enables: true
      hasOneOrderBy: { relationalTable: "employee_order", field: ORDER, direction: ASC }
    ) {
      nodes {
        ...ModuleUnitDetailDriverEmployee
      }
      pageInfo {
        ...PageInfoField
      }
    }
    employeeDrivableTrucks {
      nodes {
        ...ModuleUnitDetailEmployeeDrivableTruck
      }
      pageInfo {
        ...PageInfoField
      }
    }
    subcontractors: companyRelations(enables: true, involvements: [subcontractor]) {
      nodes {
        ...ModuleUnitDetailSubconratctor
      }
      pageInfo {
        ...PageInfoField
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
  ${PageInfoFieldFragmentDoc}
  ${ModuleUnitDetailContractFragmentDoc}
  ${ModuleUnitDetailTruckFragmentDoc}
  ${ModuleUnitDetailDriverEmployeeFragmentDoc}
  ${ModuleUnitDetailEmployeeDrivableTruckFragmentDoc}
  ${ModuleUnitDetailSubconratctorFragmentDoc}
`

/**
 * __useContainerUnitDetailQuery__
 *
 * To run a query within a React component, call `useContainerUnitDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerUnitDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContainerUnitDetailQuery(
  baseOptions: Apollo.QueryHookOptions<ContainerUnitDetailQuery, ContainerUnitDetailQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContainerUnitDetailQuery, ContainerUnitDetailQueryVariables>(
    ContainerUnitDetailDocument,
    options
  )
}
export function useContainerUnitDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerUnitDetailQuery,
    ContainerUnitDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContainerUnitDetailQuery, ContainerUnitDetailQueryVariables>(
    ContainerUnitDetailDocument,
    options
  )
}
export type ContainerUnitDetailQueryHookResult = ReturnType<typeof useContainerUnitDetailQuery>
export type ContainerUnitDetailLazyQueryHookResult = ReturnType<
  typeof useContainerUnitDetailLazyQuery
>
export type ContainerUnitDetailQueryResult = Apollo.QueryResult<
  ContainerUnitDetailQuery,
  ContainerUnitDetailQueryVariables
>
export const ContainerUnitDetailContractsDocument = gql`
  query ContainerUnitDetailContracts($text: String!) {
    contracts(enables: true, text: $text) {
      nodes {
        ...ModuleUnitDetailContract
      }
      pageInfo {
        ...PageInfoField
      }
    }
  }
  ${ModuleUnitDetailContractFragmentDoc}
  ${PageInfoFieldFragmentDoc}
`

/**
 * __useContainerUnitDetailContractsQuery__
 *
 * To run a query within a React component, call `useContainerUnitDetailContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerUnitDetailContractsQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useContainerUnitDetailContractsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContainerUnitDetailContractsQuery,
    ContainerUnitDetailContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContainerUnitDetailContractsQuery,
    ContainerUnitDetailContractsQueryVariables
  >(ContainerUnitDetailContractsDocument, options)
}
export function useContainerUnitDetailContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContainerUnitDetailContractsQuery,
    ContainerUnitDetailContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContainerUnitDetailContractsQuery,
    ContainerUnitDetailContractsQueryVariables
  >(ContainerUnitDetailContractsDocument, options)
}
export type ContainerUnitDetailContractsQueryHookResult = ReturnType<
  typeof useContainerUnitDetailContractsQuery
>
export type ContainerUnitDetailContractsLazyQueryHookResult = ReturnType<
  typeof useContainerUnitDetailContractsLazyQuery
>
export type ContainerUnitDetailContractsQueryResult = Apollo.QueryResult<
  ContainerUnitDetailContractsQuery,
  ContainerUnitDetailContractsQueryVariables
>
export const ContainerUnitDetailUnitUpdateDocument = gql`
  subscription ContainerUnitDetailUnitUpdate($id: ID!) {
    unitUpdate(id: $id) {
      unit {
        ...ModuleUnitDetailUnit
        nextUnit {
          ...ModuleUnitDetailUnit
        }
      }
    }
  }
  ${ModuleUnitDetailUnitFragmentDoc}
`

/**
 * __useContainerUnitDetailUnitUpdateSubscription__
 *
 * To run a query within a React component, call `useContainerUnitDetailUnitUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailUnitUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerUnitDetailUnitUpdateSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContainerUnitDetailUnitUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ContainerUnitDetailUnitUpdateSubscription,
    ContainerUnitDetailUnitUpdateSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    ContainerUnitDetailUnitUpdateSubscription,
    ContainerUnitDetailUnitUpdateSubscriptionVariables
  >(ContainerUnitDetailUnitUpdateDocument, options)
}
export type ContainerUnitDetailUnitUpdateSubscriptionHookResult = ReturnType<
  typeof useContainerUnitDetailUnitUpdateSubscription
>
export type ContainerUnitDetailUnitUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ContainerUnitDetailUnitUpdateSubscription>
export const ContainerUnitDetailUnitDestroyDocument = gql`
  subscription ContainerUnitDetailUnitDestroy {
    unitDestroy {
      destroiedUnitId
    }
  }
`

/**
 * __useContainerUnitDetailUnitDestroySubscription__
 *
 * To run a query within a React component, call `useContainerUnitDetailUnitDestroySubscription` and pass it any options that fit your needs.
 * When your component renders, `useContainerUnitDetailUnitDestroySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerUnitDetailUnitDestroySubscription({
 *   variables: {
 *   },
 * });
 */
export function useContainerUnitDetailUnitDestroySubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ContainerUnitDetailUnitDestroySubscription,
    ContainerUnitDetailUnitDestroySubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    ContainerUnitDetailUnitDestroySubscription,
    ContainerUnitDetailUnitDestroySubscriptionVariables
  >(ContainerUnitDetailUnitDestroyDocument, options)
}
export type ContainerUnitDetailUnitDestroySubscriptionHookResult = ReturnType<
  typeof useContainerUnitDetailUnitDestroySubscription
>
export type ContainerUnitDetailUnitDestroySubscriptionResult =
  Apollo.SubscriptionResult<ContainerUnitDetailUnitDestroySubscription>
export const ContextServiceDocument = gql`
  query ContextService {
    current {
      ...ContextServiceCurrent
    }
  }
  ${ContextServiceCurrentFragmentDoc}
`

/**
 * __useContextServiceQuery__
 *
 * To run a query within a React component, call `useContextServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextServiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useContextServiceQuery(
  baseOptions?: Apollo.QueryHookOptions<ContextServiceQuery, ContextServiceQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContextServiceQuery, ContextServiceQueryVariables>(
    ContextServiceDocument,
    options
  )
}
export function useContextServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContextServiceQuery, ContextServiceQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContextServiceQuery, ContextServiceQueryVariables>(
    ContextServiceDocument,
    options
  )
}
export type ContextServiceQueryHookResult = ReturnType<typeof useContextServiceQuery>
export type ContextServiceLazyQueryHookResult = ReturnType<typeof useContextServiceLazyQuery>
export type ContextServiceQueryResult = Apollo.QueryResult<
  ContextServiceQuery,
  ContextServiceQueryVariables
>
export const ContextServiceCurrentUpdateDocument = gql`
  subscription ContextServiceCurrentUpdate {
    currentUpdate {
      current {
        ...ContextServiceCurrent
      }
    }
  }
  ${ContextServiceCurrentFragmentDoc}
`

/**
 * __useContextServiceCurrentUpdateSubscription__
 *
 * To run a query within a React component, call `useContextServiceCurrentUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContextServiceCurrentUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextServiceCurrentUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useContextServiceCurrentUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ContextServiceCurrentUpdateSubscription,
    ContextServiceCurrentUpdateSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    ContextServiceCurrentUpdateSubscription,
    ContextServiceCurrentUpdateSubscriptionVariables
  >(ContextServiceCurrentUpdateDocument, options)
}
export type ContextServiceCurrentUpdateSubscriptionHookResult = ReturnType<
  typeof useContextServiceCurrentUpdateSubscription
>
export type ContextServiceCurrentUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ContextServiceCurrentUpdateSubscription>
